



/*! jQuery v3.6.0 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(C,e){"use strict";var t=[],r=Object.getPrototypeOf,s=t.slice,g=t.flat?function(e){return t.flat.call(e)}:function(e){return t.concat.apply([],e)},u=t.push,i=t.indexOf,n={},o=n.toString,v=n.hasOwnProperty,a=v.toString,l=a.call(Object),y={},m=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},x=function(e){return null!=e&&e===e.window},E=C.document,c={type:!0,src:!0,nonce:!0,noModule:!0};function b(e,t,n){var r,i,o=(n=n||E).createElement("script");if(o.text=e,t)for(r in c)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function w(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[o.call(e)]||"object":typeof e}var f="3.6.0",S=function(e,t){return new S.fn.init(e,t)};function p(e){var t=!!e&&"length"in e&&e.length,n=w(e);return!m(e)&&!x(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}S.fn=S.prototype={jquery:f,constructor:S,length:0,toArray:function(){return s.call(this)},get:function(e){return null==e?s.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=S.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return S.each(this,e)},map:function(n){return this.pushStack(S.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(s.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(S.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(S.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:u,sort:t.sort,splice:t.splice},S.extend=S.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||m(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(S.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||S.isPlainObject(n)?n:{},i=!1,a[t]=S.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},S.extend({expando:"jQuery"+(f+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==o.call(e))&&(!(t=r(e))||"function"==typeof(n=v.call(t,"constructor")&&t.constructor)&&a.call(n)===l)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){b(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(p(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},makeArray:function(e,t){var n=t||[];return null!=e&&(p(Object(e))?S.merge(n,"string"==typeof e?[e]:e):u.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:i.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(p(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:y}),"function"==typeof Symbol&&(S.fn[Symbol.iterator]=t[Symbol.iterator]),S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var d=function(n){var e,d,b,o,i,h,f,g,w,u,l,T,C,a,E,v,s,c,y,S="sizzle"+1*new Date,p=n.document,k=0,r=0,m=ue(),x=ue(),A=ue(),N=ue(),j=function(e,t){return e===t&&(l=!0),0},D={}.hasOwnProperty,t=[],q=t.pop,L=t.push,H=t.push,O=t.slice,P=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},R="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",M="[\\x20\\t\\r\\n\\f]",I="(?:\\\\[\\da-fA-F]{1,6}"+M+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",W="\\["+M+"*("+I+")(?:"+M+"*([*^$|!~]?=)"+M+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+I+"))|)"+M+"*\\]",F=":("+I+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+W+")*)|.*)\\)|)",B=new RegExp(M+"+","g"),$=new RegExp("^"+M+"+|((?:^|[^\\\\])(?:\\\\.)*)"+M+"+$","g"),_=new RegExp("^"+M+"*,"+M+"*"),z=new RegExp("^"+M+"*([>+~]|"+M+")"+M+"*"),U=new RegExp(M+"|>"),X=new RegExp(F),V=new RegExp("^"+I+"$"),G={ID:new RegExp("^#("+I+")"),CLASS:new RegExp("^\\.("+I+")"),TAG:new RegExp("^("+I+"|[*])"),ATTR:new RegExp("^"+W),PSEUDO:new RegExp("^"+F),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+M+"*(even|odd|(([+-]|)(\\d*)n|)"+M+"*(?:([+-]|)"+M+"*(\\d+)|))"+M+"*\\)|)","i"),bool:new RegExp("^(?:"+R+")$","i"),needsContext:new RegExp("^"+M+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+M+"*((?:-\\d)?\\d*)"+M+"*\\)|)(?=[^-]|$)","i")},Y=/HTML$/i,Q=/^(?:input|select|textarea|button)$/i,J=/^h\d$/i,K=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ee=/[+~]/,te=new RegExp("\\\\[\\da-fA-F]{1,6}"+M+"?|\\\\([^\\r\\n\\f])","g"),ne=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},re=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ie=function(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},oe=function(){T()},ae=be(function(e){return!0===e.disabled&&"fieldset"===e.nodeName.toLowerCase()},{dir:"parentNode",next:"legend"});try{H.apply(t=O.call(p.childNodes),p.childNodes),t[p.childNodes.length].nodeType}catch(e){H={apply:t.length?function(e,t){L.apply(e,O.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]);e.length=n-1}}}function se(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(T(e),e=e||C,E)){if(11!==p&&(u=Z.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return n.push(a),n}else if(f&&(a=f.getElementById(i))&&y(e,a)&&a.id===i)return n.push(a),n}else{if(u[2])return H.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&d.getElementsByClassName&&e.getElementsByClassName)return H.apply(n,e.getElementsByClassName(i)),n}if(d.qsa&&!N[t+" "]&&(!v||!v.test(t))&&(1!==p||"object"!==e.nodeName.toLowerCase())){if(c=t,f=e,1===p&&(U.test(t)||z.test(t))){(f=ee.test(t)&&ye(e.parentNode)||e)===e&&d.scope||((s=e.getAttribute("id"))?s=s.replace(re,ie):e.setAttribute("id",s=S)),o=(l=h(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+xe(l[o]);c=l.join(",")}try{return H.apply(n,f.querySelectorAll(c)),n}catch(e){N(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return g(t.replace($,"$1"),e,n,r)}function ue(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function le(e){return e[S]=!0,e}function ce(e){var t=C.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function fe(e,t){var n=e.split("|"),r=n.length;while(r--)b.attrHandle[n[r]]=t}function pe(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function de(t){return function(e){return"input"===e.nodeName.toLowerCase()&&e.type===t}}function he(n){return function(e){var t=e.nodeName.toLowerCase();return("input"===t||"button"===t)&&e.type===n}}function ge(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&ae(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function ve(a){return le(function(o){return o=+o,le(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function ye(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}for(e in d=se.support={},i=se.isXML=function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!Y.test(t||n&&n.nodeName||"HTML")},T=se.setDocument=function(e){var t,n,r=e?e.ownerDocument||e:p;return r!=C&&9===r.nodeType&&r.documentElement&&(a=(C=r).documentElement,E=!i(C),p!=C&&(n=C.defaultView)&&n.top!==n&&(n.addEventListener?n.addEventListener("unload",oe,!1):n.attachEvent&&n.attachEvent("onunload",oe)),d.scope=ce(function(e){return a.appendChild(e).appendChild(C.createElement("div")),"undefined"!=typeof e.querySelectorAll&&!e.querySelectorAll(":scope fieldset div").length}),d.attributes=ce(function(e){return e.className="i",!e.getAttribute("className")}),d.getElementsByTagName=ce(function(e){return e.appendChild(C.createComment("")),!e.getElementsByTagName("*").length}),d.getElementsByClassName=K.test(C.getElementsByClassName),d.getById=ce(function(e){return a.appendChild(e).id=S,!C.getElementsByName||!C.getElementsByName(S).length}),d.getById?(b.filter.ID=function(e){var t=e.replace(te,ne);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(te,ne);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=d.getElementsByTagName?function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):d.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},b.find.CLASS=d.getElementsByClassName&&function(e,t){if("undefined"!=typeof t.getElementsByClassName&&E)return t.getElementsByClassName(e)},s=[],v=[],(d.qsa=K.test(C.querySelectorAll))&&(ce(function(e){var t;a.appendChild(e).innerHTML="<a id='"+S+"'></a><select id='"+S+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&v.push("[*^$]="+M+"*(?:''|\"\")"),e.querySelectorAll("[selected]").length||v.push("\\["+M+"*(?:value|"+R+")"),e.querySelectorAll("[id~="+S+"-]").length||v.push("~="),(t=C.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||v.push("\\["+M+"*name"+M+"*="+M+"*(?:''|\"\")"),e.querySelectorAll(":checked").length||v.push(":checked"),e.querySelectorAll("a#"+S+"+*").length||v.push(".#.+[+~]"),e.querySelectorAll("\\\f"),v.push("[\\r\\n\\f]")}),ce(function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=C.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&v.push("name"+M+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&v.push(":enabled",":disabled"),a.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&v.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),v.push(",.*:")})),(d.matchesSelector=K.test(c=a.matches||a.webkitMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector||a.msMatchesSelector))&&ce(function(e){d.disconnectedMatch=c.call(e,"*"),c.call(e,"[s!='']:x"),s.push("!=",F)}),v=v.length&&new RegExp(v.join("|")),s=s.length&&new RegExp(s.join("|")),t=K.test(a.compareDocumentPosition),y=t||K.test(a.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},j=t?function(e,t){if(e===t)return l=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!d.sortDetached&&t.compareDocumentPosition(e)===n?e==C||e.ownerDocument==p&&y(p,e)?-1:t==C||t.ownerDocument==p&&y(p,t)?1:u?P(u,e)-P(u,t):0:4&n?-1:1)}:function(e,t){if(e===t)return l=!0,0;var n,r=0,i=e.parentNode,o=t.parentNode,a=[e],s=[t];if(!i||!o)return e==C?-1:t==C?1:i?-1:o?1:u?P(u,e)-P(u,t):0;if(i===o)return pe(e,t);n=e;while(n=n.parentNode)a.unshift(n);n=t;while(n=n.parentNode)s.unshift(n);while(a[r]===s[r])r++;return r?pe(a[r],s[r]):a[r]==p?-1:s[r]==p?1:0}),C},se.matches=function(e,t){return se(e,null,null,t)},se.matchesSelector=function(e,t){if(T(e),d.matchesSelector&&E&&!N[t+" "]&&(!s||!s.test(t))&&(!v||!v.test(t)))try{var n=c.call(e,t);if(n||d.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){N(t,!0)}return 0<se(t,C,null,[e]).length},se.contains=function(e,t){return(e.ownerDocument||e)!=C&&T(e),y(e,t)},se.attr=function(e,t){(e.ownerDocument||e)!=C&&T(e);var n=b.attrHandle[t.toLowerCase()],r=n&&D.call(b.attrHandle,t.toLowerCase())?n(e,t,!E):void 0;return void 0!==r?r:d.attributes||!E?e.getAttribute(t):(r=e.getAttributeNode(t))&&r.specified?r.value:null},se.escape=function(e){return(e+"").replace(re,ie)},se.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},se.uniqueSort=function(e){var t,n=[],r=0,i=0;if(l=!d.detectDuplicates,u=!d.sortStable&&e.slice(0),e.sort(j),l){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)e.splice(n[r],1)}return u=null,e},o=se.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=o(e)}else if(3===i||4===i)return e.nodeValue}else while(t=e[r++])n+=o(t);return n},(b=se.selectors={cacheLength:50,createPseudo:le,match:G,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(te,ne),e[3]=(e[3]||e[4]||e[5]||"").replace(te,ne),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||se.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&se.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return G.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&X.test(n)&&(t=h(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(te,ne).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=m[e+" "];return t||(t=new RegExp("(^|"+M+")"+e+"("+M+"|$)"))&&m(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=se.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(B," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(h,e,t,g,v){var y="nth"!==h.slice(0,3),m="last"!==h.slice(-4),x="of-type"===e;return 1===g&&0===v?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u,l=y!==m?"nextSibling":"previousSibling",c=e.parentNode,f=x&&e.nodeName.toLowerCase(),p=!n&&!x,d=!1;if(c){if(y){while(l){a=e;while(a=a[l])if(x?a.nodeName.toLowerCase()===f:1===a.nodeType)return!1;u=l="only"===h&&!u&&"nextSibling"}return!0}if(u=[m?c.firstChild:c.lastChild],m&&p){d=(s=(r=(i=(o=(a=c)[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===k&&r[1])&&r[2],a=s&&c.childNodes[s];while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if(1===a.nodeType&&++d&&a===e){i[h]=[k,s,d];break}}else if(p&&(d=s=(r=(i=(o=(a=e)[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===k&&r[1]),!1===d)while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if((x?a.nodeName.toLowerCase()===f:1===a.nodeType)&&++d&&(p&&((i=(o=a[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]=[k,d]),a===e))break;return(d-=v)===g||d%g==0&&0<=d/g}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||se.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?le(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=P(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:le(function(e){var r=[],i=[],s=f(e.replace($,"$1"));return s[S]?le(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:le(function(t){return function(e){return 0<se(t,e).length}}),contains:le(function(t){return t=t.replace(te,ne),function(e){return-1<(e.textContent||o(e)).indexOf(t)}}),lang:le(function(n){return V.test(n||"")||se.error("unsupported lang: "+n),n=n.replace(te,ne).toLowerCase(),function(e){var t;do{if(t=E?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=n.location&&n.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===a},focus:function(e){return e===C.activeElement&&(!C.hasFocus||C.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:ge(!1),disabled:ge(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return J.test(e.nodeName)},input:function(e){return Q.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:ve(function(){return[0]}),last:ve(function(e,t){return[t-1]}),eq:ve(function(e,t,n){return[n<0?n+t:n]}),even:ve(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:ve(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:ve(function(e,t,n){for(var r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:ve(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=de(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=he(e);function me(){}function xe(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function be(s,e,t){var u=e.dir,l=e.next,c=l||u,f=t&&"parentNode"===c,p=r++;return e.first?function(e,t,n){while(e=e[u])if(1===e.nodeType||f)return s(e,t,n);return!1}:function(e,t,n){var r,i,o,a=[k,p];if(n){while(e=e[u])if((1===e.nodeType||f)&&s(e,t,n))return!0}else while(e=e[u])if(1===e.nodeType||f)if(i=(o=e[S]||(e[S]={}))[e.uniqueID]||(o[e.uniqueID]={}),l&&l===e.nodeName.toLowerCase())e=e[u]||e;else{if((r=i[c])&&r[0]===k&&r[1]===p)return a[2]=r[2];if((i[c]=a)[2]=s(e,t,n))return!0}return!1}}function we(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Te(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function Ce(d,h,g,v,y,e){return v&&!v[S]&&(v=Ce(v)),y&&!y[S]&&(y=Ce(y,e)),le(function(e,t,n,r){var i,o,a,s=[],u=[],l=t.length,c=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)se(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),f=!d||!e&&h?c:Te(c,s,d,n,r),p=g?y||(e?d:l||v)?[]:t:f;if(g&&g(f,p,n,r),v){i=Te(p,u),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(p[u[o]]=!(f[u[o]]=a))}if(e){if(y||d){if(y){i=[],o=p.length;while(o--)(a=p[o])&&i.push(f[o]=a);y(null,p=[],i,r)}o=p.length;while(o--)(a=p[o])&&-1<(i=y?P(e,a):s[o])&&(e[i]=!(t[i]=a))}}else p=Te(p===t?p.splice(l,p.length):p),y?y(null,t,p,r):H.apply(t,p)})}function Ee(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=be(function(e){return e===i},a,!0),l=be(function(e){return-1<P(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!==w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[be(we(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return Ce(1<s&&we(c),1<s&&xe(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace($,"$1"),t,s<n&&Ee(e.slice(s,n)),n<r&&Ee(e=e.slice(n)),n<r&&xe(e))}c.push(t)}return we(c)}return me.prototype=b.filters=b.pseudos,b.setFilters=new me,h=se.tokenize=function(e,t){var n,r,i,o,a,s,u,l=x[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=_.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=z.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace($," ")}),a=a.slice(n.length)),b.filter)!(r=G[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?se.error(e):x(e,s).slice(0)},f=se.compile=function(e,t){var n,v,y,m,x,r,i=[],o=[],a=A[e+" "];if(!a){t||(t=h(e)),n=t.length;while(n--)(a=Ee(t[n]))[S]?i.push(a):o.push(a);(a=A(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=k+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==C||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==C||(T(o),n=!E);while(s=v[a++])if(s(o,t||C,n)){r.push(o);break}i&&(k=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=q.call(r));f=Te(f)}H.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&se.uniqueSort(r)}return i&&(k=h,w=p),c},m?le(r):r))).selector=e}return a},g=se.select=function(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&h(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&E&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(te,ne),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=G.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(te,ne),ee.test(o[0].type)&&ye(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&xe(o)))return H.apply(n,r),n;break}}}return(l||f(e,c))(r,t,!E,n,!t||ee.test(e)&&ye(t.parentNode)||t),n},d.sortStable=S.split("").sort(j).join("")===S,d.detectDuplicates=!!l,T(),d.sortDetached=ce(function(e){return 1&e.compareDocumentPosition(C.createElement("fieldset"))}),ce(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||fe("type|href|height|width",function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)}),d.attributes&&ce(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||fe("value",function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue}),ce(function(e){return null==e.getAttribute("disabled")})||fe(R,function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null}),se}(C);S.find=d,S.expr=d.selectors,S.expr[":"]=S.expr.pseudos,S.uniqueSort=S.unique=d.uniqueSort,S.text=d.getText,S.isXMLDoc=d.isXML,S.contains=d.contains,S.escapeSelector=d.escape;var h=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&S(e).is(n))break;r.push(e)}return r},T=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},k=S.expr.match.needsContext;function A(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var N=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function j(e,n,r){return m(n)?S.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?S.grep(e,function(e){return e===n!==r}):"string"!=typeof n?S.grep(e,function(e){return-1<i.call(n,e)!==r}):S.filter(n,e,r)}S.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?S.find.matchesSelector(r,e)?[r]:[]:S.find.matches(e,S.grep(t,function(e){return 1===e.nodeType}))},S.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(S(e).filter(function(){for(t=0;t<r;t++)if(S.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)S.find(e,i[t],n);return 1<r?S.uniqueSort(n):n},filter:function(e){return this.pushStack(j(this,e||[],!1))},not:function(e){return this.pushStack(j(this,e||[],!0))},is:function(e){return!!j(this,"string"==typeof e&&k.test(e)?S(e):e||[],!1).length}});var D,q=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(S.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||D,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:q.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof S?t[0]:t,S.merge(this,S.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:E,!0)),N.test(r[1])&&S.isPlainObject(t))for(r in t)m(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=E.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):m(e)?void 0!==n.ready?n.ready(e):e(S):S.makeArray(e,this)}).prototype=S.fn,D=S(E);var L=/^(?:parents|prev(?:Until|All))/,H={children:!0,contents:!0,next:!0,prev:!0};function O(e,t){while((e=e[t])&&1!==e.nodeType);return e}S.fn.extend({has:function(e){var t=S(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(S.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&S(e);if(!k.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&S.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?S.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?i.call(S(e),this[0]):i.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(S.uniqueSort(S.merge(this.get(),S(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),S.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return h(e,"parentNode")},parentsUntil:function(e,t,n){return h(e,"parentNode",n)},next:function(e){return O(e,"nextSibling")},prev:function(e){return O(e,"previousSibling")},nextAll:function(e){return h(e,"nextSibling")},prevAll:function(e){return h(e,"previousSibling")},nextUntil:function(e,t,n){return h(e,"nextSibling",n)},prevUntil:function(e,t,n){return h(e,"previousSibling",n)},siblings:function(e){return T((e.parentNode||{}).firstChild,e)},children:function(e){return T(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(A(e,"template")&&(e=e.content||e),S.merge([],e.childNodes))}},function(r,i){S.fn[r]=function(e,t){var n=S.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=S.filter(t,n)),1<this.length&&(H[r]||S.uniqueSort(n),L.test(r)&&n.reverse()),this.pushStack(n)}});var P=/[^\x20\t\r\n\f]+/g;function R(e){return e}function M(e){throw e}function I(e,t,n,r){var i;try{e&&m(i=e.promise)?i.call(e).done(t).fail(n):e&&m(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}S.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},S.each(e.match(P)||[],function(e,t){n[t]=!0}),n):S.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){S.each(e,function(e,t){m(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==w(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return S.each(arguments,function(e,t){var n;while(-1<(n=S.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<S.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},S.extend({Deferred:function(e){var o=[["notify","progress",S.Callbacks("memory"),S.Callbacks("memory"),2],["resolve","done",S.Callbacks("once memory"),S.Callbacks("once memory"),0,"resolved"],["reject","fail",S.Callbacks("once memory"),S.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return S.Deferred(function(r){S.each(o,function(e,t){var n=m(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&m(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,m(t)?s?t.call(e,l(u,o,R,s),l(u,o,M,s)):(u++,t.call(e,l(u,o,R,s),l(u,o,M,s),l(u,o,R,o.notifyWith))):(a!==R&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){S.Deferred.exceptionHook&&S.Deferred.exceptionHook(e,t.stackTrace),u<=i+1&&(a!==M&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(S.Deferred.getStackHook&&(t.stackTrace=S.Deferred.getStackHook()),C.setTimeout(t))}}return S.Deferred(function(e){o[0][3].add(l(0,e,m(r)?r:R,e.notifyWith)),o[1][3].add(l(0,e,m(t)?t:R)),o[2][3].add(l(0,e,m(n)?n:M))}).promise()},promise:function(e){return null!=e?S.extend(e,a):a}},s={};return S.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=s.call(arguments),o=S.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?s.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(I(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||m(i[t]&&i[t].then)))return o.then();while(t--)I(i[t],a(t),o.reject);return o.promise()}});var W=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;S.Deferred.exceptionHook=function(e,t){C.console&&C.console.warn&&e&&W.test(e.name)&&C.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},S.readyException=function(e){C.setTimeout(function(){throw e})};var F=S.Deferred();function B(){E.removeEventListener("DOMContentLoaded",B),C.removeEventListener("load",B),S.ready()}S.fn.ready=function(e){return F.then(e)["catch"](function(e){S.readyException(e)}),this},S.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--S.readyWait:S.isReady)||(S.isReady=!0)!==e&&0<--S.readyWait||F.resolveWith(E,[S])}}),S.ready.then=F.then,"complete"===E.readyState||"loading"!==E.readyState&&!E.documentElement.doScroll?C.setTimeout(S.ready):(E.addEventListener("DOMContentLoaded",B),C.addEventListener("load",B));var $=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===w(n))for(s in i=!0,n)$(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,m(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(S(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},_=/^-ms-/,z=/-([a-z])/g;function U(e,t){return t.toUpperCase()}function X(e){return e.replace(_,"ms-").replace(z,U)}var V=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function G(){this.expando=S.expando+G.uid++}G.uid=1,G.prototype={cache:function(e){var t=e[this.expando];return t||(t={},V(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[X(t)]=n;else for(r in t)i[X(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][X(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(X):(t=X(t))in r?[t]:t.match(P)||[]).length;while(n--)delete r[t[n]]}(void 0===t||S.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!S.isEmptyObject(t)}};var Y=new G,Q=new G,J=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,K=/[A-Z]/g;function Z(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(K,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:J.test(i)?JSON.parse(i):i)}catch(e){}Q.set(e,t,n)}else n=void 0;return n}S.extend({hasData:function(e){return Q.hasData(e)||Y.hasData(e)},data:function(e,t,n){return Q.access(e,t,n)},removeData:function(e,t){Q.remove(e,t)},_data:function(e,t,n){return Y.access(e,t,n)},_removeData:function(e,t){Y.remove(e,t)}}),S.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=Q.get(o),1===o.nodeType&&!Y.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=X(r.slice(5)),Z(o,r,i[r]));Y.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){Q.set(this,n)}):$(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=Q.get(o,n))?t:void 0!==(t=Z(o,n))?t:void 0;this.each(function(){Q.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){Q.remove(this,e)})}}),S.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=Y.get(e,t),n&&(!r||Array.isArray(n)?r=Y.access(e,t,S.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=S.queue(e,t),r=n.length,i=n.shift(),o=S._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){S.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return Y.get(e,n)||Y.access(e,n,{empty:S.Callbacks("once memory").add(function(){Y.remove(e,[t+"queue",n])})})}}),S.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?S.queue(this[0],t):void 0===n?this:this.each(function(){var e=S.queue(this,t,n);S._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&S.dequeue(this,t)})},dequeue:function(e){return this.each(function(){S.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=S.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=Y.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var ee=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,te=new RegExp("^(?:([+-])=|)("+ee+")([a-z%]*)$","i"),ne=["Top","Right","Bottom","Left"],re=E.documentElement,ie=function(e){return S.contains(e.ownerDocument,e)},oe={composed:!0};re.getRootNode&&(ie=function(e){return S.contains(e.ownerDocument,e)||e.getRootNode(oe)===e.ownerDocument});var ae=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&ie(e)&&"none"===S.css(e,"display")};function se(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return S.css(e,t,"")},u=s(),l=n&&n[3]||(S.cssNumber[t]?"":"px"),c=e.nodeType&&(S.cssNumber[t]||"px"!==l&&+u)&&te.exec(S.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)S.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,S.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ue={};function le(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=Y.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ae(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ue[s])||(o=a.body.appendChild(a.createElement(s)),u=S.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ue[s]=u)))):"none"!==n&&(l[c]="none",Y.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}S.fn.extend({show:function(){return le(this,!0)},hide:function(){return le(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ae(this)?S(this).show():S(this).hide()})}});var ce,fe,pe=/^(?:checkbox|radio)$/i,de=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,he=/^$|^module$|\/(?:java|ecma)script/i;ce=E.createDocumentFragment().appendChild(E.createElement("div")),(fe=E.createElement("input")).setAttribute("type","radio"),fe.setAttribute("checked","checked"),fe.setAttribute("name","t"),ce.appendChild(fe),y.checkClone=ce.cloneNode(!0).cloneNode(!0).lastChild.checked,ce.innerHTML="<textarea>x</textarea>",y.noCloneChecked=!!ce.cloneNode(!0).lastChild.defaultValue,ce.innerHTML="<option></option>",y.option=!!ce.lastChild;var ge={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function ve(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&A(e,t)?S.merge([e],n):n}function ye(e,t){for(var n=0,r=e.length;n<r;n++)Y.set(e[n],"globalEval",!t||Y.get(t[n],"globalEval"))}ge.tbody=ge.tfoot=ge.colgroup=ge.caption=ge.thead,ge.th=ge.td,y.option||(ge.optgroup=ge.option=[1,"<select multiple='multiple'>","</select>"]);var me=/<|&#?\w+;/;function xe(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===w(o))S.merge(p,o.nodeType?[o]:o);else if(me.test(o)){a=a||f.appendChild(t.createElement("div")),s=(de.exec(o)||["",""])[1].toLowerCase(),u=ge[s]||ge._default,a.innerHTML=u[1]+S.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;S.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<S.inArray(o,r))i&&i.push(o);else if(l=ie(o),a=ve(f.appendChild(o),"script"),l&&ye(a),n){c=0;while(o=a[c++])he.test(o.type||"")&&n.push(o)}return f}var be=/^([^.]*)(?:\.(.+)|)/;function we(){return!0}function Te(){return!1}function Ce(e,t){return e===function(){try{return E.activeElement}catch(e){}}()==("focus"===t)}function Ee(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Ee(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=Te;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return S().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=S.guid++)),e.each(function(){S.event.add(this,t,i,r,n)})}function Se(e,i,o){o?(Y.set(e,i,!1),S.event.add(e,i,{namespace:!1,handler:function(e){var t,n,r=Y.get(this,i);if(1&e.isTrigger&&this[i]){if(r.length)(S.event.special[i]||{}).delegateType&&e.stopPropagation();else if(r=s.call(arguments),Y.set(this,i,r),t=o(this,i),this[i](),r!==(n=Y.get(this,i))||t?Y.set(this,i,!1):n={},r!==n)return e.stopImmediatePropagation(),e.preventDefault(),n&&n.value}else r.length&&(Y.set(this,i,{value:S.event.trigger(S.extend(r[0],S.Event.prototype),r.slice(1),this)}),e.stopImmediatePropagation())}})):void 0===Y.get(e,i)&&S.event.add(e,i,we)}S.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=Y.get(t);if(V(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&S.find.matchesSelector(re,i),n.guid||(n.guid=S.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof S&&S.event.triggered!==e.type?S.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(P)||[""]).length;while(l--)d=g=(s=be.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=S.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=S.event.special[d]||{},c=S.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&S.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),S.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=Y.hasData(e)&&Y.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(P)||[""]).length;while(l--)if(d=g=(s=be.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=S.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||S.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)S.event.remove(e,d+t[l],n,r,!0);S.isEmptyObject(u)&&Y.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=S.event.fix(e),l=(Y.get(this,"events")||Object.create(null))[u.type]||[],c=S.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=S.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((S.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<S(i,this).index(l):S.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(S.Event.prototype,t,{enumerable:!0,configurable:!0,get:m(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[S.expando]?e:new S.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&Se(t,"click",we),!1},trigger:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&Se(t,"click"),!0},_default:function(e){var t=e.target;return pe.test(t.type)&&t.click&&A(t,"input")&&Y.get(t,"click")||A(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},S.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},S.Event=function(e,t){if(!(this instanceof S.Event))return new S.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?we:Te,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&S.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[S.expando]=!0},S.Event.prototype={constructor:S.Event,isDefaultPrevented:Te,isPropagationStopped:Te,isImmediatePropagationStopped:Te,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=we,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=we,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=we,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},S.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},S.event.addProp),S.each({focus:"focusin",blur:"focusout"},function(e,t){S.event.special[e]={setup:function(){return Se(this,e,Ce),!1},trigger:function(){return Se(this,e),!0},_default:function(){return!0},delegateType:t}}),S.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){S.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||S.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),S.fn.extend({on:function(e,t,n,r){return Ee(this,e,t,n,r)},one:function(e,t,n,r){return Ee(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,S(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=Te),this.each(function(){S.event.remove(this,e,n,t)})}});var ke=/<script|<style|<link/i,Ae=/checked\s*(?:[^=]|=\s*.checked.)/i,Ne=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function je(e,t){return A(e,"table")&&A(11!==t.nodeType?t:t.firstChild,"tr")&&S(e).children("tbody")[0]||e}function De(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function qe(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Le(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(Y.hasData(e)&&(s=Y.get(e).events))for(i in Y.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)S.event.add(t,i,s[i][n]);Q.hasData(e)&&(o=Q.access(e),a=S.extend({},o),Q.set(t,a))}}function He(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=m(d);if(h||1<f&&"string"==typeof d&&!y.checkClone&&Ae.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),He(t,r,i,o)});if(f&&(t=(e=xe(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=S.map(ve(e,"script"),De)).length;c<f;c++)u=e,c!==p&&(u=S.clone(u,!0,!0),s&&S.merge(a,ve(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,S.map(a,qe),c=0;c<s;c++)u=a[c],he.test(u.type||"")&&!Y.access(u,"globalEval")&&S.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?S._evalUrl&&!u.noModule&&S._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):b(u.textContent.replace(Ne,""),u,l))}return n}function Oe(e,t,n){for(var r,i=t?S.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||S.cleanData(ve(r)),r.parentNode&&(n&&ie(r)&&ye(ve(r,"script")),r.parentNode.removeChild(r));return e}S.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=ie(e);if(!(y.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||S.isXMLDoc(e)))for(a=ve(c),r=0,i=(o=ve(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&pe.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||ve(e),a=a||ve(c),r=0,i=o.length;r<i;r++)Le(o[r],a[r]);else Le(e,c);return 0<(a=ve(c,"script")).length&&ye(a,!f&&ve(e,"script")),c},cleanData:function(e){for(var t,n,r,i=S.event.special,o=0;void 0!==(n=e[o]);o++)if(V(n)){if(t=n[Y.expando]){if(t.events)for(r in t.events)i[r]?S.event.remove(n,r):S.removeEvent(n,r,t.handle);n[Y.expando]=void 0}n[Q.expando]&&(n[Q.expando]=void 0)}}}),S.fn.extend({detach:function(e){return Oe(this,e,!0)},remove:function(e){return Oe(this,e)},text:function(e){return $(this,function(e){return void 0===e?S.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return He(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||je(this,e).appendChild(e)})},prepend:function(){return He(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=je(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return He(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return He(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(S.cleanData(ve(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return S.clone(this,e,t)})},html:function(e){return $(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!ke.test(e)&&!ge[(de.exec(e)||["",""])[1].toLowerCase()]){e=S.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(S.cleanData(ve(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return He(this,arguments,function(e){var t=this.parentNode;S.inArray(this,n)<0&&(S.cleanData(ve(this)),t&&t.replaceChild(e,this))},n)}}),S.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){S.fn[e]=function(e){for(var t,n=[],r=S(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),S(r[o])[a](t),u.apply(n,t.get());return this.pushStack(n)}});var Pe=new RegExp("^("+ee+")(?!px)[a-z%]+$","i"),Re=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=C),t.getComputedStyle(e)},Me=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ie=new RegExp(ne.join("|"),"i");function We(e,t,n){var r,i,o,a,s=e.style;return(n=n||Re(e))&&(""!==(a=n.getPropertyValue(t)||n[t])||ie(e)||(a=S.style(e,t)),!y.pixelBoxStyles()&&Pe.test(a)&&Ie.test(t)&&(r=s.width,i=s.minWidth,o=s.maxWidth,s.minWidth=s.maxWidth=s.width=a,a=n.width,s.width=r,s.minWidth=i,s.maxWidth=o)),void 0!==a?a+"":a}function Fe(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",re.appendChild(u).appendChild(l);var e=C.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),re.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=E.createElement("div"),l=E.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",y.clearCloneStyle="content-box"===l.style.backgroundClip,S.extend(y,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=E.createElement("table"),t=E.createElement("tr"),n=E.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",re.appendChild(e).appendChild(t).appendChild(n),r=C.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,re.removeChild(e)),a}}))}();var Be=["Webkit","Moz","ms"],$e=E.createElement("div").style,_e={};function ze(e){var t=S.cssProps[e]||_e[e];return t||(e in $e?e:_e[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Be.length;while(n--)if((e=Be[n]+t)in $e)return e}(e)||e)}var Ue=/^(none|table(?!-c[ea]).+)/,Xe=/^--/,Ve={position:"absolute",visibility:"hidden",display:"block"},Ge={letterSpacing:"0",fontWeight:"400"};function Ye(e,t,n){var r=te.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function Qe(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(u+=S.css(e,n+ne[a],!0,i)),r?("content"===n&&(u-=S.css(e,"padding"+ne[a],!0,i)),"margin"!==n&&(u-=S.css(e,"border"+ne[a]+"Width",!0,i))):(u+=S.css(e,"padding"+ne[a],!0,i),"padding"!==n?u+=S.css(e,"border"+ne[a]+"Width",!0,i):s+=S.css(e,"border"+ne[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u}function Je(e,t,n){var r=Re(e),i=(!y.boxSizingReliable()||n)&&"border-box"===S.css(e,"boxSizing",!1,r),o=i,a=We(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(Pe.test(a)){if(!n)return a;a="auto"}return(!y.boxSizingReliable()&&i||!y.reliableTrDimensions()&&A(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===S.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===S.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+Qe(e,t,n||(i?"border":"content"),o,r,a)+"px"}function Ke(e,t,n,r,i){return new Ke.prototype.init(e,t,n,r,i)}S.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=We(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=X(t),u=Xe.test(t),l=e.style;if(u||(t=ze(s)),a=S.cssHooks[t]||S.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=te.exec(n))&&i[1]&&(n=se(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(S.cssNumber[s]?"":"px")),y.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=X(t);return Xe.test(t)||(t=ze(s)),(a=S.cssHooks[t]||S.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=We(e,t,r)),"normal"===i&&t in Ge&&(i=Ge[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),S.each(["height","width"],function(e,u){S.cssHooks[u]={get:function(e,t,n){if(t)return!Ue.test(S.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?Je(e,u,n):Me(e,Ve,function(){return Je(e,u,n)})},set:function(e,t,n){var r,i=Re(e),o=!y.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===S.css(e,"boxSizing",!1,i),s=n?Qe(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-Qe(e,u,"border",!1,i)-.5)),s&&(r=te.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=S.css(e,u)),Ye(0,t,s)}}}),S.cssHooks.marginLeft=Fe(y.reliableMarginLeft,function(e,t){if(t)return(parseFloat(We(e,"marginLeft"))||e.getBoundingClientRect().left-Me(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),S.each({margin:"",padding:"",border:"Width"},function(i,o){S.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+ne[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(S.cssHooks[i+o].set=Ye)}),S.fn.extend({css:function(e,t){return $(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Re(e),i=t.length;a<i;a++)o[t[a]]=S.css(e,t[a],!1,r);return o}return void 0!==n?S.style(e,t,n):S.css(e,t)},e,t,1<arguments.length)}}),((S.Tween=Ke).prototype={constructor:Ke,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||S.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(S.cssNumber[n]?"":"px")},cur:function(){var e=Ke.propHooks[this.prop];return e&&e.get?e.get(this):Ke.propHooks._default.get(this)},run:function(e){var t,n=Ke.propHooks[this.prop];return this.options.duration?this.pos=t=S.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):Ke.propHooks._default.set(this),this}}).init.prototype=Ke.prototype,(Ke.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=S.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){S.fx.step[e.prop]?S.fx.step[e.prop](e):1!==e.elem.nodeType||!S.cssHooks[e.prop]&&null==e.elem.style[ze(e.prop)]?e.elem[e.prop]=e.now:S.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=Ke.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},S.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},S.fx=Ke.prototype.init,S.fx.step={};var Ze,et,tt,nt,rt=/^(?:toggle|show|hide)$/,it=/queueHooks$/;function ot(){et&&(!1===E.hidden&&C.requestAnimationFrame?C.requestAnimationFrame(ot):C.setTimeout(ot,S.fx.interval),S.fx.tick())}function at(){return C.setTimeout(function(){Ze=void 0}),Ze=Date.now()}function st(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=ne[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function ut(e,t,n){for(var r,i=(lt.tweeners[t]||[]).concat(lt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function lt(o,e,t){var n,a,r=0,i=lt.prefilters.length,s=S.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=Ze||at(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:S.extend({},e),opts:S.extend(!0,{specialEasing:{},easing:S.easing._default},t),originalProperties:e,originalOptions:t,startTime:Ze||at(),duration:t.duration,tweens:[],createTween:function(e,t){var n=S.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=X(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=S.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=lt.prefilters[r].call(l,o,c,l.opts))return m(n.stop)&&(S._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return S.map(c,ut,l),m(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),S.fx.timer(S.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}S.Animation=S.extend(lt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return se(n.elem,e,te.exec(t),n),n}]},tweener:function(e,t){m(e)?(t=e,e=["*"]):e=e.match(P);for(var n,r=0,i=e.length;r<i;r++)n=e[r],lt.tweeners[n]=lt.tweeners[n]||[],lt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ae(e),v=Y.get(e,"fxshow");for(r in n.queue||(null==(a=S._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,S.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],rt.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||S.style(e,r)}if((u=!S.isEmptyObject(t))||!S.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=Y.get(e,"display")),"none"===(c=S.css(e,"display"))&&(l?c=l:(le([e],!0),l=e.style.display||l,c=S.css(e,"display"),le([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===S.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=Y.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&le([e],!0),p.done(function(){for(r in g||le([e]),Y.remove(e,"fxshow"),d)S.style(e,r,d[r])})),u=ut(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?lt.prefilters.unshift(e):lt.prefilters.push(e)}}),S.speed=function(e,t,n){var r=e&&"object"==typeof e?S.extend({},e):{complete:n||!n&&t||m(e)&&e,duration:e,easing:n&&t||t&&!m(t)&&t};return S.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in S.fx.speeds?r.duration=S.fx.speeds[r.duration]:r.duration=S.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){m(r.old)&&r.old.call(this),r.queue&&S.dequeue(this,r.queue)},r},S.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ae).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=S.isEmptyObject(t),o=S.speed(e,n,r),a=function(){var e=lt(this,S.extend({},t),o);(i||Y.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=S.timers,r=Y.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&it.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||S.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=Y.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=S.timers,o=n?n.length:0;for(t.finish=!0,S.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),S.each(["toggle","show","hide"],function(e,r){var i=S.fn[r];S.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(st(r,!0),e,t,n)}}),S.each({slideDown:st("show"),slideUp:st("hide"),slideToggle:st("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){S.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),S.timers=[],S.fx.tick=function(){var e,t=0,n=S.timers;for(Ze=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||S.fx.stop(),Ze=void 0},S.fx.timer=function(e){S.timers.push(e),S.fx.start()},S.fx.interval=13,S.fx.start=function(){et||(et=!0,ot())},S.fx.stop=function(){et=null},S.fx.speeds={slow:600,fast:200,_default:400},S.fn.delay=function(r,e){return r=S.fx&&S.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=C.setTimeout(e,r);t.stop=function(){C.clearTimeout(n)}})},tt=E.createElement("input"),nt=E.createElement("select").appendChild(E.createElement("option")),tt.type="checkbox",y.checkOn=""!==tt.value,y.optSelected=nt.selected,(tt=E.createElement("input")).value="t",tt.type="radio",y.radioValue="t"===tt.value;var ct,ft=S.expr.attrHandle;S.fn.extend({attr:function(e,t){return $(this,S.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){S.removeAttr(this,e)})}}),S.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?S.prop(e,t,n):(1===o&&S.isXMLDoc(e)||(i=S.attrHooks[t.toLowerCase()]||(S.expr.match.bool.test(t)?ct:void 0)),void 0!==n?null===n?void S.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=S.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!y.radioValue&&"radio"===t&&A(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(P);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),ct={set:function(e,t,n){return!1===t?S.removeAttr(e,n):e.setAttribute(n,n),n}},S.each(S.expr.match.bool.source.match(/\w+/g),function(e,t){var a=ft[t]||S.find.attr;ft[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=ft[o],ft[o]=r,r=null!=a(e,t,n)?o:null,ft[o]=i),r}});var pt=/^(?:input|select|textarea|button)$/i,dt=/^(?:a|area)$/i;function ht(e){return(e.match(P)||[]).join(" ")}function gt(e){return e.getAttribute&&e.getAttribute("class")||""}function vt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(P)||[]}S.fn.extend({prop:function(e,t){return $(this,S.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[S.propFix[e]||e]})}}),S.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&S.isXMLDoc(e)||(t=S.propFix[t]||t,i=S.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=S.find.attr(e,"tabindex");return t?parseInt(t,10):pt.test(e.nodeName)||dt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),y.optSelected||(S.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),S.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){S.propFix[this.toLowerCase()]=this}),S.fn.extend({addClass:function(t){var e,n,r,i,o,a,s,u=0;if(m(t))return this.each(function(e){S(this).addClass(t.call(this,e,gt(this)))});if((e=vt(t)).length)while(n=this[u++])if(i=gt(n),r=1===n.nodeType&&" "+ht(i)+" "){a=0;while(o=e[a++])r.indexOf(" "+o+" ")<0&&(r+=o+" ");i!==(s=ht(r))&&n.setAttribute("class",s)}return this},removeClass:function(t){var e,n,r,i,o,a,s,u=0;if(m(t))return this.each(function(e){S(this).removeClass(t.call(this,e,gt(this)))});if(!arguments.length)return this.attr("class","");if((e=vt(t)).length)while(n=this[u++])if(i=gt(n),r=1===n.nodeType&&" "+ht(i)+" "){a=0;while(o=e[a++])while(-1<r.indexOf(" "+o+" "))r=r.replace(" "+o+" "," ");i!==(s=ht(r))&&n.setAttribute("class",s)}return this},toggleClass:function(i,t){var o=typeof i,a="string"===o||Array.isArray(i);return"boolean"==typeof t&&a?t?this.addClass(i):this.removeClass(i):m(i)?this.each(function(e){S(this).toggleClass(i.call(this,e,gt(this),t),t)}):this.each(function(){var e,t,n,r;if(a){t=0,n=S(this),r=vt(i);while(e=r[t++])n.hasClass(e)?n.removeClass(e):n.addClass(e)}else void 0!==i&&"boolean"!==o||((e=gt(this))&&Y.set(this,"__className__",e),this.setAttribute&&this.setAttribute("class",e||!1===i?"":Y.get(this,"__className__")||""))})},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+ht(gt(n))+" ").indexOf(t))return!0;return!1}});var yt=/\r/g;S.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=m(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,S(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=S.map(t,function(e){return null==e?"":e+""})),(r=S.valHooks[this.type]||S.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=S.valHooks[t.type]||S.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(yt,""):null==e?"":e:void 0}}),S.extend({valHooks:{option:{get:function(e){var t=S.find.attr(e,"value");return null!=t?t:ht(S.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!A(n.parentNode,"optgroup"))){if(t=S(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=S.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<S.inArray(S.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),S.each(["radio","checkbox"],function(){S.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<S.inArray(S(e).val(),t)}},y.checkOn||(S.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})}),y.focusin="onfocusin"in C;var mt=/^(?:focusinfocus|focusoutblur)$/,xt=function(e){e.stopPropagation()};S.extend(S.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||E],d=v.call(e,"type")?e.type:e,h=v.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||E,3!==n.nodeType&&8!==n.nodeType&&!mt.test(d+S.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[S.expando]?e:new S.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:S.makeArray(t,[e]),c=S.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!x(n)){for(s=c.delegateType||d,mt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||E)&&p.push(a.defaultView||a.parentWindow||C)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(Y.get(o,"events")||Object.create(null))[e.type]&&Y.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&V(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!V(n)||u&&m(n[d])&&!x(n)&&((a=n[u])&&(n[u]=null),S.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,xt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,xt),S.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=S.extend(new S.Event,n,{type:e,isSimulated:!0});S.event.trigger(r,null,t)}}),S.fn.extend({trigger:function(e,t){return this.each(function(){S.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return S.event.trigger(e,t,n,!0)}}),y.focusin||S.each({focus:"focusin",blur:"focusout"},function(n,r){var i=function(e){S.event.simulate(r,e.target,S.event.fix(e))};S.event.special[r]={setup:function(){var e=this.ownerDocument||this.document||this,t=Y.access(e,r);t||e.addEventListener(n,i,!0),Y.access(e,r,(t||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=Y.access(e,r)-1;t?Y.access(e,r,t):(e.removeEventListener(n,i,!0),Y.remove(e,r))}}});var bt=C.location,wt={guid:Date.now()},Tt=/\?/;S.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new C.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||S.error("Invalid XML: "+(n?S.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Ct=/\[\]$/,Et=/\r?\n/g,St=/^(?:submit|button|image|reset|file)$/i,kt=/^(?:input|select|textarea|keygen)/i;function At(n,e,r,i){var t;if(Array.isArray(e))S.each(e,function(e,t){r||Ct.test(n)?i(n,t):At(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==w(e))i(n,e);else for(t in e)At(n+"["+t+"]",e[t],r,i)}S.param=function(e,t){var n,r=[],i=function(e,t){var n=m(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!S.isPlainObject(e))S.each(e,function(){i(this.name,this.value)});else for(n in e)At(n,e[n],t,i);return r.join("&")},S.fn.extend({serialize:function(){return S.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=S.prop(this,"elements");return e?S.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!S(this).is(":disabled")&&kt.test(this.nodeName)&&!St.test(e)&&(this.checked||!pe.test(e))}).map(function(e,t){var n=S(this).val();return null==n?null:Array.isArray(n)?S.map(n,function(e){return{name:t.name,value:e.replace(Et,"\r\n")}}):{name:t.name,value:n.replace(Et,"\r\n")}}).get()}});var Nt=/%20/g,jt=/#.*$/,Dt=/([?&])_=[^&]*/,qt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Lt=/^(?:GET|HEAD)$/,Ht=/^\/\//,Ot={},Pt={},Rt="*/".concat("*"),Mt=E.createElement("a");function It(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(P)||[];if(m(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Wt(t,i,o,a){var s={},u=t===Pt;function l(e){var r;return s[e]=!0,S.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Ft(e,t){var n,r,i=S.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&S.extend(!0,e,r),e}Mt.href=bt.href,S.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:bt.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(bt.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Rt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":S.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Ft(Ft(e,S.ajaxSettings),t):Ft(S.ajaxSettings,e)},ajaxPrefilter:It(Ot),ajaxTransport:It(Pt),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=S.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?S(y):S.event,x=S.Deferred(),b=S.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=qt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||bt.href)+"").replace(Ht,bt.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(P)||[""],null==v.crossDomain){r=E.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Mt.protocol+"//"+Mt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=S.param(v.data,v.traditional)),Wt(Ot,v,t,T),h)return T;for(i in(g=S.event&&v.global)&&0==S.active++&&S.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Lt.test(v.type),f=v.url.replace(jt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Nt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(Tt.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(Dt,"$1"),o=(Tt.test(f)?"&":"?")+"_="+wt.guid+++o),v.url=f+o),v.ifModified&&(S.lastModified[f]&&T.setRequestHeader("If-Modified-Since",S.lastModified[f]),S.etag[f]&&T.setRequestHeader("If-None-Match",S.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+Rt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Wt(Pt,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=C.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&C.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<S.inArray("script",v.dataTypes)&&S.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(S.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(S.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--S.active||S.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return S.get(e,t,n,"json")},getScript:function(e,t){return S.get(e,void 0,t,"script")}}),S.each(["get","post"],function(e,i){S[i]=function(e,t,n,r){return m(t)&&(r=r||n,n=t,t=void 0),S.ajax(S.extend({url:e,type:i,dataType:r,data:t,success:n},S.isPlainObject(e)&&e))}}),S.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),S._evalUrl=function(e,t,n){return S.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){S.globalEval(e,t,n)}})},S.fn.extend({wrapAll:function(e){var t;return this[0]&&(m(e)&&(e=e.call(this[0])),t=S(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return m(n)?this.each(function(e){S(this).wrapInner(n.call(this,e))}):this.each(function(){var e=S(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=m(t);return this.each(function(e){S(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){S(this).replaceWith(this.childNodes)}),this}}),S.expr.pseudos.hidden=function(e){return!S.expr.pseudos.visible(e)},S.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},S.ajaxSettings.xhr=function(){try{return new C.XMLHttpRequest}catch(e){}};var Bt={0:200,1223:204},$t=S.ajaxSettings.xhr();y.cors=!!$t&&"withCredentials"in $t,y.ajax=$t=!!$t,S.ajaxTransport(function(i){var o,a;if(y.cors||$t&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Bt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&C.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),S.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),S.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return S.globalEval(e),e}}}),S.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),S.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=S("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),E.head.appendChild(r[0])},abort:function(){i&&i()}}});var _t,zt=[],Ut=/(=)\?(?=&|$)|\?\?/;S.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=zt.pop()||S.expando+"_"+wt.guid++;return this[e]=!0,e}}),S.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Ut.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Ut.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=m(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Ut,"$1"+r):!1!==e.jsonp&&(e.url+=(Tt.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||S.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=C[r],C[r]=function(){o=arguments},n.always(function(){void 0===i?S(C).removeProp(r):C[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,zt.push(r)),o&&m(i)&&i(o[0]),o=i=void 0}),"script"}),y.createHTMLDocument=((_t=E.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===_t.childNodes.length),S.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(y.createHTMLDocument?((r=(t=E.implementation.createHTMLDocument("")).createElement("base")).href=E.location.href,t.head.appendChild(r)):t=E),o=!n&&[],(i=N.exec(e))?[t.createElement(i[1])]:(i=xe([e],t,o),o&&o.length&&S(o).remove(),S.merge([],i.childNodes)));var r,i,o},S.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=ht(e.slice(s)),e=e.slice(0,s)),m(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&S.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?S("<div>").append(S.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},S.expr.pseudos.animated=function(t){return S.grep(S.timers,function(e){return t===e.elem}).length},S.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=S.css(e,"position"),c=S(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=S.css(e,"top"),u=S.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),m(t)&&(t=t.call(e,n,S.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},S.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){S.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===S.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===S.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=S(e).offset()).top+=S.css(e,"borderTopWidth",!0),i.left+=S.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-S.css(r,"marginTop",!0),left:t.left-i.left-S.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===S.css(e,"position"))e=e.offsetParent;return e||re})}}),S.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;S.fn[t]=function(e){return $(this,function(e,t,n){var r;if(x(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),S.each(["top","left"],function(e,n){S.cssHooks[n]=Fe(y.pixelPosition,function(e,t){if(t)return t=We(e,n),Pe.test(t)?S(e).position()[n]+"px":t})}),S.each({Height:"height",Width:"width"},function(a,s){S.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){S.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return $(this,function(e,t,n){var r;return x(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?S.css(e,t,i):S.style(e,t,n,i)},s,n?e:void 0,n)}})}),S.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){S.fn[t]=function(e){return this.on(t,e)}}),S.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){S.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var Xt=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;S.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),m(e))return r=s.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(s.call(arguments)))}).guid=e.guid=e.guid||S.guid++,i},S.holdReady=function(e){e?S.readyWait++:S.ready(!0)},S.isArray=Array.isArray,S.parseJSON=JSON.parse,S.nodeName=A,S.isFunction=m,S.isWindow=x,S.camelCase=X,S.type=w,S.now=Date.now,S.isNumeric=function(e){var t=S.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},S.trim=function(e){return null==e?"":(e+"").replace(Xt,"")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return S});var Vt=C.jQuery,Gt=C.$;return S.noConflict=function(e){return C.$===S&&(C.$=Gt),e&&C.jQuery===S&&(C.jQuery=Vt),S},"undefined"==typeof e&&(C.jQuery=C.$=S),S});

/*
 * jquery.easie.js:
 * http://www.github.com/jaukia/easie
 *
 * Version history:
 * 1.0.1 Semver versioning for jQuery plugins repository
 * 1.0.0 Initial public version
 *
 * LICENCE INFORMATION:
 *
 * Copyright (c) 2011 Janne Aukia (janne.aukia.com),
 * Louis-Rémi Babé (public@lrbabe.com).
 *
 * Dual licensed under the MIT (MIT-LICENSE.txt)
 * and GPL Version 2 (GPL-LICENSE.txt) licenses.
 *
 * LICENCE INFORMATION FOR DERIVED FUNCTIONS:
 *
 * Function cubicBezierAtTime is written by Christian Effenberger, 
 * and corresponds 1:1 to the WebKit project function.
 * "WebCore and JavaScriptCore are available under the 
 * Lesser GNU Public License. WebKit is available under 
 * a BSD-style license."
 *
 */
/* jslint sub: true */
/* includes custom easing names, removed non-CSS3 default easings */
!function(n){"use strict";n.easie=function(r,e,u,t,i,a){if(i=i||[r,e,u,t].join("-"),!n.easing[i]||a){var f=function(n,r){var e;r=r||101;var u=[];for(e=0;e<r+1;e++)u[e]=n.call(null,e/r);return function(n){if(1===n)return u[r];var e=r*n,t=Math.floor(e),i=u[t],a=u[t+1];return i+(a-i)*(e-t)}}(function(n){return function(n,r,e,u,t,i){var a=0,f=0,o=0,c=0,s=0,l=0;function v(n){return((a*n+f)*n+o)*n}return a=1-(o=3*r)-(f=3*(u-r)-o),c=1-(l=3*e)-(s=3*(t-e)-l),function(n,r){return e=function(n,r){var e,u,t,i,c,s,l;function g(n){return n>=0?n:0-n}for(t=n,s=0;s<8;s++){if(g(i=v(t)-n)<r)return t;if(g(c=(3*a*(l=t)+2*f)*l+o)<1e-6)break;t-=i/c}if(u=1,(t=n)<(e=0))return e;if(t>u)return u;for(;e<u;){if(g((i=v(t))-n)<r)return t;n>i?e=t:u=t,t=.5*(u-e)+e}return t}(n,r),((c*e+s)*e+l)*e;var e}(n,function(n){return 1/(200*n)}(i))}(n,r,e,u,t,5)});n.easing[i]=function(n,r,e,u){return f.call(null,n)},n.easing[i].params=[r,e,u,t]}return i};var r=n.easie;r(.25,.1,.25,1,"ease"),r(.42,0,1,1,"ease-in"),r(0,0,.58,1,"ease-out"),r(.42,0,.58,1,"ease-in-out")}(jQuery);

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}"undefined"==typeof window.Shopify&&(window.Shopify={}),Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return void 0!==t},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,(t.prototype.constructor=t).baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){return(Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e)+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(o){if(!Shopify.isDefined(this.variants))return null;var t=Shopify.map(this.variants,function(t){var e="option"+(o+1);return t[e]==undefined?null:t[e]});return null==t[0]?null:Shopify.uniq(t)},Shopify.Product.prototype.getVariant=function(i){var r=null;return i.length!=this.options.length||Shopify.each(this.variants,function(t){for(var e=!0,o=0;o<i.length;o++){t["option"+(o+1)]!=i[o]&&(e=!1)}1!=e||(r=t)}),r},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function n(t,e){return void 0===t?e:t}function o(t,e,o,i){if(e=n(e,2),o=n(o,","),i=n(i,"."),isNaN(t)||null==t)return 0;var r=(t=(t/100).toFixed(e)).split(".");return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+o)+(r[1]?i+r[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var i="",r=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(r)[1]){case"amount":i=o(t,2);break;case"amount_no_decimals":i=o(t,0);break;case"amount_with_comma_separator":i=o(t,2,".",",");break;case"amount_with_space_separator":i=o(t,2," ",",");break;case"amount_with_period_and_space_separator":i=o(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":i=o(t,0,".",",");break;case"amount_no_decimals_with_space_separator":i=o(t,0," ");break;case"amount_with_apostrophe_separator":i=o(t,2,"'",".")}return a.replace(r,i)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0};if(!this.selectVariantFromDropdown(t)){var e=this;setTimeout(function(){e.selectVariantFromParams(t)||e.fireOnChangeForFirstDropdown.call(e,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){this.selectVariantFromParams(t)||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=o[r.getAttribute("data-option")];null!=n&&this.optionExistInSelect(r,n)&&(r.value=n)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var i=this.selectorDivClass,r=this.product.optionNames();return Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",i),1<r.length){var o=document.createElement("label");o.htmlFor=t.element.id,o.innerHTML=t.name,e.appendChild(o)}return e.appendChild(t.element),e})},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,n,a,s){if(!Shopify.isDefined(a))a=!0;if(!Shopify.isDefined(s))s="/";var e=document.getElementById(t),o=e.childNodes,p=(e.parentNode,n.length),l=[];Shopify.each(o,function(t){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var e=t.innerHTML.split(new RegExp("\\s*\\"+s+"\\s*"));0==n.length&&(p=e.length-(a?1:0));var o=e.slice(0,p),i=a?e[p]:"",r=(t.getAttribute("value"),{available:!t.disabled,id:parseFloat(t.value),price:i,option1:o[0],option2:o[1],option3:o[2]});l.push(r)}});var i={variants:l};if(0==n.length){i.options=[];for(var r=0;r<p;r++)i.options[r]="option "+(r+1)}else i.options=n;return i},Shopify.SingleOptionSelector=function(o,i,t,e){this.multiSelector=o,this.values=e,this.index=i,this.name=t,this.element=document.createElement("select");for(var r=0;r<e.length;r++){var n=document.createElement("option");n.value=e[r],n.innerHTML=e[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(i+1)),this.element.id=o.domIdPrefix+"-option-"+i,this.element.onchange=function(t,e){e=e||{},o.updateSelectors(i,e)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);return null!==e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null==o)return null;var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};

/* api.jquery.js */
function floatToString(t,r){var e=t.toFixed(r).toString();return e.match(/^\.\d+/)?"0"+e:e}function attributeToString(t){return"string"!=typeof t&&"undefined"===(t+="")&&(t=""),jQuery.trim(t)}"undefined"==typeof window.Shopify&&(window.Shopify={}),Shopify.money_format="$",Shopify.onError=function(t,r){var e=eval("("+t.responseText+")");e.message?alert(e.message+"("+e.status+"): "+e.description):alert("Error : "+Shopify.fullMessagesFromErrors(e).join("; ")+".")},Shopify.fullMessagesFromErrors=function(t){var o=[];return jQuery.each(t,function(e,t){jQuery.each(t,function(t,r){o.push(e+" "+r)})}),o},Shopify.onCartUpdate=function(t){alert("There are now "+t.item_count+" items in the cart.")},Shopify.onCartShippingRatesUpdate=function(t,r){var e="";r.zip&&(e+=r.zip+", "),r.province&&(e+=r.province+", "),e+=r.country,alert("There are "+t.length+" shipping rates available for "+e+", starting at "+Shopify.formatMoney(t[0].price)+".")},Shopify.onItemAdded=function(t){alert(t.title+" was added to your shopping cart.")},Shopify.onProduct=function(t){alert("Received everything we ever wanted to know about "+t.title)},Shopify.formatMoney=function(t,r){function n(t,r){return void 0===t?r:t}function e(t,r,e,o){if(r=n(r,2),e=n(e,","),o=n(o,"."),isNaN(t)||null==t)return 0;var a=(t=(t/100).toFixed(r)).split(".");return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+e)+(a[1]?o+a[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var o="",a=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(a)[1]){case"amount":o=e(t,2);break;case"amount_no_decimals":o=e(t,0);break;case"amount_with_comma_separator":o=e(t,2,".",",");break;case"amount_with_space_separator":o=e(t,2," ",",");break;case"amount_with_period_and_space_separator":o=e(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=e(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=e(t,0,".","");break;case"amount_with_space_separator":o=e(t,2,",","");break;case"amount_with_apostrophe_separator":o=e(t,2,"'",".")}return i.replace(a,o)},Shopify.resizeImage=function(t,r){try{if("original"==r)return t;var e=t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);return e[1]+"_"+r+"."+e[2]}catch(o){return t}},Shopify.addItem=function(t,r,e){var o={type:"POST",url:window.routes.cartAddUrl + ".js",data:"quantity="+(r=r||1)+"&id="+t,dataType:"json",success:function(t){"function"==typeof e?e(t):Shopify.onItemAdded(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(o)},Shopify.addItemFromForm=function(t,r){var e={type:"POST",url:window.routes.cartAddUrl + ".js",data:jQuery("#"+t).serialize(),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onItemAdded(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.getCart=function(r){jQuery.getJSON(window.routes.cartUrl + ".js",function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)})},Shopify.pollForCartShippingRatesForDestination=function(o,a,t){t=t||Shopify.onError;var n=function(){jQuery.ajax("/cart/async_shipping_rates",{dataType:"json",success:function(t,r,e){200===e.status?"function"==typeof a?a(t.shipping_rates,o):Shopify.onCartShippingRatesUpdate(t.shipping_rates,o):setTimeout(n,500)},error:t})};return n},Shopify.getCartShippingRatesForDestination=function(t,r,e){e=e||Shopify.onError;var o={type:"POST",url:"/cart/prepare_shipping_rates",data:Shopify.param({shipping_address:t}),success:Shopify.pollForCartShippingRatesForDestination(t,r,e),error:e};jQuery.ajax(o)},Shopify.getProduct=function(t,r){jQuery.getJSON("/products/"+t+".js",function(t){"function"==typeof r?r(t):Shopify.onProduct(t)})},Shopify.changeItem=function(t,r,e){var o={type:"POST",url:window.routes.cartChangeUrl + ".js",data:"quantity="+r+"&id="+t,dataType:"json",success:function(t){"function"==typeof e?e(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(o)},Shopify.removeItem=function(t,r){var e={type:"POST",url:window.routes.cartChangeUrl + ".js",data:"quantity=0&id="+t,dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.clear=function(r){var t={type:"POST",url:window.routes.cartClearUrl + ".js",data:"",dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(t)},Shopify.updateCartFromForm=function(t,r){var e={type:"POST",url:window.routes.cartUpdateUrl + ".js",data:jQuery("#"+t).serialize(),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.updateCartAttributes=function(t,r){var o="";jQuery.isArray(t)?jQuery.each(t,function(t,r){var e=attributeToString(r.key);""!==e&&(o+="attributes["+e+"]="+attributeToString(r.value)+"&")}):"object"==typeof t&&null!==t&&jQuery.each(t,function(t,r){o+="attributes["+attributeToString(t)+"]="+attributeToString(r)+"&"});var e={type:"POST",url:window.routes.cartUpdateUrl + ".js",data:o,dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.updateCartNote=function(t,r){var e={type:"POST",url:window.routes.cartUpdateUrl + ".js",data:"note="+attributeToString(t),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},"1.4"<=jQuery.fn.jquery?Shopify.param=jQuery.param:(Shopify.param=function(t){var e=[],r=function(t,r){r=jQuery.isFunction(r)?r():r,e[e.length]=encodeURIComponent(t)+"="+encodeURIComponent(r)};if(jQuery.isArray(t)||t.jquery)jQuery.each(t,function(){r(this.name,this.value)});else for(var o in t)Shopify.buildParams(o,t[o],r);return e.join("&").replace(/%20/g,"+")},Shopify.buildParams=function(e,t,o){jQuery.isArray(t)&&t.length?jQuery.each(t,function(t,r){rbracket.test(e)?o(e,r):Shopify.buildParams(e+"["+("object"==typeof r||jQuery.isArray(r)?t:"")+"]",r,o)}):null!=t&&"object"==typeof t?Shopify.isEmptyObject(t)?o(e,""):jQuery.each(t,function(t,r){Shopify.buildParams(e+"["+t+"]",r,o)}):o(e,t)},Shopify.isEmptyObject=function(t){for(var r in t)return!1;return!0});






window.isChromeMobile = (/(?=.*Chrome)(?=.*Android)|CriOS/i.test(navigator.userAgent) ? true : false);

try {
  window.variantRegex1 = new RegExp('^(.+)(\\.\\w{2,4}.*)$');
  window.variantRegex2 = new RegExp('([^\\s]+(?<!\\_[\\d|x]+))(\\_[\\d|x]+)*(\\.\\w{2,4}[^\\s]*)([^\\,]*\\,*)', 'g');
  window.variantRegexSupported = true;
} catch(error) {
  window.variantRegexSupported = false;
  console.log(error.message);
}

function setImagesLoaded(images)
{
  images.each(function()
  {
    if (this.complete)
      $(this).addClass('loaded');
    else
      $(this).one('load', function() { $(this).addClass('loaded'); });
  });
}

$(window).on('load', function()
{
  setImagesLoaded($('img[loading="lazy"]'));
});

/* <head> js */




/* section 'header' js */

setInterval(function time() {
  var d = new Date();
  var hours = 24 - d.getHours();
  var min = 60 - d.getMinutes();
  if ((hours + '').length == 1) {
    hours = '0' + hours;
  }
  if ((min + '').length == 1) {
    min = '0' + min;
  }
  var sec = 60 - d.getSeconds();
  if ((sec + '').length == 1) {
    sec = '0' + sec;
  }
  var ht = '<span class="timeHours"><div class="timeNum">' + hours + '</div><div class="timeTxt">H</div></span> <span class="dots">:</span> ';
  ht += '<span class="timeMins"><div class="timeNum">' + min + '</div><div class="timeTxt">M</div></span> <span class="dots">:</span> ';
  ht += '<span class="timeSec"><div class="timeNum">' + sec + '</div><div class="timeTxt">S</div></span>';
  $('#finalCountdown').html(ht);
  $('.anouncment_timer').css('opacity', 1);
}, 1000);


function initExtend(callback)
{
  /* Extend header js (custom) */

  $.getScript('https://sdk.helloextend.com/extend-sdk-client/v1/extend-sdk-client.min.js', function()
  {
    $.getScript('https://sdk.helloextend.com/extend-sdk-client-shopify-addon/v1/extend-sdk-client-shopify-addon.min.js', function()
    {
	  Extend.config({ storeId: '820d3910-2e77-453d-8ad5-6ba32d7164b8', environment: 'production' });

	  /* snippet 'extend-polyfills.liquid' */

	  

	  (function () {
	    function CustomEvent ( event, params ) {
	      if ( typeof window.CustomEvent === "function" ) {
	        return new window.CustomEvent(event, params);
	      } else {
	        params = params || { bubbles: false, cancelable: false, detail: null };
	        var evt = document.createEvent( 'CustomEvent' );
	        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
	        return evt;
	      };
	    }
	    window.Extend.CustomEvent = CustomEvent;
	  })();

	  

	  if (callback) { callback(); }
    });
  });
}


$(document).ready(function() {
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  if (window.location.href.indexOf("emailref") > -1 || getCookie('emailref')) {
    if (getCookie('emailref')) {
      var now = new Date().getTime();
      var countDownDate = parseInt(getCookie('emailref')) + now;
    } else {
      var countDownDate = new Date().getTime() + 86400000;
    }
    if (parseInt(getCookie('emailref')) < 0 && getCookie('usercome') == null && window.location.href.indexOf("emailref") > -1) {
      var countDownDate = new Date().getTime() + 86400000;
      setCookie('usercome', 'set', 1);
    }
    var x = setInterval(function() {
      var now = new Date().getTime();
      var distance = countDownDate - now;
      setCookie('emailref', distance, 0);
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      var ht1 = '<span class="timeHours"><div class="timeNum">' + hours + '</div><div class="timeTxt">H</div></span> <span class="dots">:</span> ';
      ht1 += '<span class="timeMins"><div class="timeNum">' + minutes + '</div><div class="timeTxt">M</div></span> <span class="dots">:</span> ';
      ht1 += '<span class="timeSec"><div class="timeNum">' + seconds + '</div><div class="timeTxt">S</div></span>';
      $('#finalCountdown1').html(ht1);
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("finalCountdown1").innerHTML = "EXPIRED";
        $('.normalBar').show();
        $('.refranceBar').hide();
      } else {
        $('.refranceBar').show();
        $('.normalBar').hide();
        $('.anouncment_timer').css('opacity', 1);
      }
    }, 1000);
  } else {
    $('.normalBar').show();
  }
  //$('.salesbarOuter').slideDown();

  if ($('body.template-product').length && $(window).width() > 767)
  {
    
    $('.js-product-zoom-nav-slider .nav-slide.init-image img[loading="lazy"]').attr('loading', 'eager');
    setTimeout(function() {
      $('.js-product-zoom-nav-slider').addClass('visible');
    }, 0);
  }

  $.getScript('https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=QGFDp9');

  
  if (($('body.template-product').length && $(window).width() > 767) || $('body.template-cart .cart__row').length)
    initExtend();
  

  if ($('body.template-product').length && $('.product-details .form-btn-grp .add-to-cart.sold-out').length)
  {
    var startTime = new Date();
    $('.product-details .form-btn-grp').on('DOMNodeInserted', function() {
      if ($('#product-restore-email').length || new Date() - startTime > 10000) {
        $('#product-restore-email').addClass('visible');
        $(this).off('DOMNodeInserted');
      }
    });
  }
});





/* template 'collection' js */

if ($('body.template-collection').length)
{
  $(function() {
    $(window).one('scroll', function() {
      if (!$('.grid-uniform.all-products[data-ajax-loaded="true"]').length) { load_ajax_products(); }
    });

    $('.collection-filters .collection-filters-bottom .collection-filter-item-dropdown[data-has-tags="true"]').each(function() {
      $('li[data-dropdown-id="' + $(this).data('dropdown-id') + '"]').show();
    });

    $('.collection-filters-list > li').on('click', function(e) {
      e.preventDefault();
      if ($(this).hasClass('active')) {
        var bottomContainer = $(this).closest('.collection-filters').find('.collection-filters-bottom');
        $('.collection-filters-list > li').removeClass('active');
        $(bottomContainer).find('.collection-filter-item-dropdown.active').removeClass('active').slideToggle();
      } else {
        var id = $(this).attr('data-dropdown-id');
        var bottomContainer = $(this).closest('.collection-filters').find('.collection-filters-bottom');
        $('.collection-filters-list > li').removeClass('active');
        $(this).addClass('active');
        $(bottomContainer).find('.collection-filter-item-dropdown.active').removeClass('active').slideToggle();
        setTimeout(function() {
          $(bottomContainer).find('.collection-filter-item-dropdown[data-dropdown-id="' + id + '"]').addClass('active').slideToggle();
        }, 500);
      }
      if (!$('.grid-uniform.all-products[data-ajax-loaded="true"]').length) { load_ajax_products(); }
    });
    // Mobile Filter
    $('.collection-filters .mobile-toggles .filter').on('click', function() {
      $(this).toggleClass('active');
      $('.collection-filters .mobile-toggles .sort').removeClass('active');
      $('.collection-filters .collection-filters-list-wrapper').slideToggle();
      if($('.mobile-sort').is(':visible')) $('.mobile-sort').slideToggle();
      $('.collection-filters .collection-filter-item-dropdown.active').removeClass('active').slideToggle();
      $('.collection-filters .collection-filters-list li.active').removeClass('active');
      if (!$('.grid-uniform.all-products[data-ajax-loaded="true"]').length) { load_ajax_products(); }
    });

    $('.collection-filters .mobile-toggles .sort').on('click', function() {
      $(this).toggleClass('active');
      $('.collection-filters .mobile-toggles .filter').removeClass('active');
      if($('.collection-filters .collection-filters-list-wrapper').is(':visible')) $('.collection-filters .collection-filters-list-wrapper').slideToggle();
      $('.collection-filters .collection-filter-item-dropdown.active').removeClass('active').slideToggle();
      $('.mobile-sort').slideToggle();
      if (!$('.grid-uniform.all-products[data-ajax-loaded="true"]').length) { load_ajax_products(); }
    });

    // Custom Filtering

    $('.collection-filter-item-dropdown .collection-filter-item-new, .collection-filter-item-dropdown .collection-sort-item-new').on('click', function(event) {
      event.preventDefault();

      if ($('.collection-main-wrapper .ajax-loader-top.ajax-loading').length) { return; }
      
      if ($('.collection-current-filter[data-tag="' + $(this).data('tag') + '"]').length) {
        if ($(this).closest('.collection-filter-item-dropdown').hasClass('single-choice'))
          $(this).closest('.collection-filter-item-dropdown').find('ul > li').removeClass('active');
        $('.collection-current-filter[data-tag="' + $(this).data('tag') + '"]').click();
        return;
      }

      if ($(this).closest('.collection-filter-item-dropdown').hasClass('single-choice')) {
        $(this).closest('.collection-filter-item-dropdown').find('ul > li').removeClass('active');
        $(this).closest('li').addClass('active');

        $('.collection-filters .collection-current-filters ul > li > a[data-category="' + $(this).data('category') + '"]').each(function() {
          $(this).closest('li').remove();
        });

        $('.collection-filters .collection-current-filters ul').append('<li><a class="collection-current-filter single-choice" href="javascript:void(0)" title="Remove tag ' + $(this).data('tag') + '" data-category="' + $(this).data('category') + '" data-tag="' + $(this).data('tag') + '">' + $(this).data('tag').split('_').pop() + '</a></li>');
      }
      else {
        $('.collection-filters .collection-current-filters ul').append('<li><a class="collection-current-filter" href="javascript:void(0)" title="Remove tag ' + $(this).data('tag') + '" data-category="' + $(this).data('category') + '" data-tag="' + $(this).data('tag') + '">' + $(this).data('tag').split('_').pop() + '</a></li>');
      }

      update_filtered_products();
    });

    $('.collection-filters .collection-current-filters ul').on('click', 'li .collection-current-filter', function(event) {
      event.preventDefault();

      if ($('.collection-main-wrapper .ajax-loader-top.ajax-loading').length) { return; }

      if ($(this).hasClass('single-choice'))
        $('.collection-filter-item-dropdown .collection-filter-item-new[data-tag="' + $(this).data('tag') + '"], .collection-filter-item-dropdown .collection-sort-item-new[data-tag="' + $(this).data('tag') + '"]').closest('li').removeClass('active');

      $(this).closest('li').remove();

      update_filtered_products();
    });

    function load_ajax_products() {
      var url = '//' + location.host + location.pathname + '?view=ajax';
      var length = $('.product-grid-item .product-select.available.multiple-variants').length;
      var gt = (length ? ':gt(' + (length - 1) + ')' : '');
      $.ajax({
        type: 'GET',
        url: url,
        beforeSend: function() {
          $('.collection-main-wrapper .ajax-loader-bottom').addClass('ajax-loading');
        },
        success: function(data) {
          $('.grid-uniform.all-products').append(data.split('<!-- collection.ajax -->')[1]);
          $('.grid-uniform.all-products').attr('data-ajax-loaded', 'true');
          setImagesLoaded($('.grid-uniform.all-products img[loading="lazy"]:not(.loaded)'));
          $('.product-grid-item .product-select.available.multiple-variants' + gt).each(function() {
            new Shopify.OptionSelectors($(this).attr('id'), { product: $(this).data('json'), onVariantSelected: selectCallback, enableHistoryState: false });
          });
        },
        complete: function() {
          $('.collection-main-wrapper .ajax-loader-bottom').removeClass('ajax-loading');
        }
      });
    }

    function update_filtered_products() {
      var all_products = $('.grid-uniform.all-products');
      var filtered_products = $('.grid-uniform.filtered-products');
      var sort_item = $('.collection-filter-item-dropdown ul > li.active > .collection-sort-item-new');

      if (!$('.collection-filters .collection-current-filters ul li').length) {
        all_products.hide();
        filtered_products.hide();
        filtered_products.find('.product-grid-item').each(function() {
          var placeholder = all_products.find('.product-grid-item-placeholder[data-handle="' + $(this).data('handle') + '"]');
          $(this).insertBefore(placeholder);
          placeholder.remove();
        });
        if (!sort_item.length) {
          all_products.show();
          return;
        }
      }

      var filters = {};
      $('.collection-current-filter:not([data-category="sort"])').each(function() {
        var category = $(this).data('category');
        var tag = $(this).data('tag');
        if (!filters[category]) { filters[category] = []; }
        filters[category].push(tag);
      });

      var url = '//' + location.host + location.pathname + '?view=json' + (sort_item.length ? '&sort_by=' + sort_item.data('sort-type') : '');

      $.ajax({
        type: 'GET',
        url: url,
        beforeSend: function() {
          $('.collection-main-wrapper .ajax-loader-top').addClass('ajax-loading');
          all_products.hide();
          filtered_products.hide();
          filtered_products.find('.product-grid-item').each(function() {
            var placeholder = all_products.find('.product-grid-item-placeholder[data-handle="' + $(this).data('handle') + '"]');
            $(this).insertBefore(placeholder);
            placeholder.remove();
          });
        },
        success: function(data) {
          var products = JSON.parse(data);

          if ($.isEmptyObject(filters)) {
            for (var i = 0; i < products.length; i++) {
              var product = all_products.find('.product-grid-item[data-handle="' + products[i].handle + '"]');
              if (product.length) {
                product.after('<div id="' + products[i].id + '" data-handle="' + products[i].handle + '" class="product-grid-item-placeholder"></div>');
                product.appendTo($('.grid-uniform.filtered-products'));
              }
              filtered_products.show();
            }
            return;
          }

          for (var i = 0; i < products.length; i++) {
            var matched = false;
            for (key in filters) {
              matched = false;
              for (var j = 0; j < filters[key].length; j++) {
                for (var k = 0; k < products[i].tags.length; k++) {
                  if (filters[key][j] == products[i].tags[k]) { matched = true; break; }
                }
                if (matched) { break; }
              }
              if (!matched) { break; }
            }
            if (matched) {
              var product = all_products.find('.product-grid-item[data-handle="' + products[i].handle + '"]');
              if (product.length) {
                product.after('<div id="' + products[i].id + '" data-handle="' + products[i].handle + '" class="product-grid-item-placeholder"></div>');
                product.appendTo($('.grid-uniform.filtered-products'));
              }
              filtered_products.show();
            }
          }
        },
        complete: function() {
          $('.collection-main-wrapper .ajax-loader-top').removeClass('ajax-loading');
        },
        error: function() {
          filtered_products.hide();
          filtered_products.find('.product-grid-item').each(function() {
            var placeholder = all_products.find('.product-grid-item-placeholder[data-handle="' + $(this).data('handle') + '"]');
            $(this).insertBefore(placeholder);
            placeholder.remove();
          });
          all_products.show();
        }
      });
    }
  });
}


/* snippets 'product-grid-item', 'product-grid-item-bundle' js */

$(document).ready(function($)
{
  $('.product-grid-item .product-select.available.multiple-variants').each(function()
  {
    new Shopify.OptionSelectors($(this).attr('id'), { product: $(this).data('json'), onVariantSelected: selectCallback, enableHistoryState: false });
  });
});


/* section 'product-template-new' js */

if ($('body.template-product').length)
{
  if ($('.engrvOptions').length)
  {
    $(document).ready(function()
    {
      var mmtopx = 3.779528;
      var caseSixe = $('.engrvOptions .demoHTMLContainer').data('size');
      var proSize = Number(caseSixe - 3);
      var textAvailSize = (caseSixe - 3)/2;

      $('.engrvOptions .demoHTMLContainer').height(mmtopx*proSize).width(mmtopx*proSize);

      var abnew = mmtopx*proSize/2;
      var abnew = abnew*1.4142;

      $('.engrvOptions .demoVisiblePart').height(abnew).width(abnew).css('margin-top',(mmtopx*textAvailSize/4)+mmtopx);

      $('.productEngvBtn button').on('click',function(e) {
        e.preventDefault();
        $('.engrvOptions').show();
        var hea = $('.header-container').height() + $('.stickyAddtoCart').height();
        var goto = $('.engrvOptions').offset().top - hea;
        //if ($(window).width() < 768) {
          //$('.stickyAddtoCart').addClass('hide');
        //}
        $('html, body').animate({ scrollTop: goto }, 'slow'); 
      });
      $('#customizeSectionEngraveWatchButton').on('click',function(e) {
        e.preventDefault();
        $('.engrvOptions').hide();
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        $('.isEngraving').val('').attr('disabled','disabled');
        $('.engErr').remove();
        if ($(window).width() < 768) {
          $('.stickyAddtoCart').removeClass('hide');
        }
      });
    });
  }

  if ($('.pro_desc_slider, .pro_desc_video').length)
  {
    $(window).on('load', function()
    {
      $('#see-it-styled').show();
    });
  }

  // Custom inventory script

  $(function()
  {
    $('.new-prdt a.pro-link[href*="#"], .new-prdt a.product-short-description-link[href*="#"]').on('click', function (e) {   
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top-100
      }, 500);
    });

    function randomIntFromInterval(min, max) { // min and max included
      var product_id =  $('body').data('product-id');
      var rnd_number =  Math.floor(Math.random() * (max - min + 1) + min);
      if ($.cookie('setQty1_' + product_id)) { 
        $('.stock-text').html('ONLY <span class="rnd-number">'+$.cookie('setQty1_' + product_id)+'</span> REMAINING');
      } else { 
        $('.stock-text').html('ONLY <span class="rnd-number">'+rnd_number+'</span> REMAINING');
        $.cookie('setQty1_' + product_id, rnd_number, { expires: 1, path: '/' });
      }
    }
    randomIntFromInterval(7, 35);

    /*
    $('.nav-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.js-product-zoom-slider',
      swipeToSlide: true,
      infinite: true,
      dots: false,
      arrows: true,
      centerMode: true,
      focusOnSelect: true
    });
    */
  });

  // Klaviyo VC Tracking Pixel

  window._learnq = window._learnq || [];

  window._learnq.push(['track', 'Viewed Product', window.trackViewedItem]);
  window._learnq.push(['trackViewedItem', {
    Title: window.trackViewedItem.Name,
    ItemId: window.trackViewedItem.ProductID,
    Categories: window.trackViewedItem.Categories,
    ImageUrl: window.trackViewedItem.ImageURL,
    Url: window.trackViewedItem.URL,
    Metadata: {
      Brand: window.trackViewedItem.Brand,
      Price: window.trackViewedItem.Price,
      CompareAtPrice: window.trackViewedItem.CompareAtPrice
    }
  }]);

  
  /* snippet 'extend-product-integration.liquid' (custom) */
  
  window.addEventListener('DOMContentLoaded', function() {
    // initial isUsd bool check
    var isUsd = true;

    window.setTimeout(function() {
      // grabbing currency-code from pdp price
      var currencyCheck = document.querySelector('.currency-code');
      // if !currencyCheck then the page should be in USD and we can display offers otherwise its not USD and we return
      var isUsd = (!currencyCheck ? true : false);

      if (window.Shopify.currency.active === 'USD' && isUsd === true) {
        function extendProductMain(startTime) {
          if (!(window.Extend && window.ExtendShopify)) {
            if (new Date() - startTime < 10000)
              setTimeout(function() { extendProductMain(startTime); }, 100);
            return;
          }

          // initial variables
          var productForm = document.querySelector('form[action="' + window.routes.cartAddUrl + '"]');
          var addToCartButton = productForm.querySelector('button[name="add"]');  
          var extendOffer = productForm.querySelector('#extend-offer');

          function findAll(element) {
            var items = document.querySelectorAll(element);
            return items ? Array.prototype.slice.call(items, 0) : [];
          }

          function initProductOffer() {
            // fail safes
            if (!productForm || !addToCartButton || !extendOffer) return;

            function isExtend() {
              if (meta.product && meta.product.vendor == "Extend") {
                addToCartButton.disabled = true;
              }
            }

            // Checks if product is an Extend warranty and if so disables 
            isExtend();

            // variant change event listener
            window.addEventListener('variantChange', function () {
              var urlParams = new URLSearchParams(window.location.search);

              window.setTimeout(function() {
                var variantId = productForm.id.value;

                if (variantId) {
                  Extend.setActiveProduct('#extend-offer', variantId);
                  isExtend();
                }
              }, 250);
            });

            var firstVariant = productForm.id.value;
            Extend.buttons.render(extendOffer, {referenceId: firstVariant });

            // finds all color variant elements on a products page and listens for a click on each one
            // Ken - causes the widget to flash/reload and is apparently unnecessary
            //findAll('.swatch label').forEach(function(color) {
              //color.addEventListener('click', function() {
                //dispatchEvent(Extend.CustomEvent('variantChange'));
              //});
            //});

            function handleAddToCart(e) {
              e.preventDefault();
              e.stopPropagation();

              var quantityEl = productForm.querySelector('[name="quantity"]');
              var quantity = quantityEl && quantityEl.value;

              ExtendShopify.handleAddToCart("#extend-offer", {
                quantity: quantity,
                modal: false,
                done: function () {
                  addToCartButton.removeEventListener("click", handleAddToCart, true);
                  addToCartButton.click();
                  addToCartButton.addEventListener("click", handleAddToCart, true);
                }
              });
            }

            addToCartButton.addEventListener("click", handleAddToCart, true);
          }

          // initial product offer render
          initProductOffer();
        }

        if ($(window).width() > 767) {
          $(window).on('mousedown.extend mousemove.extend touchstart.extend keydown.extend scroll.extend', function() {
            $(this).off('.extend');
            extendProductMain(new Date());
          });
        }
        else {
          $(window).one('scroll.extend', function() {
            initExtend(function() { return extendProductMain(new Date()); });
          });
        }
      }
    }, 1250);
  });
  
}


/* 'page-(mens|womens|...)-gift-guide-template' js, page-earth-day-template' js */

if ($('body.template-page .gift-guide').length || $('body.template-page .earth-day').length)
{
  if ($('.custom_own').length)
  {
    $(document).ready(function()
    {
      var mmtopx = 3.779528;
      var caseSixe = 45;
      var proSize = Number(caseSixe - 3);
      var textAvailSize = (caseSixe - 3)/2;

      $('.engrvOptions .demoHTMLContainer').height(mmtopx*proSize).width(mmtopx*proSize);

      var abnew = mmtopx*proSize/2;
      var abnew = abnew*1.4142;

      $('.engrvOptions .demoVisiblePart').height(abnew).width(abnew).css('margin-top',(mmtopx*textAvailSize/4)+mmtopx);

      $('.gen').on('click',function(e) {
        e.preventDefault();
        $('.error').hide();
        $('.gen').closest('.col-half').removeClass('show_add');
        $(this).closest('.col-half').addClass('show_add');
        //$('.btnNext').removeClass('highlight');
        $(this).closest('.collec_list').find('.btnNext').addClass('highlight');
      });

      $('.select_b').on('click',function(e) {
        e.preventDefault();
        //$('.btnNext').removeClass('highlight');
        $(this).closest('.collec_list').find('.btnNext').addClass('highlight');
        $('.error').hide();
        $('.select_b').closest('.col-half').removeClass('show_add');
        $(this).closest('.col-half').addClass('show_add');
        if ($(this).closest('.show_add').find('.select_b').hasClass('lucky')) {
          $('.btn_text').attr('data-href', 'section-7');
          $('.btn_text').addClass('feeling_lucky');
        } else {
          $('.btn_text').attr('data-href', 'section-3');
          $('.btn_text').removeClass('feeling_lucky');
        }
      });

      $('.productEngvBtn button').on('click',function(e) {
        e.preventDefault();
        $('.engrvOptions').show();
        $('.feel_addtocart').show();
        $('.feel_addtocart').text('Add to cart').removeAttr('disabled','disabled');
        $('#section-4').show().addClass('active_custom');
        $('#section-4 .flex-row').hide();
        $('.customactive .watch_pro .category-item-box').addClass('show_add');
        $('.overlay').addClass('active');
        $('body').addClass('open_model');
        var hea = $('.header-container').height() + $('.stickyAddtoCart').height();
        var goto = $('.engrvOptions').offset().top - hea;
        if ($(window).width() < 768) {
          $('.stickyAddtoCart').addClass('hide');
        }
        $('html, body').animate({ scrollTop: goto }, 'slow'); 
      });

      function showPrev(anchor, gender) {
        $('.inner_block').hide();
        $('.'+gender).show();
        $('.last_section .'+gender).addClass('customactive');

        $('.tab').hide();
        $('#'+anchor).show("slide");

        $('.nav-tabs li').removeClass('active');
        $('.'+anchor).addClass('active');
        $('.nav-tabs > .active').next('li').removeClass('finish');
        $('.nav-tabs > .active').removeClass('next_d');
        $('.nav-tabs > .active').next('li').addClass('next_d');
      }
      function showNext(anchor, gender) {
        $('.inner_block').hide();
        $('.'+gender).show();
        $('.last_section .'+gender).addClass('customactive');

        $('.tab').hide();
        $('#'+anchor).show("slide");

        $('.nav-tabs > .active').addClass('finish');
        $('.nav-tabs li').removeClass('active');
        $('.'+anchor).addClass('active');
        $('.nav-tabs > .active').removeClass('next_d');
        $('.nav-tabs > .active').next('li').addClass('next_d');

        $('#done_block').html(' ');
        if (anchor == 'section-7') {
          $('.show_add').each(function() {
            var get_h = $(this).find('.grid-product__wrapper').html();
            $('#done_block').append(get_h);
          });
        }
      }

      $('.btnNext').click(function(e) {
        e.preventDefault();
        var anchor = $(this).attr('data-href');
        var gender = $('.show_add .gen').attr('data-gender');
        if ($('.'+anchor).next('li').hasClass("active")) {
          showPrev(anchor,gender);
        } else {
          if ($(this).closest('.tab').hasClass('collec_list')) {
            if ($(this).closest('.tab').find('.show_add').length > 0) {
              showNext(anchor,gender);
              $('.error').hide();
            } else {
              e.preventDefault();
              $(this).closest('.tab').find('.error').show();
            }

          } else if ($(this).closest('.tab').hasClass('engrvOptions')) {
            if ($('#section-4 .engInputTextBox').val() != '') {
              showNext(anchor,gender);
              $('.error').hide();
            } else {
              e.preventDefault();
              $(this).closest('.tab').find('.error').show();
            }
          } else {
            showNext(anchor,gender);
          }
        }
        //$('html, body').animate({ scrollTop: $('.gift_box').offset().top - 300 }, 500);
      });
      $('body').on('click','.tab .main_inner',function(e) {
        e.preventDefault();
        var id = $(this).closest('.collec_list').attr('id');
        $('#'+id).find('.category-item-box').removeClass('show_add');
        $(this).closest('.category-item-box').addClass('show_add');
        //$('.btnNext').removeClass('highlight');
        $(this).closest('.collec_list').find('.btnNext').addClass('highlight');
        $('.error').hide();
      });
      $('body').on('click','.feeling_lucky',function(e) {
        $('.all_done').hide();
        $('.last_section').show();
        $('.nav-tabs li').addClass('finish');
        $('.step').removeClass('active');
        $('.section-7').addClass('active');
      });

      $('.custom-text .engInputTextBox').on('keyup', function() {
        $('.show_add .engInputTextBox').val($(this).val());
        //$('.btnNext').removeClass('highlight');
        $(this).closest('.engrvOptions').find('.btnNext').addClass('highlight');
      });
      $('.custom-text  .engFontStyle').change(function() {
        $('.show_add .engFontStyle').val($(this).val()).trigger('change');
      });
    });
  }

  if ($('.product-gift').length)
  {
    $(document).ready(function()
    {
      $('.btn_add_cart_both').each(function() {
        $(this).off('click').on('click', function(event) {
          //$(this).closest('.product-gift-item-products').find('form').submit();
          $(this).closest('.product-gift-item-qv-inner').find('form').first().submit();
          var secondForm = $(this).closest('.product-gift-item-qv-inner').find('form').last();
          setTimeout(function() {
            console.log( secondForm );
            secondForm.submit();
          }, 250);
          event.preventDefault();
        });
      });
      $('.product-gift-item-inner').off('click').on('click', function(event) {
        event.preventDefault();
        // scroll to quickview
        var scrollToItem = $(($('.gotoSection.active').length ? '.active_t ' : '') + '.product-gift-inner');
        $('html, body').animate({
          //scrollTop: scrollToItem.offset().top + scrollToItem.height() - 70
          scrollTop: scrollToItem.offset().top + scrollToItem.height() - $('.header-container').height()
        }, 350);
        var $giftClick = $(this);
        var left = $giftClick.offset().left + ($giftClick.outerWidth()/2) - 16;
        $('head').append('<style id="arrow-styles3">#landing-page .product-gift .product-gift-item-qv .product-gift-item-qv-inner:before, #landing-page .product-gift .product-gift-item-qv .product-gift-item-qv-inner:after {left: '+left+'px;}</style>');
        var index = $(this).attr("data-index");
        $('.product-gift-item-qv').hide();
        $('.product-gift-item-qv-'+index).show();
        if( $(window).width() < 768 ) {
          $('.product-gift-item-qv-lifestyle-'+index).flickity({
            pageDots: false,
            imagesLoaded: true,
            cellAlign: 'left',
            wrapAround: true,
            dragThreshold: 10,
            selectedAttraction: 0.2,
            friction: 0.8,
            arrowShape: {
              x0: 10,
              x1: 60, y1: 50,
              x2: 60, y2: 45,
              x3: 15
            }
          });
        }
        // Remove quickshop window
        $('.gift-prod-view-close').off('click').on('click', function(e) {
          $('html, body').animate({
            scrollTop: $(this).offset().top - 600
          }, 350);
          $('.product-gift-item-qv').hide();
          $('#arrow-styles3').remove();
          e.preventDefault();
        });
      });
    });
  }

  $(document).ready(function()
  {
    if ($('.gotoSection.active').length)
    {
      var c = $('.gotoSection.active').attr('data-id');
      var container = $(c + ', ' + c + '+ .product-gift, ' + c + ' + .product-gift + .collection-feature');
      var slider = container.find('.slick-slider');
      container.addClass('active_t').show();
      if (slider.length) { slider.slick('setPosition'); }
    }
    $('.gotoSection').on('click', function(e) {
      e.preventDefault();
      $('.gotoSection').removeClass('active');
      $(this).addClass('active');
      var c = $(this).attr('data-id');
      $('.toogleStyle, .toogleStyle + .product-gift, .toogleStyle + .product-gift + .collection-feature').removeClass('active_t').hide();
      var container = $(c + ', ' + c + '+ .product-gift, ' + c + ' + .product-gift + .collection-feature');
      var slider = container.find('.slick-slider');
      container.addClass('active_t').show();
      if (slider.length) { slider.slick('setPosition'); }
      var fd = $(c).offset();
      //$('html, body').animate({ scrollTop: fd.top - 75 }, 'slow');
      $('html, body').animate({ scrollTop: fd.top - $('.header-container').height() }, 'slow');
    });
  });
}


/* section 'page-new-landing-template(2|10|13|25|-collections|...)', 'page-(mens|womens|...)-gift-guide-template' js, page-earth-day-template' js */

if ($('body.template-page .landing-template').length || $('body.template-page .gift-guide').length || $('body.template-page .earth-day').length)
{
  if ($('.page-wood_type').length)
  {
    $(document).ready(function()
    {
      $('.arrowdowntfwrap').click(function(event) {
        event.preventDefault();
        //var scrollpx = $('#section-1509362942343').offset().top;
        var scrollpx = $(this).closest('.page-wood_type').offset().top;
        $('html, body').animate({
          //scrollTop: scrollpx - 82
          scrollTop: scrollpx - $('.header-container').height()
        }, 800);
      });

      $('.wood-type-item-inner').off('click');

      $(document).on('click', '.wood-type-item-inner', function(event) {
        event.preventDefault();
        // scroll to quickview
        $('html, body').animate({
          scrollTop: $(this).offset().top - 0
        }, 350);
        var $prodClick = $(this);
        var collection = $(this).data('collection');
        var justProduct = $(this).data('just-product');
        $('.woodTypeProduct').hide();
        if (justProduct && collection) {
          var container = $('.woodTypeProduct#' + collection);
          var slider = container.find('.slick-slider');
          container.show();
          if (slider.length) { slider.slick('setPosition'); }
        }
        var left = $prodClick.offset().left - 16;

        if (!theme.cache.$html.hasClass('lt-ie9')) {
          enquire.register(theme.variables.mediaQueryMediumDown, {
            match: function() {
              // Quickview
              left = $prodClick.offset().left + ($prodClick.outerWidth() / 2)
            },
            unmatch: function() {
              // Re-init offset to show quickview
              left = $prodClick.offset().left - 16;
            }
          });
        }

        $('head').append('<style id="arrow-styles2">#shopify-section-page-new-landing-template .page-wood_type .wood-type-view .wood-type-view-inner:after, #shopify-section-page-new-landing-template .page-wood_type .wood-type-view .wood-type-view-inner:before {left: ' + left + 'px;}</style>');
        var html = $(this).siblings('.wood-type-view').clone();
        $('.quick-type-view').html(html).find('.wood-type-view').show();

        // Remove quickshop window
        $('.wood-type-view-close').off('click').on('click', function(e) {
          $('html, body').animate({
            scrollTop: $(this).offset().top - 600
          }, 350);
          $('.quick-type-view').empty();
          $('.woodTypeProduct').hide();
          $('#arrow-styles2').remove();
          e.preventDefault();
        });
      });
    });
  }

  if ($('.custom-tabs').length)
  {
    $(document).ready(function()
    {
      // 1st carousel, main
      //$('.custom-tab-content').flickity({
        //prevNextButtons: true,
        //pageDots: false
      //});
      // 2nd carousel, navigation
      //$('.custom-tab-header').flickity({
        //asNavFor: '.custom-tab-content',
        //imagesLoaded: true,
        //prevNextButtons: false,
        //contain: true,
        //pageDots: false
      //});
      $('.custom-tab-content').slick({
        infinite: false,
        speed: (window.isChromeMobile ? 150 : 300),
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.custom-tab-header',
        arrow: true,
        nextArrow:'<button type="button" data-role="none" class="slick-next-custom slick-arrow" aria-label="Next" role="button" style="display: block;" aria-disabled="false"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        prevArrow:'<button type="button" data-role="none" class="slick-prev-custom slick-arrow slick-disabled" aria-label="Previous" role="button" aria-disabled="true" style="display: block;"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow"></path></svg></button>',
        focusOnSelect: true
      });
      $('.custom-tab-header').slick({
        infinite: false,
        speed: (window.isChromeMobile ? 150 : 300),
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.custom-tab-content',
        arrow: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
  }

  if ($('.custom-gallery').length)
  {
    $(document).ready(function()
    {
      if ($(window).width() < 768)
      {
        //$('.custom-gallery-wrap').flickity({
          //prevNextButtons: true,
          //imagesLoaded: true,
          //contain: true,
          //pageDots: false
        //});
        $('.custom-gallery-wrap').slick({
          infinite: false,
          speed: (window.isChromeMobile ? 150 : 400),
          slidesToShow: 1,
          slidesToScroll: 1,
          arrow: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrow: true,
                nextArrow:'<button class="flickity-prev-next-button next" type="button" aria-label="next"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
                prevArrow:'<button class="flickity-prev-next-button previous" type="button" aria-label="previous" disabled><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>'
              }
            }
          ]
        });
        $('.custom-gallery-wrap').on('beforeChange', function(event, slick, currentSlide, nextSlide)
        {
          $(this).find('.flickity-prev-next-button.previous').prop('disabled', (!nextSlide ? true : false));
          $(this).find('.flickity-prev-next-button.next').prop('disabled', (nextSlide >= slick.slideCount - slick.options.slidesToShow ? true : false));
        });
      }
    });
  }
}


/* section 'page-review-template' js */

if ($('body.template-page .page-reviews').length)
{
  $('.instagram-images').prepend('<script src="//foursixty.com/media/scripts/fs.embed.v2.5.js" data-feed-id="tigfit-bands_1" data-theme="showcase_v2_5" data-page-size="9"></script>');

  $('.reviews-filter-by select').on('change', function() {
    var review_count = $(this).val();
    var currentCollection = $('.review-collection-item.active').attr('data-handle');

    //$('#stamped-reviews-widget').attr('data-rating', review_count);
    //$('#stamped-reviews-widget').attr('data-min-rating', 1);
    $('.review-listing-'+currentCollection+' #stamped-reviews-widget').attr('data-rating', review_count);
    $('.review-listing-'+currentCollection+' #stamped-reviews-widget').attr('data-min-rating', 1);

    $('.review-listing-'+currentCollection+' #stamped-reviews-widget').data('rating', review_count);
    $('.review-listing-'+currentCollection+' #stamped-reviews-widget').data('min-rating', 1);

    setTimeout(function() {
      StampedFn.pageWidget($('.review-listing-'+currentCollection+' #stamped-reviews-widget'));
    }, 0);

    console.log($('.review-listing-'+currentCollection+' #stamped-reviews-widget'));
  });
}


/* section 'product-newsletter' js */



if ($('#email_signup, #password_signup').length)
{
  $.getScript('//www.klaviyo.com/media/js/public/klaviyo_subscribe.js', function()
  {
    if ($('#email_signup').length)
    {
      KlaviyoSubscribe.attachToForms('#email_signup', {
        hide_form_on_success: true,
        success_message: "Thank you for Subscribing!",
        success: function ($form) {
          $('#email_signup .form-field').hide();
        }
      });
    }
    if ($('#password_signup').length)
    {
      KlaviyoSubscribe.attachToForms('#password_signup', {
        hide_form_on_success: true,
        success_message: "Check your inbox - we've sent you your exclusive password",
        success: function ($form) {
          $('#password_signup .input-group').hide();
        }
      });
    }
  });
}


/* section 'footer' js */

//$.getScript('https://widget.sezzle.com/v1/javascript/price-widget?uuid=55556334-5b63-45ee-bfb2-92e80dc41847');


if ($(window).width() > 1299)
{

/* section 'main-menu' js */

$('#PageContainer > *:not(#shopify-section-header)').on('mouseenter', function() {
  $('.site-nav .site-nav__item.has-mega-menu-2').removeClass('active');
});
  
$('.site-nav .site-nav__item.has-mega-menu-2').on('mouseenter', function() {
  $('.site-nav .site-nav__item.has-mega-menu-2').not($(this)).removeClass('active');
  $(this).addClass('active');
});

$('.mega-menu-2 .mega-menu-2-link').on('mouseenter', function() {
  var menu = $('.mega-menu-2[data-item="' +  $(this).closest('.mega-menu-2').data('item') + '"]');
  var link = $(this);
  var content = menu.find('.mega-menu-2-content[data-id="' +  $(this).data('id') + '"]');
  menu.find('.mega-menu-2-link').not(link).removeClass('active');
  menu.find('.mega-menu-2-content').not(content).removeClass('active');
  link.addClass('active');
  content.addClass('active');
  if (content.filter('.large-content').length)
    menu.addClass('show-large-content');
  else
    menu.removeClass('show-large-content');
});

$(window).one('mousemove', function() {
  
  $('.site-nav .site-nav__item.has-mega-menu-2 img[loading="lazy"]').attr('loading', 'eager');
});

}
else
{

/* section 'mobile-menu' js */

$(document).ready(function() {
  
  if ($('.mobile-menu-2').length) {
    function setMobileMenu() {
      $('.mobile-menu-2-modal').css({
        'top': $('#sticky-wrapper').outerHeight() + 'px',
        'height': window.innerHeight - $('#sticky-wrapper').outerHeight() + 'px'
      });
    }
    function toggleMobileMenu() {
      if ($('.mobile-menu-2:not(:visible)').length) {
        $('.mobile-menu-2:not(:visible)').show();
        
        $('.mobile-menu-2-nav-link img[loading="lazy"]').attr('loading', 'eager');
        setTimeout(function() {
          toggleMobileMenuContinue();
        }, 100);
      }
      else {
        toggleMobileMenuContinue();
      }

      function toggleMobileMenuContinue() {
        if ($('.mobile-menu-2:not(.active)').length) {
          //setMobileMenu();

          $('body').addClass('mobile-menu-2-open');
          $('.mobile-menu-2').addClass('active');
          $('.mobile-menu-2-dropdown-menu').removeClass('active');
        }
        else {
          $('body').removeClass('mobile-menu-2-open');
          //$('.mobile-menu-2').addClass('transitioning');
          $('.mobile-menu-2').removeClass('active');
          $('.mobile-menu-2-dropdown-menu').removeClass('active');
        }
      }
    }
    $(window).on('load resize scroll', function() {
      setTimeout(function() {
        setMobileMenu();
      }, 500);
    });
    $('.mobileNavBtn').on('click', function() {
      toggleMobileMenu();
    });
    $('.mobile-menu-2-nav-item.has-dropdown .mobile-menu-2-nav-link, .mobile-menu-2-dropdown-item.has-dropdown .mobile-menu-2-dropdown-link').on('click', function() {
      $(this).siblings('.mobile-menu-2-dropdown-menu').addClass('active');
    });
    $('.mobile-menu-2-dropdown-menu .mobile-menu-2-back').on('click', function() {
      $(this).closest('.mobile-menu-2-dropdown-menu').removeClass('active');
    });
    $(document).on('click', function(event) {
      if ($('.mobile-menu-2.active').length && !$(event.target).closest('.mobileNavBtn').length && !$(event.target).closest('.mobile-menu-2.active .mobile-menu-2-modal').length) {
        toggleMobileMenu();
      }
    });
    /*
    $('.mobile-menu-2 .mobile-menu-2-modal').on('transitionstart', function() {
      $(this).closest('.mobile-menu-2').addClass('transitioning');
    });
    $('.mobile-menu-2 .mobile-menu-2-modal').on('transitionend', function() {
      $(this).closest('.mobile-menu-2').removeClass('transitioning');
    });
    */
  }
});

}


/* snippet cartHoverModel.liquid */

function cartHoverModel()
{
  //const start = new Date();

  
  $('#crt img[loading="lazy"]').attr('loading', 'eager');

  if ($('#crt .sgcol_loop:not(.slick-initialized), #crt .brcol_loop:not(.slick-initialized)').length)
  {
    $('#crt .swatch .swatch-element.available').each(function()
    {
      $('#crt .swatch[data-option-index="' + $(this).closest('.swatch').data('option-index') + '"] .' + $(this).data('handle') + '').removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
    });
  }

  $(document).ready(function()
  {
    function setFreeShippingBar()
    {
      var container = $('.cart-goal-bar[data-type="free-shipping"]');
      var country_code = $('body').attr('data-country-code');
      var express_shipping_country_codes = container.attr('data-express-shipping-country-codes').split(',');
      var shipping_type = (country_code == 'US' ? 'usa' : (country_code == 'CA' ? 'canada' : (express_shipping_country_codes.includes(country_code) ? 'express' : 'intl')));
      var cart_free_shipping_bar_text = container.find('.cart-goal-bar-text');
      var cart_free_shipping_bar_progress = container.find('.cart-goal-bar-progress');
      var cart_free_shipping_bar_progress_min = container.find('.cart-goal-bar-progress-min');
      var cart_free_shipping_bar_progress_max = container.find('.cart-goal-bar-progress-max');
      var cart_free_shipping_bar_progress_bar = container.find('.cart-goal-bar-progress-bar');

      var line_position = cart_free_shipping_bar_progress_bar.attr('data-line-position-' + shipping_type);
      var shipping_goal_is_complete = (line_position == '100%' ? true : false);

      cart_free_shipping_bar_text.html(cart_free_shipping_bar_text.attr('data-svg-' + (shipping_goal_is_complete ? 'after' : 'before')) + cart_free_shipping_bar_text.attr('data-message-' + shipping_type));
      if (cart_free_shipping_bar_progress.attr('data-show-progress-' + shipping_type) == 'true')
        cart_free_shipping_bar_progress.show();
      else
        cart_free_shipping_bar_progress.hide();
      cart_free_shipping_bar_progress_min.html(cart_free_shipping_bar_progress_min.attr('data-progress-min-' + shipping_type));
      cart_free_shipping_bar_progress_max.html(cart_free_shipping_bar_progress_max.attr('data-progress-max-' + shipping_type));
      cart_free_shipping_bar_progress_bar.css('background-size', line_position + ' 100%');
      if (shipping_goal_is_complete)
        container.addClass('complete');
      else
        container.removeClass('complete');

      container.removeClass('invisible');
    }
    
    function cartCouponAjax(input_val, type)
    {
      $.ajax({
        url: '/checkout' + (type != 'load' ? '?discount=' + encodeURIComponent(input_val) : ''),
        type: 'GET',
        beforeSend: function() {
          if (type == 'apply')
            $('.cart-coupon-form').append('<div class="veil"><div class="underlay"></div><div class="spinner"><div class="dot1"></div><div class="dot2"></div></div></div>');
        },
        complete: function(jqXHR, status) {
          var subtotal, discount;
          subtotal = discount = 0;
          if (status == 'success')
          {
            var html = $($.parseHTML(jqXHR.responseText));
            var subtotal_line = html.find('.total-line--subtotal');
            var reduction_line = html.find('.total-line--reduction');
            var subtotal_amount = subtotal_line.find('[data-checkout-subtotal-price-target]');
            var subtotal_amount_text = subtotal_amount.text().trim();
            var reduction_code = reduction_line.find('.reduction-code__text');
            var reduction_code_text = reduction_code.text().trim();
            var reduction_amount = reduction_line.find('[data-checkout-discount-amount-target]');
            var reduction_amount_text = reduction_amount.text().trim().replace(/^(\-)(\s+)(.*)$/, '$1$3');
            if (reduction_line.length &&
                reduction_code.length &&
                (type == 'load' || reduction_code_text.toUpperCase() == input_val.toUpperCase()) &&
                reduction_amount.length)
            {
              subtotal = subtotal_amount.data('checkout-subtotal-price-target');
              discount = reduction_amount.data('checkout-discount-amount-target');
              var discount_name = Math.floor(discount / subtotal * 100) + '% Off';
              var discount_amount = '-' + Shopify.formatMoney(discount, $('body').attr('data-money')).replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim();
              $('#crt').attr('data-discount-applied-code', reduction_code_text);
              $('#crt').attr('data-discount-applied-name', discount_name);
              $('#crt').attr('data-discount-applied-amount', discount_amount);
              $('#crt form input[name="discount"]').val(reduction_code_text);
              $('.cart-coupon-input').addClass('applied');
              $('.cart-coupon-code').text(reduction_code_text);
              $('.cart-coupon-discount, .cart-coupon-promo-name').text(discount_name);
              $('.cart-coupon-promo-discount').text(discount_amount);
              $('.cart-coupon-info').show();
            }
          }
          else if (status == 'error' && jqXHR.status == 409)
          {
            $('.cart-coupon-box .veil').remove();
            return;
          }
          if (type == 'apply')
          {
            $('.cart-coupon-error').hide();
            if (discount)
            {
              $('#crt').attr('data-discount-error-type', '');
            }
            else
            {
              $('#crt').attr('data-discount-error-type', 'invalid');
              $('.cart-coupon-error.cart-coupon-error-invalid').show();
            }
            $('.cart-coupon-input').val('');
          }
          refreshCartDrawer();
          $('.cart-coupon-box .veil').remove();
        }
      });
    }

    if ($('.cart-goal-bar[data-type="free-shipping"]').length) { setFreeShippingBar(); }

    if (!$('.cartDrawer .draweAddOns .dr_pro_item .single-option-selector').length)
    {
      $('.cartDrawer .draweAddOns .dr_pro_item .product-select').each(function()
      {
        new Shopify.OptionSelectors($(this).attr('id'), { product: $(this).data('json'), onVariantSelected: selectCallbackCart, enableHistoryState: false });
      });
    }

    if ($('.cart-coupon-box').length)
    {
      if ($('#crt').attr('data-discount-show') && $('#crt').attr('data-discount-show') == 'true')
      {
        $('.cart-coupon-label').addClass('active');
        $('.cart-coupon-content').show();
      }

      if ($('#crt').attr('data-discount-code') && $('#crt').attr('data-discount-code') != '')
      {
        $('.cart-coupon-input').val($('#crt').attr('data-discount-code'));
      }

      if ($('#crt').attr('data-discount-error-type') && $('#crt').attr('data-discount-error-type') != '')
      {
        $('.cart-coupon-error').hide();
        if ($('#crt').attr('data-discount-error-type') == 'missing')
          $('.cart-coupon-error.cart-coupon-error-missing').show();
        else if ($('#crt').attr('data-discount-error-type') == 'invalid')
          $('.cart-coupon-error.cart-coupon-error-invalid').show();
      }

      if ($('#crt').attr('data-discount-applied-code') && $('#crt').attr('data-discount-applied-code') != '' &&
         $('#crt').attr('data-discount-applied-name') && $('#crt').attr('data-discount-applied-name') != '' &&
         $('#crt').attr('data-discount-applied-amount') && $('#crt').attr('data-discount-applied-amount') != '')
      {
        $('.cart-coupon-input').addClass('applied');
        $('#crt form input[name="discount"]').val($('#crt').attr('data-discount-applied-code'));
        $('.cart-coupon-code').text($('#crt').attr('data-discount-applied-code'));
        $('.cart-coupon-discount, .cart-coupon-promo-name').text($('#crt').attr('data-discount-applied-name'));
        $('.cart-coupon-promo-discount').text($('#crt').attr('data-discount-applied-amount'));
        $('.cart-coupon-info').show();
        cartCouponAjax($('#crt').attr('data-discount-applied-code'), 'reload');
      }
      else
      {
        cartCouponAjax(null, 'load');
      }

      $('.cart-coupon-label').on('click', function()
      {
        $(this).toggleClass('active');
        if ($('.cart-coupon-content:visible').length)
        {
          $('.cart-coupon-content').hide();
          refreshCartDrawer();
          $('.cart-coupon-content').show();
          $('.cart-coupon-content').slideToggle();
        }
        else
        {
          $('.cart-coupon-content').slideToggle(function() { refreshCartDrawer(); });
        }
        $('#crt').attr('data-discount-show', ($(this).hasClass('active') ? 'true' : 'false'));
      });

      $('.cart-coupon-input').on('blur', function()
      {
        var input_val = $(this).val().trim();
        $(this).val(input_val);
        $('#crt').attr('data-discount-code', input_val);
      });

      $('.cart-coupon-apply').on('click', function()
      {
        var input = $('.cart-coupon-input');
        var input_val = input.val().trim();
        input.val(input_val);
        if (!input_val)
        {
          $('.cart-coupon-error').hide();
          $('.cart-coupon-error.cart-coupon-error-missing').show();
          $('#crt').attr('data-discount-error-type', 'missing');
        }
        else
        {
          $('#crt').attr('data-discount-error-type', '');
          cartCouponAjax(input_val, 'apply');
        }
      });

      $('.cart-coupon-remove').on('click', function()
      {
        $('.cart-coupon-info').hide();
        $('.cart-coupon-input').removeClass('applied');
        $('#crt').attr({'data-discount-applied-code': '', 'data-discount-applied-name': '', 'data-discount-applied-amount': ''});
        $('#crt form input[name="discount"]').val('');
        refreshCartDrawer();
      });
    }

    $('.cart__checkout').on('click', function()
    {
      if (!$('.cartLineItem.added, .cart-coupon-input.applied').length && $('body').attr('id') != 'gift-card') { $('input[name="discount"]').remove(); }
      //if (!$(this).hasClass('has-note')) { var note = ''; ShopifyAPI.updateCartNote(note, function() {}); }
    });
  });

  $('.check_select').on('change', function()
  {
    if ($(this).is(':checked'))
      $('#gift-wrapping').val('yes');
    else
      $('#gift-wrapping').val('No');
  });

  /*
  $(function()
  {
    if ($('.sgcol_loop:not(.slick-initialized), .brcol_loop:not(.slick-initialized)').length)
    {
      $('#crt .swatch :radio').on('change', function()
      {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
      });
    }
  });
  */

  $(document).ready(function()
  {
    var mf = $('body').attr('data-money');
    var mf_no_cc = $('body').attr('data-money-no-cc');
    var currency_code = $('body').attr('data-cc');

    var cart_items_container = $('.cartDrawer .quick-items.upsell');
    if (cart_items_container.length)
    {
      var upsell_class = cart_items_container.data('upsell-class');
      var dis = Number(cart_items_container.data('upsell-percent'));
      var wc = Number(cart_items_container.data('watch-count'));
      var ctp = Number(cart_items_container.data('cart-total-price'));
      var g = [];

      cart_items_container.find('.cartLineItem.' + upsell_class).each(function(i, v) {
        g.push(Number($(this).attr('data-item-price')));
      });
      //g.sort();
      g.sort(function(a, b) { return a - b; });

      if (g.length) {
        var tpm = 0;
        $(g).each(function(i, v) {
          var x = g[i];
          $('.' + upsell_class + ':not(.added)[data-item-price="' + x + '"]').each(function() {
            var q = Number($(this).attr('data-lineqty'));
            var lp = Number($(this).attr('data-line-price'));
            if (wc > 0) {
              if (q > wc)
                var sp = (Number($(this).attr('data-item-price')) * wc) * (dis / 100);
              else
                var sp = (Number($(this).attr('data-item-price')) * q) * (dis / 100);

              var newp = lp - sp;
              tpm = tpm + sp;

              var html = '';
              if (lp != newp)
                html += '<span class="compare-price"><span class="money">' + (lp > 0 ? Shopify.formatMoney(lp, mf_no_cc).replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() : 'FREE') + '</span></span>';
              html += '<span class="product-price"><span class="money">' + (newp > 0 ? Shopify.formatMoney(newp, mf).replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(currency_code, '<span class="currency-code">' + currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() : 'FREE') + '</span></span>';
              $(this).find('.pprice').html(html);

              $(this).addClass('added');
              wc = wc - q;
            }
          });
        });
        var cftp = ctp - tpm;
        $('.sgDiscountAmount').html(Shopify.formatMoney(tpm, mf).replace(/^(.*)(\<span class\=[\"|\']*money[\"|\']*\>)(.*)(\<\/span\>)(.*)$/, '$1$3$5').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim());
        $('.cartTotal .right').html(Shopify.formatMoney(cftp, mf).replace(/^(.*)(\<span class\=[\"|\']*money[\"|\']*\>)(.*)(\<\/span\>)(.*)$/, '$1$3$5').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim());
      }
    }

    $('.draweAddOns .drawer-item .drawer-item-toggle').on('click',function()
    {
      $(this).hide();
      var content = $(this).closest('.drawer-item').find('.drawer-item-content');
      var quick_items = $(this).closest('.quick-items');
      content.show();
      content.find('.slick-initialized').slick('refresh');
      quick_items.scrollTop(quick_items[0].scrollHeight);
    });

    $('.draweAddOns .drawer-item .drawer-close').on('click',function()
    {
      var item = $(this).closest('.drawer-item');
      item.find('.drawer-item-toggle').show();
      item.find('.drawer-item-content').hide();
    });

    $('.draweAddOns .dr_pro_item').each(function()
    {
      var price = $(this).data('price');
      var compare_price = $(this).data('compare-price');
      var html = '';
      if (compare_price != price)
        html += '<del class="compare-price"><span class=money>'+(compare_price > 0 ? Shopify.formatMoney(compare_price, mf_no_cc).replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(currency_code, '<span class="currency-code">' + currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() : 'FREE')+'</span></del>';
      html += '<span class="product-price"><span class=money>'+(price > 0 ? Shopify.formatMoney(price, mf).replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(currency_code, '<span class="currency-code">' + currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() : 'FREE')+'</span></span>';
      $(this).find('.sgPrice').html(html);
    });

    $('.getEngPriceLine').each(function()
    {
      var line = $(this);
      var qty = Number(line.attr('data-qty'));
      $.get('/products/add-engrave?view=customData', function(data)
      {
        var s =  JSON.parse(data);
        var op = s.oprice*qty;
        var mf = s.mf;
        line.html('+ ' + Shopify.formatMoney(op, mf).replace(/^(.*)(\<span class\=[\"|\']*money[\"|\']*\>)(.*)(\<\/span\>)(.*)$/, '$1$3$5').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim());
      });
    });
  });

  
  if (window.Shopify.currency.active === 'USD' && $('#crt .quick-items').length)
  {
    if (!(window.Extend && window.ExtendShopify && window.Shopify && window.Shopify.currency))
      initExtend(extendAjaxCart);
    else
      extendAjaxCart();

    function extendAjaxCart()
    {
      /* snippet 'extend-ajax-cart-integration.liquid' (custom) */

      if (window.Extend && window.ExtendShopify && window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'USD') {
        var localCart = {};

        function findAll(elementToFind, parentElement) {
          var items = parentElement ? parentElement.querySelectorAll(elementToFind) : document.querySelectorAll(elementToFind);
          return items;
        }

        function initCartOffer() {
          findAll('#extend-cart-offer').forEach(function(el) {
            var variantId = el.getAttribute('data-extend-variant')
            var quantity = el.getAttribute('data-extend-quantity')

            if (ExtendShopify.warrantyAlreadyInCart(variantId, localCart.items)) { return; }

            if (el.querySelector('#extend-cart-offer div')) { return; }

            Extend.buttons.renderSimpleOffer(el, {
              referenceId: variantId,
              onAddToCart: function (options) {
                ExtendShopify.addPlanToCart(
                  {
                    plan: options.plan,
                    product: options.product,
                    quantity: quantity,
                  },
                  function (err) {
                    // an error occurred
                    if (err) {
                      return;
                    } else {
                      extendHardRefreshCartDrawer();
                    }
                  }
                );
              },
            });
          })

          ExtendShopify.normalizeCart({cart: localCart, balance: true}, function (err, data) {
            if (data && data.updates) {
              extendHardRefreshCartDrawer();
            }
          });
        }

        function extendHardRefreshCartDrawer() {
          $.get(window.routes.cartUrl + '?view=mini', function(data) {
            if ($('#crt .quick-items .draweAddOns').length)
              $('#crt-drawers').html('').append($('#crt .quick-items .draweAddOns'));
            $('#crt').html(data);
            $('#crt .quick-items .draweAddOns-placeholder').each(function()
            {
              $('#crt-drawers .draweAddOns[data-drawer-type="' + $(this).data('drawer-type') + '"]').insertBefore($(this));
              $(this).remove();
            });
            cartHoverModel();
            if ($('.sgcol_loop').length) {
              if ($('.sgcol_loop').hasClass('slick-initialized')) {
                $('.sgcol_loop').slick('refresh');
              } else {
                $('.sgcol_loop').slick();
              }
            }
            if ($('.brcol_loop').length) {
              if ($('.brcol_loop').hasClass('slick-initialized')) {
                $('.brcol_loop').slick('refresh');
              } else {
                $('.brcol_loop').slick();
              }
            }
            refreshCartDrawer();
          });
        }

        $.getJSON(window.routes.cartUrl + '.js', function(data)
        {
          localCart = data;
          initCartOffer();
        });
      }
    }
  }
  

  //const end = (Date.now() - start) / 1000;
  //console.log('cartHoverModel(): ' + end + ' seconds');
}

$(document).ready(function()
{
  cartHoverModel();
  setTimeout(function() {
    $('.js-drawer-toggle-right').removeClass('disabled');
  }, 100);
  if ($('.home-featured-products, .related-products .products-grid').length)
    featuredProductsModel(false);
});

$(window).on('pageshow', function(event)
{
  if ($('body.template-cart').length) { return; }
  var historyTraversal = event.persisted || (typeof window.performance != 'undefined' && window.performance.navigation.type === 2);
  if (historyTraversal) {
    $.get(window.routes.cartUrl + '?view=mini', function(data) {
      if ($('#crt .quick-items .draweAddOns').length)
        $('#crt-drawers').html('').append($('#crt .quick-items .draweAddOns'));
      $('#crt').html(data);
      $('#crt .quick-items .draweAddOns-placeholder').each(function()
      {
        $('#crt-drawers .draweAddOns[data-drawer-type="' + $(this).data('drawer-type') + '"]').insertBefore($(this));
        $(this).remove();
      });
      cartHoverModel();
      setTimeout(function() {
        if ($('.sgcol_loop').length) {
          if ($('.sgcol_loop').hasClass('slick-initialized')) {
            $('.sgcol_loop').slick('refresh');
          } else {
            $('.sgcol_loop').slick();
          }
        }
        if ($('.brcol_loop').length) {
          if ($('.brcol_loop').hasClass('slick-initialized')) {
            $('.brcol_loop').slick('refresh');
          } else {
            $('.brcol_loop').slick();
          }
        }
        refreshCartDrawer();
        $('.js-drawer-toggle-right').removeClass('disabled');
      }, 0);
    });
    if ($('.home-featured-products, .related-products .products-grid').length)
      featuredProductsModel(true);
  }
  
});


/* https://cdn-stamped-io.azureedge.net/files/widget.min.js */

if ($('body.template-product, body.template-page .page-reviews').length)
{
  $('#SearchModal').after('<script async type="text/javascript" id="stamped-script-widget" data-api-key="pubkey-7cm6Lnv7KaVI10AB9G6EY82WUso0m4" src="https://cdn-stamped-io.azureedge.net/files/widget.min.js"></script>');
}


/* <body> js */

/*
window.addEventListener("pageshow", function(event) {
  var historyTraversal = event.persisted || (typeof window.performance != "undefined" && window.performance.navigation.type === 2);
  if (historyTraversal) {
    window.location.reload();
  }
});
*/

/*
jQuery(function() {
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
  });
});
*/

$(function() {
  $(document).on('change', '.swatch :radio', function() {
    var id = $(this).attr('id');
    var radio = (/\-clone$/.test(id) ? $('[id="' + id.replace(/\-clone$/, '') + '"]') : $(this));
    var optionIndex = radio.closest('.swatch').attr('data-option-index');
    var optionValue = radio.val();
    radio.closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
  });
});

var selectCallbackCart = function(variant, selector) {
  //var mf = "";
  var pid = '#ps' + selector.product.id;
  var mf = $('body').attr('data-money');
  var mf_no_cc = $('body').attr('data-money-no-cc');
  var currency_code = $('body').attr('data-cc');
  if (variant) {
    var variant_url = '/products/' + $(pid).data('handle') + '?variant=' + variant.id;
    var upsell_price = variant.price * Number($(pid + ' .sgPrice').closest('.draweAddOns').data('upsell-percent')) / 100;
    $(pid + ' a, ' + pid + '-clone a').attr('href', variant_url);
    $(pid + ' .sgPrice, ' + pid + '-clone .sgPrice').html('<del class="compare-price"><span class=money>' + Shopify.formatMoney(variant.price, mf_no_cc).replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(currency_code, '<span class="currency-code">' + currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</span></del><span class="product-price"><span class=money>' + Shopify.formatMoney(upsell_price, mf).replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(currency_code, '<span class="currency-code">' + currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</span></span>');

    //var form = $('#' + selector.domIdPrefix).closest('form');
    var form = $('[id^="' + $('#' + selector.domIdPrefix).closest('form').attr('id') + '"]');
    var preorder_disabled = (form.find('[data-preorder-disabled="true"]').length ? true : false);
    for (var i = 0, length = variant.options.length; i < length; i++) {
      var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
      if (radioButton.length) {
        //radioButton.get(0).checked = true;
        radioButton.prop('checked', true);
        form.find('.swatch[data-option-index="' + i + '"] .curcolor').html(radioButton.val());
      }
    }
  }
  if (variant && variant.featured_image) {
    //$(pid + ' .productImage, ' + pid + '-clone .productImage').attr('src', Shopify.resizeImage(variant.featured_image.src, 'compact'));
    
    var image = $(pid + ' .productImage, ' + pid + '-clone .productImage');
    if (image.length) {
      var variant_featured_image_src = variant.featured_image.src.replace('https:', '');
      var image_src = Shopify.resizeImage(variant.featured_image.src, 'compact');
      
      image.attr('src', image_src);
    }
  }
  if (variant && variant.available) {
    if (variant.inventory_quantity > 0 || !selector.product.tags.filter(item => item.toLowerCase().indexOf('preorder:') > -1).length || preorder_disabled)
      $(pid + ' .add-to-cart, ' + pid + '-clone .add-to-cart').removeAttr('disabled').removeClass('sold-out').val('Add to cart');
    else
      $(pid + ' .add-to-cart, ' + pid + '-clone .add-to-cart').removeAttr('disabled').removeClass('sold-out').val('Pre Order');
  } else {
    $(pid + ' .add-to-cart, ' + pid + '-clone .add-to-cart').attr('disabled', 'disabled').addClass('sold-out').val('Sold out');
  }
};

var selectCallback = function(variant, selector) {
  //var mf = "";
  var mf = $('body').attr('data-money');
  var mf_no_cc = $('body').attr('data-money-no-cc');
  var currency_code = $('body').attr('data-cc');
  var pid = '#p' + selector.product.id;
  if (variant) {
    if (variant.price < variant.compare_at_price) {
      $(pid + ' .grid-product__price, ' + pid + '-clone .grid-product__price').html('<del class="comparePrice"><span class=money>' + Shopify.formatMoney(variant.compare_at_price, mf_no_cc).replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(currency_code, '<span class="currency-code">' + currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</span></del><span class="originalPrice"><span class=money>' + Shopify.formatMoney(variant.price, mf).replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(currency_code, '<span class="currency-code">' + currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</span></span>');
    } else {
      $(pid + ' .grid-product__price, ' + pid + '-clone .grid-product__price').html('<span class="originalPrice"><span class=money>' + Shopify.formatMoney(variant.price, mf).replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(currency_code, '<span class="currency-code">' + currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</span></span>');
    }

    //var form = $('#' + selector.domIdPrefix).closest('form');
    var form = $('[id^="' + $('#' + selector.domIdPrefix).closest('form').attr('id') + '"]');
    var preorder_disabled = (form.find('[data-preorder-disabled="true"]').length ? true : false);
    for (var i = 0, length = variant.options.length; i < length; i++) {
      var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
      if (radioButton.length) {
        //radioButton.get(0).checked = true;
        radioButton.prop('checked', true);
        form.find('.swatch[data-option-index="' + i + '"] .curcolor').html(radioButton.val());
      }
    }

    var product_options_length = selector.product.options.length;
    var product_options_values = [];

    for (var i = 0; i < product_options_length; i++) {
      var swatch_elements = form.filter('[id="' + form.attr('id').replace(/\-clone$/, '') + '"]').find('.swatch[data-option-index="' + i + '"] .swatch-element');
      product_options_values.push([]);
      swatch_elements.each(function() {
        product_options_values[i].push($(this).attr('data-value'));
      });
    }

    for (var i = 0; i < product_options_length; i++) {
      var variant_options = variant.options.slice();
      for (var j = 0; j < product_options_values[i].length; j++) {
        var variant_title = '';
        variant_options[i] = product_options_values[i][j];
        for (var k = 0; k < variant_options.length; k++)
          variant_title += variant_options[k] + (k < variant_options.length - 1 ? ' / ' : '');
        for (var l = 0; l < selector.product.variants.length; l++) {
          if (selector.product.variants[l]['title'] == variant_title) {
            var swatch_element = form.find('.swatch[data-option-index="' + i + '"] .swatch-element[data-value="' + variant_options[i] + '"]');
            var swatch_element_input = swatch_element.find('input[value="' + variant_options[i] + '"]');
            if (selector.product.variants[l]['available'] == true || (false && swatch_element.hasClass('color'))) {
              swatch_element.addClass('available').removeClass('soldout');
              swatch_element_input.prop('disabled', false);
            }
            else {
              swatch_element.addClass('soldout').removeClass('available');
              swatch_element_input.prop('disabled', true);
            }
          }
        }
      }
    }

    if (form.find('.swatch:not(.slick-initialized)').length && !form.closest('.home-featured-products, .related-products .products-grid').length) {
      form.find('.swatch:not(.slick-initialized)').each(function()
      {
        var is_color = ($(this).hasClass('swatch_color') ? true : false);
        var swatch_elements = $(this).find('.swatch-element');
        if ((is_color && swatch_elements.length > 4) || (!is_color && swatch_elements.length > 2))
        {
          $(this).on('init reInit', function(event, slick, currentSlide)
          {
            var container = $(this);
            setTimeout(function()
            {
              $('#' + container.find(':radio:checked').attr('id').replace(/\-clone$/, '')).change();
            }, 0);
          });
          $(this).slick({
            infinite: true,
            speed: (window.isChromeMobile ? 150 : 300),
            slidesToShow: (is_color ? 4 : 2),
            slidesToScroll: 1,
            arrow: true,
            nextArrow:'<button type="button" data-role="none" class="slick-next-custom slick-arrow" aria-label="Next" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
            prevArrow:'<button type="button" data-role="none" class="slick-prev-custom slick-arrow" aria-label="Previous" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow"></path></svg></button>'
          });
        }
      });
    }
  }
  if (variant && variant.featured_image) {
    var piurl = $(pid + ' .grid-product__image-link').attr('data-href') + '?variant=' + variant.id;
    var variant_featured_image_src = variant.featured_image.src.replace('https:', '');
    var variant_featured_image_src_next = variant_featured_image_src;
    for (i = 0; i < selector.product.images.length; i++) {
      if (variant_featured_image_src == selector.product.images[i]) {
        if (i < selector.product.images.length - 1)
          variant_featured_image_src_next = selector.product.images[i + 1];
        else
          variant_featured_image_src_next = selector.product.images[0];
        break;
      }
    }
    $(pid + ' .grid-product__image-link, ' + pid + '-clone .grid-product__image-link').attr('href', piurl);
    //$(pid + ' .grid-product__image-link:eq(0) .product--image, ' + pid + '-clone .grid-product__image-link:eq(0) .product--image').attr('src', Shopify.resizeImage(variant_featured_image_src, 'large')).attr('data-src', Shopify.resizeImage(variant_featured_image_src, 'large')).attr('srcset', Shopify.resizeImage(variant_featured_image_src, 'large'));
    //$(pid + ' .grid-product__image-link:eq(1) .product--image, ' + pid + '-clone .grid-product__image-link:eq(1) .product--image').attr('src', Shopify.resizeImage(variant_featured_image_src_next, 'large')).attr('data-src', Shopify.resizeImage(variant_featured_image_src_next, 'large')).attr('srcset', Shopify.resizeImage(variant_featured_image_src_next, 'large'));
    if (window.variantRegexSupported) {
      
      var image1 = $(pid + ' .grid-product__image-link:eq(0) .product--image, ' + pid + '-clone .grid-product__image-link:eq(0) .product--image');  
      var image2 = $(pid + ' .grid-product__image-link:eq(1) .product--image, ' + pid + '-clone .grid-product__image-link:eq(1) .product--image');
      if (image1.length) {
        var variant_featured_image_src_match = variant_featured_image_src.match(window.variantRegex1);
        var image1_srcset = image1.attr('srcset').replace(window.variantRegex2, variant_featured_image_src_match[1] + '$2' + variant_featured_image_src_match[2] + '$4');
        
        image1.attr('srcset', image1_srcset);
      }
      if (image2.length) {
        var variant_featured_image_src_next_match = variant_featured_image_src_next.match(window.variantRegex1);
        var image2_srcset = image2.attr('srcset').replace(window.variantRegex2, variant_featured_image_src_next_match[1] + '$2' + variant_featured_image_src_next_match[2] + '$4');
        
        image2.attr('srcset', image2_srcset);
      }
    }
  }
  if (variant && variant.available) {
    if ($(pid + ', ' + pid + '-clone').hasClass('is-sold-out')) {
      $(pid + ', ' + pid + '-clone').removeClass('is-sold-out');
      $(pid + ' .grid-product__image-wrapper .badge.sold-out, ' + pid + '-clone .grid-product__image-wrapper .badge.sold-out').remove();
    }
    if (variant.inventory_quantity > 0 || !selector.product.tags.filter(item => item.toLowerCase().indexOf('preorder:') > -1).length || preorder_disabled)
      $(pid + ' .add-to-cart, ' + pid + '-clone .add-to-cart').removeAttr('disabled').find('span').text('Add to cart');
    else
      $(pid + ' .add-to-cart, ' + pid + '-clone .add-to-cart').removeAttr('disabled').find('span').text('Pre Order');
  } else {
    if (!$(pid + ', ' + pid + '-clone').hasClass('is-sold-out')) {
      $(pid + ', ' + pid + '-clone').addClass('is-sold-out');
      $(pid + ' .grid-product__image-wrapper, ' + pid + '-clone .grid-product__image-wrapper').prepend('<span class="badge sold-out">Sold out</span>');
      $(pid + ' .add-to-cart, ' + pid + '-clone .add-to-cart').attr('disabled', 'disabled').find('span').text('Sold out');
    }
  }
};

$(function() {
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = document.cookie;
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function setDeliveryEstimateMessage()
  {
    var container = $('.delivery-estimate-text');
    var content = container.find('.delivery-estimate-text-content');
    var country_code = $('body').attr('data-country-code');
    var shipping_method = container.attr('data-shipping-method');
    var free_shipping_usa = container.attr('data-free-shipping-usa');
    var free_shipping_canada = container.attr('data-free-shipping-canada');
    var free_shipping_intl = container.attr('data-free-shipping-intl');
    var express_shipping_usa = container.attr('data-express-shipping-usa');
    var express_shipping_canada = container.attr('data-express-shipping-canada');
    var express_shipping_intl = container.attr('data-express-shipping-intl');

    switch(country_code)
    {
      case 'US':
        switch(shipping_method)
        {
          case 'free':
            content.html(free_shipping_usa);
            break;
          case 'express':
            content.html(express_shipping_usa);
            break;
        }
        break;
      case 'CA':
        switch(shipping_method)
        {
          case 'free':
            content.html(free_shipping_canada);
            break;
          case 'express':
            content.html(express_shipping_canada);
            break;
        }
        break;
      default:
        switch(shipping_method)
        {
          case 'free':
            content.html(free_shipping_intl);
            break;
          case 'express':
            content.html(express_shipping_intl);
            break;
        }
    }
    if (!$('.product-form .add-to-cart.pre-order').length) { container.show(); }

    container.find('.swap-text').off('click').on('click', function()
    {
      setDeliveryEstimateMessageSwap(container);
    });

    container.find('.swap-icon').off('click').on('click', function()
    {
      setDeliveryEstimateMessageSwap(container);
    });
  }

  function setDeliveryEstimateMessageSwap(container)
  {
    if (container.attr('data-shipping-method') == 'free')
      container.attr('data-shipping-method', 'express');
    else
      container.attr('data-shipping-method', 'free');
    setDeliveryEstimateMessage();
  }

  /*
  $.getJSON('https://api.ipinfodb.com/v3/ip-country/?key=2466e157b0ad4c8e039bd29eb2b9e1bd9144e012dc94fb9e199cefae4732205d&format=json', function(data) {
    if ($('.delivery-estimate-text').length)
    {
      $('.delivery-estimate-text').attr('data-country-code', data.countryCode);
      setDeliveryEstimateMessage();
    }

    if (getCookie('country_cookie') != 'yes') {
	  var cn = data.countryName.replace(' ', '-');
	  var cc = data.countryCode;
	  //var eurozone = ['Austria','Belgium','Bulgaria','Croatia','Cyprus','Czech-Republic','Estonia','Finland','France','Germany','Greece','Hungary','Ireland','Italy','Latvia','Lithuania','Luxembourg','Malta','Netherlands','Norway','Poland','Portugal','Romania','Slovakia','Slovenia','Spain','Sweden'];
	  var eurozone = ['Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech-Republic', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain'];
	  if ($.inArray(cn, eurozone) != -1) {
	    cn = 'European-Union';
	  }
      $('.currency-box option').removeAttr('selected');
      if ($('.currency-box option[data-country="' + cn + '"]').length) {
        var val = $('.currency-box option[data-country="' + cn + '"]').attr('value');
        $('.currency-box').val(val).trigger('change');
        $('.currency-box option[value="' + val + '"]').attr('selected', 'selected');
        $('.nice-select.currency-box').remove();
        $('.currency-box').niceSelect2();
        setCookie('country_cookie', 'yes', 1);
      }
    }
  });
  */

  $.getJSON('/browsing_context_suggestions.json', function(data) {
    $('body').attr('data-country-code', data.detected_values.country.handle);
    
    if ($('.delivery-estimate-text').length) { setDeliveryEstimateMessage(); }

    if (getCookie('country_cookie') != 'yes') {
	  var cn = data.detected_values.country.name.replace(/\s/g, '-').replace('Hong-Kong-SAR', 'Hong-Kong');
	  var cc = data.detected_values.country.handle;
	  //var eurozone = ['Austria','Belgium','Bulgaria','Croatia','Cyprus','Czech-Republic','Estonia','Finland','France','Germany','Greece','Hungary','Ireland','Italy','Latvia','Lithuania','Luxembourg','Malta','Netherlands','Norway','Poland','Portugal','Romania','Slovakia','Slovenia','Spain','Sweden'];
	  //var eurozone = ['Andorra', 'Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech-Republic', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain'];
	  var eurozone = ['Akrotiri-and-Dhekelia-UK', 'Aland-Islands-Finland', 'Andorra', 'Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech-Republic', 'Estonia', 'Finland', 'France', 'French-Guiana', 'French-Southern-and-Antarctic-Lands', 'Germany', 'Greece', 'Guadeloupe', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Martinique', 'Mayotte', 'Netherlands', 'Poland', 'Portugal', 'Reunion', 'Romania', 'Saint-Barthelemy', 'Saint-Martin', 'Saint-Pierre-and-Miquelon', 'Slovakia', 'Slovenia', 'Spain', 'Vatican-City'];
	  var gbr_countries = ['United-Kingdom', 'Gibraltar', 'Isle-of-Man', 'Jersey'];
      var dkk_countries = ['Denmark', 'Greenland'];
      var aud_countries = ['Australia', 'Norfolk-Island'];
      if ($.inArray(cn, eurozone) != -1)
	    cn = 'European-Union';
      else if ($.inArray(cn, gbr_countries) != -1)
	    cn = 'United-Kingdom';
      else if ($.inArray(cn, dkk_countries) != -1)
	    cn = 'Denmark';
      else if ($.inArray(cn, aud_countries) != -1)
	    cn = 'Australia';
      $('.currency-box option').removeAttr('selected');
      if ($('.currency-box option[data-country="' + cn + '"]').length) {
        var val = $('.currency-box option[data-country="' + cn + '"]').attr('value');
        $('.currency-box').val(val).trigger('change');
        $('.currency-box option[value="' + val + '"]').attr('selected', 'selected');
        $('.nice-select.currency-box').remove();
        $('.currency-box').niceSelect2();
        setCookie('country_cookie', 'yes', 1);
      }
    }
  });

  
  //var rs = '{"ALL":"Albania","DZD":"Algeria","USD":"American-Samoa","EUR":"Andorra","AOA":"Angola","XCD":"Anguilla","XCD":"Antarctica","XCD":"Antigua-and-Barbuda","ARS":"Argentina","AMD":"Armenia","AWG":"Aruba","AUD":"Australia","EUR":"Austria","AZN":"Azerbaijan","BSD":"Bahamas","BHD":"Bahrain","BDT":"Bangladesh","BBD":"Barbados","BYR":"Belarus","EUR":"Belgium","BZD":"Belize","XOF":"Benin","BMD":"Bermuda","BTN":"Bhutan","BOB":"Bolivia","BAM":"Bosnia-Herzegovina","BWP":"Botswana","NOK":"Bouvet Island","BRL":"Brazil","USD":"British Indian Ocean Territory","BND":"Brunei Darussalam","BGN":"Bulgaria","XOF":"Burkina Faso","BIF":"Burundi","KHR":"Cambodia","XAF":"Cameroon","CAD":"Canada","CVE":"Cape Verde","KYD":"Cayman Islands","XAF":"Central African Republic","XAF":"Chad","CLP":"Chile","CNY":"China","AUD":"Christmas Island","AUD":"Cocos (Keeling) Islands","COP":"Colombia","KMF":"Comoros","XAF":"Congo","CDF":"Congo, Dem. Republic","NZD":"Cook Islands","CRC":"Costa Rica","HRK":"Croatia","CUP":"Cuba","EUR":"Cyprus","CZK":"Czech Rep.","DKK":"Denmark","DJF":"Djibouti","XCD":"Dominica","DOP":"Dominican Republic","ECS":"Ecuador","EGP":"Egypt","SVC":"El Salvador","XAF":"Equatorial Guinea","ERN":"Eritrea","EUR":"Estonia","ETB":"Ethiopia","EUR":"European Union","FKP":"Falkland Islands (Malvinas)","DKK":"Faroe Islands","FJD":"Fiji","EUR":"Finland","EUR":"France","EUR":"French Guiana","EUR":"French Southern Territories","XAF":"Gabon","GMD":"Gambia","GEL":"Georgia","EUR":"Germany","GHS":"Ghana","GIP":"Gibraltar","GBP":"Great Britain","EUR":"Greece","DKK":"Denmark","XCD":"Grenada","EUR":"Guadeloupe (French)","USD":"Guam (USA)","QTQ":"Guatemala","GGP":"Guernsey","GNF":"Guinea","GWP":"Guinea Bissau","GYD":"Guyana","HTG":"Haiti","AUD":"Heard Island and McDonald Islands","HNL":"Honduras","HKD":"Hong-Kong","HUF":"Hungary","ISK":"Iceland","INR":"India","IDR":"Indonesia","IRR":"Iran","IQD":"Iraq","EUR":"Ireland","GBP":"Isle of Man","ILS":"Israel","EUR":"Italy","XOF":"Ivory Coast","JMD":"Jamaica","JPY":"Japan","GBP":"Jersey","JOD":"Jordan","KZT":"Kazakhstan","KES":"Kenya","AUD":"Kiribati","KPW":"Korea-North","KRW":"Korea-South","KWD":"Kuwait","KGS":"Kyrgyzstan","LAK":"Laos","LVL":"Latvia","LBP":"Lebanon","LSL":"Lesotho","LRD":"Liberia","LYD":"Libya","CHF":"Liechtenstein","LTL":"Lithuania","EUR":"Luxembourg","MOP":"Macau","MKD":"Macedonia","MGF":"Madagascar","MWK":"Malawi","MYR":"Malaysia","MVR":"Maldives","XOF":"Mali","EUR":"Malta","USD":"Marshall Islands","EUR":"Martinique (French)","MRO":"Mauritania","MUR":"Mauritius","EUR":"Mayotte","MXN":"Mexico","USD":"Micronesia","MDL":"Moldova","EUR":"Monaco","MNT":"Mongolia","EUR":"Montenegro","XCD":"Montserrat","MAD":"Morocco","MZN":"Mozambique","MMK":"Myanmar","NAD":"Namibia","AUD":"Nauru","NPR":"Nepal","EUR":"Netherlands","ANG":"Netherlands Antilles","XPF":"New Caledonia (French)","NZD":"New Zealand","NIO":"Nicaragua","XOF":"Niger","NGN":"Nigeria","NZD":"Niue","AUD":"Norfolk Island","USD":"Northern Mariana Islands","NOK":"Norway","OMR":"Oman","PKR":"Pakistan","USD":"Palau","PAB":"Panama","PGK":"Papua New Guinea","PYG":"Paraguay","PEN":"Peru","PHP":"Philippines","NZD":"Pitcairn Island","PLN":"Poland","XPF":"Polynesia (French)","EUR":"Portugal","USD":"Puerto Rico","QAR":"Qatar","EUR":"Reunion (French)","RON":"Romania","RUB":"Russia","RWF":"Rwanda","SHP":"Saint-Helena","XCD":"Saint Kitts & Nevis Anguilla","XCD":"Saint-Lucia","EUR":"Saint Pierre and Miquelon","XCD":"Saint-Vincent-and-the-Grenadines","WST":"Samoa","EUR":"San Marino","STD":"Sao-Tome-and-Principe","SAR":"Saudi Arabia","XOF":"Senegal","RSD":"Serbia","SCR":"Seychelles","SLL":"Sierra-Leone","SGD":"Singapore","EUR":"Slovakia","EUR":"Slovenia","SBD":"Solomon-Islands","SOS":"Somalia","ZAR":"South Africa","GBP":"South-Georgia & South-Sandwich-Islands","SSP":"South Sudan","EUR":"European-Union","LKR":"Sri Lanka","SDG":"Sudan","SRD":"Suriname","NOK":"Svalbard and Jan Mayen Islands","SZL":"Swaziland","SEK":"Sweden","CHF":"Switzerland","SYP":"Syria","TWD":"Taiwan","TJS":"Tajikistan","TZS":"Tanzania","THB":"Thailand","XOF":"Togo","NZD":"New-Zealand","TOP":"Tonga","TTD":"Trinidad and Tobago","TND":"Tunisia","TRY":"Turkey","TMT":"Turkmenistan","USD":"Turks and Caicos Islands","AUD":"Australia","GBP":"United-Kingdom","UGX":"Uganda","UAH":"Ukraine","AED":"United Arab Emirates","UYU":"Uruguay","USD":"USA","USD":"United States of America","USD":"United-States","USD":"USA Minor Outlying Islands","UZS":"Uzbekistan","VUV":"Vanuatu","EUR":"European-Union","VEF":"Venezuela","VND":"Vietnam","USD":"Virgin Islands (British)","USD":"United-States","XPF":"Wallis-and-Futuna-Islands","MAD":"Western-Sahara","YER":"Yemen","ZMW":"Zambia","ZWD":"Zimbabwe"}';
  var rs = '{"ALL":"Albania","DZD":"Algeria","USD":"American-Samoa","EUR":"Andorra","AOA":"Angola","XCD":"Anguilla","XCD":"Antarctica","XCD":"Antigua-and-Barbuda","ARS":"Argentina","AMD":"Armenia","AWG":"Aruba","AUD":"Australia","EUR":"Austria","AZN":"Azerbaijan","BSD":"Bahamas","BHD":"Bahrain","BDT":"Bangladesh","BBD":"Barbados","BYR":"Belarus","EUR":"Belgium","BZD":"Belize","XOF":"Benin","BMD":"Bermuda","BTN":"Bhutan","BOB":"Bolivia","BAM":"Bosnia-Herzegovina","BWP":"Botswana","NOK":"Bouvet-Island","BRL":"Brazil","USD":"British-Indian-Ocean-Territory","BND":"Brunei-Darussalam","BGN":"Bulgaria","XOF":"Burkina-Faso","BIF":"Burundi","KHR":"Cambodia","XAF":"Cameroon","CAD":"Canada","CVE":"Cape-Verde","KYD":"Cayman-Islands","XAF":"Central-African-Republic","XAF":"Chad","CLP":"Chile","CNY":"China","AUD":"Christmas-Island","AUD":"Cocos-(Keeling)-Islands","COP":"Colombia","KMF":"Comoros","XAF":"Congo","CDF":"Congo,-Dem.-Republic","NZD":"Cook-Islands","CRC":"Costa-Rica","HRK":"Croatia","CUP":"Cuba","EUR":"Cyprus","CZK":"Czech-Rep.","DKK":"Denmark","DJF":"Djibouti","XCD":"Dominica","DOP":"Dominican-Republic","ECS":"Ecuador","EGP":"Egypt","SVC":"El-Salvador","XAF":"Equatorial-Guinea","ERN":"Eritrea","EUR":"Estonia","ETB":"Ethiopia","EUR":"European-Union","FKP":"Falkland-Islands-(Malvinas)","DKK":"Faroe-Islands","FJD":"Fiji","EUR":"Finland","EUR":"France","EUR":"French-Guiana","EUR":"French-Southern-Territories","XAF":"Gabon","GMD":"Gambia","GEL":"Georgia","EUR":"Germany","GHS":"Ghana","GIP":"Gibraltar","GBP":"Great-Britain","EUR":"Greece","DKK":"Denmark","XCD":"Grenada","EUR":"Guadeloupe-(French)","USD":"Guam-(USA)","QTQ":"Guatemala","GGP":"Guernsey","GNF":"Guinea","GWP":"Guinea-Bissau","GYD":"Guyana","HTG":"Haiti","AUD":"Heard-Island-and-McDonald-Islands","HNL":"Honduras","HKD":"Hong-Kong","HUF":"Hungary","ISK":"Iceland","INR":"India","IDR":"Indonesia","IRR":"Iran","IQD":"Iraq","EUR":"Ireland","GBP":"Isle-of-Man","ILS":"Israel","EUR":"Italy","XOF":"Ivory-Coast","JMD":"Jamaica","JPY":"Japan","GBP":"Jersey","JOD":"Jordan","KZT":"Kazakhstan","KES":"Kenya","AUD":"Kiribati","KPW":"Korea-North","KRW":"Korea-South","KWD":"Kuwait","KGS":"Kyrgyzstan","LAK":"Laos","LVL":"Latvia","LBP":"Lebanon","LSL":"Lesotho","LRD":"Liberia","LYD":"Libya","CHF":"Liechtenstein","LTL":"Lithuania","EUR":"Luxembourg","MOP":"Macau","MKD":"Macedonia","MGF":"Madagascar","MWK":"Malawi","MYR":"Malaysia","MVR":"Maldives","XOF":"Mali","EUR":"Malta","USD":"Marshall-Islands","EUR":"Martinique-(French)","MRO":"Mauritania","MUR":"Mauritius","EUR":"Mayotte","MXN":"Mexico","USD":"Micronesia","MDL":"Moldova","EUR":"Monaco","MNT":"Mongolia","EUR":"Montenegro","XCD":"Montserrat","MAD":"Morocco","MZN":"Mozambique","MMK":"Myanmar","NAD":"Namibia","AUD":"Nauru","NPR":"Nepal","EUR":"Netherlands","ANG":"Netherlands-Antilles","XPF":"New-Caledonia-(French)","NZD":"New-Zealand","NIO":"Nicaragua","XOF":"Niger","NGN":"Nigeria","NZD":"Niue","AUD":"Norfolk-Island","USD":"Northern-Mariana-Islands","NOK":"Norway","OMR":"Oman","PKR":"Pakistan","USD":"Palau","PAB":"Panama","PGK":"Papua-New-Guinea","PYG":"Paraguay","PEN":"Peru","PHP":"Philippines","NZD":"Pitcairn-Island","PLN":"Poland","XPF":"Polynesia-(French)","EUR":"Portugal","USD":"Puerto-Rico","QAR":"Qatar","EUR":"Reunion-(French)","RON":"Romania","RUB":"Russia","RWF":"Rwanda","SHP":"Saint-Helena","XCD":"Saint-Kitts-&-Nevis-Anguilla","XCD":"Saint-Lucia","EUR":"Saint-Pierre-and-Miquelon","XCD":"Saint-Vincent-and-the-Grenadines","WST":"Samoa","EUR":"San-Marino","STD":"Sao-Tome-and-Principe","SAR":"Saudi-Arabia","XOF":"Senegal","RSD":"Serbia","SCR":"Seychelles","SLL":"Sierra-Leone","SGD":"Singapore","EUR":"Slovakia","EUR":"Slovenia","SBD":"Solomon-Islands","SOS":"Somalia","ZAR":"South-Africa","GBP":"South-Georgia-&-South-Sandwich-Islands","SSP":"South-Sudan","EUR":"European-Union","LKR":"Sri-Lanka","SDG":"Sudan","SRD":"Suriname","NOK":"Svalbard-and-Jan-Mayen-Islands","SZL":"Swaziland","SEK":"Sweden","CHF":"Switzerland","SYP":"Syria","TWD":"Taiwan","TJS":"Tajikistan","TZS":"Tanzania","THB":"Thailand","XOF":"Togo","NZD":"New-Zealand","TOP":"Tonga","TTD":"Trinidad-and-Tobago","TND":"Tunisia","TRY":"Turkey","TMT":"Turkmenistan","USD":"Turks-and-Caicos-Islands","AUD":"Australia","GBP":"United-Kingdom","UGX":"Uganda","UAH":"Ukraine","AED":"United-Arab-Emirates","UYU":"Uruguay","USD":"USA","USD":"United-States-of-America","USD":"United-States","USD":"USA-Minor-Outlying-Islands","UZS":"Uzbekistan","VUV":"Vanuatu","EUR":"European-Union","VEF":"Venezuela","VND":"Vietnam","USD":"Virgin-Islands-(British)","USD":"United-States","XPF":"Wallis-and-Futuna-Islands","MAD":"Western-Sahara","YER":"Yemen","ZMW":"Zambia","ZWD":"Zimbabwe","NOK":"Norway"}';
  var robj = $.parseJSON(rs);

  $('.currency-box option').each(function() {
    var v = $(this).attr('value');
    var ocn = robj[v];
    $(this).attr('data-country', ocn).attr('data-country', ocn);
  });
  $('.currency-box').niceSelect2();

  $.get('/products/add-engrave?view=customData', function(data) {
    var s = JSON.parse(data);
    $('.getEngPrice').html(s.price);
  });
  $('.getEngPriceLine').each(function() {
    var line = $(this);
    var qty = Number(line.attr('data-qty'));
    $.get('/products/add-engrave?view=customData', function(data) {
      var s = JSON.parse(data);
      var op = s.oprice * qty;
      var mf = s.mf;
      line.html('+ ' + Shopify.formatMoney(op, mf).replace(/^(.*)(\<span class\=[\"|\']*money[\"|\']*\>)(.*)(\<\/span\>)(.*)$/, '$1$3$5').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim());
    });
  });

  $('.currency-selector select').on('change', function() {

    var currency = $(this).val();

    //$(this).parents('form').submit();
    $.fn.serializeFormJSON = function() {
      var o = {};
      var a = this.serializeArray();
      $.each(a, function() {
        if (o[this.name]) {
          if (!o[this.name].push) {
            o[this.name] = [o[this.name]];
          }
          o[this.name].push(this.value || '');
        } else {
          o[this.name] = this.value || '';
        }
      });
      return o;
    };

    $.ajax({
      url: window.routes.cartUpdateUrl + '.js',
      type: 'post',
      dataType: 'json',
      data: $('#currency_form').serializeFormJSON(),
      success: function(data) {
        $('.currency-box').niceSelect2();
        if ($('body.template-cart').length) {
          $.get(window.routes.cartUrl + '/?view=full-cart', function(data) {
            $('#full-cart-temp').append($('#full-cart .additional_checkout_buttons'));
            $('#full-cart').html(data);
            $('#full-cart .additional_checkout_buttons').replaceWith($('#full-cart-temp .additional_checkout_buttons'));
          });
        }
        if ($('body.template-product').length) {
          var product_handle = $('body').data('product-handle');
          $.get('/products/' + product_handle + '?view=customData', function(data) {
            var s = JSON.parse(data);
            $('.product-details .product-prices').removeClass('visible');
            $('.product-details .product-price').html('<span class=money>' + s.price.replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(s.currency_code, '<span class="currency-code">' + s.currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</span>');
            $('.product-details .product-compare-price').html('<span class=money>' + s.compare_at_price_without_currency_code.replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(s.currency_code, '<span class="currency-code">' + s.currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</span>');
            if (/^AED|ARS|BRL|CHF|ILS|JPY$/i.test(s.currency_code))
              $('.product-details .product-prices').addClass('long-currency');
            else
              $('.product-details .product-prices').removeClass('long-currency');
            adjust_price_font_size($('.product-details .product-price .money'), $('.product-details .product-compare-price .money'), 0.75);
            $('.product-details .product-prices').addClass('visible');
            $('.stAdRight .stPrice').html('<del>' + s.compare_at_price.replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</del> ' + s.price.replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim());
            $('.triggerMainPro span').html(s.price.replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim());
            $('body').attr('data-money', s.mf);
            theme.strings.moneyFormat = s.mf;
            $('body').attr('data-money-no-cc', s.mf_no_cc);
            theme.strings.moneyFormatWithoutCurrencyCode = s.mf_no_cc;
            $('body').attr('data-cc', s.currency_code);
            theme.strings.currencyCode = s.currency_code;
          });
          $.get('/products/add-engrave?view=customData', function(data) {
            var s = JSON.parse(data);
            $('.getEngPrice').html(s.price);
          });
          if ($('.watch-tool-kit-option').length) {
            var watch_tool_kit_product_handle = $('.watch-tool-kit-option').data('product-handle');
            $.get('/products/' + watch_tool_kit_product_handle + '?view=customData', function(data) {
              var s = JSON.parse(data);
              $('.watch-tool-kit-option-price').html('<span class=money>' + s.price.replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(s.currency_code, '<span class="currency-code">' + s.currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</span>');
            });
          }
          $.getJSON('/products/' + product_handle + '.js', function(pjson) {
            var pjson = JSON.stringify(pjson);
            $('[id^="ProductJson-"][id$="product-template-new"]').text(pjson);
            var sections = new theme.Sections();
            sections.register('product-template-new', theme.Product);
            //grid.append('<script>new Shopify.OptionSelectors("product-select-'+id+'", { product: '+pjson+', onVariantSelected: selectCallback, enableHistoryState: false }); <\/script>');
          });
        }
        $.get(window.routes.cartUrl + "?view=mini-drawers-show-all-enabled-hidden", function(data) {
          if ($('body.template-cart').length) { return; }
          $('#crt-drawers').html(data);
          $.get(window.routes.cartUrl + "?view=mini-include-drawers", function(data) {
            $('#crt').html(data);
            cartHoverModel();
            if ($('.sgcol_loop').length) {
              if ($('.sgcol_loop').hasClass('slick-initialized')) {
                $('.sgcol_loop').slick('refresh');
              } else {
                $('.sgcol_loop').slick();
              }
            }
            if ($('.brcol_loop').length) {
              if ($('.brcol_loop').hasClass('slick-initialized')) {
                $('.brcol_loop').slick('refresh');
              } else {
                $('.brcol_loop').slick();
              }
            }
            refreshCartDrawer();
          });
        });
        if ($('.category-item-box.slick-slide .selector-wrapper').length) {
          var slider = $('.category-item-box.slick-slide').closest('.slick-slider');
          slider.addClass('selectors-unslick').slick('unslick');
          slider.find('.selector-wrapper').last().addClass('last-selector');
        }
        $('.category-item-box').each(function() {
          var grid = $(this);
          var handle = grid.attr('data-handle');
          $.get('/products/' + handle + '?view=customData', function(data) {
            var s = JSON.parse(data);
            grid.find('.originalPrice').html('<span class=money>' + s.price.replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(s.currency_code, '<span class="currency-code">' + s.currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</span>');
            grid.find('.comparePrice').html('<span class=money>' + s.compare_at_price_without_currency_code.replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(s.currency_code, '<span class="currency-code">' + s.currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</span>');
            $('[data-quick="' + handle + '"]').find('.product-price').html('<span class=money>' + s.price.replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(s.currency_code, '<span class="currency-code">' + s.currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</span>');
            $('[data-quick="' + handle + '"]').find('.product-compare-price').html('<span class=money>' + s.compare_at_price_without_currency_code.replace(/^(.*?)(\<span class\=[\"|\']*money[\"|\']*\>)(.*?)(\<\/span\>)(.*?)$/, '$1$3$5').replace(s.currency_code, '<span class="currency-code">' + s.currency_code + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) {return $1 + Math.round($2 + '.' + $4) + $5; }).trim() + '</span>');
            $('body').attr('data-money', s.mf);
            theme.strings.moneyFormat = s.mf;
            $('body').attr('data-money-no-cc', s.mf_no_cc);
            theme.strings.moneyFormatWithoutCurrencyCode = s.mf_no_cc;
            $('body').attr('data-cc', s.currency_code);
            theme.strings.currencyCode = s.currency_code;
            var selector_wrapper = grid.find('.selector-wrapper');
            if (selector_wrapper.length) {
              $.getJSON('/products/' + handle + '.js', function(json) {
                var select = grid.find('.product-select.available.multiple-variants');
                var id = select.attr('id');
                select.attr('data-json', JSON.stringify(json));
                grid.find('.selector-wrapper').remove();
                new Shopify.OptionSelectors(id, { product: json, onVariantSelected: selectCallback, enableHistoryState: false });
                if (selector_wrapper.hasClass('last-selector')) {
                  selector_wrapper.removeClass('last-selector');
                  $('.selectors-unslick').removeClass('selectors-unslick').slick({
                    infinite: true,
                    slidesToShow: ($(window).width() > 767 ? 3 : 1),
                    slidesToScroll: 1
                  });
                }
              });
            }
          });
        });
        $('.addonItem').each(function() {
          var grid = $(this);
          var handle = grid.attr('data-handle');
          $.get('/products/' + handle + '?view=customData', function(data) {
            var s = JSON.parse(data);
            grid.find('.addonPrice').html(s.price);
          });
        });

        // Workaround for Shopify FB Pixel currency bug
        window.ShopifyAnalytics.meta.currency = currency;
        window.trekkie.trekkie.defaultAttributes.currency = currency;
        window.trekkie.trekkie.options.defaultAttributes.currency = currency;
      },
      error: function(data) {
        console.log('ee', data);
      }
    });
  });
  
});




/*! lazysizes - v3.0.0 */
!function(a,b){var c=b(a,a.document);a.lazySizes=c,"object"==typeof module&&module.exports&&(module.exports=c)}(window,function(a,b){"use strict";if(b.getElementsByClassName){var c,d=b.documentElement,e=a.Date,f=a.HTMLPictureElement,g="addEventListener",h="getAttribute",i=a[g],j=a.setTimeout,k=a.requestAnimationFrame||j,l=a.requestIdleCallback,m=/^picture$/i,n=["load","error","lazyincluded","_lazyloaded"],o={},p=Array.prototype.forEach,q=function(a,b){return o[b]||(o[b]=new RegExp("(\\s|^)"+b+"(\\s|$)")),o[b].test(a[h]("class")||"")&&o[b]},r=function(a,b){q(a,b)||a.setAttribute("class",(a[h]("class")||"").trim()+" "+b)},s=function(a,b){var c;(c=q(a,b))&&a.setAttribute("class",(a[h]("class")||"").replace(c," "))},t=function(a,b,c){var d=c?g:"removeEventListener";c&&t(a,b),n.forEach(function(c){a[d](c,b)})},u=function(a,c,d,e,f){var g=b.createEvent("CustomEvent");return g.initCustomEvent(c,!e,!f,d||{}),a.dispatchEvent(g),g},v=function(b,d){var e;!f&&(e=a.picturefill||c.pf)?e({reevaluate:!0,elements:[b]}):d&&d.src&&(b.src=d.src)},w=function(a,b){return(getComputedStyle(a,null)||{})[b]},x=function(a,b,d){for(d=d||a.offsetWidth;d<c.minSize&&b&&!a._lazysizesWidth;)d=b.offsetWidth,b=b.parentNode;return d},y=function(){var a,c,d=[],e=[],f=d,g=function(){var b=f;for(f=d.length?e:d,a=!0,c=!1;b.length;)b.shift()();a=!1},h=function(d,e){a&&!e?d.apply(this,arguments):(f.push(d),c||(c=!0,(b.hidden?j:k)(g)))};return h._lsFlush=g,h}(),z=function(a,b){return b?function(){y(a)}:function(){var b=this,c=arguments;y(function(){a.apply(b,c)})}},A=function(a){var b,c=0,d=125,f=666,g=f,h=function(){b=!1,c=e.now(),a()},i=l?function(){l(h,{timeout:g}),g!==f&&(g=f)}:z(function(){j(h)},!0);return function(a){var f;(a=a===!0)&&(g=44),b||(b=!0,f=d-(e.now()-c),0>f&&(f=0),a||9>f&&l?i():j(i,f))}},B=function(a){var b,c,d=99,f=function(){b=null,a()},g=function(){var a=e.now()-c;d>a?j(g,d-a):(l||f)(f)};return function(){c=e.now(),b||(b=j(g,d))}},C=function(){var f,k,l,n,o,x,C,E,F,G,H,I,J,K,L,M=/^img$/i,N=/^iframe$/i,O="onscroll"in a&&!/glebot/.test(navigator.userAgent),P=0,Q=0,R=0,S=-1,T=function(a){R--,a&&a.target&&t(a.target,T),(!a||0>R||!a.target)&&(R=0)},U=function(a,c){var e,f=a,g="hidden"==w(b.body,"visibility")||"hidden"!=w(a,"visibility");for(F-=c,I+=c,G-=c,H+=c;g&&(f=f.offsetParent)&&f!=b.body&&f!=d;)g=(w(f,"opacity")||1)>0,g&&"visible"!=w(f,"overflow")&&(e=f.getBoundingClientRect(),g=H>e.left&&G<e.right&&I>e.top-1&&F<e.bottom+1);return g},V=function(){var a,e,g,i,j,m,n,p,q;if((o=c.loadMode)&&8>R&&(a=f.length)){e=0,S++,null==K&&("expand"in c||(c.expand=d.clientHeight>500&&d.clientWidth>500?500:370),J=c.expand,K=J*c.expFactor),K>Q&&1>R&&S>2&&o>2&&!b.hidden?(Q=K,S=0):Q=o>1&&S>1&&6>R?J:P;for(;a>e;e++)if(f[e]&&!f[e]._lazyRace)if(O)if((p=f[e][h]("data-expand"))&&(m=1*p)||(m=Q),q!==m&&(C=innerWidth+m*L,E=innerHeight+m,n=-1*m,q=m),g=f[e].getBoundingClientRect(),(I=g.bottom)>=n&&(F=g.top)<=E&&(H=g.right)>=n*L&&(G=g.left)<=C&&(I||H||G||F)&&(l&&3>R&&!p&&(3>o||4>S)||U(f[e],m))){if(ba(f[e]),j=!0,R>9)break}else!j&&l&&!i&&4>R&&4>S&&o>2&&(k[0]||c.preloadAfterLoad)&&(k[0]||!p&&(I||H||G||F||"auto"!=f[e][h](c.sizesAttr)))&&(i=k[0]||f[e]);else ba(f[e]);i&&!j&&ba(i)}},W=A(V),X=function(a){r(a.target,c.loadedClass),s(a.target,c.loadingClass),t(a.target,Z)},Y=z(X),Z=function(a){Y({target:a.target})},$=function(a,b){try{a.contentWindow.location.replace(b)}catch(c){a.src=b}},_=function(a){var b,d,e=a[h](c.srcsetAttr);(b=c.customMedia[a[h]("data-media")||a[h]("media")])&&a.setAttribute("media",b),e&&a.setAttribute("srcset",e),b&&(d=a.parentNode,d.insertBefore(a.cloneNode(),a),d.removeChild(a))},aa=z(function(a,b,d,e,f){var g,i,k,l,o,q;(o=u(a,"lazybeforeunveil",b)).defaultPrevented||(e&&(d?r(a,c.autosizesClass):a.setAttribute("sizes",e)),i=a[h](c.srcsetAttr),g=a[h](c.srcAttr),f&&(k=a.parentNode,l=k&&m.test(k.nodeName||"")),q=b.firesLoad||"src"in a&&(i||g||l),o={target:a},q&&(t(a,T,!0),clearTimeout(n),n=j(T,2500),r(a,c.loadingClass),t(a,Z,!0)),l&&p.call(k.getElementsByTagName("source"),_),i?a.setAttribute("srcset",i):g&&!l&&(N.test(a.nodeName)?$(a,g):a.src=g),(i||l)&&v(a,{src:g})),a._lazyRace&&delete a._lazyRace,s(a,c.lazyClass),y(function(){(!q||a.complete&&a.naturalWidth>1)&&(q?T(o):R--,X(o))},!0)}),ba=function(a){var b,d=M.test(a.nodeName),e=d&&(a[h](c.sizesAttr)||a[h]("sizes")),f="auto"==e;(!f&&l||!d||!a.src&&!a.srcset||a.complete||q(a,c.errorClass))&&(b=u(a,"lazyunveilread").detail,f&&D.updateElem(a,!0,a.offsetWidth),a._lazyRace=!0,R++,aa(a,b,f,e,d))},ca=function(){if(!l){if(e.now()-x<999)return void j(ca,999);var a=B(function(){c.loadMode=3,W()});l=!0,c.loadMode=3,W(),i("scroll",function(){3==c.loadMode&&(c.loadMode=2),a()},!0)}};return{_:function(){x=e.now(),f=b.getElementsByClassName(c.lazyClass),k=b.getElementsByClassName(c.lazyClass+" "+c.preloadClass),L=c.hFac,i("scroll",W,!0),i("resize",W,!0),a.MutationObserver?new MutationObserver(W).observe(d,{childList:!0,subtree:!0,attributes:!0}):(d[g]("DOMNodeInserted",W,!0),d[g]("DOMAttrModified",W,!0),setInterval(W,999)),i("hashchange",W,!0),["focus","mouseover","click","load","transitionend","animationend","webkitAnimationEnd"].forEach(function(a){b[g](a,W,!0)}),/d$|^c/.test(b.readyState)?ca():(i("load",ca),b[g]("DOMContentLoaded",W),j(ca,2e4)),f.length?(V(),y._lsFlush()):W()},checkElems:W,unveil:ba}}(),D=function(){var a,d=z(function(a,b,c,d){var e,f,g;if(a._lazysizesWidth=d,d+="px",a.setAttribute("sizes",d),m.test(b.nodeName||""))for(e=b.getElementsByTagName("source"),f=0,g=e.length;g>f;f++)e[f].setAttribute("sizes",d);c.detail.dataAttr||v(a,c.detail)}),e=function(a,b,c){var e,f=a.parentNode;f&&(c=x(a,f,c),e=u(a,"lazybeforesizes",{width:c,dataAttr:!!b}),e.defaultPrevented||(c=e.detail.width,c&&c!==a._lazysizesWidth&&d(a,f,e,c)))},f=function(){var b,c=a.length;if(c)for(b=0;c>b;b++)e(a[b])},g=B(f);return{_:function(){a=b.getElementsByClassName(c.autosizesClass),i("resize",g)},checkElems:g,updateElem:e}}(),E=function(){E.i||(E.i=!0,D._(),C._())};return function(){var b,d={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.5,hFac:.8,loadMode:2};c=a.lazySizesConfig||a.lazysizesConfig||{};for(b in d)b in c||(c[b]=d[b]);a.lazySizesConfig=c,j(function(){c.init&&E()})}(),{cfg:c,autoSizer:D,loader:C,init:E,uP:v,aC:r,rC:s,hC:q,fire:u,gW:x,rAF:y}}});
/*! ls.rias.min.js - lazysizes - v3.0.0 */
!function(a,b,c){"use strict";function d(b,c){var d,e,f,g,h=a.getComputedStyle(b);e=b.parentNode,g={isPicture:!(!e||!m.test(e.nodeName||""))},f=function(a,c){var d=b.getAttribute("data-"+a);if(!d){var e=h.getPropertyValue("--ls-"+a);e&&(d=e.trim())}if(d){if("true"==d)d=!0;else if("false"==d)d=!1;else if(l.test(d))d=parseFloat(d);else if("function"==typeof j[a])d=j[a](b,d);else if(q.test(d))try{d=JSON.parse(d)}catch(f){}g[a]=d}else a in j&&"function"!=typeof j[a]?g[a]=j[a]:c&&"function"==typeof j[a]&&(g[a]=j[a](b,d))};for(d in j)f(d);return c.replace(p,function(a,b){b in g||f(b,!0)}),g}function e(a,b){var c=[],d=function(a,c){return k[typeof b[c]]?b[c]:a};return c.srcset=[],b.absUrl&&(s.setAttribute("href",a),a=s.href),a=((b.prefix||"")+a+(b.postfix||"")).replace(p,d),b.widths.forEach(function(d){var e=b.widthmap[d]||d,f={u:a.replace(n,e).replace(o,b.ratio?Math.round(d*b.ratio):""),w:d};c.push(f),c.srcset.push(f.c=f.u+" "+d+"w")}),c}function f(a,c,d){var f=0,g=0,h=d;if(a){if("container"===c.ratio){for(f=h.scrollWidth,g=h.scrollHeight;!(f&&g||h===b);)h=h.parentNode,f=h.scrollWidth,g=h.scrollHeight;f&&g&&(c.ratio=g/f)}a=e(a,c),a.isPicture=c.isPicture,u&&"IMG"==d.nodeName.toUpperCase()?d.removeAttribute(i.srcsetAttr):d.setAttribute(i.srcsetAttr,a.srcset.join(", ")),Object.defineProperty(d,"_lazyrias",{value:a,writable:!0})}}function g(a,b){var c=d(a,b);return j.modifyOptions.call(a,{target:a,details:c,detail:c}),lazySizes.fire(a,"lazyriasmodifyoptions",c),c}function h(a){return a.getAttribute(a.getAttribute("data-srcattr")||j.srcAttr)||a.getAttribute(i.srcsetAttr)||a.getAttribute(i.srcAttr)||a.getAttribute("data-pfsrcset")||""}if(b.addEventListener){var i,j,k={string:1,number:1},l=/^\-*\+*\d+\.*\d*$/,m=/^picture$/i,n=/\s*\{\s*width\s*\}\s*/i,o=/\s*\{\s*height\s*\}\s*/i,p=/\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,q=/^\[.*\]|\{.*\}$/,r=/^(?:auto|\d+(px)?)$/,s=b.createElement("a"),t=b.createElement("img"),u="srcset"in t&&!("sizes"in t),v=!!a.HTMLPictureElement&&!u;!function(){var b,c=function(){},d={prefix:"",postfix:"",srcAttr:"data-src",absUrl:!1,modifyOptions:c,widthmap:{},ratio:!1};i=a.lazySizes&&lazySizes.cfg||a.lazySizesConfig,i||(i={},a.lazySizesConfig=i),i.supportsType||(i.supportsType=function(a){return!a}),i.rias||(i.rias={}),j=i.rias,"widths"in j||(j.widths=[],function(a){for(var b,c=0;!b||3e3>b;)c+=5,c>30&&(c+=1),b=36*c,a.push(b)}(j.widths));for(b in d)b in j||(j[b]=d[b])}(),addEventListener("lazybeforesizes",function(a){var b,c,d,e,k,l,m,o,p,q,s,t,u;if(b=a.target,a.detail.dataAttr&&!a.defaultPrevented&&!j.disabled&&(p=b.getAttribute(i.sizesAttr)||b.getAttribute("sizes"))&&r.test(p)){if(c=h(b),d=g(b,c),s=n.test(d.prefix)||n.test(d.postfix),d.isPicture&&(e=b.parentNode))for(k=e.getElementsByTagName("source"),l=0,m=k.length;m>l;l++)(s||n.test(o=h(k[l])))&&(f(o,d,k[l]),t=!0);s||n.test(c)?(f(c,d,b),t=!0):t&&(u=[],u.srcset=[],u.isPicture=!0,Object.defineProperty(b,"_lazyrias",{value:u,writable:!0})),t&&(v?b.removeAttribute(i.srcAttr):"auto"!=p&&(q={width:parseInt(p,10)},w({target:b,detail:q})))}},!0);var w=function(){var c=function(a,b){return a.w-b.w},d=function(a){var b,c,d=a.length,e=a[d-1],f=0;for(f;d>f;f++)if(e=a[f],e.d=e.w/a.w,e.d>=a.d){!e.cached&&(b=a[f-1])&&b.d>a.d-.13*Math.pow(a.d,2.2)&&(c=Math.pow(b.d-.6,1.6),b.cached&&(b.d+=.15*c),b.d+(e.d-a.d)*c>a.d&&(e=b));break}return e},e=function(a,b){var c;return!a._lazyrias&&lazySizes.pWS&&(c=lazySizes.pWS(a.getAttribute(i.srcsetAttr||""))).length&&(Object.defineProperty(a,"_lazyrias",{value:c,writable:!0}),b&&a.parentNode&&(c.isPicture="PICTURE"==a.parentNode.nodeName.toUpperCase())),a._lazyrias},f=function(b){var c=a.devicePixelRatio||1,d=lazySizes.getX&&lazySizes.getX(b);return Math.min(d||c,2.4,c)},g=function(b,g){var h,i,j,k,l,m;if(l=b._lazyrias,l.isPicture&&a.matchMedia)for(i=0,h=b.parentNode.getElementsByTagName("source"),j=h.length;j>i;i++)if(e(h[i])&&!h[i].getAttribute("type")&&(!(k=h[i].getAttribute("media"))||(matchMedia(k)||{}).matches)){l=h[i]._lazyrias;break}return(!l.w||l.w<g)&&(l.w=g,l.d=f(b),m=d(l.sort(c))),m},h=function(c){var d,f=c.target;return!u&&(a.respimage||a.picturefill||lazySizesConfig.pf)?void b.removeEventListener("lazybeforesizes",h):void(("_lazyrias"in f||c.detail.dataAttr&&e(f,!0))&&(d=g(f,c.detail.width),d&&d.u&&f._lazyrias.cur!=d.u&&(f._lazyrias.cur=d.u,d.cached=!0,lazySizes.rAF(function(){f.setAttribute(i.srcAttr,d.u),f.setAttribute("src",d.u)}))))};return v?h=function(){}:addEventListener("lazybeforesizes",h),h}()}}(window,document);
/*! ls.bgset.min.js - lazysizes - v3.0.0 */
!function(){"use strict";if(window.addEventListener){var a=/\s+/g,b=/\s*\|\s+|\s+\|\s*/g,c=/^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,d=/\(|\)|'/,e={contain:1,cover:1},f=function(a){var b=lazySizes.gW(a,a.parentNode);return(!a._lazysizesWidth||b>a._lazysizesWidth)&&(a._lazysizesWidth=b),a._lazysizesWidth},g=function(a){var b;return b=(getComputedStyle(a)||{getPropertyValue:function(){}}).getPropertyValue("background-size"),!e[b]&&e[a.style.backgroundSize]&&(b=a.style.backgroundSize),b},h=function(d,e,f){var g=document.createElement("picture"),h=e.getAttribute(lazySizesConfig.sizesAttr),i=e.getAttribute("data-ratio"),j=e.getAttribute("data-optimumx");e._lazybgset&&e._lazybgset.parentNode==e&&e.removeChild(e._lazybgset),Object.defineProperty(f,"_lazybgset",{value:e,writable:!0}),Object.defineProperty(e,"_lazybgset",{value:g,writable:!0}),d=d.replace(a," ").split(b),g.style.display="none",f.className=lazySizesConfig.lazyClass,1!=d.length||h||(h="auto"),d.forEach(function(a){var b=document.createElement("source");h&&"auto"!=h&&b.setAttribute("sizes",h),a.match(c)&&(b.setAttribute(lazySizesConfig.srcsetAttr,RegExp.$1),RegExp.$2&&b.setAttribute("media",lazySizesConfig.customMedia[RegExp.$2]||RegExp.$2)),g.appendChild(b)}),h&&(f.setAttribute(lazySizesConfig.sizesAttr,h),e.removeAttribute(lazySizesConfig.sizesAttr),e.removeAttribute("sizes")),j&&f.setAttribute("data-optimumx",j),i&&f.setAttribute("data-ratio",i),g.appendChild(f),e.appendChild(g)},i=function(a){if(a.target._lazybgset){var b=a.target,c=b._lazybgset,e=b.currentSrc||b.src;e&&(c.style.backgroundImage="url("+(d.test(e)?JSON.stringify(e):e)+")"),b._lazybgsetLoading&&(lazySizes.fire(c,"_lazyloaded",{},!1,!0),delete b._lazybgsetLoading)}};addEventListener("lazybeforeunveil",function(a){var b,c,d;!a.defaultPrevented&&(b=a.target.getAttribute("data-bgset"))&&(d=a.target,c=document.createElement("img"),c.alt="",c._lazybgsetLoading=!0,a.detail.firesLoad=!0,h(b,d,c),setTimeout(function(){lazySizes.loader.unveil(c),lazySizes.rAF(function(){lazySizes.fire(c,"_lazyloaded",{},!0,!0),c.complete&&i({target:c})})}))}),document.addEventListener("load",i,!0),window.addEventListener("lazybeforesizes",function(a){if(a.target._lazybgset&&a.detail.dataAttr){var b=a.target._lazybgset,c=g(b);e[c]&&(a.target._lazysizesParentFit=c,lazySizes.rAF(function(){a.target.setAttribute("data-parent-fit",c),a.target._lazysizesParentFit&&delete a.target._lazysizesParentFit}))}},!0),document.documentElement.addEventListener("lazybeforesizes",function(a){!a.defaultPrevented&&a.target._lazybgset&&(a.detail.width=f(a.target._lazybgset))})}}();
/*! ls.object-fit.min.js - lazysizes - v3.0.0 */
!function(){"use strict";function a(a){var b=getComputedStyle(a,null)||{},c=b.fontFamily||"",d=c.match(f)||"",e=d&&c.match(g)||"";return e&&(e=e[1]),{fit:d&&d[1]||"",position:j[e]||e||"center"}}function b(a,b){var c,d=lazySizes.cfg,e=a.cloneNode(!1),f=e.style,g=function(){var b=a.currentSrc||a.src;b&&(f.backgroundImage="url("+(i.test(b)?JSON.stringify(b):b)+")",c||(c=!0,lazySizes.rC(e,d.loadingClass),lazySizes.aC(e,d.loadedClass)))};a._lazysizesParentFit=b.fit,a.addEventListener("load",function(){lazySizes.rAF(g)},!0),e.addEventListener("load",function(){var a=e.currentSrc||e.src;a&&a!=h&&(e.src=h,e.srcset="")}),lazySizes.rAF(function(){var c=a,i=a.parentNode;"PICTURE"==i.nodeName.toUpperCase()&&(c=i,i=i.parentNode),lazySizes.rC(e,d.loadedClass),lazySizes.rC(e,d.lazyClass),lazySizes.aC(e,d.loadingClass),lazySizes.aC(e,d.objectFitClass||"lazysizes-display-clone"),e.getAttribute(d.srcsetAttr)&&e.setAttribute(d.srcsetAttr,""),e.getAttribute(d.srcAttr)&&e.setAttribute(d.srcAttr,""),e.src=h,e.srcset="",f.backgroundRepeat="no-repeat",f.backgroundPosition=b.position,f.backgroundSize=b.fit,c.style.display="none",a.setAttribute("data-parent-fit",b.fit),a.setAttribute("data-parent-container","prev"),i.insertBefore(e,c),a._lazysizesParentFit&&delete a._lazysizesParentFit,a.complete&&g()})}var c=document.createElement("a").style,d="objectFit"in c,e=d&&"objectPosition"in c,f=/object-fit["']*\s*:\s*["']*(contain|cover)/,g=/object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,h="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",i=/\(|\)|'/,j={center:"center","50% 50%":"center"};d&&e||addEventListener("lazyunveilread",function(c){var e=c.target,f=a(e);!f.fit||d&&"center"==f.position||b(e,f)},!0)}();
/*! ls.parent-fit.min.js - lazysizes - v3.0.0 */
!function(a,b){"use strict";if(a.addEventListener){var c=/\s+(\d+)(w|h)\s+(\d+)(w|h)/,d=/parent-fit["']*\s*:\s*["']*(contain|cover|width)/,e=/parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,f=/^picture$/i,g=function(a){return getComputedStyle(a,null)||{}},h={getParent:function(b,c){var d=b,e=b.parentNode;return c&&"prev"!=c||!e||!f.test(e.nodeName||"")||(e=e.parentNode),"self"!=c&&(d="prev"==c?b.previousElementSibling:c&&(e.closest||a.jQuery)?(e.closest?e.closest(c):jQuery(e).closest(c)[0])||e:e),d},getFit:function(a){var b,c,f=g(a),i=f.content||f.fontFamily,j={fit:a._lazysizesParentFit||a.getAttribute("data-parent-fit")};return!j.fit&&i&&(b=i.match(d))&&(j.fit=b[1]),j.fit?(c=a._lazysizesParentContainer||a.getAttribute("data-parent-container"),!c&&i&&(b=i.match(e))&&(c=b[1]),j.parent=h.getParent(a,c)):j.fit=f.objectFit,j},getImageRatio:function(b){var d,e,g,h,i=b.parentNode,j=i&&f.test(i.nodeName||"")?i.querySelectorAll("source, img"):[b];for(d=0;d<j.length;d++)if(b=j[d],e=b.getAttribute(lazySizesConfig.srcsetAttr)||b.getAttribute("srcset")||b.getAttribute("data-pfsrcset")||b.getAttribute("data-risrcset")||"",g=b.getAttribute("media"),g=lazySizesConfig.customMedia[b.getAttribute("data-media")||g]||g,e&&(!g||(a.matchMedia&&matchMedia(g)||{}).matches)){h=parseFloat(b.getAttribute("data-aspectratio")),!h&&e.match(c)&&(h="w"==RegExp.$2?RegExp.$1/RegExp.$3:RegExp.$3/RegExp.$1);break}return h},calculateSize:function(a,b){var c,d,e,f,g=this.getFit(a),h=g.fit,i=g.parent;return"width"==h||("contain"==h||"cover"==h)&&(e=this.getImageRatio(a))?(i?b=i.clientWidth:i=a,f=b,"width"==h?f=b:(d=i.clientHeight,d>40&&(c=b/d)&&("cover"==h&&e>c||"contain"==h&&c>e)&&(f=b*(e/c))),f):b}},i=function(){a.lazySizes&&(lazySizes.parentFit||(lazySizes.parentFit=h),a.removeEventListener("lazyunveilread",i,!0))};a.addEventListener("lazyunveilread",i,!0),b.addEventListener("lazybeforesizes",function(a){if(!a.defaultPrevented){var b=a.target;a.detail.width=h.calculateSize(b,a.detail.width)}}),setTimeout(i)}}(window,document);
/*! ls.respimg.min.js - lazysizes - v3.0.0 */
!function(a,b,c){"use strict";var d,e=a.lazySizes&&lazySizes.cfg||a.lazySizesConfig,f=b.createElement("img"),g="sizes"in f&&"srcset"in f,h=/\s+\d+h/g,i=function(){var a=/\s+(\d+)(w|h)\s+(\d+)(w|h)/,c=Array.prototype.forEach;return function(d){var e=b.createElement("img"),f=function(b){var c,d=b.getAttribute(lazySizesConfig.srcsetAttr);d&&(d.match(a)&&(c="w"==RegExp.$2?RegExp.$1/RegExp.$3:RegExp.$3/RegExp.$1,c&&b.setAttribute("data-aspectratio",c)),b.setAttribute(lazySizesConfig.srcsetAttr,d.replace(h,"")))},g=function(a){var b=a.target.parentNode;b&&"PICTURE"==b.nodeName&&c.call(b.getElementsByTagName("source"),f),f(a.target)},i=function(){e.currentSrc&&b.removeEventListener("lazybeforeunveil",g)};d[1]&&(b.addEventListener("lazybeforeunveil",g),e.onload=i,e.onerror=i,e.srcset="data:,a 1w 1h",e.complete&&i())}}();if(e||(e={},a.lazySizesConfig=e),e.supportsType||(e.supportsType=function(a){return!a}),!a.picturefill&&!e.pf){if(a.HTMLPictureElement&&g)return b.msElementsFromPoint&&i(navigator.userAgent.match(/Edge\/(\d+)/)),void(e.pf=function(){});e.pf=function(b){var c,e;if(!a.picturefill)for(c=0,e=b.elements.length;e>c;c++)d(b.elements[c])},d=function(){var c=function(a,b){return a.w-b.w},f=/^\s*\d+\.*\d*px\s*$/,i=function(a){var b,c,d=a.length,e=a[d-1],f=0;for(f;d>f;f++)if(e=a[f],e.d=e.w/a.w,e.d>=a.d){!e.cached&&(b=a[f-1])&&b.d>a.d-.13*Math.pow(a.d,2.2)&&(c=Math.pow(b.d-.6,1.6),b.cached&&(b.d+=.15*c),b.d+(e.d-a.d)*c>a.d&&(e=b));break}return e},j=function(){var a,b=/(([^,\s].[^\s]+)\s+(\d+)w)/g,c=/\s/,d=function(b,c,d,e){a.push({c:c,u:d,w:1*e})};return function(e){return a=[],e=e.trim(),e.replace(h,"").replace(b,d),a.length||!e||c.test(e)||a.push({c:e,u:e,w:99}),a}}(),k=function(){k.init||(k.init=!0,addEventListener("resize",function(){var a,c=b.getElementsByClassName("lazymatchmedia"),e=function(){var a,b;for(a=0,b=c.length;b>a;a++)d(c[a])};return function(){clearTimeout(a),a=setTimeout(e,66)}}()))},l=function(b,c){var d,f=b.getAttribute("srcset")||b.getAttribute(e.srcsetAttr);!f&&c&&(f=b._lazypolyfill?b._lazypolyfill._set:b.getAttribute(e.srcAttr)||b.getAttribute("src")),b._lazypolyfill&&b._lazypolyfill._set==f||(d=j(f||""),c&&b.parentNode&&(d.isPicture="PICTURE"==b.parentNode.nodeName.toUpperCase(),d.isPicture&&a.matchMedia&&(lazySizes.aC(b,"lazymatchmedia"),k())),d._set=f,Object.defineProperty(b,"_lazypolyfill",{value:d,writable:!0}))},m=function(b){var c=a.devicePixelRatio||1,d=lazySizes.getX&&lazySizes.getX(b);return Math.min(d||c,2.5,c)},n=function(b){return a.matchMedia?(n=function(a){return!a||(matchMedia(a)||{}).matches})(b):!b},o=function(a){var b,d,g,h,j,k,o;if(h=a,l(h,!0),j=h._lazypolyfill,j.isPicture)for(d=0,b=a.parentNode.getElementsByTagName("source"),g=b.length;g>d;d++)if(e.supportsType(b[d].getAttribute("type"),a)&&n(b[d].getAttribute("media"))){h=b[d],l(h),j=h._lazypolyfill;break}return j.length>1?(o=h.getAttribute("sizes")||"",o=f.test(o)&&parseInt(o,10)||lazySizes.gW(a,a.parentNode),j.d=m(a),!j.src||!j.w||j.w<o?(j.w=o,k=i(j.sort(c)),j.src=k):k=j.src):k=j[0],k},p=function(a){if(!g||!a.parentNode||"PICTURE"==a.parentNode.nodeName.toUpperCase()){var b=o(a);b&&b.u&&a._lazypolyfill.cur!=b.u&&(a._lazypolyfill.cur=b.u,b.cached=!0,a.setAttribute(e.srcAttr,b.u),a.setAttribute("src",b.u))}};return p.parse=j,p}(),e.loadedClass&&e.loadingClass&&!function(){var a=[];['img[sizes$="px"][srcset].',"picture > img:not([srcset])."].forEach(function(b){a.push(b+e.loadedClass),a.push(b+e.loadingClass)}),e.pf({elements:b.querySelectorAll(a.join(", "))})}()}}(window,document),function(a){"use strict";var b,c=a.createElement("img");!("srcset"in c)||"sizes"in c||window.HTMLPictureElement||(b=/^picture$/i,a.addEventListener("lazybeforeunveil",function(c){var d,e,f,g,h,i,j;!c.defaultPrevented&&!lazySizesConfig.noIOSFix&&(d=c.target)&&(f=d.getAttribute(lazySizesConfig.srcsetAttr))&&(e=d.parentNode)&&((h=b.test(e.nodeName||""))||(g=d.getAttribute("sizes")||d.getAttribute(lazySizesConfig.sizesAttr)))&&(i=h?e:a.createElement("picture"),d._lazyImgSrc||Object.defineProperty(d,"_lazyImgSrc",{value:a.createElement("source"),writable:!0}),j=d._lazyImgSrc,g&&j.setAttribute("sizes",g),j.setAttribute(lazySizesConfig.srcsetAttr,f),d.setAttribute("data-pfsrcset",f),d.removeAttribute(lazySizesConfig.srcsetAttr),h||(e.insertBefore(i,d),i.appendChild(d)),i.insertBefore(j,d))}))}(document);




/* Modernizr 2.8.3 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-fontface-csstransforms-csstransforms3d-touch-mq-cssclasses-teststyles-testprop-testallprops-prefixes-domprefixes-css_pointerevents-cssclassprefix:supports!
 */
;window.Modernizr=function(a,b,c){function A(a){j.cssText=a}function B(a,b){return A(m.join(a+";")+(b||""))}function C(a,b){return typeof a===b}function D(a,b){return!!~(""+a).indexOf(b)}function E(a,b){for(var d in a){var e=a[d];if(!D(e,"-")&&j[e]!==c)return b=="pfx"?e:!0}return!1}function F(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:C(f,"function")?f.bind(d||b):f}return!1}function G(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+o.join(d+" ")+d).split(" ");return C(b,"string")||C(b,"undefined")?E(e,b):(e=(a+" "+p.join(d+" ")+d).split(" "),F(e,b,c))}var d="2.8.3",e={},f=!0,g=b.documentElement,h="modernizr",i=b.createElement(h),j=i.style,k,l={}.toString,m=" -webkit- -moz- -o- -ms- ".split(" "),n="Webkit Moz O ms",o=n.split(" "),p=n.toLowerCase().split(" "),q={},r={},s={},t=[],u=t.slice,v,w=function(a,c,d,e){var f,i,j,k,l=b.createElement("div"),m=b.body,n=m||b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:h+(d+1),l.appendChild(j);return f=["&#173;",'<style id="s',h,'">',a,"</style>"].join(""),l.id=h,(m?l:n).innerHTML+=f,n.appendChild(l),m||(n.style.background="",n.style.overflow="hidden",k=g.style.overflow,g.style.overflow="hidden",g.appendChild(n)),i=c(l,a),m?l.parentNode.removeChild(l):(n.parentNode.removeChild(n),g.style.overflow=k),!!i},x=function(b){var c=a.matchMedia||a.msMatchMedia;if(c)return c(b)&&c(b).matches||!1;var d;return w("@media "+b+" { #"+h+" { position: absolute; } }",function(b){d=(a.getComputedStyle?getComputedStyle(b,null):b.currentStyle)["position"]=="absolute"}),d},y={}.hasOwnProperty,z;!C(y,"undefined")&&!C(y.call,"undefined")?z=function(a,b){return y.call(a,b)}:z=function(a,b){return b in a&&C(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=u.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(u.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(u.call(arguments)))};return e}),q.touch=function(){var c;return"ontouchstart"in a||a.DocumentTouch&&b instanceof DocumentTouch?c=!0:w(["@media (",m.join("touch-enabled),("),h,")","{#modernizr{top:9px;position:absolute}}"].join(""),function(a){c=a.offsetTop===9}),c},q.csstransforms=function(){return!!G("transform")},q.csstransforms3d=function(){var a=!!G("perspective");return a&&"webkitPerspective"in g.style&&w("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",function(b,c){a=b.offsetLeft===9&&b.offsetHeight===3}),a},q.fontface=function(){var a;return w('@font-face {font-family:"font";src:url("https://")}',function(c,d){var e=b.getElementById("smodernizr"),f=e.sheet||e.styleSheet,g=f?f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"":"";a=/src/i.test(g)&&g.indexOf(d.split(" ")[0])===0}),a};for(var H in q)z(q,H)&&(v=H.toLowerCase(),e[v]=q[H](),t.push((e[v]?"":"no-")+v));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)z(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof f!="undefined"&&f&&(g.className+=" supports-"+(b?"":"no-")+a),e[a]=b}return e},A(""),i=k=null,e._version=d,e._prefixes=m,e._domPrefixes=p,e._cssomPrefixes=o,e.mq=x,e.testProp=function(a){return E([a])},e.testAllProps=G,e.testStyles=w,g.className=g.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+(f?" supports-js supports-"+t.join(" supports-"):""),e}(this,this.document),Modernizr.addTest("pointerevents",function(){var a=document.createElement("x"),b=document.documentElement,c=window.getComputedStyle,d;return"pointerEvents"in a.style?(a.style.pointerEvents="auto",a.style.pointerEvents="x",b.appendChild(a),d=c&&c(a,"").pointerEvents==="auto",b.removeChild(a),!!d):!1});




/* vendors.js */


// Sticky Plugin v1.0.4 for jQuery
// =============
// Author: Anthony Garand
// Improvements by German M. Bravo (Kronuz) and Ruud Kamphuis (ruudk)
// Improvements by Leonardo C. Daronco (daronco)
// Created: 02/14/2011
// Date: 07/20/2015
// Website: http://stickyjs.com/
// Description: Makes an element on the page stick on the screen as you scroll
//              It will only set the 'top' and 'position' of your element, you
//              might need to adjust the width in some cases.

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node/CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {
    var slice = Array.prototype.slice; // save ref to original slice()
    var splice = Array.prototype.splice; // save ref to original slice()

  var defaults = {
      topSpacing: 0,
      bottomSpacing: 0,
      className: 'is-sticky',
      wrapperClassName: 'sticky-wrapper',
      center: false,
      getWidthFrom: '',
      widthFromWrapper: true, // works only when .getWidthFrom is empty
      responsiveWidth: false,
      zIndex: 'inherit'
    },
    $window = $(window),
    $document = $(document),
    sticked = [],
    windowHeight = $window.height(),
    scroller = function() {
      var scrollTop = $window.scrollTop(),
        documentHeight = $document.height(),
        dwh = documentHeight - windowHeight,
        extra = (scrollTop > dwh) ? dwh - scrollTop : 0;

      for (var i = 0, l = sticked.length; i < l; i++) {
        var s = sticked[i],
          elementTop = s.stickyWrapper.offset().top,
          etse = elementTop - s.topSpacing - extra;

        //update height in case of dynamic content
        s.stickyWrapper.css('height', s.stickyElement.outerHeight());

        if (scrollTop <= etse) {
          if (s.currentTop !== null) {
            s.stickyElement
              .css({
                'width': '',
                'position': '',
                'top': '',
                'z-index': ''
              });
            s.stickyElement.parent().removeClass(s.className);
            s.stickyElement.trigger('sticky-end', [s]);
            s.currentTop = null;
          }
        }
        else {
          var newTop = documentHeight - s.stickyElement.outerHeight()
            - s.topSpacing - s.bottomSpacing - scrollTop - extra;
          if (newTop < 0) {
            newTop = newTop + s.topSpacing;
          } else {
            newTop = s.topSpacing;
          }
          if (s.currentTop !== newTop) {
            var newWidth;
            if (s.getWidthFrom) {
                padding =  s.stickyElement.innerWidth() - s.stickyElement.width();
                newWidth = $(s.getWidthFrom).width() - padding || null;
            } else if (s.widthFromWrapper) {
                newWidth = s.stickyWrapper.width();
            }
            if (newWidth == null) {
                newWidth = s.stickyElement.width();
            }
            s.stickyElement
              .css('width', newWidth)
              .css('position', 'fixed')
              .css('top', newTop)
              .css('z-index', s.zIndex);

            s.stickyElement.parent().addClass(s.className);

            if (s.currentTop === null) {
              s.stickyElement.trigger('sticky-start', [s]);
            } else {
              // sticky is started but it have to be repositioned
              s.stickyElement.trigger('sticky-update', [s]);
            }

            if (s.currentTop === s.topSpacing && s.currentTop > newTop || s.currentTop === null && newTop < s.topSpacing) {
              // just reached bottom || just started to stick but bottom is already reached
              s.stickyElement.trigger('sticky-bottom-reached', [s]);
            } else if(s.currentTop !== null && newTop === s.topSpacing && s.currentTop < newTop) {
              // sticky is started && sticked at topSpacing && overflowing from top just finished
              s.stickyElement.trigger('sticky-bottom-unreached', [s]);
            }

            s.currentTop = newTop;
          }

          // Check if sticky has reached end of container and stop sticking
          var stickyWrapperContainer = s.stickyWrapper.parent();
          var unstick = (s.stickyElement.offset().top + s.stickyElement.outerHeight() >= stickyWrapperContainer.offset().top + stickyWrapperContainer.outerHeight()) && (s.stickyElement.offset().top <= s.topSpacing);

          // workaround for Shopify chat conflict
          //if( unstick ) {
            //s.stickyElement
              //.css('position', 'absolute')
              //.css('top', '')
              //.css('bottom', 0)
              //.css('z-index', '');
          //} else {
            s.stickyElement
              .css('position', 'fixed')
              .css('top', newTop)
              .css('bottom', '')
              .css('z-index', s.zIndex);
          //}
        }
      }
    },
    resizer = function() {
      windowHeight = $window.height();

      for (var i = 0, l = sticked.length; i < l; i++) {
        var s = sticked[i];
        var newWidth = null;
        if (s.getWidthFrom) {
            if (s.responsiveWidth) {
                newWidth = $(s.getWidthFrom).width();
            }
        } else if(s.widthFromWrapper) {
            newWidth = s.stickyWrapper.width();
        }
        if (newWidth != null) {
            s.stickyElement.css('width', newWidth);
        }
      }
    },
    methods = {
      init: function(options) {
        return this.each(function() {
          var o = $.extend({}, defaults, options);
          var stickyElement = $(this);

          var stickyId = stickyElement.attr('id');
          var wrapperId = stickyId ? stickyId + '-' + defaults.wrapperClassName : defaults.wrapperClassName;
          var wrapper = $('<div></div>')
            .attr('id', wrapperId)
            .addClass(o.wrapperClassName);

          stickyElement.wrapAll(function() {
            if ($(this).parent("#" + wrapperId).length == 0) {
                    return wrapper;
            }
});

          var stickyWrapper = stickyElement.parent();

          if (o.center) {
            stickyWrapper.css({width:stickyElement.outerWidth(),marginLeft:"auto",marginRight:"auto"});
          }

          if (stickyElement.css("float") === "right") {
            stickyElement.css({"float":"none"}).parent().css({"float":"right"});
          }

          o.stickyElement = stickyElement;
          o.stickyWrapper = stickyWrapper;
          o.currentTop    = null;

          sticked.push(o);

          methods.setWrapperHeight(this);
          methods.setupChangeListeners(this);
        });
      },

      setWrapperHeight: function(stickyElement) {
        var element = $(stickyElement);
        var stickyWrapper = element.parent();
        if (stickyWrapper) {
          stickyWrapper.css('height', element.outerHeight());
        }
      },

      setupChangeListeners: function(stickyElement) {
        if (window.MutationObserver) {
          var mutationObserver = new window.MutationObserver(function(mutations) {
            if (mutations[0].addedNodes.length || mutations[0].removedNodes.length) {
              methods.setWrapperHeight(stickyElement);
            }
          });
          mutationObserver.observe(stickyElement, {subtree: true, childList: true});
        } else {
          if (window.addEventListener) {
            stickyElement.addEventListener('DOMNodeInserted', function() {
              methods.setWrapperHeight(stickyElement);
            }, false);
            stickyElement.addEventListener('DOMNodeRemoved', function() {
              methods.setWrapperHeight(stickyElement);
            }, false);
          } else if (window.attachEvent) {
            stickyElement.attachEvent('onDOMNodeInserted', function() {
              methods.setWrapperHeight(stickyElement);
            });
            stickyElement.attachEvent('onDOMNodeRemoved', function() {
              methods.setWrapperHeight(stickyElement);
            });
          }
        }
      },
      update: scroller,
      unstick: function(options) {
        return this.each(function() {
          var that = this;
          var unstickyElement = $(that);

          var removeIdx = -1;
          var i = sticked.length;
          while (i-- > 0) {
            if (sticked[i].stickyElement.get(0) === that) {
                splice.call(sticked,i,1);
                removeIdx = i;
            }
          }
          if(removeIdx !== -1) {
            unstickyElement.unwrap();
            unstickyElement
              .css({
                'width': '',
                'position': '',
                'top': '',
                'float': '',
                'z-index': ''
              })
            ;
          }
        });
      }
    };

  // should be more efficient than using $window.scroll(scroller) and $window.resize(resizer):
  if (window.addEventListener) {
    window.addEventListener('scroll', scroller, false);
    window.addEventListener('resize', resizer, false);
  } else if (window.attachEvent) {
    window.attachEvent('onscroll', scroller);
    window.attachEvent('onresize', resizer);
  }

  $.fn.sticky = function(method) {
    if (methods[method]) {
      return methods[method].apply(this, slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method ) {
      return methods.init.apply( this, arguments );
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.sticky');
    }
  };

  $.fn.unstick = function(method) {
    if (methods[method]) {
      return methods[method].apply(this, slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method ) {
      return methods.unstick.apply( this, arguments );
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.sticky');
    }
  };
  $(function() {
    setTimeout(scroller, 0);
  });
}));





// (function($){"use strict";$.ajaxChimp={responses:{"We have sent you a confirmation email":0,"Please enter a value":1,"An email address must contain a single @":2,"The domain portion of the email address is invalid (the portion after the @: )":3,"The username portion of the email address is invalid (the portion before the @: )":4,"This email address looks fake or invalid. Please enter a real email address":5},translations:{en:null},init:function(selector,options){$(selector).ajaxChimp(options)}};$.fn.ajaxChimp=function(options){$(this).each(function(i,elem){var form=$(elem);var email=form.find("input[type=email]");var label=form.find("label[for="+email.attr("id")+"]");var settings=$.extend({url:form.attr("action"),language:"en"},options);var url=settings.url.replace("/post?","/post-json?").concat("&c=?");form.attr("novalidate","true");email.attr("name","EMAIL");form.submit(function(){var msg;function successCallback(resp){if(resp.result==="success"){msg="We have sent you a confirmation email";label.removeClass("error").addClass("valid");email.removeClass("error").addClass("valid")}else{email.removeClass("valid").addClass("error");label.removeClass("valid").addClass("error");var index=-1;try{var parts=resp.msg.split(" - ",2);if(parts[1]===undefined){msg=resp.msg}else{var i=parseInt(parts[0],10);if(i.toString()===parts[0]){index=parts[0];msg=parts[1]}else{index=-1;msg=resp.msg}}}catch(e){index=-1;msg=resp.msg}}if(settings.language!=="en"&&$.ajaxChimp.responses[msg]!==undefined&&$.ajaxChimp.translations&&$.ajaxChimp.translations[settings.language]&&$.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]]){msg=$.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]]}label.html(msg);label.show(2e3);if(settings.callback){settings.callback(resp)}}var data={};var dataArray=form.serializeArray();$.each(dataArray,function(index,item){data[item.name]=item.value});$.ajax({url:url,data:data,success:successCallback,dataType:"jsonp",error:function(resp,text){console.log("mailchimp ajax submit error: "+text)}});var submitMsg="Submitting...";if(settings.language!=="en"&&$.ajaxChimp.translations&&$.ajaxChimp.translations[settings.language]&&$.ajaxChimp.translations[settings.language]["submit"]){submitMsg=$.ajaxChimp.translations[settings.language]["submit"]}label.html(submitMsg).show(2e3);return false})});return this}})(jQuery);

if ($('body.template-product').length)
{
/*!
  Zoom 1.7.20
  license: MIT
  http://www.jacklmoore.com/zoom
*/
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,r,a,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(a=c,r=u):(a=d.outerWidth(),r=d.outerHeight()),m=(e.width-c)/a,l=(e.height-u)/r,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,r),0),t=Math.max(Math.min(t,a),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),r=document.createElement("img"),a=o(r),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,r.onload=null,a.remove()}.bind(this,i.style.position,i.style.overflow)),r.onload=function(){function t(t){f.init(),f.move(t),a.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(r):!1)}function n(){a.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(r):!1)}var f=o.zoom(i,u,r,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(r)},r.setAttribute("role","presentation"),r.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);

(function(e){"use strict";e.fn.pin=function(t){var n=0,r=[],i=false,s=e(window);t=t||{};var o=function(){for(var n=0,o=r.length;n<o;n++){var u=r[n];if(t.minWidth&&s.width()<=t.minWidth){if(u.parent().is(".pin-wrapper")){u.unwrap()}u.css({width:"",left:"",top:"",position:""});if(t.activeClass){u.removeClass(t.activeClass)}i=true;continue}else{i=false}var a=t.containerSelector?u.closest(t.containerSelector):e(document.body);var f=u.offset();var l=a.offset();var c=u.offsetParent().offset();if(!u.parent().is(".pin-wrapper")){u.wrap("<div class='pin-wrapper'>")}var h=e.extend({top:0,bottom:0},t.padding||{});u.data("pin",{pad:h,from:(t.containerSelector?l.top:f.top)-h.top,to:l.top+a.height()-u.outerHeight()-h.bottom,end:l.top+a.height(),parentTop:c.top});u.css({width:u.outerWidth()});u.parent().css("height",u.outerHeight())}};var u=function(){if(i){return}n=s.scrollTop();var o=[];for(var u=0,a=r.length;u<a;u++){var f=e(r[u]),l=f.data("pin");if(!l){continue}o.push(f);var c=l.from-l.pad.bottom,h=l.to-l.pad.top;if(c+f.outerHeight()>l.end){f.css("position","");continue}if(c<n&&h>n){!(f.css("position")=="fixed")&&f.css({left:f.offset().left,top:l.pad.top}).css("position","fixed");if(t.activeClass){f.addClass(t.activeClass)}}else if(n>=h){f.css({left:"",top:h-l.parentTop+l.pad.top}).css("position","absolute");if(t.activeClass){f.addClass(t.activeClass)}}else{f.css({position:"",top:"",left:""});if(t.activeClass){f.removeClass(t.activeClass)}}}r=o};var a=function(){o();u()};this.each(function(){var t=e(this),n=e(this).data("pin")||{};if(n&&n.update){return}r.push(t);e("img",this).one("load",o);n.update=a;e(this).data("pin",n)});s.scroll(u);s.resize(function(){o()});o();s.load(a);return this}})(jQuery)
}






if ($('.counter').length)
{
/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function(){"use strict";function t(o){if(!o)throw new Error("No options passed to Waypoint constructor");if(!o.element)throw new Error("No element option passed to Waypoint constructor");if(!o.handler)throw new Error("No handler option passed to Waypoint constructor");this.key="waypoint-"+e,this.options=t.Adapter.extend({},t.defaults,o),this.element=this.options.element,this.adapter=new t.Adapter(this.element),this.callback=o.handler,this.axis=this.options.horizontal?"horizontal":"vertical",this.enabled=this.options.enabled,this.triggerPoint=null,this.group=t.Group.findOrCreate({name:this.options.group,axis:this.axis}),this.context=t.Context.findOrCreateByElement(this.options.context),t.offsetAliases[this.options.offset]&&(this.options.offset=t.offsetAliases[this.options.offset]),this.group.add(this),this.context.add(this),i[this.key]=this,e+=1}var e=0,i={};t.prototype.queueTrigger=function(t){this.group.queueTrigger(this,t)},t.prototype.trigger=function(t){this.enabled&&this.callback&&this.callback.apply(this,t)},t.prototype.destroy=function(){this.context.remove(this),this.group.remove(this),delete i[this.key]},t.prototype.disable=function(){return this.enabled=!1,this},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0,this},t.prototype.next=function(){return this.group.next(this)},t.prototype.previous=function(){return this.group.previous(this)},t.invokeAll=function(t){var e=[];for(var o in i)e.push(i[o]);for(var n=0,r=e.length;r>n;n++)e[n][t]()},t.destroyAll=function(){t.invokeAll("destroy")},t.disableAll=function(){t.invokeAll("disable")},t.enableAll=function(){t.Context.refreshAll();for(var e in i)i[e].enabled=!0;return this},t.refreshAll=function(){t.Context.refreshAll()},t.viewportHeight=function(){return window.innerHeight||document.documentElement.clientHeight},t.viewportWidth=function(){return document.documentElement.clientWidth},t.adapters=[],t.defaults={context:window,continuous:!0,enabled:!0,group:"default",horizontal:!1,offset:0},t.offsetAliases={"bottom-in-view":function(){return this.context.innerHeight()-this.adapter.outerHeight()},"right-in-view":function(){return this.context.innerWidth()-this.adapter.outerWidth()}},window.Waypoint=t}(),function(){"use strict";function t(t){window.setTimeout(t,1e3/60)}function e(t){this.element=t,this.Adapter=n.Adapter,this.adapter=new this.Adapter(t),this.key="waypoint-context-"+i,this.didScroll=!1,this.didResize=!1,this.oldScroll={x:this.adapter.scrollLeft(),y:this.adapter.scrollTop()},this.waypoints={vertical:{},horizontal:{}},t.waypointContextKey=this.key,o[t.waypointContextKey]=this,i+=1,n.windowContext||(n.windowContext=!0,n.windowContext=new e(window)),this.createThrottledScrollHandler(),this.createThrottledResizeHandler()}var i=0,o={},n=window.Waypoint,r=window.onload;e.prototype.add=function(t){var e=t.options.horizontal?"horizontal":"vertical";this.waypoints[e][t.key]=t,this.refresh()},e.prototype.checkEmpty=function(){var t=this.Adapter.isEmptyObject(this.waypoints.horizontal),e=this.Adapter.isEmptyObject(this.waypoints.vertical),i=this.element==this.element.window;t&&e&&!i&&(this.adapter.off(".waypoints"),delete o[this.key])},e.prototype.createThrottledResizeHandler=function(){function t(){e.handleResize(),e.didResize=!1}var e=this;this.adapter.on("resize.waypoints",function(){e.didResize||(e.didResize=!0,n.requestAnimationFrame(t))})},e.prototype.createThrottledScrollHandler=function(){function t(){e.handleScroll(),e.didScroll=!1}var e=this;this.adapter.on("scroll.waypoints",function(){(!e.didScroll||n.isTouch)&&(e.didScroll=!0,n.requestAnimationFrame(t))})},e.prototype.handleResize=function(){n.Context.refreshAll()},e.prototype.handleScroll=function(){var t={},e={horizontal:{newScroll:this.adapter.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.adapter.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};for(var i in e){var o=e[i],n=o.newScroll>o.oldScroll,r=n?o.forward:o.backward;for(var s in this.waypoints[i]){var a=this.waypoints[i][s];if(null!==a.triggerPoint){var l=o.oldScroll<a.triggerPoint,h=o.newScroll>=a.triggerPoint,p=l&&h,u=!l&&!h;(p||u)&&(a.queueTrigger(r),t[a.group.id]=a.group)}}}for(var c in t)t[c].flushTriggers();this.oldScroll={x:e.horizontal.newScroll,y:e.vertical.newScroll}},e.prototype.innerHeight=function(){return this.element==this.element.window?n.viewportHeight():this.adapter.innerHeight()},e.prototype.remove=function(t){delete this.waypoints[t.axis][t.key],this.checkEmpty()},e.prototype.innerWidth=function(){return this.element==this.element.window?n.viewportWidth():this.adapter.innerWidth()},e.prototype.destroy=function(){var t=[];for(var e in this.waypoints)for(var i in this.waypoints[e])t.push(this.waypoints[e][i]);for(var o=0,n=t.length;n>o;o++)t[o].destroy()},e.prototype.refresh=function(){var t,e=this.element==this.element.window,i=e?void 0:this.adapter.offset(),o={};this.handleScroll(),t={horizontal:{contextOffset:e?0:i.left,contextScroll:e?0:this.oldScroll.x,contextDimension:this.innerWidth(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:e?0:i.top,contextScroll:e?0:this.oldScroll.y,contextDimension:this.innerHeight(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};for(var r in t){var s=t[r];for(var a in this.waypoints[r]){var l,h,p,u,c,d=this.waypoints[r][a],f=d.options.offset,w=d.triggerPoint,y=0,g=null==w;d.element!==d.element.window&&(y=d.adapter.offset()[s.offsetProp]),"function"==typeof f?f=f.apply(d):"string"==typeof f&&(f=parseFloat(f),d.options.offset.indexOf("%")>-1&&(f=Math.ceil(s.contextDimension*f/100))),l=s.contextScroll-s.contextOffset,d.triggerPoint=Math.floor(y+l-f),h=w<s.oldScroll,p=d.triggerPoint>=s.oldScroll,u=h&&p,c=!h&&!p,!g&&u?(d.queueTrigger(s.backward),o[d.group.id]=d.group):!g&&c?(d.queueTrigger(s.forward),o[d.group.id]=d.group):g&&s.oldScroll>=d.triggerPoint&&(d.queueTrigger(s.forward),o[d.group.id]=d.group)}}return n.requestAnimationFrame(function(){for(var t in o)o[t].flushTriggers()}),this},e.findOrCreateByElement=function(t){return e.findByElement(t)||new e(t)},e.refreshAll=function(){for(var t in o)o[t].refresh()},e.findByElement=function(t){return o[t.waypointContextKey]},window.onload=function(){r&&r(),e.refreshAll()},n.requestAnimationFrame=function(e){var i=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||t;i.call(window,e)},n.Context=e}(),function(){"use strict";function t(t,e){return t.triggerPoint-e.triggerPoint}function e(t,e){return e.triggerPoint-t.triggerPoint}function i(t){this.name=t.name,this.axis=t.axis,this.id=this.name+"-"+this.axis,this.waypoints=[],this.clearTriggerQueues(),o[this.axis][this.name]=this}var o={vertical:{},horizontal:{}},n=window.Waypoint;i.prototype.add=function(t){this.waypoints.push(t)},i.prototype.clearTriggerQueues=function(){this.triggerQueues={up:[],down:[],left:[],right:[]}},i.prototype.flushTriggers=function(){for(var i in this.triggerQueues){var o=this.triggerQueues[i],n="up"===i||"left"===i;o.sort(n?e:t);for(var r=0,s=o.length;s>r;r+=1){var a=o[r];(a.options.continuous||r===o.length-1)&&a.trigger([i])}}this.clearTriggerQueues()},i.prototype.next=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints),o=i===this.waypoints.length-1;return o?null:this.waypoints[i+1]},i.prototype.previous=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints);return i?this.waypoints[i-1]:null},i.prototype.queueTrigger=function(t,e){this.triggerQueues[e].push(t)},i.prototype.remove=function(t){var e=n.Adapter.inArray(t,this.waypoints);e>-1&&this.waypoints.splice(e,1)},i.prototype.first=function(){return this.waypoints[0]},i.prototype.last=function(){return this.waypoints[this.waypoints.length-1]},i.findOrCreate=function(t){return o[t.axis][t.name]||new i(t)},n.Group=i}(),function(){"use strict";function t(t){this.$element=e(t)}var e=window.jQuery,i=window.Waypoint;e.each(["innerHeight","innerWidth","off","offset","on","outerHeight","outerWidth","scrollLeft","scrollTop"],function(e,i){t.prototype[i]=function(){var t=Array.prototype.slice.call(arguments);return this.$element[i].apply(this.$element,t)}}),e.each(["extend","inArray","isEmptyObject"],function(i,o){t[o]=e[o]}),i.adapters.push({name:"jquery",Adapter:t}),i.Adapter=t}(),function(){"use strict";function t(t){return function(){var i=[],o=arguments[0];return t.isFunction(arguments[0])&&(o=t.extend({},arguments[1]),o.handler=arguments[0]),this.each(function(){var n=t.extend({},o,{element:this});"string"==typeof n.context&&(n.context=t(this).closest(n.context)[0]),i.push(new e(n))}),i}}var e=window.Waypoint;window.jQuery&&(window.jQuery.fn.waypoint=t(window.jQuery)),window.Zepto&&(window.Zepto.fn.waypoint=t(window.Zepto))}();
}




if ($('.counter').length)
{

/*!
* jquery.counterup-custom.js 1.0
*
* Copyright 2013, Benjamin Intal http://gambit.ph @bfintal
* Released under the GPL v2 License
*
* Date: Nov 26, 2013
*/!function(t){"use strict";t.fn.counterUp=function(e){var n=t.extend({time:400,delay:10},e);return this.each(function(){var e=t(this),u=n,a=e.text(),r=function(){var t=[],n=u.time/u.delay,r=a,c=/[0-9]+,[0-9]+/.test(r);r=r.replace(/,/g,""),/^[0-9]+$/.test(r);for(var o=/^[0-9]+\.[0-9]+$/.test(r),d=o?(r.split(".")[1]||[]).length:0,i=n;i>=1;i--){var f=parseInt(r/n*i);if(o&&(f=parseFloat(r/n*i).toFixed(d)),c)for(;/(\d+)(\d{3})/.test(f.toString());)f=f.toString().replace(/(\d+)(\d{3})/,"$1,$2");t.unshift(f)}e.data("counterup-nums",t),e.text("0");var s=function(){e.text(e.data("counterup-nums").shift()),e.data("counterup-nums").length?setTimeout(e.data("counterup-func"),u.delay):(delete e.data("counterup-nums"),e.data("counterup-nums",null),e.data("counterup-func",null))};e.data("counterup-func",s),setTimeout(e.data("counterup-func"),u.delay)};e.waypoint(r,{offset:"100%",triggerOnce:!0})})}}(jQuery);
}

// EqualHeight
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);



if ($('body.template-page .page-reviews').length)
{
/*!

Name: Instagram Lite
Dependencies: jQuery
Author: Michael Lynch
Author URL: http://michaelynch.com
Date Created: January 14, 2014
Licensed under the MIT license

*/

;(function($) {

  $.fn.instagramLite = function(options) {

    // return if no element was bound
    // so chained events can continue
    if(!this.length) {
      return this;
    }

    // define plugin
    plugin = this;

    // define default parameters
    plugin.defaults = {
      accessToken: null,
      user_id: 'self',
      limit: null,
      list: true,
      videos: false,
      urls: false,
      captions: false,
      date: false,
      likes: false,
      comments_count: false,
      error: function() {},
      success: function() {}
    }

    // vars
    var s = $.extend({}, plugin.defaults, options),
      el = $(this);

    var formatCaption = function(caption) {

      var words = caption.split(' '),
        newCaption = '';

      for(var i = 0; i < words.length; i++) {

        var word;

        if(words[i][0] == '@') {
          var a = '<a href="http://instagram.com/'+words[i].replace('@', '').toLowerCase()+'" target="_blank">'+words[i]+'</a>';
          word = a;
        } else if(words[i][0] == '#') {
          var a = '<a href="http://instagram.com/explore/tags/'+words[i].replace('#', '').toLowerCase()+'" target="_blank">'+words[i]+'</a>';
          word = a;
        } else {
          word = words[i]
        }

        newCaption += word + ' ';
      }

      return newCaption;

    };

    var constructMedia = function(data) {

      // for each piece of media returned
      for(var i = 0; i < data.length; i++) {

        // define media namespace
        var thisMedia = data[i],
          item;

        // if media type is image or videos is set to false
        if(thisMedia.type === 'image' || thisMedia.type === 'carousel' || !s.videos) {

          // construct image
          item = '<img class="il-photo__img" src="'+thisMedia.images.standard_resolution.url+'" alt="Instagram Image" data-filter="'+thisMedia.filter+'" />';

          // if url setting is true
          if(s.urls) {
            item = '<a href="'+thisMedia.link+'" target="_blank">'+item+'<div class="insta-hover"><div class="instahover-inner"><img src="//www.mytruwood.com/cdn/shop/files/instagram.svg?90318"><span>SHOP ON INSTAGRAM</span></div></div></a>';
          }

          if(s.captions || s.date || s.likes || s.comments_count) {
            item += '<div class="il-photo__meta">';
          }

          // if caption setting is true
          if(s.captions && thisMedia.caption) {
            item += '<div class="il-photo__caption" data-caption-id="'+thisMedia.caption.id+'">'+formatCaption(thisMedia.caption.text)+'</div>';
          }

          // if date setting is true
          if(s.date) {

            var date = new Date(thisMedia.created_time * 1000),
              day = date.getDate(),
              month = date.getMonth() + 1,
              year = date.getFullYear(),
              hours = date.getHours(),
              minutes = date.getMinutes(),
              seconds = date.getSeconds();

            date = month +'/'+ day +'/'+ year;

            item += '<div class="il-photo__date">'+date+'</div>';
          }

          // if likes setting is true
          if(s.likes) {
            item += '<div class="il-photo__likes">'+thisMedia.likes.count+'</div>';
          }

          // if caption setting is true
          if(s.comments_count && thisMedia.comments) {
            item += '<div class="il-photo__comments">'+thisMedia.comments.count+'</div>';
          }

          if(s.captions || s.date || s.likes || s.comments_count) {
            item += '</div>';
          }
        }

        if(thisMedia.type === 'video' && s.videos) {

          if(thisMedia.videos) {

            var src;

            if(thisMedia.videos.standard_resolution) {
              src = thisMedia.videos.standard_resolution.url;
            } else if(thisMedia.videos.low_resolution) {
              src = thisMedia.videos.low_resolution.url;
            } else if(thisMedia.videos.low_bandwidth) {
              src = thisMedia.videos.low_bandwidth.url;
            }

            item = '<video poster="'+thisMedia.images.standard_resolution.url+'" controls>';
            item += '<source src="'+src+'" type="video/mp4;"></source>';
            item += '</video>';
          }
        }

        // if list setting is true
        if(s.list && item) {
          // redefine item with wrapping list item
                  item = '<li class="il-item instagram-item-'+i+'" data-instagram-id="'+thisMedia.id+'">'+item+'</li>';
        }

        // append image / video
        if(item !== '') {
          el.append(item);
        }
      }
    }

    var loadContent = function() {

      // if access token
      if(s.accessToken) {

        // construct API endpoint
        var url = 'https://api.instagram.com/v1/users/'+s.user_id+'/media/recent/?access_token='+s.accessToken+'&count='+s.limit;

        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'jsonp',
          success: function(data) {

            // if success status
            if(data.meta.code === 200 && data.data.length) {

              // construct media
              constructMedia(data.data);

              // execute success callback
              s.success.call(this);

            } else {
              // execute error callback
              s.error.call(this);
            }
          },
          error: function() {
            // execute error callback
            s.error.call(this);
          }
        });
      }
    }

    // init
    loadContent();
  }
})(jQuery);
}


/*  jQuery Nice Select - v1.1.0
    https://github.com/hernansartorio/jquery-nice-select
    Made by Hernán Sartorio  */
 
(function($) {}(jQuery));
! function(e) {
  e.fn.niceSelect2 = function() {
    this.each(function() {
      var s = e(this);
      if (!s.next().hasClass("nice-select") && !s.hasClass("nice-select")) {
        s.after('<div class="nice-select ' + (s.attr("class") || "") + (s.attr("disabled") ? "disabled" : '" tabindex="0') + '"><span class="current"></span><ul class="list"></ul></div>');
        var t = s.next(),
            n = s.find("option"),
            a = s.find("option:selected");
        t.find(".current").html('<span class="flags flags-' + a.data("country") + ' lazyload" data-bgset="//www.mytruwood.com/cdn/shop/t/369/assets/flags.png?v=105310174882409470371743694261 520w 510h" data-parent-fit="cover"></span> &nbsp;' + a.data("display") || a.text()), n.each(function() {
          var s = e(this).data("display");
          t.find("ul").append('<li class="option ' + (e(this).is(":selected") ? "selected" : "") + '" data-value="' + e(this).val() + '" data-country="' + e(this).data("country") + (s ? '" data-currency-symbol="' + e(this).data("currency-symbol") + '" data-display="' + s : "") + '"><span class="flags flags-' + e(this).data("country") + ' lazyload" data-bgset="//www.mytruwood.com/cdn/shop/t/369/assets/flags.png?v=105310174882409470371743694261 520w 510h" data-parent-fit="cover"></span> &nbsp;' + e(this).text() + "</li>")
        })
      }
    }), e(document).off(".nice_select"), e(document).on("click.nice_select", ".nice-select", function(s) {
      var t = e(this);
      e(".nice-select").not(t).removeClass("open"), t.toggleClass("open"), t.hasClass("open") ? (t.find(".option"), t.find(".focus").removeClass("focus"), t.find(".selected").addClass("focus")) : t.focus()
    }), e(document).on("click.nice_select", function(s) {
      0 === e(s.target).closest(".nice-select").length && e(".nice-select").removeClass("open").find(".option")
    }), e(document).on("click.nice_select", ".nice-select .option", function(s) {
      var t = e(this);
      e(".nice-select").each(function() {
        var s = e(this).find('.option[data-value="' + t.data("value") + '"]'),
            n = s.closest(".nice-select");
        n.find(".selected").removeClass("selected"), s.addClass("selected");
        var a = '<span class="flags flags-' + s.data("country") + ' lazyload" data-bgset="//www.mytruwood.com/cdn/shop/t/369/assets/flags.png?v=105310174882409470371743694261 520w 510h" data-parent-fit="cover"></span> &nbsp;' + s.data("display") || s.text();
        n.find(".current").html(a), n.prev("select").val(s.data("value")).trigger("change")
      })
    }), e(document).on("keydown.nice_select", ".nice-select", function(s) {
      var t = e(this),
          n = e(t.find(".focus") || t.find(".list .option.selected"));
      if (32 == s.keyCode || 13 == s.keyCode) return t.hasClass("open") ? n.trigger("click") : t.trigger("click"), !1;
      if (40 == s.keyCode) return t.hasClass("open") ? n.next().length > 0 && (t.find(".focus").removeClass("focus"), n.next().addClass("focus")) : t.trigger("click"), !1;
      if (38 == s.keyCode) return t.hasClass("open") ? n.prev().length > 0 && (t.find(".focus").removeClass("focus"), n.prev().addClass("focus")) : t.trigger("click"), !1;
      if (27 == s.keyCode) t.hasClass("open") && t.trigger("click");
      else if (9 == s.keyCode && t.hasClass("open")) return !1
        })
  }
}(jQuery);

/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license */
window.matchMedia||(window.matchMedia=function(){"use strict";var e=window.styleMedia||window.media;if(!e){var t=document.createElement("style"),n=document.getElementsByTagName("script")[0],d=null;t.type="text/css",t.id="matchmediajs-test",n?n.parentNode.insertBefore(t,n):document.head.appendChild(t),d="getComputedStyle"in window&&window.getComputedStyle(t,null)||t.currentStyle,e={matchMedium:function(e){var n="@media "+e+"{ #matchmediajs-test { width: 1px; } }";return t.styleSheet?t.styleSheet.cssText=n:t.textContent=n,"1px"===d.width}}}return function(t){return{matches:e.matchMedium(t||"all"),media:t||"all"}}}());

/*! matchMedia() polyfill addListener/removeListener extension. Author & copyright (c) 2012: Scott Jehl. Dual MIT/BSD license */
!function(){if(window.matchMedia&&window.matchMedia("all").addListener)return!1;var e=window.matchMedia,n=e("only all").matches,i=!1,t=0,a=[],r=function(n){clearTimeout(t),t=setTimeout(function(){for(var n=0,i=a.length;n<i;n++){var t=a[n].mql,r=a[n].listeners||[],o=e(t.media).matches;if(o!==t.matches){t.matches=o;for(var c=0,d=r.length;c<d;c++)r[c].call(window,t)}}},30)};window.matchMedia=function(t){var o=e(t),c=[],d=0;return o.addListener=function(e){n&&(i||(i=!0,window.addEventListener("resize",r,!0)),0===d&&(d=a.push({mql:o,listeners:c})),c.push(e))},o.removeListener=function(e){for(var n=0,i=c.length;n<i;n++)c[n]===e&&c.splice(n,1)},o}}();

/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!function(a,b,c){var d=window.matchMedia;"undefined"!=typeof module&&module.exports?module.exports=c(d):"function"==typeof define&&define.amd?define(function(){return b[a]=c(d)}):b[a]=c(d)}("enquire",this,function(a){"use strict";function b(a,b){var c,d=0,e=a.length;for(d;e>d&&(c=b(a[d],d),c!==!1);d++);}function c(a){return"[object Array]"===Object.prototype.toString.apply(a)}function d(a){return"function"==typeof a}function e(a){this.options=a,!a.deferSetup&&this.setup()}function f(b,c){this.query=b,this.isUnconditional=c,this.handlers=[],this.mql=a(b);var d=this;this.listener=function(a){d.mql=a,d.assess()},this.mql.addListener(this.listener)}function g(){if(!a)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!a("only all").matches}return e.prototype={setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},f.prototype={addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var c=this.handlers;b(c,function(b,d){return b.equals(a)?(b.destroy(),!c.splice(d,1)):void 0})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){b(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";b(this.handlers,function(b){b[a]()})}},g.prototype={register:function(a,e,g){var h=this.queries,i=g&&this.browserIsIncapable;return h[a]||(h[a]=new f(a,i)),d(e)&&(e={match:e}),c(e)||(e=[e]),b(e,function(b){d(b)&&(b={match:b}),h[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},new g});

/*! Magnific Popup - v1.0.0 - 2015-03-30
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2015 Dmitry Semenov; */

// customization, no autofocus on init if focused element has class "search-input-temp"
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isIE7=-1!==c.indexOf("MSIE 7."),b.isIE8=-1!==c.indexOf("MSIE 8."),b.isLowIE=b.isIE7||b.isIE8,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",b.ev=c.mainEl&&c.mainEl.length?c.mainEl.eq(0):d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.wrap.css(b.fixedContentPos?{overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}:{top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),(!b._lastFocusedEl.classList.contains('search-input-temp') && b._setFocus())):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),b.currTemplate[d]=f?a(f):!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||2!==c.which&&!c.ctrlKey&&!c.metaKey){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(a,c){if(void 0===c||c===!1)return!0;if(e=a.split("_"),e.length>1){var d=b.find(p+"-"+e[0]);if(d.length>0){var f=e[1];"replaceWith"===f?d[0]!==c[0]&&d.replaceWith(c):"img"===f?d.is("img")?d.attr("src",c):d.replaceWith('<img src="'+c+'" class="'+d.attr("class")+'" />'):d.attr(e[1],c)}}else b.find(p+"-"+a).html(c)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&times;</button>',tClose:"Close (Esc)",tLoading:"Loading..."}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery",g=Boolean(a.fn.mfpFastClick);return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s),h=g?"mfpFastClick":"click";e[h](function(){b.prev()}),f[h](function(){b.next()}),b.isIE7&&(x("b",e[0],!1,!0),x("a",e[0],!1,!0),x("b",f[0],!1,!0),x("a",f[0],!1,!0)),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowLeft&&g&&b.arrowLeft.add(b.arrowRight).destroyMfpFastClick(),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),function(){var b=1e3,c="ontouchstart"in window,d=function(){v.off("touchmove"+f+" touchend"+f)},e="mfpFastClick",f="."+e;a.fn.mfpFastClick=function(e){return a(this).each(function(){var g,h=a(this);if(c){var i,j,k,l,m,n;h.on("touchstart"+f,function(a){l=!1,n=1,m=a.originalEvent?a.originalEvent.touches[0]:a.touches[0],j=m.clientX,k=m.clientY,v.on("touchmove"+f,function(a){m=a.originalEvent?a.originalEvent.touches:a.touches,n=m.length,m=m[0],(Math.abs(m.clientX-j)>10||Math.abs(m.clientY-k)>10)&&(l=!0,d())}).on("touchend"+f,function(a){d(),l||n>1||(g=!0,a.preventDefault(),clearTimeout(i),i=setTimeout(function(){g=!1},b),e())})})}h.on("click"+f,function(){g||e()})})},a.fn.destroyMfpFastClick=function(){a(this).off("touchstart"+f+" click"+f),c&&v.off("touchmove"+f+" touchend"+f)}}(),A()});





/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
/*
customizations:
- new easing default 'ease'
- new Chrome mobile defaults
- requestAnimationFrame / cancelAnimationFrame implementation
- return to active slide on touchend if direction is vertical
- append '-clone' to clone slide ids and related attributes
*/
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";!function(){for(var i=0,t=["ms","moz","webkit","o"],s=0;s<t.length&&!window.requestAnimationFrame;++s)window.requestAnimationFrame=window[t[s]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[t[s]+"CancelAnimationFrame"]||window[t[s]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(t,s){var e=new Date().getTime(),o=Math.max(0,16-(e-i)),n=window.setTimeout(function(){t(e+o)},o);return i=e+o,n}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(i){clearTimeout(i)})}();var t,s=window.Slick||{};(s=(t=0,function s(e,o){var n,r=this;r.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(e),appendDots:i(e),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(t,s){return i('<button type="button" />').text(s+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:window.isChromeMobile&&"function"==typeof i.easing["ease-out"]?"ease-out":"function"==typeof i.easing.ease?"ease":"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:window.isChromeMobile?150:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!window.isChromeMobile,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!window.isChromeMobile,zIndex:1e3},r.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(r,r.initials),r.activeBreakpoint=null,r.animType=null,r.animProp=null,r.breakpoints=[],r.breakpointSettings=[],r.cssTransitions=!1,r.focussed=!1,r.interrupted=!1,r.hidden="hidden",r.paused=!0,r.positionProp=null,r.respondTo=null,r.rowCount=1,r.shouldClick=!0,r.$slider=i(e),r.$slidesCache=null,r.transformType=null,r.transitionType=null,r.visibilityChange="visibilitychange",r.windowWidth=0,r.windowTimer=null,n=i(e).data("slick")||{},r.options=i.extend({},r.defaults,o,n),r.currentSlide=r.options.initialSlide,r.originalSettings=r.options,void 0!==document.mozHidden?(r.hidden="mozHidden",r.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(r.hidden="webkitHidden",r.visibilityChange="webkitvisibilitychange"),r.runAutoPlay=i.proxy(r.runAutoPlay,r),r.autoPlay=i.proxy(r.autoPlay,r),r.autoPlayClear=i.proxy(r.autoPlayClear,r),r.autoPlayIterator=i.proxy(r.autoPlayIterator,r),r.changeSlide=i.proxy(r.changeSlide,r),r.clickHandler=i.proxy(r.clickHandler,r),r.selectHandler=i.proxy(r.selectHandler,r),r.setPosition=i.proxy(r.setPosition,r),r.swipeHandler=i.proxy(r.swipeHandler,r),r.dragHandler=i.proxy(r.dragHandler,r),r.keyHandler=i.proxy(r.keyHandler,r),r.instanceUid=t++,r.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,r.registerBreakpoints(),r.init(!0)})).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},s.prototype.addSlide=s.prototype.slickAdd=function(t,s,e){var o=this;if("boolean"==typeof s)e=s,s=null;else if(s<0||s>=o.slideCount)return!1;o.unload(),"number"==typeof s?0===s&&0===o.$slides.length?i(t).appendTo(o.$slideTrack):e?i(t).insertBefore(o.$slides.eq(s)):i(t).insertAfter(o.$slides.eq(s)):!0===e?i(t).prependTo(o.$slideTrack):i(t).appendTo(o.$slideTrack),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slides.each(function(t,s){i(s).attr("data-slick-index",t)}),o.$slidesCache=o.$slides,o.reinit()},s.prototype.animateHeight=function(){if(1===this.options.slidesToShow&&!0===this.options.adaptiveHeight&&!1===this.options.vertical){var i=this.$slides.eq(this.currentSlide).outerHeight(!0);this.$list.animate({height:i},this.options.speed)}},s.prototype.animateSlide=function(t,s){var e={},o=this;if(o.animateHeight(),!0===o.options.rtl&&!1===o.options.vertical&&(t=-t),!1===o.transformsEnabled)!1===o.options.vertical?o.$slideTrack.animate({left:t},o.options.speed,o.options.easing,s):o.$slideTrack.animate({top:t},o.options.speed,o.options.easing,s);else if(!1===o.cssTransitions)!0===o.options.rtl&&(o.currentLeft=-o.currentLeft),i({animStart:o.currentLeft}).animate({animStart:t},{duration:o.options.speed,easing:o.options.easing,step:function(i){i=Math.ceil(i),!1===o.options.vertical?(e[o.animType]="translate("+i+"px, 0px)",o.$slideTrack.css(e)):(e[o.animType]="translate(0px,"+i+"px)",o.$slideTrack.css(e))},complete:function(){s&&s.call()}});else if(o.applyTransition(),t=Math.ceil(t),!1===o.options.vertical?e[o.animType]="translate3d("+t+"px, 0px, 0px)":e[o.animType]="translate3d(0px,"+t+"px, 0px)",o.$slideTrack.css(e),s){var n=null,r=function(i){null===n&&(n=i),i-n>=o.options.speed?(o.disableTransition(),s.call()):requestAnimationFrame(r)};requestAnimationFrame(r)}},s.prototype.getNavTarget=function(){var t=this.options.asNavFor;return t&&null!==t&&(t=i(t).not(this.$slider)),t},s.prototype.asNavFor=function(t){var s=this.getNavTarget();null!==s&&"object"==typeof s&&s.each(function(){var s=i(this).slick("getSlick");s.unslicked||s.slideHandler(t,!0)})},s.prototype.applyTransition=function(i){var t=this,s={};!1===t.options.fade?s[t.transitionType]=t.transformType+" "+t.options.speed+"ms "+t.options.cssEase:s[t.transitionType]="opacity "+t.options.speed+"ms "+t.options.cssEase,!1===t.options.fade?t.$slideTrack.css(s):t.$slides.eq(i).css(s)},s.prototype.autoPlayLastRun=null,s.prototype.runAutoPlay=function(i){var t,s=this;null===s.autoPlayLastRun&&(s.autoPlayLastRun=i),(t=i-s.autoPlayLastRun)>=s.options.autoplaySpeed&&(s.autoPlayIterator(),s.autoPlayLastRun=i),s.autoPlayTimer=requestAnimationFrame(s.runAutoPlay)},s.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=requestAnimationFrame(i.runAutoPlay))},s.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&(cancelAnimationFrame(i.autoPlayTimer),i.autoPlayLastRun=null)},s.prototype.autoPlayIterator=function(){var i=this,t=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(t=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(t))},s.prototype.buildArrows=function(){var t=this;!0===t.options.arrows&&(t.$prevArrow=i(t.options.prevArrow).addClass("slick-arrow"),t.$nextArrow=i(t.options.nextArrow).addClass("slick-arrow"),t.slideCount>t.options.slidesToShow?(t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.prependTo(t.options.appendArrows),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.appendTo(t.options.appendArrows),!0!==t.options.infinite&&t.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},s.prototype.buildDots=function(){var t,s,e=this;if(!0===e.options.dots&&e.slideCount>e.options.slidesToShow){for(e.$slider.addClass("slick-dotted"),s=i("<ul />").addClass(e.options.dotsClass),t=0;t<=e.getDotCount();t+=1)s.append(i("<li />").append(e.options.customPaging.call(this,e,t)));e.$dots=s.appendTo(e.options.appendDots),e.$dots.find("li").first().addClass("slick-active")}},s.prototype.buildOut=function(){var t=this;t.$slides=t.$slider.children(t.options.slide+":not(.slick-cloned)").addClass("slick-slide"),t.slideCount=t.$slides.length,t.$slides.each(function(t,s){i(s).attr("data-slick-index",t).data("originalStyling",i(s).attr("style")||"")}),t.$slider.addClass("slick-slider"),t.$slideTrack=0===t.slideCount?i('<div class="slick-track"/>').appendTo(t.$slider):t.$slides.wrapAll('<div class="slick-track"/>').parent(),t.$list=t.$slideTrack.wrap('<div class="slick-list"/>').parent(),t.$slideTrack.css("opacity",0),(!0===t.options.centerMode||!0===t.options.swipeToSlide)&&(t.options.slidesToScroll=1),i("img[data-lazy]",t.$slider).not("[src]").addClass("slick-loading"),t.setupInfinite(),t.buildArrows(),t.buildDots(),t.updateDots(),t.setSlideClasses("number"==typeof t.currentSlide?t.currentSlide:0),!0===t.options.draggable&&t.$list.addClass("draggable")},s.prototype.buildRows=function(){var i,t,s,e,o,n,r;if(e=document.createDocumentFragment(),n=this.$slider.children(),this.options.rows>0){for(i=0,r=this.options.slidesPerRow*this.options.rows,o=Math.ceil(n.length/r);i<o;i++){var l=document.createElement("div");for(t=0;t<this.options.rows;t++){var a=document.createElement("div");for(s=0;s<this.options.slidesPerRow;s++){var d=i*r+(t*this.options.slidesPerRow+s);n.get(d)&&a.appendChild(n.get(d))}l.appendChild(a)}e.appendChild(l)}this.$slider.empty().append(e),this.$slider.children().children().children().css({width:100/this.options.slidesPerRow+"%",display:"inline-block"})}},s.prototype.checkResponsive=function(t,s){var e,o,n,r=this,l=!1,a=r.$slider.width(),d=window.innerWidth||i(window).width();if("window"===r.respondTo?n=d:"slider"===r.respondTo?n=a:"min"===r.respondTo&&(n=Math.min(d,a)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){for(e in o=null,r.breakpoints)r.breakpoints.hasOwnProperty(e)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[e]&&(o=r.breakpoints[e]):n>r.breakpoints[e]&&(o=r.breakpoints[e]));null!==o?null!==r.activeBreakpoint?(o!==r.activeBreakpoint||s)&&(r.activeBreakpoint=o,"unslick"===r.breakpointSettings[o]?r.unslick(o):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[o]),!0===t&&(r.currentSlide=r.options.initialSlide),r.refresh(t)),l=o):(r.activeBreakpoint=o,"unslick"===r.breakpointSettings[o]?r.unslick(o):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[o]),!0===t&&(r.currentSlide=r.options.initialSlide),r.refresh(t)),l=o):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===t&&(r.currentSlide=r.options.initialSlide),r.refresh(t),l=o),t||!1===l||r.$slider.trigger("breakpoint",[r,l])}},s.prototype.changeSlide=function(t,s){var e,o,n,r=i(t.currentTarget);switch(r.is("a")&&t.preventDefault(),r.is("li")||(r=r.closest("li")),e=(n=this.slideCount%this.options.slidesToScroll!=0)?0:(this.slideCount-this.currentSlide)%this.options.slidesToScroll,t.data.message){case"previous":o=0===e?this.options.slidesToScroll:this.options.slidesToShow-e,this.slideCount>this.options.slidesToShow&&this.slideHandler(this.currentSlide-o,!1,s);break;case"next":o=0===e?this.options.slidesToScroll:e,this.slideCount>this.options.slidesToShow&&this.slideHandler(this.currentSlide+o,!1,s);break;case"index":var l=0===t.data.index?0:t.data.index||r.index()*this.options.slidesToScroll;this.slideHandler(this.checkNavigable(l),!1,s),r.children().trigger("focus");break;default:return}},s.prototype.checkNavigable=function(i){var t,s;if(t=this.getNavigableIndexes(),s=0,i>t[t.length-1])i=t[t.length-1];else for(var e in t){if(i<t[e]){i=s;break}s=t[e]}return i},s.prototype.cleanUpEvents=function(){this.options.dots&&null!==this.$dots&&(i("li",this.$dots).off("click.slick",this.changeSlide).off("mouseenter.slick",i.proxy(this.interrupt,this,!0)).off("mouseleave.slick",i.proxy(this.interrupt,this,!1)),!0===this.options.accessibility&&this.$dots.off("keydown.slick",this.keyHandler)),this.$slider.off("focus.slick blur.slick"),!0===this.options.arrows&&this.slideCount>this.options.slidesToShow&&(this.$prevArrow&&this.$prevArrow.off("click.slick",this.changeSlide),this.$nextArrow&&this.$nextArrow.off("click.slick",this.changeSlide),!0===this.options.accessibility&&(this.$prevArrow&&this.$prevArrow.off("keydown.slick",this.keyHandler),this.$nextArrow&&this.$nextArrow.off("keydown.slick",this.keyHandler))),this.$list.off("touchstart.slick mousedown.slick",this.swipeHandler),this.$list.off("touchmove.slick mousemove.slick",this.swipeHandler),this.$list.off("touchend.slick mouseup.slick",this.swipeHandler),this.$list.off("touchcancel.slick mouseleave.slick",this.swipeHandler),this.$list.off("click.slick",this.clickHandler),i(document).off(this.visibilityChange,this.visibility),this.cleanUpSlideEvents(),!0===this.options.accessibility&&this.$list.off("keydown.slick",this.keyHandler),!0===this.options.focusOnSelect&&i(this.$slideTrack).children().off("click.slick",this.selectHandler),i(window).off("orientationchange.slick.slick-"+this.instanceUid,this.orientationChange),i(window).off("resize.slick.slick-"+this.instanceUid,this.resize),i("[draggable!=true]",this.$slideTrack).off("dragstart",this.preventDefault),i(window).off("load.slick.slick-"+this.instanceUid,this.setPosition)},s.prototype.cleanUpSlideEvents=function(){this.$list.off("mouseenter.slick",i.proxy(this.interrupt,this,!0)),this.$list.off("mouseleave.slick",i.proxy(this.interrupt,this,!1))},s.prototype.cleanUpRows=function(){var i;this.options.rows>0&&((i=this.$slides.children().children()).removeAttr("style"),this.$slider.empty().append(i))},s.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},s.prototype.destroy=function(t){var s=this;s.autoPlayClear(),s.touchObject={},s.cleanUpEvents(),i(".slick-cloned",s.$slider).detach(),s.$dots&&s.$dots.remove(),s.$prevArrow&&s.$prevArrow.length&&(s.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),s.htmlExpr.test(s.options.prevArrow)&&s.$prevArrow.remove()),s.$nextArrow&&s.$nextArrow.length&&(s.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),s.htmlExpr.test(s.options.nextArrow)&&s.$nextArrow.remove()),s.$slides&&(s.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.detach(),s.$list.detach(),s.$slider.append(s.$slides)),s.cleanUpRows(),s.$slider.removeClass("slick-slider"),s.$slider.removeClass("slick-initialized"),s.$slider.removeClass("slick-dotted"),s.unslicked=!0,t||s.$slider.trigger("destroy",[s])},s.prototype.disableTransition=function(i){var t=this,s={};s[t.transitionType]="",!1===t.options.fade?t.$slideTrack.css(s):t.$slides.eq(i).css(s)},s.prototype.fadeSlide=function(i,t){var s=this;!1===s.cssTransitions?(s.$slides.eq(i).css({zIndex:s.options.zIndex}),s.$slides.eq(i).animate({opacity:1},s.options.speed,s.options.easing,t)):(s.applyTransition(i),s.$slides.eq(i).css({opacity:1,zIndex:s.options.zIndex}),t&&setTimeout(function(){s.disableTransition(i),t.call()},s.options.speed))},s.prototype.fadeSlideOut=function(i){!1===this.cssTransitions?this.$slides.eq(i).animate({opacity:0,zIndex:this.options.zIndex-2},this.options.speed,this.options.easing):(this.applyTransition(i),this.$slides.eq(i).css({opacity:0,zIndex:this.options.zIndex-2}))},s.prototype.filterSlides=s.prototype.slickFilter=function(i){var t=this;null!==i&&(t.$slidesCache=t.$slides,t.unload(),t.$slideTrack.children(this.options.slide).detach(),t.$slidesCache.filter(i).appendTo(t.$slideTrack),t.reinit())},s.prototype.focusHandler=function(){var t=this;t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(s){s.stopImmediatePropagation();var e=i(this);setTimeout(function(){t.options.pauseOnFocus&&(t.focussed=e.is(":focus"),t.autoPlay())},0)})},s.prototype.getCurrent=s.prototype.slickCurrentSlide=function(){return this.currentSlide},s.prototype.getDotCount=function(){var i=0,t=0,s=0;if(!0===this.options.infinite){if(this.slideCount<=this.options.slidesToShow)++s;else for(;i<this.slideCount;)++s,i=t+this.options.slidesToScroll,t+=this.options.slidesToScroll<=this.options.slidesToShow?this.options.slidesToScroll:this.options.slidesToShow}else if(!0===this.options.centerMode)s=this.slideCount;else if(this.options.asNavFor)for(;i<this.slideCount;)++s,i=t+this.options.slidesToScroll,t+=this.options.slidesToScroll<=this.options.slidesToShow?this.options.slidesToScroll:this.options.slidesToShow;else s=1+Math.ceil((this.slideCount-this.options.slidesToShow)/this.options.slidesToScroll);return s-1},s.prototype.getLeft=function(i){var t,s,e,o,n=this,r=0;return n.slideOffset=0,s=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=-(n.slideWidth*n.options.slidesToShow*1),o=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?o=-1.5:1===n.options.slidesToShow&&(o=-2)),r=s*n.options.slidesToShow*o),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=-((n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*1),r=-((n.options.slidesToShow-(i-n.slideCount))*s*1)):(n.slideOffset=-(n.slideCount%n.options.slidesToScroll*n.slideWidth*1),r=-(n.slideCount%n.options.slidesToScroll*s*1)))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*s),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),t=!1===n.options.vertical?-(i*n.slideWidth*1)+n.slideOffset:-(i*s*1)+r,!0===n.options.variableWidth&&(e=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),t=!0===n.options.rtl?e[0]?-((n.$slideTrack.width()-e[0].offsetLeft-e.width())*1):0:e[0]?-1*e[0].offsetLeft:0,!0===n.options.centerMode&&(e=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),t=!0===n.options.rtl?e[0]?-((n.$slideTrack.width()-e[0].offsetLeft-e.width())*1):0:e[0]?-1*e[0].offsetLeft:0,t+=(n.$list.width()-e.outerWidth())/2)),t},s.prototype.getOption=s.prototype.slickGetOption=function(i){return this.options[i]},s.prototype.getNavigableIndexes=function(){var i,t=0,s=0,e=[];for(!1===this.options.infinite?i=this.slideCount:(t=-1*this.options.slidesToScroll,s=-1*this.options.slidesToScroll,i=2*this.slideCount);t<i;)e.push(t),t=s+this.options.slidesToScroll,s+=this.options.slidesToScroll<=this.options.slidesToShow?this.options.slidesToScroll:this.options.slidesToShow;return e},s.prototype.getSlick=function(){return this},s.prototype.getSlideCount=function(){var t,s,e,o=this;return(e=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide)?(o.$slideTrack.find(".slick-slide").each(function(t,n){if(n.offsetLeft-e+i(n).outerWidth()/2>-1*o.swipeLeft)return s=n,!1}),t=Math.abs(i(s).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},s.prototype.goTo=s.prototype.slickGoTo=function(i,t){this.changeSlide({data:{message:"index",index:parseInt(i)}},t)},s.prototype.init=function(t){var s=this;i(s.$slider).hasClass("slick-initialized")||(i(s.$slider).addClass("slick-initialized"),s.buildRows(),s.buildOut(),s.setProps(),s.startLoad(),s.loadSlider(),s.initializeEvents(),s.updateArrows(),s.updateDots(),s.checkResponsive(!0),s.focusHandler()),t&&s.$slider.trigger("init",[s]),!0===s.options.accessibility&&s.initADA(),s.options.autoplay&&(s.paused=!1,s.autoPlay())},s.prototype.initADA=function(){var t=this,s=Math.ceil(t.slideCount/t.options.slidesToShow),e=t.getNavigableIndexes().filter(function(i){return i>=0&&i<t.slideCount});t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==t.$dots&&(t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function(s){var o=e.indexOf(s);if(i(this).attr({role:"tabpanel",id:"slick-slide"+t.instanceUid+s,tabindex:-1}),-1!==o){var n="slick-slide-control"+t.instanceUid+o;i("#"+n).length&&i(this).attr({"aria-describedby":n})}}),t.$dots.attr("role","tablist").find("li").each(function(o){var n=e[o];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+t.instanceUid+o,"aria-controls":"slick-slide"+t.instanceUid+n,"aria-label":o+1+" of "+s,"aria-selected":null,tabindex:"-1"})}).eq(t.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var o=t.currentSlide,n=o+t.options.slidesToShow;o<n;o++)t.options.focusOnChange?t.$slides.eq(o).attr({tabindex:"0"}):t.$slides.eq(o).removeAttr("tabindex");t.activateADA()},s.prototype.initArrowEvents=function(){!0===this.options.arrows&&this.slideCount>this.options.slidesToShow&&(this.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},this.changeSlide),this.$nextArrow.off("click.slick").on("click.slick",{message:"next"},this.changeSlide),!0===this.options.accessibility&&(this.$prevArrow.on("keydown.slick",this.keyHandler),this.$nextArrow.on("keydown.slick",this.keyHandler)))},s.prototype.initDotEvents=function(){!0===this.options.dots&&this.slideCount>this.options.slidesToShow&&(i("li",this.$dots).on("click.slick",{message:"index"},this.changeSlide),!0===this.options.accessibility&&this.$dots.on("keydown.slick",this.keyHandler)),!0===this.options.dots&&!0===this.options.pauseOnDotsHover&&this.slideCount>this.options.slidesToShow&&i("li",this.$dots).on("mouseenter.slick",i.proxy(this.interrupt,this,!0)).on("mouseleave.slick",i.proxy(this.interrupt,this,!1))},s.prototype.initSlideEvents=function(){this.options.pauseOnHover&&(this.$list.on("mouseenter.slick",i.proxy(this.interrupt,this,!0)),this.$list.on("mouseleave.slick",i.proxy(this.interrupt,this,!1)))},s.prototype.initializeEvents=function(){this.initArrowEvents(),this.initDotEvents(),this.initSlideEvents(),this.$list.on("touchstart.slick mousedown.slick",{action:"start"},this.swipeHandler),this.$list.on("touchmove.slick mousemove.slick",{action:"move"},this.swipeHandler),this.$list.on("touchend.slick mouseup.slick",{action:"end"},this.swipeHandler),this.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},this.swipeHandler),this.$list.on("click.slick",this.clickHandler),i(document).on(this.visibilityChange,i.proxy(this.visibility,this)),!0===this.options.accessibility&&this.$list.on("keydown.slick",this.keyHandler),!0===this.options.focusOnSelect&&i(this.$slideTrack).children().on("click.slick",this.selectHandler),i(window).on("orientationchange.slick.slick-"+this.instanceUid,i.proxy(this.orientationChange,this)),i(window).on("resize.slick.slick-"+this.instanceUid,i.proxy(this.resize,this)),i("[draggable!=true]",this.$slideTrack).on("dragstart",this.preventDefault),i(window).on("load.slick.slick-"+this.instanceUid,this.setPosition),i(this.setPosition)},s.prototype.initUI=function(){!0===this.options.arrows&&this.slideCount>this.options.slidesToShow&&(this.$prevArrow.show(),this.$nextArrow.show()),!0===this.options.dots&&this.slideCount>this.options.slidesToShow&&this.$dots.show()},s.prototype.keyHandler=function(i){i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===this.options.accessibility?this.changeSlide({data:{message:!0===this.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===this.options.accessibility&&this.changeSlide({data:{message:!0===this.options.rtl?"previous":"next"}}))},s.prototype.lazyLoad=function(){var t,s,e,o,n=this;function r(t){i("img[data-lazy]",t).each(function(){var t=i(this),s=i(this).attr("data-lazy"),e=i(this).attr("data-srcset"),o=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){t.animate({opacity:0},100,function(){e&&(t.attr("srcset",e),o&&t.attr("sizes",o)),t.attr("src",s).animate({opacity:1},200,function(){t.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,t,s])})},r.onerror=function(){t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,t,s])},r.src=s})}if(!0===n.options.centerMode?!0===n.options.infinite?o=(e=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(e=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),o=2+(n.options.slidesToShow/2+1)+n.currentSlide):(o=Math.ceil((e=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide)+n.options.slidesToShow),!0===n.options.fade&&(e>0&&e--,o<=n.slideCount&&o++)),t=n.$slider.find(".slick-slide").slice(e,o),"anticipated"===n.options.lazyLoad)for(var l=e-1,a=o,d=n.$slider.find(".slick-slide"),c=0;c<n.options.slidesToScroll;c++)l<0&&(l=n.slideCount-1),t=(t=t.add(d.eq(l))).add(d.eq(a)),l--,a++;r(t),n.slideCount<=n.options.slidesToShow?r(s=n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?r(s=n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&r(s=n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},s.prototype.loadSlider=function(){this.setPosition(),this.$slideTrack.css({opacity:1}),this.$slider.removeClass("slick-loading"),this.initUI(),"progressive"===this.options.lazyLoad&&this.progressiveLazyLoad()},s.prototype.next=s.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},s.prototype.orientationChange=function(){this.checkResponsive(),this.setPosition()},s.prototype.pause=s.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},s.prototype.play=s.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},s.prototype.postSlide=function(t){var s=this;!s.unslicked&&(s.$slider.trigger("afterChange",[s,t]),s.animating=!1,s.slideCount>s.options.slidesToShow&&s.setPosition(),s.swipeLeft=null,s.options.autoplay&&s.autoPlay(),!0===s.options.accessibility&&(s.initADA(),s.options.focusOnChange))&&i(s.$slides.get(s.currentSlide)).attr("tabindex",0).focus()},s.prototype.prev=s.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},s.prototype.preventDefault=function(i){i.preventDefault()},s.prototype.progressiveLazyLoad=function(t){t=t||1;var s,e,o,n,r,l=this,a=i("img[data-lazy]",l.$slider);a.length?(e=(s=a.first()).attr("data-lazy"),o=s.attr("data-srcset"),n=s.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){o&&(s.attr("srcset",o),n&&s.attr("sizes",n)),s.attr("src",e).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,s,e]),l.progressiveLazyLoad()},r.onerror=function(){t<3?setTimeout(function(){l.progressiveLazyLoad(t+1)},500):(s.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,s,e]),l.progressiveLazyLoad())},r.src=e):l.$slider.trigger("allImagesLoaded",[l])},s.prototype.refresh=function(t){var s,e,o=this;e=o.slideCount-o.options.slidesToShow,!o.options.infinite&&o.currentSlide>e&&(o.currentSlide=e),o.slideCount<=o.options.slidesToShow&&(o.currentSlide=0),s=o.currentSlide,o.destroy(!0),i.extend(o,o.initials,{currentSlide:s}),o.init(),t||o.changeSlide({data:{message:"index",index:s}},!1)},s.prototype.registerBreakpoints=function(){var t,s,e,o=this,n=o.options.responsive||null;if("array"===i.type(n)&&n.length){for(t in o.respondTo=o.options.respondTo||"window",n)if(e=o.breakpoints.length-1,n.hasOwnProperty(t)){for(s=n[t].breakpoint;e>=0;)o.breakpoints[e]&&o.breakpoints[e]===s&&o.breakpoints.splice(e,1),e--;o.breakpoints.push(s),o.breakpointSettings[s]=n[t].settings}o.breakpoints.sort(function(i,t){return o.options.mobileFirst?i-t:t-i})}},s.prototype.reinit=function(){var t=this;t.$slides=t.$slideTrack.children(t.options.slide).addClass("slick-slide"),t.slideCount=t.$slides.length,t.currentSlide>=t.slideCount&&0!==t.currentSlide&&(t.currentSlide=t.currentSlide-t.options.slidesToScroll),t.slideCount<=t.options.slidesToShow&&(t.currentSlide=0),t.registerBreakpoints(),t.setProps(),t.setupInfinite(),t.buildArrows(),t.updateArrows(),t.initArrowEvents(),t.buildDots(),t.updateDots(),t.initDotEvents(),t.cleanUpSlideEvents(),t.initSlideEvents(),t.checkResponsive(!1,!0),!0===t.options.focusOnSelect&&i(t.$slideTrack).children().on("click.slick",t.selectHandler),t.setSlideClasses("number"==typeof t.currentSlide?t.currentSlide:0),t.setPosition(),t.focusHandler(),t.paused=!t.options.autoplay,t.autoPlay(),t.$slider.trigger("reInit",[t])},s.prototype.resize=function(){var t=this;i(window).width()!==t.windowWidth&&(clearTimeout(t.windowDelay),t.windowDelay=window.setTimeout(function(){t.windowWidth=i(window).width(),t.checkResponsive(),t.unslicked||t.setPosition()},50))},s.prototype.removeSlide=s.prototype.slickRemove=function(i,t,s){var e=this;if(i="boolean"==typeof i?!0===(t=i)?0:e.slideCount-1:!0===t?--i:i,e.slideCount<1||i<0||i>e.slideCount-1)return!1;e.unload(),!0===s?e.$slideTrack.children().remove():e.$slideTrack.children(this.options.slide).eq(i).remove(),e.$slides=e.$slideTrack.children(this.options.slide),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.append(e.$slides),e.$slidesCache=e.$slides,e.reinit()},s.prototype.setCSS=function(i){var t,s,e=this,o={};!0===e.options.rtl&&(i=-i),t="left"==e.positionProp?Math.ceil(i)+"px":"0px",s="top"==e.positionProp?Math.ceil(i)+"px":"0px",o[e.positionProp]=i,!1===e.transformsEnabled?e.$slideTrack.css(o):(o={},!1===e.cssTransitions?(o[e.animType]="translate("+t+", "+s+")",e.$slideTrack.css(o)):(o[e.animType]="translate3d("+t+", "+s+", 0px)",e.$slideTrack.css(o)))},s.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var t=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-t)},s.prototype.setFade=function(){var t,s=this;s.$slides.each(function(e,o){t=-(s.slideWidth*e*1),!0===s.options.rtl?i(o).css({position:"relative",right:t,top:0,zIndex:s.options.zIndex-2,opacity:0}):i(o).css({position:"relative",left:t,top:0,zIndex:s.options.zIndex-2,opacity:0})}),s.$slides.eq(s.currentSlide).css({zIndex:s.options.zIndex-1,opacity:1})},s.prototype.setHeight=function(){if(1===this.options.slidesToShow&&!0===this.options.adaptiveHeight&&!1===this.options.vertical){var i=this.$slides.eq(this.currentSlide).outerHeight(!0);this.$list.css("height",i)}},s.prototype.setOption=s.prototype.slickSetOption=function(){var t,s,e,o,n,r=this,l=!1;if("object"===i.type(arguments[0])?(e=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(e=arguments[0],o=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[e]=o;else if("multiple"===n)i.each(e,function(i,t){r.options[i]=t});else if("responsive"===n)for(s in o)if("array"!==i.type(r.options.responsive))r.options.responsive=[o[s]];else{for(t=r.options.responsive.length-1;t>=0;)r.options.responsive[t].breakpoint===o[s].breakpoint&&r.options.responsive.splice(t,1),t--;r.options.responsive.push(o[s])}l&&(r.unload(),r.reinit())},s.prototype.setPosition=function(){this.setDimensions(),this.setHeight(),!1===this.options.fade?this.setCSS(this.getLeft(this.currentSlide)):this.setFade(),this.$slider.trigger("setPosition",[this])},s.prototype.setProps=function(){var i=this,t=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),(void 0!==t.WebkitTransition||void 0!==t.MozTransition||void 0!==t.msTransition)&&!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==t.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===t.perspectiveProperty&&void 0===t.webkitPerspective&&(i.animType=!1)),void 0!==t.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===t.perspectiveProperty&&void 0===t.MozPerspective&&(i.animType=!1)),void 0!==t.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===t.perspectiveProperty&&void 0===t.webkitPerspective&&(i.animType=!1)),void 0!==t.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===t.msTransform&&(i.animType=!1)),void 0!==t.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},s.prototype.setSlideClasses=function(i){var t,s,e,o;if(s=this.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),this.$slides.eq(i).addClass("slick-current"),!0===this.options.centerMode){var n=this.options.slidesToShow%2==0?1:0;t=Math.floor(this.options.slidesToShow/2),!0===this.options.infinite&&(i>=t&&i<=this.slideCount-1-t?this.$slides.slice(i-t+n,i+t+1).addClass("slick-active").attr("aria-hidden","false"):(e=this.options.slidesToShow+i,s.slice(e-t+1+n,e+t+2).addClass("slick-active").attr("aria-hidden","false")),0===i?s.eq(s.length-1-this.options.slidesToShow).addClass("slick-center"):i===this.slideCount-1&&s.eq(this.options.slidesToShow).addClass("slick-center")),this.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=this.slideCount-this.options.slidesToShow?this.$slides.slice(i,i+this.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):s.length<=this.options.slidesToShow?s.addClass("slick-active").attr("aria-hidden","false"):(o=this.slideCount%this.options.slidesToShow,e=!0===this.options.infinite?this.options.slidesToShow+i:i,this.options.slidesToShow==this.options.slidesToScroll&&this.slideCount-i<this.options.slidesToShow?s.slice(e-(this.options.slidesToShow-o),e+o).addClass("slick-active").attr("aria-hidden","false"):s.slice(e,e+this.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));("ondemand"===this.options.lazyLoad||"anticipated"===this.options.lazyLoad)&&this.lazyLoad()},s.prototype.setupInfinite=function(){var t,s,e,o=this;if(!0===o.options.fade&&(o.options.centerMode=!1),!0===o.options.infinite&&!1===o.options.fade&&(s=null,o.slideCount>o.options.slidesToShow)){for(e=!0===o.options.centerMode?o.options.slidesToShow+1:o.options.slidesToShow,t=o.slideCount;t>o.slideCount-e;t-=1)s=t-1,i(o.$slides[s]).clone(!0).attr("id","").attr("data-slick-index",s-o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");for(t=0;t<e+o.slideCount;t+=1)s=t,i(o.$slides[s]).clone(!0).attr("id","").attr("data-slick-index",s+o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");o.$slideTrack.find(".slick-cloned").find("[id]").each(function(){var t=i(this).attr("id"),s=t+"-clone",e=i(this).siblings('[for="'+t+'"]');if(i(this).attr("id",s),e.length){var o=i(this).attr("name");i(this).attr("name",o+"-clone"),e.attr("for",s)}})}},s.prototype.interrupt=function(i){var t=this;i||t.autoPlay(),t.interrupted=i},s.prototype.selectHandler=function(t){var s=parseInt((i(t.target).is(".slick-slide")?i(t.target):i(t.target).parents(".slick-slide")).attr("data-slick-index"));if(s||(s=0),this.slideCount<=this.options.slidesToShow){this.slideHandler(s,!1,!0);return}this.slideHandler(s)},s.prototype.slideHandler=function(i,t,s){var e,o,n,r,l,a=null,d=this;if(t=t||!1,(!0!==d.animating||!0!==d.options.waitForAnimate)&&(!0!==d.options.fade||d.currentSlide!==i)){if(!1===t&&d.asNavFor(i),e=i,a=d.getLeft(e),r=d.getLeft(d.currentSlide),d.currentLeft=null===d.swipeLeft?r:d.swipeLeft,!1===d.options.infinite&&!1===d.options.centerMode&&(i<0||i>d.getDotCount()*d.options.slidesToScroll)||!1===d.options.infinite&&!0===d.options.centerMode&&(i<0||i>d.slideCount-d.options.slidesToScroll)){!1===d.options.fade&&(e=d.currentSlide,!0!==s&&d.slideCount>d.options.slidesToShow?d.animateSlide(r,function(){d.postSlide(e)}):d.postSlide(e));return}if(d.options.autoplay&&clearInterval(d.autoPlayTimer),o=e<0?d.slideCount%d.options.slidesToScroll!=0?d.slideCount-d.slideCount%d.options.slidesToScroll:d.slideCount+e:e>=d.slideCount?d.slideCount%d.options.slidesToScroll!=0?0:e-d.slideCount:e,d.animating=!0,d.$slider.trigger("beforeChange",[d,d.currentSlide,o]),n=d.currentSlide,d.currentSlide=o,d.setSlideClasses(d.currentSlide),d.options.asNavFor&&(l=(l=d.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(d.currentSlide),d.updateDots(),d.updateArrows(),!0===d.options.fade){!0!==s?(d.fadeSlideOut(n),d.fadeSlide(o,function(){d.postSlide(o)})):d.postSlide(o),d.animateHeight();return}!0!==s&&d.slideCount>d.options.slidesToShow?d.animateSlide(a,function(){d.postSlide(o)}):d.postSlide(o)}},s.prototype.startLoad=function(){!0===this.options.arrows&&this.slideCount>this.options.slidesToShow&&(this.$prevArrow.hide(),this.$nextArrow.hide()),!0===this.options.dots&&this.slideCount>this.options.slidesToShow&&this.$dots.hide(),this.$slider.addClass("slick-loading")},s.prototype.swipeDirection=function(){var i,t,s,e;return(i=this.touchObject.startX-this.touchObject.curX,(e=Math.round(180*(s=Math.atan2(t=this.touchObject.startY-this.touchObject.curY,i))/Math.PI))<0&&(e=360-Math.abs(e)),e<=45&&e>=0||e<=360&&e>=315)?!1===this.options.rtl?"left":"right":e>=135&&e<=225?!1===this.options.rtl?"right":"left":!0===this.options.verticalSwiping?e>=35&&e<=135?"down":"up":"vertical"},s.prototype.swipeEnd=function(i){var t,s,e=this;if(e.dragging=!1,e.swiping=!1,e.scrolling)return e.scrolling=!1,!1;if(e.interrupted=!1,e.shouldClick=!(e.touchObject.swipeLength>10),void 0===e.touchObject.curX)return!1;if(!0===e.touchObject.edgeHit&&e.$slider.trigger("edge",[e,e.swipeDirection()]),e.touchObject.swipeLength>=e.touchObject.minSwipe&&("left"==e.swipeDirection()||"right"==e.swipeDirection())){switch(s=e.swipeDirection()){case"left":case"down":t=e.options.swipeToSlide?e.checkNavigable(e.currentSlide+e.getSlideCount()):e.currentSlide+e.getSlideCount(),e.currentDirection=0;break;case"right":case"up":t=e.options.swipeToSlide?e.checkNavigable(e.currentSlide-e.getSlideCount()):e.currentSlide-e.getSlideCount(),e.currentDirection=1}"vertical"!=s&&(e.slideHandler(t),e.touchObject={},e.$slider.trigger("swipe",[e,s]))}else e.touchObject.startX!==e.touchObject.curX&&(e.slideHandler(e.currentSlide),e.touchObject={})},s.prototype.swipeHandler=function(i){var t=this;if(!1!==t.options.swipe&&(!("ontouchend"in document)||!1!==t.options.swipe)){if(!1!==t.options.draggable||-1===i.type.indexOf("mouse"))switch(t.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,t.touchObject.minSwipe=t.listWidth/t.options.touchThreshold,!0===t.options.verticalSwiping&&(t.touchObject.minSwipe=t.listHeight/t.options.touchThreshold),i.data.action){case"start":t.swipeStart(i);break;case"move":t.swipeMove(i);break;case"end":t.swipeEnd(i)}}},s.prototype.swipeMove=function(i){var t,s,e,o,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!!l.dragging&&!l.scrolling&&(!n||1===n.length)&&((t=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),l.options.verticalSwiping||l.swiping||!(r>4))?(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),s=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),o=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(o=l.touchObject.curY>l.touchObject.startY?1:-1),e=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===s||l.currentSlide>=l.getDotCount()&&"left"===s)&&(e=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=t+e*o:l.swipeLeft=t+e*(l.$list.height()/l.listWidth)*o,!0===l.options.verticalSwiping&&(l.swipeLeft=t+e*o),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))):(l.scrolling=!0,!1))},s.prototype.swipeStart=function(i){var t,s=this;if(s.interrupted=!0,1!==s.touchObject.fingerCount||s.slideCount<=s.options.slidesToShow)return s.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(t=i.originalEvent.touches[0]),s.touchObject.startX=s.touchObject.curX=void 0!==t?t.pageX:i.clientX,s.touchObject.startY=s.touchObject.curY=void 0!==t?t.pageY:i.clientY,s.dragging=!0},s.prototype.unfilterSlides=s.prototype.slickUnfilter=function(){null!==this.$slidesCache&&(this.unload(),this.$slideTrack.children(this.options.slide).detach(),this.$slidesCache.appendTo(this.$slideTrack),this.reinit())},s.prototype.unload=function(){i(".slick-cloned",this.$slider).remove(),this.$dots&&this.$dots.remove(),this.$prevArrow&&this.htmlExpr.test(this.options.prevArrow)&&this.$prevArrow.remove(),this.$nextArrow&&this.htmlExpr.test(this.options.nextArrow)&&this.$nextArrow.remove(),this.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},s.prototype.unslick=function(i){this.$slider.trigger("unslick",[this,i]),this.destroy()},s.prototype.updateArrows=function(){var i;i=Math.floor(this.options.slidesToShow/2),!0===this.options.arrows&&this.slideCount>this.options.slidesToShow&&!this.options.infinite&&(this.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),this.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===this.currentSlide?(this.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),this.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):this.currentSlide>=this.slideCount-this.options.slidesToShow&&!1===this.options.centerMode?(this.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),this.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):this.currentSlide>=this.slideCount-1&&!0===this.options.centerMode&&(this.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),this.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},s.prototype.updateDots=function(){null!==this.$dots&&(this.$dots.find("li").removeClass("slick-active").end(),this.$dots.find("li").eq(Math.floor(this.currentSlide/this.options.slidesToScroll)).addClass("slick-active"))},s.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,e=this,o=arguments[0],n=Array.prototype.slice.call(arguments,1),r=e.length;for(i=0;i<r;i++)if("object"==typeof o||void 0===o?e[i].slick=new s(e[i],o):t=e[i].slick[o].apply(e[i].slick,n),void 0!==t)return t;return e}});



/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
;(function(){function n(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function t(n,t,r){for(var e=-1,u=n.length;++e<u;){var o=n[e],i=t(o);if(null!=i&&(c===an?i===i:r(i,c)))var c=i,f=o}return f}function r(n,t,r){var e;return r(n,function(n,r,u){return t(n,r,u)?(e=n,false):void 0}),e}function e(n,t,r,e,u){return u(n,function(n,u,o){r=e?(e=false,n):t(r,n,u,o)}),r}function u(n,t){return O(t,function(t){return n[t]})}function o(n){return n&&n.Object===Object?n:null}function i(n){return vn[n];
}function c(n){var t=false;if(null!=n&&typeof n.toString!="function")try{t=!!(n+"")}catch(r){}return t}function f(n,t){return n=typeof n=="number"||hn.test(n)?+n:-1,n>-1&&0==n%1&&(null==t?9007199254740991:t)>n}function a(n){if(Y(n)&&!Pn(n)){if(n instanceof l)return n;if(En.call(n,"__wrapped__")){var t=new l(n.__wrapped__,n.__chain__);return t.__actions__=N(n.__actions__),t}}return new l(n)}function l(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t}function p(n,t,r,e){var u;return(u=n===an)||(u=xn[r],
u=(n===u||n!==n&&u!==u)&&!En.call(e,r)),u?t:n}function s(n){return X(n)?Fn(n):{}}function h(n,t,r){if(typeof n!="function")throw new TypeError("Expected a function");return setTimeout(function(){n.apply(an,r)},t)}function v(n,t){var r=true;return $n(n,function(n,e,u){return r=!!t(n,e,u)}),r}function y(n,t){var r=[];return $n(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function _(t,r,e,u){u||(u=[]);for(var o=-1,i=t.length;++o<i;){var c=t[o];r>0&&Y(c)&&L(c)&&(e||Pn(c)||K(c))?r>1?_(c,r-1,e,u):n(u,c):e||(u[u.length]=c);
}return u}function g(n,t){return n&&qn(n,t,en)}function b(n,t){return y(t,function(t){return Q(n[t])})}function j(n,t,r,e,u){return n===t?true:null==n||null==t||!X(n)&&!Y(t)?n!==n&&t!==t:m(n,t,j,r,e,u)}function m(n,t,r,e,u,o){var i=Pn(n),f=Pn(t),a="[object Array]",l="[object Array]";i||(a=kn.call(n),"[object Arguments]"==a&&(a="[object Object]")),f||(l=kn.call(t),"[object Arguments]"==l&&(l="[object Object]"));var p="[object Object]"==a&&!c(n),f="[object Object]"==l&&!c(t);return!(l=a==l)||i||p?2&u||(a=p&&En.call(n,"__wrapped__"),
f=f&&En.call(t,"__wrapped__"),!a&&!f)?l?(o||(o=[]),(a=J(o,function(t){return t[0]===n}))&&a[1]?a[1]==t:(o.push([n,t]),t=(i?I:q)(n,t,r,e,u,o),o.pop(),t)):false:r(a?n.value():n,f?t.value():t,e,u,o):$(n,t,a)}function d(n){var t=typeof n;return"function"==t?n:null==n?cn:("object"==t?x:A)(n)}function w(n){n=null==n?n:Object(n);var t,r=[];for(t in n)r.push(t);return r}function O(n,t){var r=-1,e=L(n)?Array(n.length):[];return $n(n,function(n,u,o){e[++r]=t(n,u,o)}),e}function x(n){var t=en(n);return function(r){
var e=t.length;if(null==r)return!e;for(r=Object(r);e--;){var u=t[e];if(!(u in r&&j(n[u],r[u],an,3)))return false}return true}}function E(n,t){return n=Object(n),P(t,function(t,r){return r in n&&(t[r]=n[r]),t},{})}function A(n){return function(t){return null==t?an:t[n]}}function k(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Array(u);++e<u;)r[e]=n[e+t];return r}function N(n){return k(n,0,n.length)}function S(n,t){var r;return $n(n,function(n,e,u){return r=t(n,e,u),
!r}),!!r}function T(t,r){return P(r,function(t,r){return r.func.apply(r.thisArg,n([t],r.args))},t)}function F(n,t,r,e){r||(r={});for(var u=-1,o=t.length;++u<o;){var i=t[u],c=e?e(r[i],n[i],i,r,n):n[i],f=r,a=f[i];En.call(f,i)&&(a===c||a!==a&&c!==c)&&(c!==an||i in f)||(f[i]=c)}return r}function R(n){return V(function(t,r){var e=-1,u=r.length,o=u>1?r[u-1]:an,o=typeof o=="function"?(u--,o):an;for(t=Object(t);++e<u;){var i=r[e];i&&n(t,i,e,o)}return t})}function B(n){return function(){var t=arguments,r=s(n.prototype),t=n.apply(r,t);
return X(t)?t:r}}function D(n,t,r){function e(){for(var o=-1,i=arguments.length,c=-1,f=r.length,a=Array(f+i),l=this&&this!==wn&&this instanceof e?u:n;++c<f;)a[c]=r[c];for(;i--;)a[c++]=arguments[++o];return l.apply(t,a)}if(typeof n!="function")throw new TypeError("Expected a function");var u=B(n);return e}function I(n,t,r,e,u,o){var i=-1,c=1&u,f=n.length,a=t.length;if(f!=a&&!(2&u&&a>f))return false;for(a=true;++i<f;){var l=n[i],p=t[i];if(void 0!==an){a=false;break}if(c){if(!S(t,function(n){return l===n||r(l,n,e,u,o);
})){a=false;break}}else if(l!==p&&!r(l,p,e,u,o)){a=false;break}}return a}function $(n,t,r){switch(r){case"[object Boolean]":case"[object Date]":return+n==+t;case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object Number]":return n!=+n?t!=+t:n==+t;case"[object RegExp]":case"[object String]":return n==t+""}return false}function q(n,t,r,e,u,o){var i=2&u,c=en(n),f=c.length,a=en(t).length;if(f!=a&&!i)return false;for(var l=f;l--;){var p=c[l];if(!(i?p in t:En.call(t,p)))return false}for(a=true;++l<f;){
var p=c[l],s=n[p],h=t[p];if(void 0!==an||s!==h&&!r(s,h,e,u,o)){a=false;break}i||(i="constructor"==p)}return a&&!i&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(a=false)),a}function z(n){var t=n?n.length:an;if(W(t)&&(Pn(n)||nn(n)||K(n))){n=String;for(var r=-1,e=Array(t);++r<t;)e[r]=n(r);t=e}else t=null;return t}function C(n){var t=n&&n.constructor,t=Q(t)&&t.prototype||xn;return n===t}function G(n){
return n?n[0]:an}function J(n,t){return r(n,d(t),$n)}function M(n,t){return $n(n,typeof t=="function"?t:cn)}function P(n,t,r){return e(n,d(t),r,3>arguments.length,$n)}function U(n,t){var r;if(typeof t!="function")throw new TypeError("Expected a function");return n=Un(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=an),r}}function V(n){var t;if(typeof n!="function")throw new TypeError("Expected a function");return t=In(t===an?n.length-1:Un(t),0),function(){for(var r=arguments,e=-1,u=In(r.length-t,0),o=Array(u);++e<u;)o[e]=r[t+e];
for(u=Array(t+1),e=-1;++e<t;)u[e]=r[e];return u[t]=o,n.apply(this,u)}}function H(n,t){return n>t}function K(n){return Y(n)&&L(n)&&En.call(n,"callee")&&(!Rn.call(n,"callee")||"[object Arguments]"==kn.call(n))}function L(n){return null!=n&&!(typeof n=="function"&&Q(n))&&W(zn(n))}function Q(n){return n=X(n)?kn.call(n):"","[object Function]"==n||"[object GeneratorFunction]"==n}function W(n){return typeof n=="number"&&n>-1&&0==n%1&&9007199254740991>=n}function X(n){var t=typeof n;return!!n&&("object"==t||"function"==t);
}function Y(n){return!!n&&typeof n=="object"}function Z(n){return typeof n=="number"||Y(n)&&"[object Number]"==kn.call(n)}function nn(n){return typeof n=="string"||!Pn(n)&&Y(n)&&"[object String]"==kn.call(n)}function tn(n,t){return t>n}function rn(n){return typeof n=="string"?n:null==n?"":n+""}function en(n){var t=C(n);if(!t&&!L(n))return Dn(Object(n));var r,e=z(n),u=!!e,e=e||[],o=e.length;for(r in n)!En.call(n,r)||u&&("length"==r||f(r,o))||t&&"constructor"==r||e.push(r);return e}function un(n){for(var t=-1,r=C(n),e=w(n),u=e.length,o=z(n),i=!!o,o=o||[],c=o.length;++t<u;){
var a=e[t];i&&("length"==a||f(a,c))||"constructor"==a&&(r||!En.call(n,a))||o.push(a)}return o}function on(n){return n?u(n,en(n)):[]}function cn(n){return n}function fn(t,r,e){var u=en(r),o=b(r,u);null!=e||X(r)&&(o.length||!u.length)||(e=r,r=t,t=this,o=b(r,en(r)));var i=X(e)&&"chain"in e?e.chain:true,c=Q(t);return $n(o,function(e){var u=r[e];t[e]=u,c&&(t.prototype[e]=function(){var r=this.__chain__;if(i||r){var e=t(this.__wrapped__);return(e.__actions__=N(this.__actions__)).push({func:u,args:arguments,
thisArg:t}),e.__chain__=r,e}return u.apply(t,n([this.value()],arguments))})}),t}var an,ln=1/0,pn=/[&<>"'`]/g,sn=RegExp(pn.source),hn=/^(?:0|[1-9]\d*)$/,vn={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","`":"&#96;"},yn={"function":true,object:true},_n=yn[typeof exports]&&exports&&!exports.nodeType?exports:an,gn=yn[typeof module]&&module&&!module.nodeType?module:an,bn=gn&&gn.exports===_n?_n:an,jn=o(yn[typeof self]&&self),mn=o(yn[typeof window]&&window),dn=o(yn[typeof this]&&this),wn=o(_n&&gn&&typeof global=="object"&&global)||mn!==(dn&&dn.window)&&mn||jn||dn||Function("return this")(),On=Array.prototype,xn=Object.prototype,En=xn.hasOwnProperty,An=0,kn=xn.toString,Nn=wn._,Sn=wn.Reflect,Tn=Sn?Sn.f:an,Fn=Object.create,Rn=xn.propertyIsEnumerable,Bn=wn.isFinite,Dn=Object.keys,In=Math.max,$n=function(n,t){
return function(r,e){if(null==r)return r;if(!L(r))return n(r,e);for(var u=r.length,o=t?u:-1,i=Object(r);(t?o--:++o<u)&&false!==e(i[o],o,i););return r}}(g),qn=function(n){return function(t,r,e){var u=-1,o=Object(t);e=e(t);for(var i=e.length;i--;){var c=e[n?i:++u];if(false===r(o[c],c,o))break}return t}}();Tn&&!Rn.call({valueOf:1},"valueOf")&&(w=function(n){n=Tn(n);for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r});var zn=A("length"),Cn=V(function(t,r){return Pn(t)||(t=null==t?[]:[Object(t)]),_(r,1),
n(N(t),on)}),Gn=V(function(n,t,r){return D(n,t,r)}),Jn=V(function(n,t){return h(n,1,t)}),Mn=V(function(n,t,r){return h(n,Vn(t)||0,r)}),Pn=Array.isArray,Un=Number,Vn=Number,Hn=R(function(n,t){F(t,en(t),n)}),Kn=R(function(n,t){F(t,un(t),n)}),Ln=R(function(n,t,r,e){F(t,un(t),n,e)}),Qn=V(function(n){return n.push(an,p),Ln.apply(an,n)}),Wn=V(function(n,t){return null==n?{}:E(n,_(t,1))}),Xn=d;l.prototype=s(a.prototype),l.prototype.constructor=l,a.assignIn=Kn,a.before=U,a.bind=Gn,a.chain=function(n){return n=a(n),
n.__chain__=true,n},a.compact=function(n){return y(n,Boolean)},a.concat=Cn,a.create=function(n,t){var r=s(n);return t?Hn(r,t):r},a.defaults=Qn,a.defer=Jn,a.delay=Mn,a.filter=function(n,t){return y(n,d(t))},a.flatten=function(n){return n&&n.length?_(n,1):[]},a.flattenDeep=function(n){return n&&n.length?_(n,ln):[]},a.iteratee=Xn,a.keys=en,a.map=function(n,t){return O(n,d(t))},a.matches=function(n){return x(Hn({},n))},a.mixin=fn,a.negate=function(n){if(typeof n!="function")throw new TypeError("Expected a function");
return function(){return!n.apply(this,arguments)}},a.once=function(n){return U(2,n)},a.pick=Wn,a.slice=function(n,t,r){var e=n?n.length:0;return r=r===an?e:+r,e?k(n,null==t?0:+t,r):[]},a.sortBy=function(n,t){var r=0;return t=d(t),O(O(n,function(n,e,u){return{c:n,b:r++,a:t(n,e,u)}}).sort(function(n,t){var r;n:{r=n.a;var e=t.a;if(r!==e){var u=null===r,o=r===an,i=r===r,c=null===e,f=e===an,a=e===e;if(r>e&&!c||!i||u&&!f&&a||o&&a){r=1;break n}if(e>r&&!u||!a||c&&!o&&i||f&&i){r=-1;break n}}r=0}return r||n.b-t.b;
}),A("c"))},a.tap=function(n,t){return t(n),n},a.thru=function(n,t){return t(n)},a.toArray=function(n){return L(n)?n.length?N(n):[]:on(n)},a.values=on,a.extend=Kn,fn(a,a),a.clone=function(n){return X(n)?Pn(n)?N(n):F(n,en(n)):n},a.escape=function(n){return(n=rn(n))&&sn.test(n)?n.replace(pn,i):n},a.every=function(n,t,r){return t=r?an:t,v(n,d(t))},a.find=J,a.forEach=M,a.has=function(n,t){return null!=n&&En.call(n,t)},a.head=G,a.identity=cn,a.indexOf=function(n,t,r){var e=n?n.length:0;r=typeof r=="number"?0>r?In(e+r,0):r:0,
r=(r||0)-1;for(var u=t===t;++r<e;){var o=n[r];if(u?o===t:o!==o)return r}return-1},a.isArguments=K,a.isArray=Pn,a.isBoolean=function(n){return true===n||false===n||Y(n)&&"[object Boolean]"==kn.call(n)},a.isDate=function(n){return Y(n)&&"[object Date]"==kn.call(n)},a.isEmpty=function(n){if(L(n)&&(Pn(n)||nn(n)||Q(n.splice)||K(n)))return!n.length;for(var t in n)if(En.call(n,t))return false;return true},a.isEqual=function(n,t){return j(n,t)},a.isFinite=function(n){return typeof n=="number"&&Bn(n)},a.isFunction=Q,a.isNaN=function(n){
return Z(n)&&n!=+n},a.isNull=function(n){return null===n},a.isNumber=Z,a.isObject=X,a.isRegExp=function(n){return X(n)&&"[object RegExp]"==kn.call(n)},a.isString=nn,a.isUndefined=function(n){return n===an},a.last=function(n){var t=n?n.length:0;return t?n[t-1]:an},a.max=function(n){return n&&n.length?t(n,cn,H):an},a.min=function(n){return n&&n.length?t(n,cn,tn):an},a.noConflict=function(){return wn._===this&&(wn._=Nn),this},a.noop=function(){},a.reduce=P,a.result=function(n,t,r){return t=null==n?an:n[t],
t===an&&(t=r),Q(t)?t.call(n):t},a.size=function(n){return null==n?0:(n=L(n)?n:en(n),n.length)},a.some=function(n,t,r){return t=r?an:t,S(n,d(t))},a.uniqueId=function(n){var t=++An;return rn(n)+t},a.each=M,a.first=G,fn(a,function(){var n={};return g(a,function(t,r){En.call(a.prototype,r)||(n[r]=t)}),n}(),{chain:false}),a.VERSION="4.5.1",$n("pop join replace reverse split push shift sort splice unshift".split(" "),function(n){var t=(/^(?:replace|split)$/.test(n)?String.prototype:On)[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|join|replace|shift)$/.test(n);
a.prototype[n]=function(){var n=arguments;return e&&!this.__chain__?t.apply(this.value(),n):this[r](function(r){return t.apply(r,n)})}}),a.prototype.toJSON=a.prototype.valueOf=a.prototype.value=function(){return T(this.__wrapped__,this.__actions__)},(mn||jn||{})._=a,typeof define=="function"&&typeof define.amd=="object"&&define.amd? define(function(){return a}):_n&&gn?(bn&&((gn.exports=a)._=a),_n._=a):wn._=a}).call(this);

/*
 * Debounce function
 * based on unminified version from http://davidwalsh.name/javascript-debounce-function
 */
theme.debounce = function(n,t,u){var e;return function(){var a=this,r=arguments,i=function(){e=null,u||n.apply(a,r)},o=u&&!e;clearTimeout(e),e=setTimeout(i,t),o&&n.apply(a,r)}};



!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"object"==typeof exports?module.exports=e(require("jquery")):e(jQuery)}(function(e){var n=/\+/g;function o(e){return t.raw?e:encodeURIComponent(e)}function i(e){return o(t.json?JSON.stringify(e):String(e))}function r(o,i){var r=t.raw?o:function(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(n," ")),t.json?JSON.parse(e):e}catch(e){}}(o);return e.isFunction(i)?i(r):r}var t=e.cookie=function(n,c,u){if(arguments.length>1&&!e.isFunction(c)){if("number"==typeof(u=e.extend({},t.defaults,u)).expires){var s=u.expires,a=u.expires=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*s)}return document.cookie=[o(n),"=",i(c),u.expires?"; expires="+u.expires.toUTCString():"",u.path?"; path="+u.path:"",u.domain?"; domain="+u.domain:"",u.secure?"; secure":""].join("")}for(var d,f=n?void 0:{},p=document.cookie?document.cookie.split("; "):[],l=0,m=p.length;l<m;l++){var x=p[l].split("="),g=(d=x.shift(),t.raw?d:decodeURIComponent(d)),v=x.join("=");if(n===g){f=r(v,c);break}n||void 0===(v=r(v))||(f[g]=v)}return f};t.defaults={},e.removeCookie=function(n,o){return e.cookie(n,"",e.extend({},o,{expires:-1})),!e.cookie(n)}});

if ($('.idx-logo .logo-section').length) {
  $(document).ready(function() {
    $('.idx-logo .logo-section').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    });
    
  });
}



if ($('body.template-list-collections').length)
{
/* Final Tiles Gallery - Kagami theme */
function ftg_getURLParameter(t){return decodeURIComponent((new RegExp("[?|&]"+t+"=([^&;]+?)(&|#|;|$)").exec(location.search)||[,""])[1].replace(/\+/g,"%20"))||null}if(function(t){t.fn.autoComplete=function(e){var o=t.extend({},t.fn.autoComplete.defaults,e);return"string"==typeof e?(this.each(function(){var o=t(this);"destroy"==e&&(t(window).off("resize.autocomplete",o.updateSC),o.off("blur.autocomplete focus.autocomplete keydown.autocomplete keyup.autocomplete"),o.data("autocomplete")?o.attr("autocomplete",o.data("autocomplete")):o.removeAttr("autocomplete"),t(o.data("sc")).remove(),o.removeData("sc").removeData("autocomplete"))}),this):this.each(function(){function e(t){var e=i.val();if(i.cache[e]=t,t.length&&e.length>=o.minChars){for(var n="",s=0;s<t.length;s++)n+=o.renderItem(t[s],e);i.sc.html(n),i.updateSC(0)}else i.sc.hide()}var i=t(this);i.sc=t(".mega-search__suggestions"),i.data("sc",i.sc).data("autocomplete",i.attr("autocomplete")),i.attr("autocomplete","off"),i.cache={},i.last_val="",i.updateSC=function(e,o){if(!e&&(i.sc.show(),i.sc.maxHeight||(i.sc.maxHeight=parseInt(i.sc.css("max-height"))),i.sc.suggestionHeight||(i.sc.suggestionHeight=t(".autocomplete-suggestion",i.sc).first().outerHeight()),i.sc.suggestionHeight))if(o){var n=i.sc.scrollTop(),s=o.offset().top-i.sc.offset().top;s+i.sc.suggestionHeight-i.sc.maxHeight>0?i.sc.scrollTop(s+i.sc.suggestionHeight+n-i.sc.maxHeight):s<0&&i.sc.scrollTop(s+n)}else i.sc.scrollTop(0)},t(window).on("resize.autocomplete",i.updateSC),i.sc.on("mouseleave",".autocomplete-suggestion",function(){t(".autocomplete-suggestion.selected").removeClass("selected")}),i.sc.on("mouseenter",".autocomplete-suggestion",function(){t(".autocomplete-suggestion.selected").removeClass("selected"),t(this).addClass("selected")}),i.sc.on("mousedown",".autocomplete-suggestion",function(e){var n=t(this),s=n.data("val");return(s||n.hasClass("autocomplete-suggestion"))&&(i.val(s),o.onSelect(e,s,n),i.sc.hide()),!1}),i.on("blur.autocomplete",function(){try{over_sb=t(".autocomplete-suggestions:hover").length}catch(e){over_sb=0}over_sb?i.is(":focus")||setTimeout(function(){i.focus()},20):(i.last_val=i.val(),i.sc.hide(),setTimeout(function(){i.sc.hide()},350))}),o.minChars||i.on("focus.autocomplete",function(){i.last_val="\n",i.trigger("keyup.autocomplete")}),i.on("keydown.autocomplete",function(e){if((40==e.which||38==e.which)&&i.sc.html()){var n,s=t(".autocomplete-suggestion.selected",i.sc);return s.length?(n=40==e.which?s.next(".autocomplete-suggestion"):s.prev(".autocomplete-suggestion"),n.length?(s.removeClass("selected"),n.addClass("selected")):(s.removeClass("selected"),n=0)):(n=40==e.which?t(".autocomplete-suggestion",i.sc).first():t(".autocomplete-suggestion",i.sc).last(),n.addClass("selected")),i.updateSC(0,n),!1}if(27==e.which)i.val(i.last_val).sc.hide();else if(13==e.which||9==e.which){var s=t(".autocomplete-suggestion.selected",i.sc);s.length&&i.sc.is(":visible")&&(o.onSelect(e,s.data("val"),s),setTimeout(function(){i.sc.hide()},20))}}),i.on("keyup.autocomplete",function(n){if(!~t.inArray(n.which,[13,27,35,36,37,38,39,40])){var s=i.val();if(s.length>=o.minChars){if(s!=i.last_val){if(i.last_val=s,clearTimeout(i.timer),o.cache){if(s in i.cache)return void e(i.cache[s]);for(var r=1;r<s.length-o.minChars;r++){var a=s.slice(0,s.length-r);if(a in i.cache&&!i.cache[a].length)return void e([])}}i.timer=setTimeout(function(){o.source(s,e)},o.delay)}}else i.last_val=s,i.sc.hide()}})})},t.fn.autoComplete.defaults={source:0,minChars:3,delay:150,cache:1,menuClass:"",appendTo:"body",renderItem:function(t,e){e=e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&");var o=new RegExp("("+e.split(" ").join("|")+")","gi");return'<div class="autocomplete-suggestion" data-val="'+t+'">'+t.replace(o,"<b>$1</b>")+"</div>"},onSelect:function(t,e,o){}}}(jQuery),function(t){var e=0,o="scrollIntoView"in document.createElement("li");t.fn.awesomecomplete=function(i){var i=t.extend({},t.fn.awesomecomplete.defaults,i);return this.each(function(){var s=t(this),r=t.meta?t.extend({},i,s.data()):i;s.data("awesomecomplete-config",r);var a=t(r.attachTo||s),l=t("<ul/>");r.wrapSuggestions?l.appendTo(a):l.insertAfter(a),l.hide().addClass(r.suggestionListClass).css("width",a.innerWidth()),s.data("awesomecomplete-list",l);var c,d=!1;s.keyup(function(t){return d?void(d=!1):void(t.which>36&&t.which<41||16==t.which||(r.typingDelay>0?(clearTimeout(c),c=setTimeout(function(){n(s)},r.typingDelay)):n(s)))}),s.keydown(function(t){var e=l.children("li."+r.activeItemClass);switch(t.which){case 13:0!==e.length&&l.is(":visible")&&(t.preventDefault(),s.val(e.data("awesomecomplete-value")),r.onComplete(e.data("awesomecomplete-dataItem")),l.hide()),l.hide(),d=!0;break;case 38:t.preventDefault(),0===e.length?l.children("li:last-child").addClass(r.activeItemClass):(e.prev().addClass(r.activeItemClass),e.removeClass(r.activeItemClass));break;case 40:t.preventDefault(),0===e.length?l.children("li:first-child").addClass(r.activeItemClass):e.is(":not(:last-child)")&&(e.next().addClass(r.activeItemClass),e.removeClass(r.activeItemClass));break;case 27:l.hide(),d=!0}if(o&&l.is(":visible")){var e=l.children("li."+r.activeItemClass);e.length>0&&e.get(0).scrollIntoView(!1)}}),s.keypress(function(t){l.children("li."+r.activeItemClass);13==t.which&&l.children("li."+r.activeItemClass).length>0&&t.preventDefault()});var u=!1,p=!1;t(document).bind("mousedown.awesomecomplete"+ ++e,function(){u=!0}),t(document).bind("mouseup.awesomecomplete"+e,function(){u=!1,p&&(p=!1,l.hide())}),s.blur(function(){if(u)p=!0;else{var t=l.children("li."+r.activeItemClass);l.is(":visible")&&0!==t.length&&s.val(t.data("awesomecomplete-value")),l.hide()}}),s.focus(function(){l.children(":not(."+r.noResultsClass+")").length>0&&l.show()})})};var i=function(e,o){return function(i){t(".autocomplete__spinner").hide(),s(e,i,o)}},n=function(e){var o=e.val();t(".autocomplete__spinner").show(),e.data("awesomecomplete-list").hide(),"function"==typeof e.data("awesomecomplete-config").dataMethod?e.data("awesomecomplete-config").dataMethod(o,e,i(e,o)):s(e,e.data("awesomecomplete-config").staticData,o)},s=function(e,o,i){var n=e.data("awesomecomplete-list");if(n.empty().hide(),""!==i){for(var s=e.data("awesomecomplete-config"),r=[],a=0;a<o.length;a++){var l=jQuery.extend({},o[a]);r.push({dataItem:l,originalDataItem:o[a]})}r.sort(function(t,e){return s.sortFunction(t,e,i)}),r=r.slice(0,s.resultLimit);for(var c in r)r.hasOwnProperty(c)&&t('<li class="'+s.itemClass+'">'+s.renderFunction(r[c].dataItem,i,r[c].topMatch,r[c].originalDataItem,s)+"</li>").data("awesomecomplete-dataItem",r[c].originalDataItem).data("awesomecomplete-value",s.valueFunction(r[c].originalDataItem,s)).appendTo(n).click(function(){var o=t(this);e.val(o.data("awesomecomplete-value")),s.onComplete(o.data("awesomecomplete-dataItem"))}).mouseover(function(){t(this).addClass(s.activeItemClass).siblings().removeClass(s.activeItemClass)});void 0!==s.noResultsMessage&&0==r.length&&n.append(t('<li class="'+s.noResultsClass+'">'+s.noResultsMessage+"</li>")),(r.length>0||void 0!==s.noResultsMessage)&&n.show()}},r=function(t,e,o,i){return e===i.nameField||null===e?'<p class="title">'+t[i.nameField]+"</p>":'<p class="title">'+t[i.nameField]+'</p><p class="matchRow"><span class="matchedField">'+e+"</span>: "+t[e]+"</p>"},a=function(t,e){return t[e.nameField]},l=function(t,e,o){return t.matchedTermCount==e.matchedTermCount?e.matchCount-t.matchCount:e.matchedTermCount-t.matchedTermCount};t.fn.awesomecomplete.defaults={activeItemClass:"active",itemClass:"item",attachTo:void 0,wrapSuggestions:!1,dataMethod:void 0,dontMatch:[],highlightMatches:!0,highlightClass:"match",ignoreCase:!0,nameField:"name",noResultsClass:"noResults",noResultsMessage:void 0,onComplete:function(t){},sortFunction:l,splitTerm:!0,staticData:[],suggestionListClass:"autocomplete",renderFunction:r,resultLimit:10,typingDelay:0,valueFunction:a,wordDelimiter:/[^\da-z]+/gi}}(jQuery),function(t,e){"function"==typeof define&&define.amd?define([],function(){return t.returnExportsGlobal=e()}):"object"==typeof exports?module.exports=e():t.bouncefix=e()}(this,function(){var t;t=function(){function t(t,e,o,i){this.el=t,this.eventName=e,this.handler=o,this.context=i,this.add()}return t.prototype._handler=function(t,e){var o={};for(var i in t)o[i]=t[i];o.stopPropagation=function(){t.stopPropagation?t.stopPropagation():t.cancelBubble=!0},o.preventDefault=function(){t.preventDefault?t.preventDefault():t.returnValue=!1},this.handler.call(this.context||e,o)},t.prototype.add=function(){var t=this;t.cachedHandler=function(e){t._handler.call(t,e,this)},t.el.addEventListener(t.eventName,t.cachedHandler,!1)},t.prototype.remove=function(){this.el.removeEventListener(this.eventName,this.cachedHandler)},t}();var e;e=function(){var t={};return t.getTargetedEl=function(t,e){for(;;){if(t.classList.contains(e))break;if(!(t=t.parentElement))break}return t},t.isScrollable=function(t){return t.scrollHeight>t.offsetHeight},t.scrollToEnd=function(t){var e=t.scrollTop,o=t.offsetHeight,i=t.scrollHeight;e<=0&&(t.scrollTop=1),e+o>=i&&(t.scrollTop=i-o-1)},t}();var o;o=function(t,e){var o=function(e){if(!(this instanceof o))return new o(e);if(!e)throw new Error('"className" argument is required');this.className=e,this.startListener=new t(document,"touchstart",this.touchStart,this),this.endListener=new t(document,"touchend",this.touchEnd,this)};return o.prototype.touchStart=function(o){var i=e.getTargetedEl(o.target,this.className);return i&&e.isScrollable(i)?e.scrollToEnd(i):void(i&&!this.moveListener&&(this.moveListener=new t(i,"touchmove",this.touchMove,this)))},o.prototype.touchMove=function(t){t.preventDefault()},o.prototype.touchEnd=function(t){this.moveListener&&(this.moveListener.remove(),delete this.moveListener)},o.prototype.remove=function(){this.startListener.remove(),this.endListener.remove()},o}(t,e);var i;return i=function(t){var e={cache:{}};return e.add=function(e){this.cache[e]||(this.cache[e]=new t(e))},e.remove=function(t){this.cache[t]&&(this.cache[t].remove(),delete this.cache[t])},e}(o)}),function(t){"function"==typeof define&&define.amd?define(["jquery"],t):t("object"==typeof exports?require("jquery"):jQuery)}(function(t){function e(t){return a.raw?t:encodeURIComponent(t)}function o(t){return a.raw?t:decodeURIComponent(t)}function i(t){return e(a.json?JSON.stringify(t):String(t))}function n(t){0===t.indexOf('"')&&(t=t.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return t=decodeURIComponent(t.replace(r," ")),a.json?JSON.parse(t):t}catch(e){}}function s(e,o){var i=a.raw?e:n(e);return t.isFunction(o)?o(i):i}var r=/\+/g,a=t.cookie=function(n,r,l){if(arguments.length>1&&!t.isFunction(r)){if(l=t.extend({},a.defaults,l),"number"==typeof l.expires){var c=l.expires,d=l.expires=new Date;d.setTime(+d+864e5*c)}return document.cookie=[e(n),"=",i(r),l.expires?"; expires="+l.expires.toUTCString():"",l.path?"; path="+l.path:"",l.domain?"; domain="+l.domain:"",l.secure?"; secure":""].join("")}for(var u=n?void 0:{},p=document.cookie?document.cookie.split("; "):[],h=0,m=p.length;h<m;h++){var f=p[h].split("="),g=o(f.shift()),y=f.join("=");if(n&&n===g){u=s(y,r);break}n||void 0===(y=s(y))||(u[g]=y)}return u};a.defaults={},t.removeCookie=function(e,o){return void 0!==t.cookie(e)&&(t.cookie(e,"",t.extend({},o,{expires:-1})),!t.cookie(e))}}),"undefined"==typeof Currency)var Currency={};Currency.cookie={configuration:{expires:365,path:"/",domain:window.location.hostname},name:"currency",write:function(t){jQuery.cookie(this.name,t,this.configuration)},read:function(){return jQuery.cookie(this.name)},destroy:function(){jQuery.cookie(this.name,null,this.configuration)}},Currency.moneyFormats={USD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} USD"},EUR:{money_format:"&euro;{{amount}}",money_with_currency_format:"&euro;{{amount}} EUR"},GBP:{money_format:"&pound;{{amount}}",money_with_currency_format:"&pound;{{amount}} GBP"},CAD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} CAD"},ALL:{money_format:"Lek {{amount}}",money_with_currency_format:"Lek {{amount}} ALL"},DZD:{money_format:"DA {{amount}}",money_with_currency_format:"DA {{amount}} DZD"},AOA:{money_format:"Kz{{amount}}",money_with_currency_format:"Kz{{amount}} AOA"},ARS:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} ARS"},AMD:{money_format:"{{amount}} AMD",money_with_currency_format:"{{amount}} AMD"},AWG:{money_format:"Afl{{amount}}",money_with_currency_format:"Afl{{amount}} AWG"},AUD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} AUD"},BBD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} Bds"},AZN:{money_format:"m.{{amount}}",money_with_currency_format:"m.{{amount}} AZN"},BDT:{money_format:"Tk {{amount}}",money_with_currency_format:"Tk {{amount}} BDT"},BSD:{money_format:"BS${{amount}}",money_with_currency_format:"BS${{amount}} BSD"},BHD:{money_format:"{{amount}}0 BD",money_with_currency_format:"{{amount}}0 BHD"},BYR:{money_format:"Br {{amount}}",money_with_currency_format:"Br {{amount}} BYR"},BZD:{money_format:"BZ${{amount}}",money_with_currency_format:"BZ${{amount}} BZD"},BTN:{money_format:"Nu {{amount}}",money_with_currency_format:"Nu {{amount}} BTN"},BAM:{money_format:"KM {{amount_with_comma_separator}}",money_with_currency_format:"KM {{amount_with_comma_separator}} BAM"},BRL:{money_format:"R$ {{amount_with_comma_separator}}",money_with_currency_format:"R$ {{amount_with_comma_separator}} BRL"},BOB:{money_format:"Bs{{amount_with_comma_separator}}",money_with_currency_format:"Bs{{amount_with_comma_separator}} BOB"},BWP:{money_format:"P{{amount}}",money_with_currency_format:"P{{amount}} BWP"},BND:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} BND"},BGN:{money_format:"{{amount}} Ð»Ð²",money_with_currency_format:"{{amount}} Ð»Ð² BGN"},MMK:{money_format:"K{{amount}}",money_with_currency_format:"K{{amount}} MMK"},KHR:{money_format:"KHR{{amount}}",money_with_currency_format:"KHR{{amount}}"},KYD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} KYD"},XAF:{money_format:"FCFA{{amount}}",money_with_currency_format:"FCFA{{amount}} XAF"},CLP:{money_format:"${{amount_no_decimals}}",money_with_currency_format:"${{amount_no_decimals}} CLP"},CNY:{money_format:"&#165;{{amount}}",money_with_currency_format:"&#165;{{amount}} CNY"},COP:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} COP"},CRC:{money_format:"&#8353; {{amount_with_comma_separator}}",money_with_currency_format:"&#8353; {{amount_with_comma_separator}} CRC"},HRK:{money_format:"{{amount_with_comma_separator}} kn",money_with_currency_format:"{{amount_with_comma_separator}} kn HRK"},CZK:{money_format:"{{amount_with_comma_separator}} K&#269;",money_with_currency_format:"{{amount_with_comma_separator}} K&#269;"},DKK:{money_format:"{{amount_with_comma_separator}}",money_with_currency_format:"kr.{{amount_with_comma_separator}}"},DOP:{money_format:"RD$ {{amount}}",money_with_currency_format:"RD$ {{amount}}"},XCD:{money_format:"${{amount}}",money_with_currency_format:"EC${{amount}}"},EGP:{money_format:"LE {{amount}}",money_with_currency_format:"LE {{amount}} EGP"},ETB:{money_format:"Br{{amount}}",money_with_currency_format:"Br{{amount}} ETB"},XPF:{money_format:"{{amount_no_decimals_with_comma_separator}} XPF",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} XPF"},FJD:{money_format:"${{amount}}",money_with_currency_format:"FJ${{amount}}"},GMD:{money_format:"D {{amount}}",money_with_currency_format:"D {{amount}} GMD"},GHS:{money_format:"GH&#8373;{{amount}}",money_with_currency_format:"GH&#8373;{{amount}}"},GTQ:{money_format:"Q{{amount}}",money_with_currency_format:"{{amount}} GTQ"},GYD:{money_format:"G${{amount}}",money_with_currency_format:"${{amount}} GYD"},GEL:{money_format:"{{amount}} GEL",money_with_currency_format:"{{amount}} GEL"},HNL:{money_format:"L {{amount}}",money_with_currency_format:"L {{amount}} HNL"},HKD:{money_format:"${{amount}}",money_with_currency_format:"HK${{amount}}"},HUF:{money_format:"{{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} Ft"},ISK:{money_format:"{{amount_no_decimals}} kr",money_with_currency_format:"{{amount_no_decimals}} kr ISK"},INR:{money_format:"Rs. {{amount}}",money_with_currency_format:"Rs. {{amount}}"},IDR:{money_format:"{{amount_with_comma_separator}}",money_with_currency_format:"Rp {{amount_with_comma_separator}}"},ILS:{money_format:"{{amount}} NIS",money_with_currency_format:"{{amount}} NIS"},JMD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} JMD"},JPY:{money_format:"&#165;{{amount_no_decimals}}",money_with_currency_format:"&#165;{{amount_no_decimals}} JPY"},JEP:{money_format:"&pound;{{amount}}",money_with_currency_format:"&pound;{{amount}} JEP"},JOD:{money_format:"{{amount}}0 JD",money_with_currency_format:"{{amount}}0 JOD"},KZT:{money_format:"{{amount}} KZT",money_with_currency_format:"{{amount}} KZT"},KES:{money_format:"KSh{{amount}}",money_with_currency_format:"KSh{{amount}}"},KWD:{money_format:"{{amount}}0 KD",money_with_currency_format:"{{amount}}0 KWD"},KGS:{money_format:"Ð»Ð²{{amount}}",money_with_currency_format:"Ð»Ð²{{amount}}"},LVL:{money_format:"Ls {{amount}}",money_with_currency_format:"Ls {{amount}} LVL"},LBP:{money_format:"L&pound;{{amount}}",money_with_currency_format:"L&pound;{{amount}} LBP"},LTL:{money_format:"{{amount}} Lt",money_with_currency_format:"{{amount}} Lt"},MGA:{money_format:"Ar {{amount}}",money_with_currency_format:"Ar {{amount}} MGA"},MKD:{money_format:"Ð´ÐµÐ½ {{amount}}",money_with_currency_format:"Ð´ÐµÐ½ {{amount}} MKD"},MOP:{money_format:"MOP${{amount}}",money_with_currency_format:"MOP${{amount}}"},MVR:{money_format:"Rf{{amount}}",money_with_currency_format:"Rf{{amount}} MRf"},MXN:{money_format:"$ {{amount}}",money_with_currency_format:"$ {{amount}} MXN"},MYR:{money_format:"RM{{amount}} MYR",money_with_currency_format:"RM{{amount}} MYR"},MUR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} MUR"},MDL:{money_format:"{{amount}} MDL",money_with_currency_format:"{{amount}} MDL"},MAD:{money_format:"{{amount}} dh",money_with_currency_format:"Dh {{amount}} MAD"},MNT:{money_format:"{{amount_no_decimals}} &#8366",money_with_currency_format:"{{amount_no_decimals}} MNT"},MZN:{money_format:"{{amount}} Mt",money_with_currency_format:"Mt {{amount}} MZN"},NAD:{money_format:"N${{amount}}",money_with_currency_format:"N${{amount}} NAD"},NPR:{money_format:"Rs{{amount}}",money_with_currency_format:"Rs{{amount}} NPR"},ANG:{money_format:"&fnof;{{amount}}",money_with_currency_format:"{{amount}} NA&fnof;"},NZD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} NZD"},NIO:{money_format:"C${{amount}}",money_with_currency_format:"C${{amount}} NIO"},NGN:{money_format:"&#8358;{{amount}}",money_with_currency_format:"&#8358;{{amount}} NGN"},NOK:{money_format:"kr {{amount_with_comma_separator}}",money_with_currency_format:"kr {{amount_with_comma_separator}} NOK"},OMR:{money_format:"{{amount_with_comma_separator}} OMR",money_with_currency_format:"{{amount_with_comma_separator}} OMR"},PKR:{money_format:"Rs.{{amount}}",money_with_currency_format:"Rs.{{amount}} PKR"},PGK:{money_format:"K {{amount}}",money_with_currency_format:"K {{amount}} PGK"},PYG:{money_format:"Gs. {{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"Gs. {{amount_no_decimals_with_comma_separator}} PYG"},PEN:{money_format:"S/. {{amount}}",money_with_currency_format:"S/. {{amount}} PEN"},PHP:{money_format:"&#8369;{{amount}}",money_with_currency_format:"&#8369;{{amount}} PHP"},PLN:{money_format:"{{amount_with_comma_separator}} zl",money_with_currency_format:"{{amount_with_comma_separator}} zl PLN"},QAR:{money_format:"QAR {{amount_with_comma_separator}}",money_with_currency_format:"QAR {{amount_with_comma_separator}}"},RON:{money_format:"{{amount_with_comma_separator}} lei",money_with_currency_format:"{{amount_with_comma_separator}} lei RON"},RUB:{money_format:"&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",money_with_currency_format:"&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"},RWF:{money_format:"{{amount_no_decimals}} RF",money_with_currency_format:"{{amount_no_decimals}} RWF"},WST:{money_format:"WS$ {{amount}}",money_with_currency_format:"WS$ {{amount}} WST"},SAR:{money_format:"{{amount}} SR",money_with_currency_format:"{{amount}} SAR"},STD:{money_format:"Db {{amount}}",money_with_currency_format:"Db {{amount}} STD"},RSD:{money_format:"{{amount}} RSD",money_with_currency_format:"{{amount}} RSD"},SCR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} SCR"},SGD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} SGD"},SYP:{money_format:"S&pound;{{amount}}",money_with_currency_format:"S&pound;{{amount}} SYP"},ZAR:{money_format:"R {{amount}}",money_with_currency_format:"R {{amount}} ZAR"},KRW:{money_format:"&#8361;{{amount_no_decimals}}",money_with_currency_format:"&#8361;{{amount_no_decimals}} KRW"},LKR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} LKR"},SEK:{money_format:"{{amount_no_decimals}} kr",money_with_currency_format:"{{amount_no_decimals}} kr SEK"},CHF:{money_format:"SFr. {{amount}}",money_with_currency_format:"SFr. {{amount}} CHF"},TWD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} TWD"},THB:{money_format:"{{amount}} &#xe3f;",money_with_currency_format:"{{amount}} &#xe3f; THB"},TZS:{money_format:"{{amount}} TZS",money_with_currency_format:"{{amount}} TZS"},TTD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} TTD"},TND:{money_format:"{{amount}}",money_with_currency_format:"{{amount}} DT"},TRY:{money_format:"{{amount}}TL",money_with_currency_format:"{{amount}}TL"},UGX:{money_format:"Ush {{amount_no_decimals}}",money_with_currency_format:"Ush {{amount_no_decimals}} UGX"},UAH:{money_format:"â‚´{{amount}}",money_with_currency_format:"â‚´{{amount}} UAH"},AED:{money_format:"Dhs. {{amount}}",money_with_currency_format:"Dhs. {{amount}} AED"},UYU:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} UYU"},VUV:{money_format:"${{amount}}",money_with_currency_format:"${{amount}}VT"},VEF:{money_format:"Bs. {{amount_with_comma_separator}}",money_with_currency_format:"Bs. {{amount_with_comma_separator}} VEF"},VND:{money_format:"{{amount_no_decimals_with_comma_separator}}&#8363;",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} VND"},XBT:{money_format:"{{amount_no_decimals}} BTC",money_with_currency_format:"{{amount_no_decimals}} BTC"},XOF:{money_format:"CFA{{amount}}",money_with_currency_format:"CFA{{amount}} XOF"},ZMW:{money_format:"K{{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"ZMW{{amount_no_decimals_with_comma_separator}}"}},Currency.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,n){if(e=o(e,2),i=o(i,","),n=o(n,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var s=t.split("."),r=s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),a=s[1]?n+s[1]:"";return r+a}if("function"==typeof Shopify.formatMoney)return Shopify.formatMoney(t,e);"string"==typeof t&&(t=t.replace(".",""));var n="",s=/\{\{\s*(\w+)\s*\}\}/,r=e||"${{amount}}";switch(r.match(s)[1]){case"amount":n=i(t,2);break;case"amount_no_decimals":n=i(t,0);break;case"amount_with_comma_separator":n=i(t,2,".",",");break;case"amount_no_decimals_with_comma_separator":n=i(t,0,".",",")}return r.replace(s,n)},Currency.currentCurrency="",Currency.format="money_format",Currency.convertAll=function(t,e,o,i){t=t||Currency.currentCurrency,e=e||$(".currency-selector__select").val(),jQuery(o||"[data-money-convertible]").each(function(){if(jQuery(this).attr("data-currency")!==e){if(jQuery(this).attr("data-currency-"+e))jQuery(this).html(jQuery(this).attr("data-currency-"+e));else{var o=0,n=Currency.moneyFormats[t][i||Currency.format]||"{{amount}}",s=Currency.moneyFormats[e][i||Currency.format]||"{{amount}}";o=n.indexOf("amount_no_decimals")!==-1?Currency.convert(100*parseInt(jQuery(this).html().replace(/[^0-9]/g,""),10),t,e):"JOD"===t||"KWD"==t||"BHD"==t?Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g,""),10)/10,t,e):Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g,""),10),t,e);var r=Currency.formatMoney(o,s);jQuery(this).html(r),jQuery(this).attr("data-currency-"+e,r)}jQuery(this).attr("data-currency",e)}}),this.currentCurrency=e,this.cookie.write(e)};var qualifyURL=function(t){var e=document.createElement("img");return e.src=t,t=e.src,e.src=null,t};!function(t,e,o,n){function s(e,o){this.element=e,this.$element=t(e),this.settings=t.extend({},a,o),this._columnSize=0,this._defaults=a,this._name=r,this.tiles=[],this._loadedImages=0,this._rows=[[]],this._currentRow=0,this._currentRowTile=0,this.edges=[],this.imagesData={},this.currentWidth=0,this.currentImageSizeFactor=1,this.currentColumnsCount=0,this.ajaxComplete=!1,this.isLoading=!1,this.currentPage=1,this.init()}t.fn.visible=function(o){if(!t(this).offset())return!0;var i=t(this),n=t(e),s=n.scrollTop(),r=s+n.height(),a=i.offset().top,l=a+i.height(),c=o===!0?l:a,d=o===!0?a:l;return d<=r&&c>=s};var r="finalTilesGallery",a={layout:"final",columns:[[4e3,5],[1024,4],[800,3],[480,2],[320,1]],rowHeight:200,margin:10,minTileWidth:200,ignoreImageAttributes:!0,imageSizeFactor:[[4e3,.9],[1024,.8],[800,.7],[600,.6],[480,.5],[320,.3]],gridSize:10,allowEnlargement:!0,autoLoadURL:null,autoLoadOffset:50,selectedFilter:"",loadingTarget:"",onComplete:function(){},onUpdate:function(){},onAutoLoaded:function(){},onAutoLoadCompleted:function(){},debug:!1};t.extend(s.prototype,{print:function(t){this.settings.debug&&console.log(t)},setCurrentImageSizeFactor:function(){this.currentImageSizeFactor=1;for(var o=t(e).width(),i=0;i<this.settings.imageSizeFactor.length;i++)this.settings.imageSizeFactor[i][0]>=o&&(this.currentImageSizeFactor=this.settings.imageSizeFactor[i][1]);this.currentImageSizeFactor||(this.currentImageSizeFactor=1),this.print("current image size factor: "+this.currentImageSizeFactor+" ("+o+")")},setCurrentColumnSize:function(){for(var o=t(e).width(),i=0;i<this.settings.columns.length;i++)this.settings.columns[i][0]>=o&&(this.currentColumnsCount=this.settings.columns[i][1]);this._columnSize=Math.floor((this.currentWidth-this.settings.margin*(this.currentColumnsCount-1))/this.currentColumnsCount),console.log(this.currentWidth,this._columnSize,this.currentColumnsCount),this.print(this.currentWidth,this._columnSize)},init:function(){var o=this,i=this.settings.selectedFilter,n=ftg_getURLParameter("ftg-set");if(n&&(i=n),o.currentWidth=o.$element.width(),0==o.$element.filter(":visible").length)return o.print("cannot initialize the gallery, container is hidden. Retrying in 500ms."),void setTimeout(function(){o.init()},500);this.$element.find(".ftg-items").css({position:"relative"});var i=this.settings.selectedFilter,n=ftg_getURLParameter("ftg-set");n&&(i=n);var o=this;null!=i&&(o.print(".. found filter ("+i+")"),o.$element.find(".ftg-filters a").removeClass("selected"),o.$element.find(".ftg-filters a").each(function(){t(this).data("filter")==i&&(o.print(".. selecting filter"),t(this).addClass("selected"))}));var s=e.location.hash;if(this.$element.find(".ftg-items").css({position:"relative",minWidth:o.settings.minTileWidth}),s&&"#ftg-set-ftgall"!=s&&"#ftg-set"==s.substr(0,8)||o.settings.selectedFilter){var r="#ftg-set-"+o.settings.selectedFilter;s&&(r=s);var a=r.replace("#","."),l=[];o.$element.find(".ftg-filters a").each(function(){l.push(t(this).attr("href"))}),t.inArray(r,l)>=0&&(a=a.substring(1),o.$element.find(".ftg-filters a").each(function(){t(this).attr("href")!=r&&(o.$element.find(".item").each(function(){var e=t(this).parent().parent();0==e.hasClass(a)&&e.addClass("ftg-hidden")}),t(this).removeClass("selected"))}),t('a[href="'+r+'"]').addClass("selected"))}if(this.tiles=this.$element.find(".tile").not(".ftg-hidden"),this.tiles.css({transition:"all .3s"}),this.currentWidth=this.$element.width(),this.print("this.currentWidth: "+this.currentWidth),0==o.$element.filter(":visible").length)return o.warn("cannot initialize the gallery, container is hidden. Retrying in 500ms."),void setTimeout(function(){o.init()},500);"columns"!=this.settings.layout&&"rows"!=this.settings.layout&&"final"!=this.settings.layout&&console.log("WARNING: unknown layout, falling back to 'final'."),"columns"==this.settings.layout&&this.setCurrentColumnSize();var c=0;this.setCurrentImageSizeFactor(),t(e).resize(function(){c=setTimeout(function(){o.currentWidth!=o.$element.width()&&(clearTimeout(c),o.print("this.currentWidth",this.currentWidth),o.currentWidth=o.$element.width(),o.setCurrentColumnSize(),o.setCurrentImageSizeFactor(),o.refresh())},500)}),o.isLoading=!0,o.settings.autoLoadURL&&t(e).scroll(function(){if(!o.ajaxComplete&&!o.isLoading){var i=t(o.settings.loadingTarget);t(e).scrollTop()>=i.offset().top-t(e).height()-o.settings.autoLoadOffset&&(o.isLoading=!0,t.get(o.settings.autoLoadURL,{page:++o.currentPage},function(t){var e=o.settings.onAutoLoaded(t);0==e.length?(o.ajaxComplete=!0,o.settings.onAutoLoadCompleted()):(o.$element.find(".ftg-items").append(e),o.tiles=o.$element.find(".tile"),o.loadImage())}))}}),this.setupFilters(),this.edges.push({left:0,top:0,width:this.currentWidth,index:0}),this.loadImage()},addElements:function(t){this.$element.find(".ftg-items").append(t),this.tiles=this.$element.find(".tile"),this.loadImage()},removeAt:function(t){this.tiles[t].remove(),this.refresh()},clear:function(){this.$element.find(".ftg-items").height(0).empty(),this.refresh()},setupFilters:function(){var e=this;e.$element.find(".ftg-filters a").click(function(o){o.preventDefault(),e.$element.find(".ftg-filters a").removeClass("selected"),t(this).addClass("selected");var i=t(this).attr("href").replace("#ftg-set-","");"ftgall"==i?e.$element.find(".tile").removeClass("ftg-hidden"):e.$element.find(".tile").not(".ftg-set-"+i).addClass("ftg-hidden").end().filter(".ftg-set-"+i).removeClass("ftg-hidden"),e.refresh()})},printEdges:function(){for(this.$element.find(".edge").remove(),i=0;i<this.edges.length;i++){var e=t("<div class='edge' />");e.append("top: "+this.edges[i].top+"<br>"),e.append("left: "+this.edges[i].left+"<br>"),e.append("width: "+this.edges[i].width+"<br>"),e.css({left:this.edges[i].left,top:this.edges[i].top,marginTop:-25,marginLeft:20}),this.$element.append(e)}},printEdge:function(e){var o=t("<div class='edge enlarged-"+e.enlarged+"' />");o.append("<b>"+e.index+" "+e["case"]+"</b><br>"),o.append("t: "+Math.round(e.top)+" l: "+e.left+"<br>"),o.append("width: "+e.width+"<br>"),o.append("idx: "+e.tileIndex+"<br>"),o.css({left:e.left,top:e.top,marginTop:-25,marginLeft:20}),this.$element.append(o)},refresh:function(){this.$element.find(".edge").remove(),this.edges=[{left:0,top:0,width:this.currentWidth}],this.tiles.removeClass("ftg-loaded ftg-enlarged"),this.tiles=this.$element.find(".tile").not(".ftg-hidden"),this._loadedImages=0,this.loadImage()},getAvailableRowSpace:function(){return this.currentWidth-this.getBusyRowSpace()},getBusyRowSpace:function(){for(var t=0,e=0;e<this._rows[this._currentRow].length;e++)t+=this._rows[this._currentRow][e].data("width")+this.settings.margin;return t},addImageToRow:function(t){console.log(this._rows),console.log(this._currentRow),this._rows[this._currentRow].push(t)},fitImagesInRow:function(){for(var t=(this.getAvailableRowSpace()-this.settings.margin,(this.currentWidth-(this._rows[this._currentRow].length-1)*this.settings.margin)/this.getBusyRowSpace()),e=0;e<this._rows[this._currentRow].length;e++){$item=this._rows[this._currentRow][e];var o=$item.data("width");$item.data("height");$item.data("width",o*t),this.add(this._currentRowTile++)}},nextTile:function(t){var e=this;if(t&&e.add(e._loadedImages),
++e._loadedImages<e.tiles.length)e.loadImage();else{var o=e.lowerEdgeTop();e.print("lower edge top: "+o),e.$element.find(".ftg-items").height(o),e.isLoading=!1,e.settings.onComplete()}},loadImage:function(){var t=this,e=this.tiles.eq(this._loadedImages);e.children("iframe").length&&e.children("iframe").addClass("item");var o=e.find(".item");switch(o.get(0).tagName.toLowerCase()){case"img":var i=new Image;i.onload=function(){var n=t.currentImageSizeFactor;e.data("ftg-ignore-size-factor")&&(n=1);var s={},r=!0;if("final"==t.settings.layout){var a=o.attr("width")?parseInt(o.attr("width")):i.width,l=o.attr("height")?parseInt(o.attr("height")):i.height;s.width=a*n,s.height=l*n}"columns"==t.settings.layout&&(s.width=t._columnSize,s.height=s.width*i.height/i.width),"rows"==t.settings.layout&&(s.width=t.settings.rowHeight*i.width/i.height,s.height=t.settings.rowHeight,r=!1,t.getAvailableRowSpace()>s.width?t.addImageToRow(o):(t.fitImagesInRow(),t._currentRow++,t._rows.push([]),t.addImageToRow(o))),o.attr("src",this.src),t.imagesData["tile"+t._loadedImages]={width:s.width,height:s.height,owidth:i.width,oheight:i.height,src:i.src},t.nextTile(r)},i.onerror=function(){t.print("error loading image: "+i.src),t.nextTile(!0)},i.src=o.data("src"),e.data("ftg-type","image");break;case"svg":t.imagesData["tile"+t._loadedImages]={width:parseInt(o.attr("width")),height:parseInt(o.attr("height")),owidth:parseInt(o.attr("width")),oheight:parseInt(o.attr("height"))},e.data("ftg-type","svg"),t.nextTile(!0);break;case"iframe":t.imagesData["tile"+t._loadedImages]={width:parseInt(o.attr("width")),height:parseInt(o.attr("height")),owidth:parseInt(o.attr("width")),oheight:parseInt(o.attr("height"))},e.data("ftg-type","iframe"),t.nextTile(!0);break;default:t.imagesData["tile"+t._loadedImages]={width:parseInt(o.data("width")),height:parseInt(o.data("height")),owidth:parseInt(o.data("width")),oheight:parseInt(o.data("height"))},t.nextTile(!0)}},higherEdge:function(){for(var t=1e5,e=0,o=0;o<this.edges.length;o++)this.edges[o].top<t&&(e=o,t=this.edges[o].top);return this.edges[e]},lowerEdgeTop:function(){for(var t=0,e=0;e<this.edges.length;e++)this.edges[e].top>t&&(t=this.edges[e].top);return t},alignEdge:function(t,e){for(var o=0;o<this.edges.length;o++)if(this.edges[o].left+this.edges[o].width+this.settings.margin==t.left&&(this.print("found edge on left",o),t.top==this.edges[o].top))return this.print("edges can be aligned [1]"),{side:"left",edge:this.edges[o]};for(var o=0;o<this.edges.length;o++)if(this.edges[o].left-this.settings.margin==t.left+t.width&&(this.print("found edge on right",o),t.top==this.edges[o].top))return this.print("edges can be aligned [2]"),{side:"right",edge:this.edges[o]};return null},removeEdge:function(t){for(var e=[],o=0;o<this.edges.length;o++)this.edges[o]!=t&&e.push(this.edges[o]);this.edges=e},add:function(t){var e=this.tiles.eq(t),o=e.find(".item"),i="tile"+t,n=this.imagesData[i].width,s=this.imagesData[i].height,r=this.higherEdge();if(this.print(r),r.tileIndex=t,this.print(t+" ["+e.data("ftg-type")+"] ("+n+"x"+s+")"),r.top>0&&(r.top+=this.settings.margin),e.css({left:r.left,top:r.top,position:"absolute"}),r.enlarged=!1,r.width<n+this.settings.margin){r["case"]="Te",this.print("Te",r.width);var a=r.width,l=s/n*a;a+r.left-this.settings.margin==this.currentWidth&&(this.print("END"),a-=this.settings.margin,l=s/n*a),n=a,s=l}else if(r.width>n)if(this.print("tE"),"columns"==this.settings.layout||r.width-n>=this.settings.minTileWidth){r["case"]="tE",this.print("tE1",r.width,r.left,this.currentWidth);var c={left:r.left+n+this.settings.margin,top:r.top-(r.top>0?this.settings.margin:0),width:r.width-n-this.settings.margin,marginLeft:!0,"case":"NEW",index:r.index+1};this.edges.push(c)}else{r["case"]="tE2",this.print("tE2"),this.print("enlargement",r.width,r.left,this.currentWidth);var a=(r.left+r.width==this.currentWidth?0:this.settings.margin,r.width),l=this.settings.allowEnlargement&&"rows"!=this.settings.layout?s/n*a:s;this.settings.allowEnlargement?(e.addClass("ftg-enlarged"),r.enlarged=!0):"rows"!=this.settings.layout&&e.find(".item").css({width:n,height:s}),n=a,s=l}if(r.top+=s,this.settings.gridSize){var d=r.top%this.settings.gridSize;r.top-=d,s-=d}r.left=r.left,r.width=n;var u=!0,p=this.alignEdge(r,t);p&&("left"==p.side?(this.removeEdge(r),p.edge.width+=n+this.settings.margin,s-=r.top-p.edge.top,r.top-=s,u=!1):(this.removeEdge(p.edge),r.width+=this.settings.margin+p.edge.width,u=!1),e.height(s)),this.$element.find(".ftg-items").height()<r.top&&this.$element.find(".ftg-items").height(r.top),this.settings.debug&&u&&this.printEdge(r),"iframe"==e.data("ftg-type")&&e.find("iframe").height(s),this.print(n+"x"+s),this.print("----"),e.css({width:n,height:s});var h=n/this.imagesData[i].width,m=this.imagesData[i].height*h-s;o.css({height:"auto"}),m>0&&o.css({top:0-m/2}),e.addClass("ftg-loaded")}}),t.fn[r]=function(e){return this.each(function(){t.data(this,r)||t.data(this,r,new s(this,e))}),this}}(jQuery,window,document),function(t,e){"use strict";function o(o,i){this.options=t.extend({},a,i),this.$element=t(o),this.$win=t(e),this.$loadingClassTarget=this._getLoadingClassTarget(),this.$scrollContainer=this._getScrollContainer(),this.loading=!1,this.doneLoadingInt=null,this.pageCount=this.options.triggerInitialLoad?this.options.startingPageCount-1:this.options.startingPageCount,this.destroyed=!1,this._init()}function i(e,o,i){e&&t.isFunction(e[o])&&e[o].apply(e,i)}function n(t,e,o){var i;return function(){var n=this,s=arguments,r=function(){i=null,o||t.apply(n,s)},a=o&&!i;clearTimeout(i),i=setTimeout(r,e),a&&t.apply(n,s)}}var s="infiniteScrollHelper",r="plugin_"+s,a={bottomBuffer:0,debounceInt:100,doneLoading:null,interval:300,loadingClass:"loading",loadingClassTarget:null,loadMoreDelay:0,loadMore:t.noop,startingPageCount:1,triggerInitialLoad:!1};o.prototype._init=function(){this._addListeners(),this.options.triggerInitialLoad?this._beginLoadMore(this.options.loadMoreDelay):this._handleScroll()},o.prototype._getLoadingClassTarget=function(){return this.options.loadingClassTarget?t(this.options.loadingClassTarget):this.$element},o.prototype._getScrollContainer=function(){var e=null;return"scroll"==this.$element.css("overflow-y")&&(e=this.$element),e||(e=this.$element.parents().filter(function(){return"scroll"==t(this).css("overflow-y")})),e=e.length>0?e:this.$win},o.prototype._addListeners=function(){var t=this;this.$scrollContainer.on("scroll."+s,n(function(){t._handleScroll()},this.options.debounceInt))},o.prototype._removeListeners=function(){this.$scrollContainer.off("scroll."+s)},o.prototype._handleScroll=function(t){var e=this;this._shouldTriggerLoad()&&(this._beginLoadMore(this.options.loadMoreDelay),this.options.doneLoading&&(this.doneLoadingInt=setInterval(function(){e.options.doneLoading(e.pageCount)&&e._endLoadMore()},this.options.interval)))},o.prototype._shouldTriggerLoad=function(){var t=this._getElementHeight(),e=this.$scrollContainer.scrollTop()+this.$scrollContainer.height()+this.options.bottomBuffer;return!this.loading&&e>=t&&this.$element.is(":visible")},o.prototype._getElementHeight=function(){return this.$element==this.$scrollContainer?this.$element[0].scrollHeight:this.$element.height()},o.prototype._beginLoadMore=function(e){e=e||0,setTimeout(t.proxy(function(){this.pageCount++,this.options.loadMore(this.pageCount,t.proxy(this._endLoadMore,this)),this.$loadingClassTarget.addClass(this.options.loadingClass)},this),e),this.loading=!0,this._removeListeners()},o.prototype._endLoadMore=function(){clearInterval(this.doneLoadingInt),this.loading=!1,this.$loadingClassTarget.removeClass(this.options.loadingClass),!this.destroyed&&this._addListeners()},o.prototype.destroy=function(){this._removeListeners(),this.options.loadMore=null,this.options.doneLoading=null,t.data(this.$element[0],r,null),clearInterval(this.doneLoadingInt),this.destroyed=!0},t.fn[s]=function(e){var n=!1,s=arguments;return"string"==typeof e&&(n=e),this.each(function(){var a=t.data(this,r);a||n?n&&i(a,n,Array.prototype.slice.call(s,1)):t.data(this,r,new o(this,e))})},e.InfiniteScrollHelper=e.InfiniteScrollHelper||o}(jQuery,window),function(){var t;t=function(){function t(t,e){var o,i;if(this.options={target:"instafeed",get:"popular",resolution:"thumbnail",sortBy:"none",links:!0,mock:!1,useHttp:!1},"object"==typeof t)for(o in t)i=t[o],this.options[o]=i;this.context=null!=e?e:this,this.unique=this._genKey()}return t.prototype.hasNext=function(){return"string"==typeof this.context.nextUrl&&this.context.nextUrl.length>0},t.prototype.next=function(){return!!this.hasNext()&&this.run(this.context.nextUrl)},t.prototype.run=function(e){var o,i,n;if("string"!=typeof this.options.clientId&&"string"!=typeof this.options.accessToken)throw new Error("Missing clientId or accessToken.");if("string"!=typeof this.options.accessToken&&"string"!=typeof this.options.clientId)throw new Error("Missing clientId or accessToken.");return null!=this.options.before&&"function"==typeof this.options.before&&this.options.before.call(this),"undefined"!=typeof document&&null!==document&&(n=document.createElement("script"),n.id="instafeed-fetcher",n.src=e||this._buildUrl(),o=document.getElementsByTagName("head"),o[0].appendChild(n),i="instafeedCache"+this.unique,window[i]=new t(this.options,this),window[i].unique=this.unique),!0},t.prototype.parse=function(t){var e,o,i,n,s,r,a,l,c,d,u,p,h,m,f,g,y,v,w,_,k,C,T,S,$,b,x,L,E,I,A,O,D;if("object"!=typeof t){if(null!=this.options.error&&"function"==typeof this.options.error)return this.options.error.call(this,"Invalid JSON data"),!1;throw new Error("Invalid JSON response")}if(200!==t.meta.code){if(null!=this.options.error&&"function"==typeof this.options.error)return this.options.error.call(this,t.meta.error_message),!1;throw new Error("Error from Instagram: "+t.meta.error_message)}if(0===t.data.length){if(null!=this.options.error&&"function"==typeof this.options.error)return this.options.error.call(this,"No images were returned from Instagram"),!1;throw new Error("No images were returned from Instagram")}if(null!=this.options.success&&"function"==typeof this.options.success&&this.options.success.call(this,t),this.context.nextUrl="",null!=t.pagination&&(this.context.nextUrl=t.pagination.next_url),"none"!==this.options.sortBy)switch(A="random"===this.options.sortBy?["","random"]:this.options.sortBy.split("-"),I="least"===A[0],A[1]){case"random":t.data.sort(function(){return.5-Math.random()});break;case"recent":t.data=this._sortBy(t.data,"created_time",I);break;case"liked":t.data=this._sortBy(t.data,"likes.count",I);break;case"commented":t.data=this._sortBy(t.data,"comments.count",I);break;default:throw new Error("Invalid option for sortBy: '"+this.options.sortBy+"'.")}if("undefined"!=typeof document&&null!==document&&this.options.mock===!1){if(g=t.data,E=parseInt(this.options.limit,10),null!=this.options.limit&&g.length>E&&(g=g.slice(0,E)),a=document.createDocumentFragment(),null!=this.options.filter&&"function"==typeof this.options.filter&&(g=this._filter(g,this.options.filter)),null!=this.options.template&&"string"==typeof this.options.template){for(c="",m="",_="",D=document.createElement("div"),u=0,$=g.length;u<$;u++){if(p=g[u],h=p.images[this.options.resolution],"object"!=typeof h)throw r="No image found for resolution: "+this.options.resolution+".",new Error(r);k=h.width,v=h.height,w="square",k>v&&(w="landscape"),k<v&&(w="portrait"),f=h.url,d=window.location.protocol.indexOf("http")>=0,d&&!this.options.useHttp&&(f=f.replace(/https?:\/\//,"//")),m=this._makeTemplate(this.options.template,{model:p,id:p.id,link:p.link,type:p.type,image:f,width:k,height:v,orientation:w,caption:this._getObjectProperty(p,"caption.text"),likes:p.likes.count,comments:p.comments.count,location:this._getObjectProperty(p,"location.name")}),c+=m}for(D.innerHTML=c,n=[],i=0,o=D.childNodes.length;i<o;)n.push(D.childNodes[i]),i+=1;for(T=0,b=n.length;T<b;T++)L=n[T],a.appendChild(L)}else for(S=0,x=g.length;S<x;S++){if(p=g[S],y=document.createElement("img"),h=p.images[this.options.resolution],"object"!=typeof h)throw r="No image found for resolution: "+this.options.resolution+".",new Error(r);f=h.url,d=window.location.protocol.indexOf("http")>=0,d&&!this.options.useHttp&&(f=f.replace(/https?:\/\//,"//")),y.src=f,this.options.links===!0?(e=document.createElement("a"),e.href=p.link,e.appendChild(y),a.appendChild(e)):a.appendChild(y)}if(O=this.options.target,"string"==typeof O&&(O=document.getElementById(O)),null==O)throw r='No element with id="'+this.options.target+'" on page.',new Error(r);O.appendChild(a),l=document.getElementsByTagName("head")[0],l.removeChild(document.getElementById("instafeed-fetcher")),C="instafeedCache"+this.unique,window[C]=void 0;try{delete window[C]}catch(R){s=R}}return null!=this.options.after&&"function"==typeof this.options.after&&this.options.after.call(this),!0},t.prototype._buildUrl=function(){var t,e,o;switch(t="https://api.instagram.com/v1",this.options.get){case"popular":e="media/popular";break;case"tagged":if(!this.options.tagName)throw new Error("No tag name specified. Use the 'tagName' option.");e="tags/"+this.options.tagName+"/media/recent";break;case"location":if(!this.options.locationId)throw new Error("No location specified. Use the 'locationId' option.");e="locations/"+this.options.locationId+"/media/recent";break;case"user":if(!this.options.userId)throw new Error("No user specified. Use the 'userId' option.");e="users/"+this.options.userId+"/media/recent";break;default:throw new Error("Invalid option for get: '"+this.options.get+"'.")}return o=t+"/"+e,o+=null!=this.options.accessToken?"?access_token="+this.options.accessToken:"?client_id="+this.options.clientId,null!=this.options.limit&&(o+="&count="+this.options.limit),o+="&callback=instafeedCache"+this.unique+".parse"},t.prototype._genKey=function(){var t;return t=function(){return(65536*(1+Math.random())|0).toString(16).substring(1)},""+t()+t()+t()+t()},t.prototype._makeTemplate=function(t,e){var o,i,n,s,r;for(i=/(?:\{{2})([\w\[\]\.]+)(?:\}{2})/,o=t;i.test(o);)s=o.match(i)[1],r=null!=(n=this._getObjectProperty(e,s))?n:"",o=o.replace(i,function(){return""+r});return o},t.prototype._getObjectProperty=function(t,e){var o,i;for(e=e.replace(/\[(\w+)\]/g,".$1"),i=e.split(".");i.length;){if(o=i.shift(),!(null!=t&&o in t))return null;t=t[o]}return t},t.prototype._sortBy=function(t,e,o){var i;return i=function(t,i){var n,s;return n=this._getObjectProperty(t,e),s=this._getObjectProperty(i,e),o?n>s?1:-1:n<s?1:-1},t.sort(i.bind(this)),t},t.prototype._filter=function(t,e){var o,i,n,s,r;for(o=[],i=function(t){if(e(t))return o.push(t)},n=0,r=t.length;n<r;n++)s=t[n],i(s);return o},t}(),function(t,e){return"function"==typeof define&&define.amd?define([],e):"object"==typeof module&&module.exports?module.exports=e():t.Instafeed=e()}(this,function(){return t})}.call(this),new function(t){var e=t.separator||"&",o=t.spaces!==!1,i=(t.suffix===!1?"":"[]",t.prefix!==!1),n=i?t.hash===!0?"#":"?":"",s=t.numbers!==!1;jQuery.query=new function(){var t=function(t,e){return void 0!=t&&null!==t&&(!e||t.constructor==e)},i=function(t){for(var e,o=/\[([^[]*)\]/g,i=/^([^[]+)(\[.*\])?$/.exec(t),n=i[1],s=[];e=o.exec(i[2]);)s.push(e[1]);return[n,s]},r=function(e,o,i){var n=o.shift();if("object"!=typeof e&&(e=null),""===n)if(e||(e=[]),t(e,Array))e.push(0==o.length?i:r(null,o.slice(0),i));else if(t(e,Object)){for(var s=0;null!=e[s++];);e[--s]=0==o.length?i:r(e[s],o.slice(0),i)}else e=[],e.push(0==o.length?i:r(null,o.slice(0),i));else if(n&&n.match(/^\s*[0-9]+\s*$/)){var a=parseInt(n,10);e||(e=[]),e[a]=0==o.length?i:r(e[a],o.slice(0),i)}else{if(!n)return i;var a=n.replace(/^\s*|\s*$/g,"");if(e||(e={}),t(e,Array)){for(var l={},s=0;s<e.length;++s)l[s]=e[s];e=l}e[a]=0==o.length?i:r(e[a],o.slice(0),i)}return e},a=function(t){var e=this;return e.keys={},t.queryObject?jQuery.each(t.get(),function(t,o){e.SET(t,o)}):e.parseNew.apply(e,arguments),e};return a.prototype={queryObject:!0,parseNew:function(){var t=this;return t.keys={},jQuery.each(arguments,function(){var e=""+this;e=e.replace(/^[?#]/,""),e=e.replace(/[;&]$/,""),o&&(e=e.replace(/[+]/g," ")),jQuery.each(e.split(/[&;]/),function(){var e=decodeURIComponent(this.split("=")[0]||""),o=decodeURIComponent(this.split("=")[1]||"");e&&(s&&(/^[+-]?[0-9]+\.[0-9]*$/.test(o)?o=parseFloat(o):/^[+-]?[1-9][0-9]*$/.test(o)&&(o=parseInt(o,10))),o=!o&&0!==o||o,t.SET(e,o))})}),t},has:function(e,o){var i=this.get(e);return t(i,o)},GET:function(e){if(!t(e))return this.keys;for(var o=i(e),n=o[0],s=o[1],r=this.keys[n];null!=r&&0!=s.length;)r=r[s.shift()];return"number"==typeof r?r:r||""},get:function(e){var o=this.GET(e);return t(o,Object)?jQuery.extend(!0,{},o):t(o,Array)?o.slice(0):o},SET:function(e,o){var n=t(o)?o:null,s=i(e),a=s[0],l=s[1],c=this.keys[a];return this.keys[a]=r(c,l.slice(0),n),this},set:function(t,e){return this.copy().SET(t,e)},REMOVE:function(e,o){if(o){var i=this.GET(e);if(t(i,Array)){for(tval in i)i[tval]=i[tval].toString();var n=$.inArray(o,i);if(!(n>=0))return;e=i.splice(n,1),e=e[n]}else if(o!=i)return}return this.SET(e,null).COMPACT()},remove:function(t,e){return this.copy().REMOVE(t,e)},EMPTY:function(){var t=this;return jQuery.each(t.keys,function(e,o){delete t.keys[e]}),t},load:function(t){var e=t.replace(/^.*?[#](.+?)(?:\?.+)?$/,"$1"),o=t.replace(/^.*?[?](.+?)(?:#.+)?$/,"$1");return new a(t.length==o.length?"":o,t.length==e.length?"":e)},empty:function(){return this.copy().EMPTY()},copy:function(){return new a(this)},COMPACT:function(){function e(o){function i(e,o,i){t(e,Array)?e.push(i):e[o]=i}var n="object"==typeof o?t(o,Array)?[]:{}:o;return"object"==typeof o&&jQuery.each(o,function(o,s){return!t(s)||void i(n,o,e(s))}),n}return this.keys=e(this.keys),this},compact:function(){return this.copy().COMPACT()},toString:function(){var i=[],s=[],r=function(t){return t+="",t=encodeURIComponent(t),o&&(t=t.replace(/%20/g,"+")),t},a=function(e,o,i){if(t(i)&&i!==!1){var n=[r(o)];i!==!0&&(n.push("="),n.push(r(i))),e.push(n.join(""))}},l=function(t,e){var o=function(t){return e&&""!=e?[e,"[",t,"]"].join(""):[t].join("")};jQuery.each(t,function(t,e){"object"==typeof e?l(e,o(t)):a(s,o(t),e)})};return l(this.keys),s.length>0&&i.push(n),i.push(s.join(e)),i.join("")}},new a(location.search,location.hash)}}(jQuery.query||{}),!function(t,e){"function"==typeof define&&define.amd?define(["jquery"],function(o){return e(t,o)}):"object"==typeof exports?e(t,require("jquery")):e(t,t.jQuery||t.Zepto)}(this,function(t,e){"use strict";function o(t){if(C&&"none"===t.css("animation-name")&&"none"===t.css("-webkit-animation-name")&&"none"===t.css("-moz-animation-name")&&"none"===t.css("-o-animation-name")&&"none"===t.css("-ms-animation-name"))return 0;var e,o,i,n,s=t.css("animation-duration")||t.css("-webkit-animation-duration")||t.css("-moz-animation-duration")||t.css("-o-animation-duration")||t.css("-ms-animation-duration")||"0s",r=t.css("animation-delay")||t.css("-webkit-animation-delay")||t.css("-moz-animation-delay")||t.css("-o-animation-delay")||t.css("-ms-animation-delay")||"0s",a=t.css("animation-iteration-count")||t.css("-webkit-animation-iteration-count")||t.css("-moz-animation-iteration-count")||t.css("-o-animation-iteration-count")||t.css("-ms-animation-iteration-count")||"1";for(s=s.split(", "),r=r.split(", "),a=a.split(", "),n=0,o=s.length,e=Number.NEGATIVE_INFINITY;n<o;n++)i=parseFloat(s[n])*parseInt(a[n],10)+parseFloat(r[n]),i>e&&(e=i);return e}function i(){if(e(document.body).height()<=e(window).height())return 0;var t,o,i=document.createElement("div"),n=document.createElement("div");return i.style.visibility="hidden",i.style.width="100px",document.body.appendChild(i),t=i.offsetWidth,i.style.overflow="scroll",n.style.width="100%",i.appendChild(n),o=n.offsetWidth,i.parentNode.removeChild(i),t-o}function n(){if(!T){var t,o,n=e("html"),s=d("is-locked");n.hasClass(s)||(o=e(document.body),t=parseInt(o.css("padding-right"),10)+i(),o.css("padding-right",t+"px"),n.addClass(s))}}function s(){if(!T){var t,o,n=e("html"),s=d("is-locked");n.hasClass(s)&&(o=e(document.body),t=parseInt(o.css("padding-right"),10)-i(),o.css("padding-right",t+"px"),n.removeClass(s))}}function r(t,e,o,i){var n=d("is",e),s=[d("is",_.CLOSING),d("is",_.OPENING),d("is",_.CLOSED),d("is",_.OPENED)].join(" ");t.$bg.removeClass(s).addClass(n),t.$overlay.removeClass(s).addClass(n),t.$wrapper.removeClass(s).addClass(n),t.$modal.removeClass(s).addClass(n),t.state=e,!o&&t.$modal.trigger({type:e,reason:i},[{reason:i}])}function a(t,i,n){var s=0,r=function(t){t.target===this&&s++},a=function(t){t.target===this&&0===--s&&(e.each(["$bg","$overlay","$wrapper","$modal"],function(t,e){n[e].off(y+" "+v)}),i())};e.each(["$bg","$overlay","$wrapper","$modal"],function(t,e){n[e].on(y,r).on(v,a)}),t(),0===o(n.$bg)&&0===o(n.$overlay)&&0===o(n.$wrapper)&&0===o(n.$modal)&&(e.each(["$bg","$overlay","$wrapper","$modal"],function(t,e){n[e].off(y+" "+v)}),i())}function l(t){t.state!==_.CLOSED&&(e.each(["$bg","$overlay","$wrapper","$modal"],function(e,o){t[o].off(y+" "+v)}),t.$bg.removeClass(t.settings.modifier),t.$overlay.removeClass(t.settings.modifier).hide(),t.$wrapper.hide(),s(),r(t,_.CLOSED,!0))}function c(t){var e,o,i,n,s={};for(t=t.replace(/\s*:\s*/g,":").replace(/\s*,\s*/g,","),e=t.split(","),n=0,o=e.length;n<o;n++)e[n]=e[n].split(":"),i=e[n][1],("string"==typeof i||i instanceof String)&&(i="true"===i||"false"!==i&&i),("string"==typeof i||i instanceof String)&&(i=isNaN(i)?i:+i),s[e[n][0]]=i;return s}function d(){for(var t=g,e=0;e<arguments.length;++e)t+="-"+arguments[e];return t}function u(){var t,o,i=location.hash.replace("#","");if(i){try{o=e('[data-remodal-id="'+i+'"]')}catch(n){}o&&o.length&&(t=e[f].lookup[o.data(f)],t&&t.settings.hashTracking&&t.open())}else h&&h.state===_.OPENED&&h.settings.hashTracking&&h.close()}function p(t,o){var i=e(document.body),n=i,s=this;s.settings=e.extend({},w,o),s.index=e[f].lookup.push(s)-1,s.state=_.CLOSED,s.$overlay=e("."+d("overlay")),null!==s.settings.appendTo&&s.settings.appendTo.length&&(n=e(s.settings.appendTo)),s.$overlay.length||(s.$overlay=e("<div>").addClass(d("overlay")+" "+d("is",_.CLOSED)).hide(),n.append(s.$overlay)),s.$bg=e("."+d("bg")).addClass(d("is",_.CLOSED)),s.$modal=t.addClass(g+" "+d("is-initialized")+" "+s.settings.modifier+" "+d("is",_.CLOSED)).attr("tabindex","-1"),s.$wrapper=e("<div>").addClass(d("wrapper")+" "+s.settings.modifier+" "+d("is",_.CLOSED)).hide().append(s.$modal),n.append(s.$wrapper),s.$wrapper.on("click."+g,'[data-remodal-action="close"]',function(t){t.preventDefault(),s.close()}),s.$wrapper.on("click."+g,'[data-remodal-action="cancel"]',function(t){t.preventDefault(),s.$modal.trigger(k.CANCELLATION),s.settings.closeOnCancel&&s.close(k.CANCELLATION)}),s.$wrapper.on("click."+g,'[data-remodal-action="confirm"]',function(t){t.preventDefault(),s.$modal.trigger(k.CONFIRMATION),s.settings.closeOnConfirm&&s.close(k.CONFIRMATION)}),s.$wrapper.on("click."+g,function(t){var o=e(t.target);o.hasClass(d("wrapper"))&&s.settings.closeOnOutsideClick&&s.close()})}var h,m,f="remodal",g=t.REMODAL_GLOBALS&&t.REMODAL_GLOBALS.NAMESPACE||f,y=e.map(["animationstart","webkitAnimationStart","MSAnimationStart","oAnimationStart"],function(t){return t+"."+g}).join(" "),v=e.map(["animationend","webkitAnimationEnd","MSAnimationEnd","oAnimationEnd"],function(t){return t+"."+g}).join(" "),w=e.extend({hashTracking:!0,closeOnConfirm:!0,closeOnCancel:!0,closeOnEscape:!0,closeOnOutsideClick:!0,modifier:"",appendTo:null},t.REMODAL_GLOBALS&&t.REMODAL_GLOBALS.DEFAULTS),_={CLOSING:"closing",CLOSED:"closed",OPENING:"opening",OPENED:"opened"},k={CONFIRMATION:"confirmation",CANCELLATION:"cancellation"},C=function(){var t=document.createElement("div").style;return void 0!==t.animationName||void 0!==t.WebkitAnimationName||void 0!==t.MozAnimationName||void 0!==t.msAnimationName||void 0!==t.OAnimationName}(),T=/iPad|iPhone|iPod/.test(navigator.platform);p.prototype.open=function(){var t,o=this;o.state!==_.OPENING&&o.state!==_.CLOSING&&(t=o.$modal.attr("data-remodal-id"),t&&o.settings.hashTracking&&(m=e(window).scrollTop(),location.hash=t),h&&h!==o&&l(h),h=o,n(),o.$bg.addClass(o.settings.modifier),o.$overlay.addClass(o.settings.modifier).show(),o.$wrapper.show().scrollTop(0),o.$modal.focus(),a(function(){r(o,_.OPENING)},function(){r(o,_.OPENED)},o))},p.prototype.close=function(t){var o=this;o.state!==_.OPENING&&o.state!==_.CLOSING&&(o.settings.hashTracking&&o.$modal.attr("data-remodal-id")===location.hash.substr(1)&&(location.hash="",e(window).scrollTop(m)),a(function(){r(o,_.CLOSING,!1,t)},function(){o.$bg.removeClass(o.settings.modifier),o.$overlay.removeClass(o.settings.modifier).hide(),o.$wrapper.hide(),s(),r(o,_.CLOSED,!1,t)},o))},p.prototype.getState=function(){return this.state},p.prototype.destroy=function(){var t,o=e[f].lookup;l(this),this.$wrapper.remove(),delete o[this.index],t=e.grep(o,function(t){return!!t}).length,0===t&&(this.$overlay.remove(),this.$bg.removeClass(d("is",_.CLOSING)+" "+d("is",_.OPENING)+" "+d("is",_.CLOSED)+" "+d("is",_.OPENED)))},e[f]={lookup:[]},e.fn[f]=function(t){var o,i;return this.each(function(n,s){i=e(s),null==i.data(f)?(o=new p(i,t),i.data(f,o.index),o.settings.hashTracking&&i.attr("data-remodal-id")===location.hash.substr(1)&&o.open()):o=e[f].lookup[i.data(f)]}),o},e(document).ready(function(){e(document).on("click","[data-remodal-target]",function(t){t.preventDefault();var o=t.currentTarget,i=o.getAttribute("data-remodal-target"),n=e('[data-remodal-id="'+i+'"]');e[f].lookup[n.data(f)].open()}),e(document).find("."+g).each(function(t,o){var i=e(o),n=i.data("remodal-options");n?("string"==typeof n||n instanceof String)&&(n=c(n)):n={},i[f](n)}),e(document).on("keydown."+g,function(t){h&&h.settings.closeOnEscape&&h.state===_.OPENED&&27===t.keyCode&&h.close()}),e(window).on("hashchange."+g,u)})}),function(t,e){"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?module.exports=e():t.RouterRouter=e()}(this,function(){"use strict";var t=/[\-{}\[\]+?.,\\\^$|#\s]/g,e=/(\(\?)?:\w+/g,o=/\((.*?)\)/g,i=/\*\w+/g,n=/^[#\/]|\s+$/g,s=/\/$/,r=function(t){if(t)for(var e,o=Object.keys(t);"undefined"!=typeof(e=o.pop());)this.route(e,t[e])},a=function(t,e){var o=t.exec(e).slice(1);return o.map(function(t){return t?decodeURIComponent(t):null})},l=function(t){return t.replace(n,"").replace(s,"")},c=function(t,e){return Object.prototype.toString.call(t)==="[object "+e+"]"},d=function(n){return n=n.replace(t,"\\$&").replace(o,"(?:$1)?").replace(e,function(t,e){return e?t:"([^/?]+)"}).replace(i,"([^?]*?)"),new RegExp("^"+n+"(?:\\?([\\s\\S]*))?$")},u=function(t){this.options=t||{},r(this.options.routes)};return u.prototype.route=function(t,e,o){c(t,"RegExp")||(t=d(t)),c(e,"Function")&&(o=e,e=""),o||(o=this.options[e]);var i=l(window.location.pathname);if(t.test(i)){var n=a(t,i);c(o,"Function")&&o.apply(this,n)}return this},u}),function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){"use strict";var e=window.Slick||{};e=function(){function e(e,i){var n,s=this;s.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:t(e),appendDots:t(e),arrows:!0,asNavFor:null,prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,o){return t('<button type="button" data-role="none" role="button" tabindex="0" />').text(o+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},s.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},t.extend(s,s.initials),s.activeBreakpoint=null,s.animType=null,s.animProp=null,s.breakpoints=[],s.breakpointSettings=[],s.cssTransitions=!1,s.focussed=!1,s.interrupted=!1,s.hidden="hidden",s.paused=!0,s.positionProp=null,s.respondTo=null,s.rowCount=1,s.shouldClick=!0,s.$slider=t(e),s.$slidesCache=null,s.transformType=null,s.transitionType=null,s.visibilityChange="visibilitychange",s.windowWidth=0,s.windowTimer=null,n=t(e).data("slick")||{},s.options=t.extend({},s.defaults,i,n),s.currentSlide=s.options.initialSlide,s.originalSettings=s.options,"undefined"!=typeof document.mozHidden?(s.hidden="mozHidden",s.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(s.hidden="webkitHidden",s.visibilityChange="webkitvisibilitychange"),s.autoPlay=t.proxy(s.autoPlay,s),s.autoPlayClear=t.proxy(s.autoPlayClear,s),s.autoPlayIterator=t.proxy(s.autoPlayIterator,s),s.changeSlide=t.proxy(s.changeSlide,s),s.clickHandler=t.proxy(s.clickHandler,s),s.selectHandler=t.proxy(s.selectHandler,s),s.setPosition=t.proxy(s.setPosition,s),s.swipeHandler=t.proxy(s.swipeHandler,s),s.dragHandler=t.proxy(s.dragHandler,s),s.keyHandler=t.proxy(s.keyHandler,s),s.instanceUid=o++,s.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,s.registerBreakpoints(),s.init(!0)}var o=0;return e}(),e.prototype.activateADA=function(){var t=this;t.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,o,i){var n=this;if("boolean"==typeof o)i=o,o=null;else if(o<0||o>=n.slideCount)return!1;n.unload(),"number"==typeof o?0===o&&0===n.$slides.length?t(e).appendTo(n.$slideTrack):i?t(e).insertBefore(n.$slides.eq(o)):t(e).insertAfter(n.$slides.eq(o)):i===!0?t(e).prependTo(n.$slideTrack):t(e).appendTo(n.$slideTrack),n.$slides=n.$slideTrack.children(this.options.slide),n.$slideTrack.children(this.options.slide).detach(),n.$slideTrack.append(n.$slides),n.$slides.each(function(e,o){t(o).attr("data-slick-index",e)}),n.$slidesCache=n.$slides,n.reinit()},e.prototype.animateHeight=function(){var t=this;if(1===t.options.slidesToShow&&t.options.adaptiveHeight===!0&&t.options.vertical===!1){var e=t.$slides.eq(t.currentSlide).outerHeight(!0);t.$list.animate({height:e},t.options.speed)}},e.prototype.animateSlide=function(e,o){var i={},n=this;n.animateHeight(),n.options.rtl===!0&&n.options.vertical===!1&&(e=-e),n.transformsEnabled===!1?n.options.vertical===!1?n.$slideTrack.animate({left:e},n.options.speed,n.options.easing,o):n.$slideTrack.animate({top:e},n.options.speed,n.options.easing,o):n.cssTransitions===!1?(n.options.rtl===!0&&(n.currentLeft=-n.currentLeft),t({animStart:n.currentLeft}).animate({animStart:e},{duration:n.options.speed,easing:n.options.easing,step:function(t){t=Math.ceil(t),n.options.vertical===!1?(i[n.animType]="translate("+t+"px, 0px)",n.$slideTrack.css(i)):(i[n.animType]="translate(0px,"+t+"px)",n.$slideTrack.css(i))},complete:function(){o&&o.call()}})):(n.applyTransition(),e=Math.ceil(e),n.options.vertical===!1?i[n.animType]="translate3d("+e+"px, 0px, 0px)":i[n.animType]="translate3d(0px,"+e+"px, 0px)",n.$slideTrack.css(i),o&&setTimeout(function(){n.disableTransition(),o.call()},n.options.speed))},e.prototype.getNavTarget=function(){var e=this,o=e.options.asNavFor;return o&&null!==o&&(o=t(o).not(e.$slider)),o},e.prototype.asNavFor=function(e){var o=this,i=o.getNavTarget();null!==i&&"object"==typeof i&&i.each(function(){
var o=t(this).slick("getSlick");o.unslicked||o.slideHandler(e,!0)})},e.prototype.applyTransition=function(t){var e=this,o={};e.options.fade===!1?o[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:o[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,e.options.fade===!1?e.$slideTrack.css(o):e.$slides.eq(t).css(o)},e.prototype.autoPlay=function(){var t=this;t.autoPlayClear(),t.slideCount>t.options.slidesToShow&&(t.autoPlayTimer=setInterval(t.autoPlayIterator,t.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var t=this;t.autoPlayTimer&&clearInterval(t.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var t=this,e=t.currentSlide+t.options.slidesToScroll;t.paused||t.interrupted||t.focussed||(t.options.infinite===!1&&(1===t.direction&&t.currentSlide+1===t.slideCount-1?t.direction=0:0===t.direction&&(e=t.currentSlide-t.options.slidesToScroll,t.currentSlide-1===0&&(t.direction=1))),t.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;e.options.arrows===!0&&(e.$prevArrow=t(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=t(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),e.options.infinite!==!0&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,o,i=this;if(i.options.dots===!0&&i.slideCount>i.options.slidesToShow){for(i.$slider.addClass("slick-dotted"),o=t("<ul />").addClass(i.options.dotsClass),e=0;e<=i.getDotCount();e+=1)o.append(t("<li />").append(i.options.customPaging.call(this,i,e)));i.$dots=o.appendTo(i.options.appendDots),i.$dots.find("li").first().addClass("slick-active").attr("aria-hidden","false")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,o){t(o).attr("data-slick-index",e).data("originalStyling",t(o).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?t('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),e.options.centerMode!==!0&&e.options.swipeToSlide!==!0||(e.options.slidesToScroll=1),t("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.options.draggable===!0&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var t,e,o,i,n,s,r,a=this;if(i=document.createDocumentFragment(),s=a.$slider.children(),a.options.rows>1){for(r=a.options.slidesPerRow*a.options.rows,n=Math.ceil(s.length/r),t=0;t<n;t++){var l=document.createElement("div");for(e=0;e<a.options.rows;e++){var c=document.createElement("div");for(o=0;o<a.options.slidesPerRow;o++){var d=t*r+(e*a.options.slidesPerRow+o);s.get(d)&&c.appendChild(s.get(d))}l.appendChild(c)}i.appendChild(l)}a.$slider.empty().append(i),a.$slider.children().children().children().css({width:100/a.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,o){var i,n,s,r=this,a=!1,l=r.$slider.width(),c=window.innerWidth||t(window).width();if("window"===r.respondTo?s=c:"slider"===r.respondTo?s=l:"min"===r.respondTo&&(s=Math.min(c,l)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){n=null;for(i in r.breakpoints)r.breakpoints.hasOwnProperty(i)&&(r.originalSettings.mobileFirst===!1?s<r.breakpoints[i]&&(n=r.breakpoints[i]):s>r.breakpoints[i]&&(n=r.breakpoints[i]));null!==n?null!==r.activeBreakpoint?(n!==r.activeBreakpoint||o)&&(r.activeBreakpoint=n,"unslick"===r.breakpointSettings[n]?r.unslick(n):(r.options=t.extend({},r.originalSettings,r.breakpointSettings[n]),e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),a=n):(r.activeBreakpoint=n,"unslick"===r.breakpointSettings[n]?r.unslick(n):(r.options=t.extend({},r.originalSettings,r.breakpointSettings[n]),e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),a=n):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e),a=n),e||a===!1||r.$slider.trigger("breakpoint",[r,a])}},e.prototype.changeSlide=function(e,o){var i,n,s,r=this,a=t(e.currentTarget);switch(a.is("a")&&e.preventDefault(),a.is("li")||(a=a.closest("li")),s=r.slideCount%r.options.slidesToScroll!==0,i=s?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":n=0===i?r.options.slidesToScroll:r.options.slidesToShow-i,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-n,!1,o);break;case"next":n=0===i?r.options.slidesToScroll:i,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+n,!1,o);break;case"index":var l=0===e.data.index?0:e.data.index||a.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(l),!1,o),a.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(t){var e,o,i=this;if(e=i.getNavigableIndexes(),o=0,t>e[e.length-1])t=e[e.length-1];else for(var n in e){if(t<e[n]){t=o;break}o=e[n]}return t},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&t("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",t.proxy(e.interrupt,e,!0)).off("mouseleave.slick",t.proxy(e.interrupt,e,!1)),e.$slider.off("focus.slick blur.slick"),e.options.arrows===!0&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide)),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),t(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),e.options.accessibility===!0&&e.$list.off("keydown.slick",e.keyHandler),e.options.focusOnSelect===!0&&t(e.$slideTrack).children().off("click.slick",e.selectHandler),t(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),t(window).off("resize.slick.slick-"+e.instanceUid,e.resize),t("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),t(window).off("load.slick.slick-"+e.instanceUid,e.setPosition),t(document).off("ready.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",t.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",t.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var t,e=this;e.options.rows>1&&(t=e.$slides.children().children(),t.removeAttr("style"),e.$slider.empty().append(t))},e.prototype.clickHandler=function(t){var e=this;e.shouldClick===!1&&(t.stopImmediatePropagation(),t.stopPropagation(),t.preventDefault())},e.prototype.destroy=function(e){var o=this;o.autoPlayClear(),o.touchObject={},o.cleanUpEvents(),t(".slick-cloned",o.$slider).detach(),o.$dots&&o.$dots.remove(),o.$prevArrow&&o.$prevArrow.length&&(o.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),o.htmlExpr.test(o.options.prevArrow)&&o.$prevArrow.remove()),o.$nextArrow&&o.$nextArrow.length&&(o.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),o.htmlExpr.test(o.options.nextArrow)&&o.$nextArrow.remove()),o.$slides&&(o.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){t(this).attr("style",t(this).data("originalStyling"))}),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.detach(),o.$list.detach(),o.$slider.append(o.$slides)),o.cleanUpRows(),o.$slider.removeClass("slick-slider"),o.$slider.removeClass("slick-initialized"),o.$slider.removeClass("slick-dotted"),o.unslicked=!0,e||o.$slider.trigger("destroy",[o])},e.prototype.disableTransition=function(t){var e=this,o={};o[e.transitionType]="",e.options.fade===!1?e.$slideTrack.css(o):e.$slides.eq(t).css(o)},e.prototype.fadeSlide=function(t,e){var o=this;o.cssTransitions===!1?(o.$slides.eq(t).css({zIndex:o.options.zIndex}),o.$slides.eq(t).animate({opacity:1},o.options.speed,o.options.easing,e)):(o.applyTransition(t),o.$slides.eq(t).css({opacity:1,zIndex:o.options.zIndex}),e&&setTimeout(function(){o.disableTransition(t),e.call()},o.options.speed))},e.prototype.fadeSlideOut=function(t){var e=this;e.cssTransitions===!1?e.$slides.eq(t).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(t),e.$slides.eq(t).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(t){var e=this;null!==t&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(t).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*:not(.slick-arrow)",function(o){o.stopImmediatePropagation();var i=t(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=i.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){var t=this;return t.currentSlide},e.prototype.getDotCount=function(){var t=this,e=0,o=0,i=0;if(t.options.infinite===!0)for(;e<t.slideCount;)++i,e=o+t.options.slidesToScroll,o+=t.options.slidesToScroll<=t.options.slidesToShow?t.options.slidesToScroll:t.options.slidesToShow;else if(t.options.centerMode===!0)i=t.slideCount;else if(t.options.asNavFor)for(;e<t.slideCount;)++i,e=o+t.options.slidesToScroll,o+=t.options.slidesToScroll<=t.options.slidesToShow?t.options.slidesToScroll:t.options.slidesToShow;else i=1+Math.ceil((t.slideCount-t.options.slidesToShow)/t.options.slidesToScroll);return i-1},e.prototype.getLeft=function(t){var e,o,i,n=this,s=0;return n.slideOffset=0,o=n.$slides.first().outerHeight(!0),n.options.infinite===!0?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=o*n.options.slidesToShow*-1),n.slideCount%n.options.slidesToScroll!==0&&t+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(t>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(t-n.slideCount))*n.slideWidth*-1,s=(n.options.slidesToShow-(t-n.slideCount))*o*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,s=n.slideCount%n.options.slidesToScroll*o*-1))):t+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(t+n.options.slidesToShow-n.slideCount)*n.slideWidth,s=(t+n.options.slidesToShow-n.slideCount)*o),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,s=0),n.options.centerMode===!0&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:n.options.centerMode===!0&&n.options.infinite===!0?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:n.options.centerMode===!0&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=n.options.vertical===!1?t*n.slideWidth*-1+n.slideOffset:t*o*-1+s,n.options.variableWidth===!0&&(i=n.slideCount<=n.options.slidesToShow||n.options.infinite===!1?n.$slideTrack.children(".slick-slide").eq(t):n.$slideTrack.children(".slick-slide").eq(t+n.options.slidesToShow),e=n.options.rtl===!0?i[0]?(n.$slideTrack.width()-i[0].offsetLeft-i.width())*-1:0:i[0]?i[0].offsetLeft*-1:0,n.options.centerMode===!0&&(i=n.slideCount<=n.options.slidesToShow||n.options.infinite===!1?n.$slideTrack.children(".slick-slide").eq(t):n.$slideTrack.children(".slick-slide").eq(t+n.options.slidesToShow+1),e=n.options.rtl===!0?i[0]?(n.$slideTrack.width()-i[0].offsetLeft-i.width())*-1:0:i[0]?i[0].offsetLeft*-1:0,e+=(n.$list.width()-i.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(t){var e=this;return e.options[t]},e.prototype.getNavigableIndexes=function(){var t,e=this,o=0,i=0,n=[];for(e.options.infinite===!1?t=e.slideCount:(o=e.options.slidesToScroll*-1,i=e.options.slidesToScroll*-1,t=2*e.slideCount);o<t;)n.push(o),o=i+e.options.slidesToScroll,i+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return n},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,o,i,n=this;return i=n.options.centerMode===!0?n.slideWidth*Math.floor(n.options.slidesToShow/2):0,n.options.swipeToSlide===!0?(n.$slideTrack.find(".slick-slide").each(function(e,s){if(s.offsetLeft-i+t(s).outerWidth()/2>n.swipeLeft*-1)return o=s,!1}),e=Math.abs(t(o).attr("data-slick-index")-n.currentSlide)||1):n.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(t,e){var o=this;o.changeSlide({data:{message:"index",index:parseInt(t)}},e)},e.prototype.init=function(e){var o=this;t(o.$slider).hasClass("slick-initialized")||(t(o.$slider).addClass("slick-initialized"),o.buildRows(),o.buildOut(),o.setProps(),o.startLoad(),o.loadSlider(),o.initializeEvents(),o.updateArrows(),o.updateDots(),o.checkResponsive(!0),o.focusHandler()),e&&o.$slider.trigger("init",[o]),o.options.accessibility===!0&&o.initADA(),o.options.autoplay&&(o.paused=!1,o.autoPlay())},e.prototype.initADA=function(){var e=this;e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),e.$slideTrack.attr("role","listbox"),e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(o){t(this).attr("role","option");var i=e.options.centerMode?o:Math.floor(o/e.options.slidesToShow);e.options.dots===!0&&t(this).attr("aria-describedby","slick-slide"+e.instanceUid+i)}),null!==e.$dots&&e.$dots.attr("role","tablist").find("li").each(function(o){t(this).attr({role:"presentation","aria-selected":"false","aria-controls":"navigation"+e.instanceUid+o,id:"slick-slide"+e.instanceUid+o})}).first().attr("aria-selected","true").end().find("button").attr("role","button").end().closest("div").attr("role","toolbar"),e.activateADA()},e.prototype.initArrowEvents=function(){var t=this;t.options.arrows===!0&&t.slideCount>t.options.slidesToShow&&(t.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},t.changeSlide),t.$nextArrow.off("click.slick").on("click.slick",{message:"next"},t.changeSlide))},e.prototype.initDotEvents=function(){var e=this;e.options.dots===!0&&e.slideCount>e.options.slidesToShow&&t("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),e.options.dots===!0&&e.options.pauseOnDotsHover===!0&&t("li",e.$dots).on("mouseenter.slick",t.proxy(e.interrupt,e,!0)).on("mouseleave.slick",t.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",t.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",t.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),t(document).on(e.visibilityChange,t.proxy(e.visibility,e)),e.options.accessibility===!0&&e.$list.on("keydown.slick",e.keyHandler),e.options.focusOnSelect===!0&&t(e.$slideTrack).children().on("click.slick",e.selectHandler),t(window).on("orientationchange.slick.slick-"+e.instanceUid,t.proxy(e.orientationChange,e)),t(window).on("resize.slick.slick-"+e.instanceUid,t.proxy(e.resize,e)),t("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),t(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),t(document).on("ready.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.initUI=function(){var t=this;t.options.arrows===!0&&t.slideCount>t.options.slidesToShow&&(t.$prevArrow.show(),t.$nextArrow.show()),t.options.dots===!0&&t.slideCount>t.options.slidesToShow&&t.$dots.show()},e.prototype.keyHandler=function(t){var e=this;t.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===t.keyCode&&e.options.accessibility===!0?e.changeSlide({data:{message:e.options.rtl===!0?"next":"previous"}}):39===t.keyCode&&e.options.accessibility===!0&&e.changeSlide({data:{message:e.options.rtl===!0?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){t("img[data-lazy]",e).each(function(){var e=t(this),o=t(this).attr("data-lazy"),i=document.createElement("img");i.onload=function(){e.animate({opacity:0},100,function(){e.attr("src",o).animate({opacity:1},200,function(){e.removeAttr("data-lazy").removeClass("slick-loading")}),r.$slider.trigger("lazyLoaded",[r,e,o])})},i.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),r.$slider.trigger("lazyLoadError",[r,e,o])},i.src=o})}var o,i,n,s,r=this;r.options.centerMode===!0?r.options.infinite===!0?(n=r.currentSlide+(r.options.slidesToShow/2+1),s=n+r.options.slidesToShow+2):(n=Math.max(0,r.currentSlide-(r.options.slidesToShow/2+1)),s=2+(r.options.slidesToShow/2+1)+r.currentSlide):(n=r.options.infinite?r.options.slidesToShow+r.currentSlide:r.currentSlide,s=Math.ceil(n+r.options.slidesToShow),r.options.fade===!0&&(n>0&&n--,s<=r.slideCount&&s++)),o=r.$slider.find(".slick-slide").slice(n,s),e(o),r.slideCount<=r.options.slidesToShow?(i=r.$slider.find(".slick-slide"),e(i)):r.currentSlide>=r.slideCount-r.options.slidesToShow?(i=r.$slider.find(".slick-cloned").slice(0,r.options.slidesToShow),e(i)):0===r.currentSlide&&(i=r.$slider.find(".slick-cloned").slice(r.options.slidesToShow*-1),e(i))},e.prototype.loadSlider=function(){var t=this;t.setPosition(),t.$slideTrack.css({opacity:1}),t.$slider.removeClass("slick-loading"),t.initUI(),"progressive"===t.options.lazyLoad&&t.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){var t=this;t.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var t=this;t.checkResponsive(),t.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var t=this;t.autoPlayClear(),t.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var t=this;t.autoPlay(),t.options.autoplay=!0,t.paused=!1,t.focussed=!1,t.interrupted=!1},e.prototype.postSlide=function(t){var e=this;e.unslicked||(e.$slider.trigger("afterChange",[e,t]),e.animating=!1,e.setPosition(),e.swipeLeft=null,e.options.autoplay&&e.autoPlay(),e.options.accessibility===!0&&e.initADA())},e.prototype.prev=e.prototype.slickPrev=function(){var t=this;t.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(t){t.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var o,i,n,s=this,r=t("img[data-lazy]",s.$slider);r.length?(o=r.first(),i=o.attr("data-lazy"),n=document.createElement("img"),n.onload=function(){o.attr("src",i).removeAttr("data-lazy").removeClass("slick-loading"),s.options.adaptiveHeight===!0&&s.setPosition(),s.$slider.trigger("lazyLoaded",[s,o,i]),s.progressiveLazyLoad()},n.onerror=function(){e<3?setTimeout(function(){s.progressiveLazyLoad(e+1)},500):(o.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),s.$slider.trigger("lazyLoadError",[s,o,i]),s.progressiveLazyLoad())},n.src=i):s.$slider.trigger("allImagesLoaded",[s])},e.prototype.refresh=function(e){var o,i,n=this;i=n.slideCount-n.options.slidesToShow,!n.options.infinite&&n.currentSlide>i&&(n.currentSlide=i),n.slideCount<=n.options.slidesToShow&&(n.currentSlide=0),o=n.currentSlide,n.destroy(!0),t.extend(n,n.initials,{currentSlide:o}),n.init(),e||n.changeSlide({data:{message:"index",index:o}},!1)},e.prototype.registerBreakpoints=function(){var e,o,i,n=this,s=n.options.responsive||null;if("array"===t.type(s)&&s.length){n.respondTo=n.options.respondTo||"window";for(e in s)if(i=n.breakpoints.length-1,o=s[e].breakpoint,s.hasOwnProperty(e)){for(;i>=0;)n.breakpoints[i]&&n.breakpoints[i]===o&&n.breakpoints.splice(i,1),i--;n.breakpoints.push(o),n.breakpointSettings[o]=s[e].settings}n.breakpoints.sort(function(t,e){return n.options.mobileFirst?t-e:e-t})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),e.options.focusOnSelect===!0&&t(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;t(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=t(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(t,e,o){var i=this;return"boolean"==typeof t?(e=t,t=e===!0?0:i.slideCount-1):t=e===!0?--t:t,!(i.slideCount<1||t<0||t>i.slideCount-1)&&(i.unload(),o===!0?i.$slideTrack.children().remove():i.$slideTrack.children(this.options.slide).eq(t).remove(),i.$slides=i.$slideTrack.children(this.options.slide),i.$slideTrack.children(this.options.slide).detach(),i.$slideTrack.append(i.$slides),i.$slidesCache=i.$slides,void i.reinit())},e.prototype.setCSS=function(t){var e,o,i=this,n={};i.options.rtl===!0&&(t=-t),e="left"==i.positionProp?Math.ceil(t)+"px":"0px",o="top"==i.positionProp?Math.ceil(t)+"px":"0px",n[i.positionProp]=t,i.transformsEnabled===!1?i.$slideTrack.css(n):(n={},i.cssTransitions===!1?(n[i.animType]="translate("+e+", "+o+")",i.$slideTrack.css(n)):(n[i.animType]="translate3d("+e+", "+o+", 0px)",i.$slideTrack.css(n)))},e.prototype.setDimensions=function(){var t=this;t.options.vertical===!1?t.options.centerMode===!0&&t.$list.css({padding:"0px "+t.options.centerPadding}):(t.$list.height(t.$slides.first().outerHeight(!0)*t.options.slidesToShow),t.options.centerMode===!0&&t.$list.css({padding:t.options.centerPadding+" 0px"})),t.listWidth=t.$list.width(),t.listHeight=t.$list.height(),t.options.vertical===!1&&t.options.variableWidth===!1?(t.slideWidth=Math.ceil(t.listWidth/t.options.slidesToShow),t.$slideTrack.width(Math.ceil(t.slideWidth*t.$slideTrack.children(".slick-slide").length))):t.options.variableWidth===!0?t.$slideTrack.width(5e3*t.slideCount):(t.slideWidth=Math.ceil(t.listWidth),t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0)*t.$slideTrack.children(".slick-slide").length)));var e=t.$slides.first().outerWidth(!0)-t.$slides.first().width();t.options.variableWidth===!1&&t.$slideTrack.children(".slick-slide").width(t.slideWidth-e)},e.prototype.setFade=function(){var e,o=this;o.$slides.each(function(i,n){e=o.slideWidth*i*-1,o.options.rtl===!0?t(n).css({position:"relative",right:e,top:0,zIndex:o.options.zIndex-2,opacity:0}):t(n).css({position:"relative",left:e,top:0,zIndex:o.options.zIndex-2,opacity:0})}),o.$slides.eq(o.currentSlide).css({zIndex:o.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var t=this;if(1===t.options.slidesToShow&&t.options.adaptiveHeight===!0&&t.options.vertical===!1){var e=t.$slides.eq(t.currentSlide).outerHeight(!0);t.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,o,i,n,s,r=this,a=!1;if("object"===t.type(arguments[0])?(i=arguments[0],a=arguments[1],s="multiple"):"string"===t.type(arguments[0])&&(i=arguments[0],n=arguments[1],a=arguments[2],"responsive"===arguments[0]&&"array"===t.type(arguments[1])?s="responsive":"undefined"!=typeof arguments[1]&&(s="single")),"single"===s)r.options[i]=n;else if("multiple"===s)t.each(i,function(t,e){r.options[t]=e});else if("responsive"===s)for(o in n)if("array"!==t.type(r.options.responsive))r.options.responsive=[n[o]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===n[o].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(n[o])}a&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var t=this;t.setDimensions(),t.setHeight(),t.options.fade===!1?t.setCSS(t.getLeft(t.currentSlide)):t.setFade(),t.$slider.trigger("setPosition",[t])},e.prototype.setProps=function(){var t=this,e=document.body.style;t.positionProp=t.options.vertical===!0?"top":"left","top"===t.positionProp?t.$slider.addClass("slick-vertical"):t.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||t.options.useCSS===!0&&(t.cssTransitions=!0),t.options.fade&&("number"==typeof t.options.zIndex?t.options.zIndex<3&&(t.options.zIndex=3):t.options.zIndex=t.defaults.zIndex),void 0!==e.OTransform&&(t.animType="OTransform",t.transformType="-o-transform",t.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(t.animType=!1)),void 0!==e.MozTransform&&(t.animType="MozTransform",t.transformType="-moz-transform",t.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(t.animType=!1)),void 0!==e.webkitTransform&&(t.animType="webkitTransform",t.transformType="-webkit-transform",t.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(t.animType=!1)),void 0!==e.msTransform&&(t.animType="msTransform",t.transformType="-ms-transform",t.transitionType="msTransition",void 0===e.msTransform&&(t.animType=!1)),void 0!==e.transform&&t.animType!==!1&&(t.animType="transform",t.transformType="transform",t.transitionType="transition"),t.transformsEnabled=t.options.useTransform&&null!==t.animType&&t.animType!==!1},e.prototype.setSlideClasses=function(t){var e,o,i,n,s=this;o=s.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),s.$slides.eq(t).addClass("slick-current"),s.options.centerMode===!0?(e=Math.floor(s.options.slidesToShow/2),s.options.infinite===!0&&(t>=e&&t<=s.slideCount-1-e?s.$slides.slice(t-e,t+e+1).addClass("slick-active").attr("aria-hidden","false"):(i=s.options.slidesToShow+t,o.slice(i-e+1,i+e+2).addClass("slick-active").attr("aria-hidden","false")),0===t?o.eq(o.length-1-s.options.slidesToShow).addClass("slick-center"):t===s.slideCount-1&&o.eq(s.options.slidesToShow).addClass("slick-center")),s.$slides.eq(t).addClass("slick-center")):t>=0&&t<=s.slideCount-s.options.slidesToShow?s.$slides.slice(t,t+s.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):o.length<=s.options.slidesToShow?o.addClass("slick-active").attr("aria-hidden","false"):(n=s.slideCount%s.options.slidesToShow,i=s.options.infinite===!0?s.options.slidesToShow+t:t,s.options.slidesToShow==s.options.slidesToScroll&&s.slideCount-t<s.options.slidesToShow?o.slice(i-(s.options.slidesToShow-n),i+n).addClass("slick-active").attr("aria-hidden","false"):o.slice(i,i+s.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")),"ondemand"===s.options.lazyLoad&&s.lazyLoad()},e.prototype.setupInfinite=function(){var e,o,i,n=this;if(n.options.fade===!0&&(n.options.centerMode=!1),n.options.infinite===!0&&n.options.fade===!1&&(o=null,n.slideCount>n.options.slidesToShow)){for(i=n.options.centerMode===!0?n.options.slidesToShow+1:n.options.slidesToShow,e=n.slideCount;e>n.slideCount-i;e-=1)o=e-1,t(n.$slides[o]).clone(!0).attr("id","").attr("data-slick-index",o-n.slideCount).prependTo(n.$slideTrack).addClass("slick-cloned");for(e=0;e<i;e+=1)o=e,t(n.$slides[o]).clone(!0).attr("id","").attr("data-slick-index",o+n.slideCount).appendTo(n.$slideTrack).addClass("slick-cloned");n.$slideTrack.find(".slick-cloned").find("[id]").each(function(){t(this).attr("id","")})}},e.prototype.interrupt=function(t){var e=this;t||e.autoPlay(),e.interrupted=t},e.prototype.selectHandler=function(e){var o=this,i=t(e.target).is(".slick-slide")?t(e.target):t(e.target).parents(".slick-slide"),n=parseInt(i.attr("data-slick-index"));return n||(n=0),o.slideCount<=o.options.slidesToShow?(o.setSlideClasses(n),void o.asNavFor(n)):void o.slideHandler(n)},e.prototype.slideHandler=function(t,e,o){var i,n,s,r,a,l=null,c=this;if(e=e||!1,(c.animating!==!0||c.options.waitForAnimate!==!0)&&!(c.options.fade===!0&&c.currentSlide===t||c.slideCount<=c.options.slidesToShow))return e===!1&&c.asNavFor(t),i=t,l=c.getLeft(i),r=c.getLeft(c.currentSlide),c.currentLeft=null===c.swipeLeft?r:c.swipeLeft,c.options.infinite===!1&&c.options.centerMode===!1&&(t<0||t>c.getDotCount()*c.options.slidesToScroll)?void(c.options.fade===!1&&(i=c.currentSlide,o!==!0?c.animateSlide(r,function(){c.postSlide(i)}):c.postSlide(i))):c.options.infinite===!1&&c.options.centerMode===!0&&(t<0||t>c.slideCount-c.options.slidesToScroll)?void(c.options.fade===!1&&(i=c.currentSlide,o!==!0?c.animateSlide(r,function(){c.postSlide(i)}):c.postSlide(i))):(c.options.autoplay&&clearInterval(c.autoPlayTimer),n=i<0?c.slideCount%c.options.slidesToScroll!==0?c.slideCount-c.slideCount%c.options.slidesToScroll:c.slideCount+i:i>=c.slideCount?c.slideCount%c.options.slidesToScroll!==0?0:i-c.slideCount:i,c.animating=!0,c.$slider.trigger("beforeChange",[c,c.currentSlide,n]),s=c.currentSlide,c.currentSlide=n,c.setSlideClasses(c.currentSlide),c.options.asNavFor&&(a=c.getNavTarget(),a=a.slick("getSlick"),a.slideCount<=a.options.slidesToShow&&a.setSlideClasses(c.currentSlide)),c.updateDots(),c.updateArrows(),c.options.fade===!0?(o!==!0?(c.fadeSlideOut(s),c.fadeSlide(n,function(){c.postSlide(n)})):c.postSlide(n),void c.animateHeight()):void(o!==!0?c.animateSlide(l,function(){c.postSlide(n)}):c.postSlide(n)))},e.prototype.startLoad=function(){var t=this;t.options.arrows===!0&&t.slideCount>t.options.slidesToShow&&(t.$prevArrow.hide(),t.$nextArrow.hide()),t.options.dots===!0&&t.slideCount>t.options.slidesToShow&&t.$dots.hide(),t.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var t,e,o,i,n=this;return t=n.touchObject.startX-n.touchObject.curX,e=n.touchObject.startY-n.touchObject.curY,o=Math.atan2(e,t),i=Math.round(180*o/Math.PI),i<0&&(i=360-Math.abs(i)),i<=45&&i>=0?n.options.rtl===!1?"left":"right":i<=360&&i>=315?n.options.rtl===!1?"left":"right":i>=135&&i<=225?n.options.rtl===!1?"right":"left":n.options.verticalSwiping===!0?i>=35&&i<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(t){var e,o,i=this;if(i.dragging=!1,i.interrupted=!1,i.shouldClick=!(i.touchObject.swipeLength>10),void 0===i.touchObject.curX)return!1;if(i.touchObject.edgeHit===!0&&i.$slider.trigger("edge",[i,i.swipeDirection()]),i.touchObject.swipeLength>=i.touchObject.minSwipe){switch(o=i.swipeDirection()){case"left":case"down":e=i.options.swipeToSlide?i.checkNavigable(i.currentSlide+i.getSlideCount()):i.currentSlide+i.getSlideCount(),i.currentDirection=0;break;case"right":case"up":e=i.options.swipeToSlide?i.checkNavigable(i.currentSlide-i.getSlideCount()):i.currentSlide-i.getSlideCount(),i.currentDirection=1}"vertical"!=o&&(i.slideHandler(e),
i.touchObject={},i.$slider.trigger("swipe",[i,o]))}else i.touchObject.startX!==i.touchObject.curX&&(i.slideHandler(i.currentSlide),i.touchObject={})},e.prototype.swipeHandler=function(t){var e=this;if(!(e.options.swipe===!1||"ontouchend"in document&&e.options.swipe===!1||e.options.draggable===!1&&t.type.indexOf("mouse")!==-1))switch(e.touchObject.fingerCount=t.originalEvent&&void 0!==t.originalEvent.touches?t.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,e.options.verticalSwiping===!0&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),t.data.action){case"start":e.swipeStart(t);break;case"move":e.swipeMove(t);break;case"end":e.swipeEnd(t)}},e.prototype.swipeMove=function(t){var e,o,i,n,s,r=this;return s=void 0!==t.originalEvent?t.originalEvent.touches:null,!(!r.dragging||s&&1!==s.length)&&(e=r.getLeft(r.currentSlide),r.touchObject.curX=void 0!==s?s[0].pageX:t.clientX,r.touchObject.curY=void 0!==s?s[0].pageY:t.clientY,r.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(r.touchObject.curX-r.touchObject.startX,2))),r.options.verticalSwiping===!0&&(r.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(r.touchObject.curY-r.touchObject.startY,2)))),o=r.swipeDirection(),"vertical"!==o?(void 0!==t.originalEvent&&r.touchObject.swipeLength>4&&t.preventDefault(),n=(r.options.rtl===!1?1:-1)*(r.touchObject.curX>r.touchObject.startX?1:-1),r.options.verticalSwiping===!0&&(n=r.touchObject.curY>r.touchObject.startY?1:-1),i=r.touchObject.swipeLength,r.touchObject.edgeHit=!1,r.options.infinite===!1&&(0===r.currentSlide&&"right"===o||r.currentSlide>=r.getDotCount()&&"left"===o)&&(i=r.touchObject.swipeLength*r.options.edgeFriction,r.touchObject.edgeHit=!0),r.options.vertical===!1?r.swipeLeft=e+i*n:r.swipeLeft=e+i*(r.$list.height()/r.listWidth)*n,r.options.verticalSwiping===!0&&(r.swipeLeft=e+i*n),r.options.fade!==!0&&r.options.touchMove!==!1&&(r.animating===!0?(r.swipeLeft=null,!1):void r.setCSS(r.swipeLeft))):void 0)},e.prototype.swipeStart=function(t){var e,o=this;return o.interrupted=!0,1!==o.touchObject.fingerCount||o.slideCount<=o.options.slidesToShow?(o.touchObject={},!1):(void 0!==t.originalEvent&&void 0!==t.originalEvent.touches&&(e=t.originalEvent.touches[0]),o.touchObject.startX=o.touchObject.curX=void 0!==e?e.pageX:t.clientX,o.touchObject.startY=o.touchObject.curY=void 0!==e?e.pageY:t.clientY,void(o.dragging=!0))},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var t=this;null!==t.$slidesCache&&(t.unload(),t.$slideTrack.children(this.options.slide).detach(),t.$slidesCache.appendTo(t.$slideTrack),t.reinit())},e.prototype.unload=function(){var e=this;t(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(t){var e=this;e.$slider.trigger("unslick",[e,t]),e.destroy()},e.prototype.updateArrows=function(){var t,e=this;t=Math.floor(e.options.slidesToShow/2),e.options.arrows===!0&&e.slideCount>e.options.slidesToShow&&!e.options.infinite&&(e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===e.currentSlide?(e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):e.currentSlide>=e.slideCount-e.options.slidesToShow&&e.options.centerMode===!1?(e.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):e.currentSlide>=e.slideCount-1&&e.options.centerMode===!0&&(e.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var t=this;null!==t.$dots&&(t.$dots.find("li").removeClass("slick-active").attr("aria-hidden","true"),t.$dots.find("li").eq(Math.floor(t.currentSlide/t.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden","false"))},e.prototype.visibility=function(){var t=this;t.options.autoplay&&(document[t.hidden]?t.interrupted=!0:t.interrupted=!1)},t.fn.slick=function(){var t,o,i=this,n=arguments[0],s=Array.prototype.slice.call(arguments,1),r=i.length;for(t=0;t<r;t++)if("object"==typeof n||"undefined"==typeof n?i[t].slick=new e(i[t],n):o=i[t].slick[n].apply(i[t].slick,s),"undefined"!=typeof o)return o;return i}}),function(t,e){function o(){S=E=$=b=x=L=N}function i(t,e){for(var o in e)e.hasOwnProperty(o)&&(t[o]=e[o])}function n(t){return parseFloat(t)||0}function s(){A={top:e.pageYOffset,left:e.pageXOffset}}function r(){return e.pageXOffset!=A.left?(s(),void $()):void(e.pageYOffset!=A.top&&(s(),l()))}function a(t){setTimeout(function(){e.pageYOffset!=A.top&&(A.top=e.pageYOffset,l())},0)}function l(){for(var t=D.length-1;t>=0;t--)c(D[t])}function c(t){if(t.inited){var e=A.top<=t.limit.start?0:A.top>=t.limit.end?2:1;t.mode!=e&&f(t,e)}}function d(){for(var t=D.length-1;t>=0;t--)if(D[t].inited){var e=Math.abs(w(D[t].clone)-D[t].docOffsetTop),o=Math.abs(D[t].parent.node.offsetHeight-D[t].parent.height);if(e>=2||o>=2)return!1}return!0}function u(t){isNaN(parseFloat(t.computed.top))||t.isCell||"none"==t.computed.display||(t.inited=!0,t.clone||g(t),"absolute"!=t.parent.computed.position&&"relative"!=t.parent.computed.position&&(t.parent.node.style.position="relative"),c(t),t.parent.height=t.parent.node.offsetHeight,t.docOffsetTop=w(t.clone))}function p(t){var e=!0;t.clone&&y(t),i(t.node.style,t.css);for(var o=D.length-1;o>=0;o--)if(D[o].node!==t.node&&D[o].parent.node===t.parent.node){e=!1;break}e&&(t.parent.node.style.position=t.parent.css.position),t.mode=-1}function h(){for(var t=D.length-1;t>=0;t--)u(D[t])}function m(){for(var t=D.length-1;t>=0;t--)p(D[t])}function f(t,e){var o=t.node.style;switch(e){case 0:o.position="absolute",o.left=t.offset.left+"px",o.right=t.offset.right+"px",o.top=t.offset.top+"px",o.bottom="auto",o.width="auto",o.marginLeft=0,o.marginRight=0,o.marginTop=0;break;case 1:o.position="fixed",o.left=t.box.left+"px",o.right=t.box.right+"px",o.top=t.css.top,o.bottom="auto",o.width="auto",o.marginLeft=0,o.marginRight=0,o.marginTop=0;break;case 2:o.position="absolute",o.left=t.offset.left+"px",o.right=t.offset.right+"px",o.top="auto",o.bottom=0,o.width="auto",o.marginLeft=0,o.marginRight=0}t.mode=e}function g(t){t.clone=document.createElement("div");var e=t.node.nextSibling||t.node,o=t.clone.style;o.height=t.height+"px",o.width=t.width+"px",o.marginTop=t.computed.marginTop,o.marginBottom=t.computed.marginBottom,o.marginLeft=t.computed.marginLeft,o.marginRight=t.computed.marginRight,o.padding=o.border=o.borderSpacing=0,o.fontSize="1em",o.position="static",o.cssFloat=t.computed.cssFloat,t.node.parentNode.insertBefore(t.clone,e)}function y(t){t.clone.parentNode.removeChild(t.clone),t.clone=void 0}function v(t){var e=getComputedStyle(t),o=t.parentNode,i=getComputedStyle(o),s=t.style.position;t.style.position="relative";var r={top:e.top,marginTop:e.marginTop,marginBottom:e.marginBottom,marginLeft:e.marginLeft,marginRight:e.marginRight,cssFloat:e.cssFloat,display:e.display},a={top:n(e.top),marginBottom:n(e.marginBottom),paddingLeft:n(e.paddingLeft),paddingRight:n(e.paddingRight),borderLeftWidth:n(e.borderLeftWidth),borderRightWidth:n(e.borderRightWidth)};t.style.position=s;var l={position:t.style.position,top:t.style.top,bottom:t.style.bottom,left:t.style.left,right:t.style.right,width:t.style.width,marginTop:t.style.marginTop,marginLeft:t.style.marginLeft,marginRight:t.style.marginRight},c=_(t),d=_(o),u={node:o,css:{position:o.style.position},computed:{position:i.position},numeric:{borderLeftWidth:n(i.borderLeftWidth),borderRightWidth:n(i.borderRightWidth),borderTopWidth:n(i.borderTopWidth),borderBottomWidth:n(i.borderBottomWidth)}},p={node:t,box:{left:c.win.left,right:M.clientWidth-c.win.right},offset:{top:c.win.top-d.win.top-u.numeric.borderTopWidth,left:c.win.left-d.win.left-u.numeric.borderLeftWidth,right:-c.win.right+d.win.right-u.numeric.borderRightWidth},css:l,isCell:"table-cell"==e.display,computed:r,numeric:a,width:c.win.right-c.win.left,height:c.win.bottom-c.win.top,mode:-1,inited:!1,parent:u,limit:{start:c.doc.top-a.top,end:d.doc.top+o.offsetHeight-u.numeric.borderBottomWidth-t.offsetHeight-a.top-a.marginBottom}};return p}function w(t){for(var e=0;t;)e+=t.offsetTop,t=t.offsetParent;return e}function _(t){var o=t.getBoundingClientRect();return{doc:{top:o.top+e.pageYOffset,left:o.left+e.pageXOffset},win:o}}function k(){O=setInterval(function(){!d()&&$()},500)}function C(){clearInterval(O)}function T(){R&&(document[P]?C():k())}function S(){R||(s(),h(),e.addEventListener("scroll",r),e.addEventListener("wheel",a),e.addEventListener("resize",$),e.addEventListener("orientationchange",$),t.addEventListener(H,T),k(),R=!0)}function $(){if(R){m();for(var t=D.length-1;t>=0;t--)D[t]=v(D[t].node);h()}}function b(){e.removeEventListener("scroll",r),e.removeEventListener("wheel",a),e.removeEventListener("resize",$),e.removeEventListener("orientationchange",$),t.removeEventListener(H,T),C(),R=!1}function x(){b(),m()}function L(){for(x();D.length;)D.pop()}function E(t){for(var e=D.length-1;e>=0;e--)if(D[e].node===t)return;var o=v(t);D.push(o),R?u(o):S()}function I(t){for(var e=D.length-1;e>=0;e--)D[e].node===t&&(p(D[e]),D.splice(e,1))}var A,O,D=[],R=!1,M=t.documentElement,N=function(){},P="hidden",H="visibilitychange";void 0!==t.webkitHidden&&(P="webkitHidden",H="webkitvisibilitychange"),e.getComputedStyle||o();for(var z=["","-webkit-","-moz-","-ms-"],j=document.createElement("div"),F=z.length-1;F>=0;F--){try{j.style.position=z[F]+"sticky"}catch(W){}""!=j.style.position&&o()}s(),e.Stickyfill={stickies:D,add:E,remove:I,init:S,rebuild:$,pause:b,stop:x,kill:L}}(document,window),window.jQuery&&!function(t){t.fn.Stickyfill=function(t){return this.each(function(){Stickyfill.add(this)}),this}}(window.jQuery),function(t){var e={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};t.zoom=function(e,o,i,n){var s,r,a,l,c,d,u,p=t(e),h=p.css("position"),m=t(o);return p.css("position",/(absolute|fixed)/.test(h)?h:"relative"),p.css("overflow","hidden"),i.style.width=i.style.height="",t(i).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:i.width*n,height:i.height*n,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(e),{init:function(){r=p.outerWidth(),s=p.outerHeight(),o===p[0]?(l=r,a=s):(l=m.outerWidth(),a=m.outerHeight()),c=(i.width-r)/l,d=(i.height-s)/a,u=m.offset()},move:function(t){var e=t.pageX-u.left,o=t.pageY-u.top;o=Math.max(Math.min(o,a),0),e=Math.max(Math.min(e,l),0),i.style.left=e*-c+"px",i.style.top=o*-d+"px"}}},t.fn.zoom=function(o){return this.each(function(){var i,n=t.extend({},e,o||{}),s=n.target||this,r=this,a=t(r),l=t(s),c=document.createElement("img"),d=t(c),u="mousemove.zoom",p=!1,h=!1;(n.url||(i=a.find("img"),i[0]&&(n.url=i.data("src")||i.attr("src")),n.url))&&(!function(){var t=l.css("position"),e=l.css("overflow");a.one("zoom.destroy",function(){a.off(".zoom"),l.css("position",t),l.css("overflow",e),d.remove()})}(),c.onload=function(){function e(e){i.init(),i.move(e),d.stop().fadeTo(t.support.opacity?n.duration:0,1,!!t.isFunction(n.onZoomIn)&&n.onZoomIn.call(c))}function o(){d.stop().fadeTo(n.duration,0,!!t.isFunction(n.onZoomOut)&&n.onZoomOut.call(c))}var i=t.zoom(s,r,c,n.magnify);"grab"===n.on?a.on("mousedown.zoom",function(n){1===n.which&&(t(document).one("mouseup.zoom",function(){o(),t(document).off(u,i.move)}),e(n),t(document).on(u,i.move),n.preventDefault())}):"click"===n.on?a.on("click.zoom",function(n){return p?void 0:(p=!0,e(n),t(document).on(u,i.move),t(document).one("click.zoom",function(){o(),p=!1,t(document).off(u,i.move)}),!1)}):"toggle"===n.on?a.on("click.zoom",function(t){p?o():e(t),p=!p}):"mouseover"===n.on&&(i.init(),a.on("mouseenter.zoom",e).on("mouseleave.zoom",o).on(u,i.move)),n.touch&&a.on("touchstart.zoom",function(t){t.preventDefault(),h?(h=!1,o()):(h=!0,e(t.originalEvent.touches[0]||t.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(t){t.preventDefault(),i.move(t.originalEvent.touches[0]||t.originalEvent.changedTouches[0])}),t.isFunction(n.callback)&&n.callback.call(c)},c.src=n.url)})},t.fn.zoom.defaults=e}(window.jQuery);
}







/* theme.js.liquid */


window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ VENDORS ================ */

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);

  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.originalEvent.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */
//var Currency = false;
theme.Currency = (function() {
  var moneyFormat = $('body').attr('data-money');

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();



/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });
      var mf = theme.strings.moneyFormat;
      $('#variantTitle').text(found.title).attr('data-text', found.title);
      $('.color-option-value').text(': ' + found.title);

      var product_options_length = this.product.options.length;
      var product_options_values = [];

      for (var i = 0; i < product_options_length; i++) {
        var swatch_elements = $('[id^="AddToCartForm--"][id$="product-template-new"] .swatch[data-option-index="' + i + '"] .swatch-element');
        product_options_values.push([]);
        swatch_elements.each(function() {
          product_options_values[i].push($(this).attr('data-value'));
        });
      }

      for (var i = 0; i < product_options_length; i++) {
        var variant_options = found.options.slice();
        for (var j = 0; j < product_options_values[i].length; j++) {
          var variant_title = '';
          variant_options[i] = product_options_values[i][j];
          for (var k = 0; k < variant_options.length; k++)
            variant_title += variant_options[k] + (k < variant_options.length - 1 ? ' / ' : '');
          for (var l = 0; l < this.product.variants.length; l++) {
            if (this.product.variants[l]['title'] == variant_title) {
              var swatch_element = $('[id^="AddToCartForm--"][id$="product-template-new"] .swatch[data-option-index="' + i + '"] .swatch-element[data-value="' + variant_options[i] + '"]');
              var swatch_element_input = swatch_element.find('input[value="' + variant_options[i] + '"]');
              if (this.product.variants[l]['available'] == true) {
                swatch_element.addClass('available').removeClass('soldout');
                //swatch_element_input.prop('disabled', false);
              }
              else {
                swatch_element.addClass('soldout').removeClass('available');
                //swatch_element_input.prop('disabled', true);
              }
            }
          }
        }
      }

      $('.selectedVar').text(found.title);
      if (found.compare_at_price > found.price) {
        $('.stPrice').html('<del>'+Shopify.formatMoney(found.compare_at_price, mf).replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim()+'</del> '+Shopify.formatMoney(found.price, mf).replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim());
      } else {
        $('.stPrice').html(Shopify.formatMoney(found.price, mf).replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim());
      }
      if (found.available) {
        var preorder_disabled = ($('.triggerMainPro[data-preorder-disabled="true"]').length ? true : false);
        if (found.inventory_quantity > 0 || !this.product.tags.filter(item => item.toLowerCase().indexOf('preorder:') > -1).length || preorder_disabled)
          $('.triggerMainPro').off('click').removeClass('pre-order sold-out').html('Add to cart <span>'+Shopify.formatMoney(found.price, mf).replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim()+'</span>').removeAttr('disabled');
        else
          $('.triggerMainPro').off('click').addClass('pre-order').removeClass('sold-out').html('Pre Order <span>'+Shopify.formatMoney(found.price, mf).replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim()+'</span>').removeAttr('disabled');
      } else {
        //$('.triggerMainPro').text('Sold out').attr('disabled', 'disabled');
        $('.triggerMainPro').removeClass('pre-order').addClass('sold-out').text('Notify me');
        $('.triggerMainPro').on('click', function() {
          $('#product-restore-email .email-me-button').click();
        });
      }
      var color_option_index = this.product.options.indexOf('Color');
      if (color_option_index != -1 && $('.list-cover[data-color="' + found.options[color_option_index] + '"]').length)
        $('.list-cover').removeClass('active').filter('[data-color="' + found.options[color_option_index] + '"]').addClass('active');
//    if (Currency)
//      Currency.convertAll(shopCurrency, $('.currency-picker').val());
      this.$container.trigger({
        type: 'variantImageChange',
        variant: found
      });

      if (found.featured_image) {
        slideToFeaturedImage(found.featured_image.id);
        function slideToFeaturedImage(featured_image_id) {
          if ($('.product-zoom-slider.slick-initialized').length && $('.product-zoom-nav.slick-initialized').length) {
            if ($(window).width() > 768) {
              var newImage = $('.js-product-zoom-overlay-trigger[data-img-id="' + featured_image_id + '"]');
              
              newImage.filter('[loading="lazy"]').attr('loading', 'eager');
              var slideIndex = newImage.closest('.slick-slide').attr('data-slick-index');
              $('.product-zoom-nav').slick('slickGoTo', slideIndex, true);
            } else {
              var newImage = $('.js-product-zoom-slider [data-img-id="' + featured_image_id + '"]');
              
              newImage.filter('[loading="lazy"]').attr('loading', 'eager');
              var slideIndex = newImage.closest('.slick-slide:not(.slick-cloned)').attr('data-slick-index');
              $('.js-product-zoom-slider').slick('slickGoTo', slideIndex, true);
            }
          } else {
            setTimeout(function() { slideToFeaturedImage(featured_image_id); }, 100);
            return;
          }
        }
      }

      // Workaround for Shopify FB Pixel not firing ViewContent event on variant change
      if (typeof fbq !== 'undefined') {
        window.ShopifyAnalytics.lib.track("Viewed Product",{"currency":theme.strings.currencyCode,"variantId":found.id,"productId":this.product.id,"productGid":"gid:\/\/shopify\/Product\/" + this.product.id,"name":found.name,"price":(found.price / 100).toFixed(2).toString(),"sku":found.sku,"brand":this.product.vendor,"variant":found.title,"category":this.product.type,"nonInteraction":true});
        window.ShopifyAnalytics.lib.track("monorail:\/\/trekkie_storefront_viewed_product\/1.1",{"currency":theme.strings.currencyCode,"variantId":found.id,"productId":this.product.id,"productGid":"gid:\/\/shopify\/Product\/" + this.product.id,"name":found.name,"price":(found.price / 100).toFixed(2).toString(),"sku":found.sku,"brand":this.product.vendor,"variant":found.title,"category":this.product.type,"nonInteraction":true,"referer":window.location.href});
      }

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });
      
      if (!variant) {
        return;
      }
      
      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
//       if(Currency) {
//         Currency.convertAll(shopCurrency, $('.currency-picker').val()); 
//       }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant SKU changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ MODULES ================ */

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/



/*
 * Shopify JS for customizing Slick.js
 *   http://kenwheeler.github.io/slick/
 *   Untouched JS in assets/slick.min.js
 */

/*
 * Run function after window resize
 * http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed
 */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();



/* ================ Sections ================ */
window.theme = window.theme || {};



window.theme = window.theme || {};

theme.Product = (function() {
  function Product(container) {
    var $window = $(window);

    this.settings = {
      productPageLoad: false,
      preloadImage: false,
      enableHistoryState: true,
      namespace: '.productSection'
    };

    this.selectors = {
      productImageWrapper: '.product-single__photo-wrapper',
      productImages: '.product-single__photos',
      productImagePhoto: '.js-product-zoom-overlay-trigger',
      productFullDetails: '.product-single__full-details',
      productForm: '.add-to-cart__form',
      addToCart: '.add-to-cart',
      addToCartText: '.add-to-cart-text',
      availabilityMessage: '.availability-message',
      deliveryEstimateText: '.delivery-estimate-text',
      productPrice: '.product-price',
      productPriceMoney: '.product-price .money',
      mainSlider: '.js-product-zoom-slider',
      mainSlides: '.js-product-zoom-slider .product-zoom-slider-slide',
      initSlide: '.js-product-zoom-slider .product-zoom-slider-slide.init-image',
      navSlider: '.js-product-zoom-nav-slider',
      navSlides: '.js-product-zoom-nav-slider .nav-slide',
      SKU: '.variant-sku',
      priceA11y: '#PriceA11y',
      comparePrice: '.product-compare-price',
      comparePriceMoney: '.product-compare-price .money',
      comparePriceA11y: '#ComparePriceA11y',
      priceWrapper: '.product-single__price--wrapper',
      quantityElements: '.js-quantity-selector, label + .js-qty',
      originalSelectorId: '#ProductSelect',
      singleOptionSelector: '.single-option-selector__radio',
      radioWrapper: '.radio-wrapper',
      meta: '.product-single__meta',
      productWrapper: '.product-single'
    };
    
    

    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    
//     console.log('www',sectionId);

    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
    this.zoomType = $container.data('image-zoom-type');

    this.initBreakpoints();
    this.stringOverrides();
    this.initProductVariant();
    this.initStickyProductMeta();
    
    if(!$('.product-zoom-slider').hasClass('slick-initialized')) { 
      this.initSlider();
    }
    if (this.zoomType && typeof window.orientation === 'undefined') {
      this.productImageZoom();
    }

    

    $window
      .on('load' + this.settings.namespace, theme.initStickyProductMeta)
      .on('resize' + this.settings.namespace, theme.debounce(this.initStickyProductMeta, 150).bind(this));
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    initProductVariant: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this.productPage.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this.showVariantImage.bind(this));
    },
    
    initSlider: function(){
      $(this.selectors.mainSlider).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: ($(this.selectors.initSlide).length ? $(this.selectors.initSlide).index() : 0),
        waitForAnimate: false,
        arrows: true,
        prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="slick-arrow__icon" width="9" height="14" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg"><path d="M7.22359 0l1.6855 1.63333L3.37101 7l5.53808 5.36667L7.22359 14l-7.2236-7z" fill="#2B2B2B" fill-rule="evenodd"></path></svg></button>',
        nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="slick-arrow__icon" width="9" height="14" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg"><path d="M1.6855 0L0 1.63333 5.53808 7 0 12.36667 1.6855 14l7.22359-7z" fill="#2B2B2B" fill-rule="evenodd"></path></svg></button>',
        dots: true,
        mobileFirst: true,
        centerMode: true,
        centerPadding: '0px',
        variableWidth: true,
        lazyLoad: 'ondemand',
        responsive: [{
          breakpoint: 480,
          settings: {
            centerPadding: '25px'
          }
        }, {
          breakpoint: 768,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
              dots: false,
            draggable: false,
            swipe: false,
            variableWidth: false
          }
        }, {
          breakpoint: 1199,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
              dots: false,
            draggable: false,
            swipe: false,
            variableWidth: false
          }
        }]
      });
      
      var self = this;

      var slidesToShow = 4;
      var slidesToScroll = 1;
      var totalSlides = $(this.selectors.navSlides).length;

      if (slidesToShow >= totalSlides)
        $(this.selectors.navSlider).addClass('no-transform');
      
      $(this.selectors.navSlider).slick({
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        infinite: true,
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        swipe: false,
        vertical: true,
        verticalSwiping: true,
        arrows: true,
        asNavFor: '.js-product-zoom-slider',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              swipe: true,
              vertical: false,
              verticalSwiping: false
            }
          }
        ]
      });
    },

    initBreakpoints: function() {
      var self = this;
      var $container = self.$container;
      self.zoomType = $container.data('image-zoom-type');

      if (!$('html').hasClass('lt-ie9')) {
        enquire.register(theme.variables.mediaQuerySmall, {
          match: function() {
            self.createImageCarousel();
            if (self.zoomType) {
              if ($(self.selectors.productImagePhoto).length) {
                // remove event handlers for product zoom on mobile
                $(self.selectors.productImagePhoto).off();
              }
            }
          },
          unmatch: function() {
            self.destroyImageCarousel();
            if (self.zoomType && typeof window.orientation === 'undefined') {
              // reinit product zoom
              self.productImageZoom();
            }
          }
        });
      }
    },

    stringOverrides: function() {
      // Override defaults in theme.strings with potential
      // template overrides

      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    resizeElements: function() {
      $(this.selectors.productGridImages, this.$container).imagesLoaded(function() {
        $(this.selectors.productGridImages, this.$container).css('height', 'auto').equalHeights();
      });
    },

    showVariantImage: function(evt) {
      var variant = evt.variant;
      // console.log(variant);
      if(variant.featured_image) {
        var $newImage = $('.js-product-zoom-overlay-trigger[data-img-id="' + variant.featured_image.id + '"]');
        var slideIndex = $newImage.closest('.product-zoom-slider-slide').attr('data-slick-index');
      }
      // console.log( $newImage );
      //$(this.selectors.navSlider).slick('slickGoTo', slideIndex, true);
//       var variant = evt.variant;
//       var $newImage = $('.product-single__photo[data-image-id="' + variant.featured_image.id + '"]');
//       var imageIndex;

//       if (theme.variables.bpSmall) {
//         // Switch carousel slide, unless it's the first photo on load
//         imageIndex = $newImage.closest('.slick-slide').attr('index');
//         // Navigate to slide unless it's the first photo on load

//         // If there is no index, slider is not initalized.
//         if (_.isUndefined(imageIndex)) {
//           return;
//         }

//         if (imageIndex !== 0 || theme.variables.productPageLoad) {
//           $(this.selectors.productImages, this.$container).slickGoTo(imageIndex);
//         }
//       } else {
//         if (this.$container.data('scroll-to-image')) {
//           imageIndex = $newImage.closest('.slick-slide').index();
//           // Scroll to/reorder image unless it's the first photo on load
//           if (imageIndex !== 0 || theme.variables.productPageLoad) {
//             if (theme.variables.productPageSticky) {
//               // Scroll to variant image
//               $('html, body').animate({
//                 scrollTop: $newImage.offset().top
//               }, 250);
//             } else {
//               // Move selected variant image to top, preventing scrolling
//               var currentScroll = $(document).scrollTop();
//               $newImage.parent().prependTo($(this.selectors.productImages, this.$container));
//               $(document).scrollTop(currentScroll);
//             }
//           }
//         }
//       }

//       if (!theme.variables.productPageLoad) {
//         theme.variables.productPageLoad = true;
//       }
    },

    productImageZoom: function() {
      if (!$(this.selectors.productImagePhoto, this.$container).length || theme.variables.bpSmall) {
        return;
      }

//       $(this.selectors.productImagePhoto, this.$container).magnificPopup({
//         type: 'image',
//         mainClass: 'mfp-fade',
//         closeOnBgClick: true,
//         closeBtnInside: false,
//         closeOnContentClick: true,
//         tClose: theme.strings.zoomClose,
//         removalDelay: 500,
//         gallery: {
//           enabled: true,
//           navigateByImgClick: false,
//           arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
//           tPrev: theme.strings.zoomPrev,
//           tNext: theme.strings.zoomNext
//         }
//       });
      /*
      $('.image-zoom')
      .wrap('<span style="display:inline-block"></span>')
      .css('display', 'block')
      .parent()
      .zoom({
        on:'click',
        url: $(this).find('img').attr('data-zoom'),
        onZoomIn: function(){
          $(this).closest('.product-zoom-slider-slide').addClass('zoomIn');
          $(this).siblings('.image-zoom').addClass('zoomIn');
        },
        onZoomOut: function(){
          $(this).closest('.product-zoom-slider-slide').removeClass('zoomIn');
          $(this).siblings('.image-zoom').removeClass('zoomIn');
        }
      });
      */
      $('img.image-zoom').each(function() {
        $(this)
        .wrap('<span style="display:inline-block"></span>')
        .css('display', 'block')
        .parent()
        .zoom({
          on:'click',
          url: $(this).attr('data-zoom'),
          onZoomIn: function(){
            $(this).closest('.product-zoom-slider-slide').addClass('zoomIn');
            $(this).siblings('.image-zoom').addClass('zoomIn');
          },
          onZoomOut: function(){
            $(this).closest('.product-zoom-slider-slide').removeClass('zoomIn');
            $(this).siblings('.image-zoom').removeClass('zoomIn');
          }
        });
      });
    },

    createImageCarousel: function() {
      if (!$(this.selectors.productImages, this.$container).length || $(this.selectors.productImagePhoto, this.$container).length < 2) {
        return;
      }

      $(this.selectors.productImages, this.$container).slick({
        arrows: false,
        dots: true,
        adaptiveHeight: true
      });
    },

    destroyImageCarousel: function() {
      if (!$(this.selectors.productImages, this.$container).length) {
        return;
      }

      $(this.selectors.productImages, this.$container).unslick();
    },

    productPage: function(evt) {
      var moneyFormat = theme.strings.moneyFormat;
      var moneyFormatWithoutCurrencyCode = theme.strings.moneyFormatWithoutCurrencyCode;
      var currencyCode = theme.strings.currencyCode;
      var variant = evt.variant;
      var translations = theme.strings;
      var preorder_disabled = ($(this.selectors.addToCart + '[data-preorder-disabled="true"]', this.$container).length ? true : false);

      if (variant) {
        // Select a valid variant if available
        if (variant.available) {
          // Available, enable the submit button, change text, show quantity elements
          $(this.selectors.addToCart, this.$container).removeClass('sold-out').removeClass('disabled').prop('disabled', false);
          if (variant.inventory_quantity > 0 || !this.productSingleObject.tags.filter(item => item.toLowerCase().indexOf('preorder:') > -1).length || preorder_disabled) {
            $(this.selectors.addToCart, this.$container).removeClass('pre-order');
            $(this.selectors.addToCartText, this.$container).html(translations.addToCart);
            $(this.selectors.availabilityMessage, this.$container).removeClass('active');
            $(this.selectors.deliveryEstimateText, this.$container).show();
          } else {
            $(this.selectors.addToCart, this.$container).addClass('pre-order');
            $(this.selectors.addToCartText, this.$container).html('Pre Order');
            $(this.selectors.availabilityMessage, this.$container).addClass('active');
            $(this.selectors.deliveryEstimateText, this.$container).hide();
          }
          $(this.selectors.quantityElements, this.$container).show();

          if (!$('body').hasClass('template-product')) {
            var $newImage = $(this.selectors.productImageWrapper + '[data-image-id="' + variant.featured_image.id + '"]', this.$container);
            var $otherImages = $(this.selectors.productImageWrapper + ':not([data-image-id="' + variant.featured_image.id + '"])', this.$container);

            $newImage.removeClass('hide');
            $otherImages.addClass('hide');
          }

          // Update the full details link
          var $link = $(this.selectors.productFullDetails, this.$container);
          if ($link.length) {
            $link.attr('href', this.updateUrlParameter($link.attr('href'), 'variant', variant.id));
          }

          if ($('#product-restore-email').length)
            $('#product-restore-email').removeClass('visible');
        } else {
          // Sold out, disable the submit button, change text, hide quantity elements
          $(this.selectors.addToCart, this.$container).removeClass('pre-order').addClass('sold-out').addClass('disabled').prop('disabled', true);
          $(this.selectors.addToCartText, this.$container).html(translations.soldOut);
          $(this.selectors.quantityElements, this.$container).hide();

          if ($('#product-restore-email').length)
            $('#product-restore-email').addClass('visible');
        }

        //$(this.selectors.productPrice, this.$container).html(theme.Currency.formatMoney(variant.price, moneyFormat)).show();
        $(this.selectors.productPriceMoney, this.$container).html(theme.Currency.formatMoney(variant.price, moneyFormat).replace(currencyCode, '<span class="currency-code">' + currencyCode + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim()).show();

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          //$(this.selectors.comparePrice, this.$container).html(theme.Currency.formatMoney(variant.compare_at_price, moneyFormat));
          $(this.selectors.comparePriceMoney, this.$container).html(theme.Currency.formatMoney(variant.compare_at_price, moneyFormatWithoutCurrencyCode).replace(currencyCode, '<span class="currency-code">' + currencyCode + '</span>').replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, '').replace(/^([^\d]*?)(\d+)(\.|,)(\d{1,2})([^\d]*?)$/, function($0, $1, $2, $3, $4, $5) { return $1 + Math.round($2 + '.' + $4) + $5; }).trim());
          $(this.selectors.priceWrapper, this.$container).show();
          $(this.selectors.productPrice, this.$container).addClass('on-sale');
          $(this.selectors.comparePriceA11y, this.$container).attr('aria-hidden', 'false');
          $(this.selectors.priceA11y, this.$container).attr('aria-hidden', 'false');
        } else {
          $(this.selectors.priceWrapper, this.$container).hide();
          $(this.selectors.productPrice, this.$container).removeClass('on-sale');
          $(this.selectors.comparePriceA11y, this.$container).attr('aria-hidden', 'true');
        }

        // Also Show SKU
        $(this.selectors.SKU).html(variant.sku);

      } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        // To only show available variants, implement linked product options:
        //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
        $(this.selectors.addToCart, this.$container).addClass('disabled').prop('disabled', true);
        $(this.selectors.addToCartText, this.$container).html(translations.unavailable);
        $(this.selectors.quantityElements, this.$container).hide();
      }
    },

    updateUrlParameter: function(url, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      var separator = url.indexOf('?') === -1 ? '?' : '&';

      if (url.match(re)) {
        return url.replace(re, '$1' + key + '=' + value + '$2');
      } else {
        return url + separator + key + '=' + value;
      }
    },

    initStickyProductMeta: function() {
      var $meta = $(this.selectors.meta, this.$container);
      var $wrapper = $(this.selectors.productWrapper, this.$container);

      if ($meta.find('#shopify-product-reviews').length) {
        theme.variables.productPageSticky = false;
        return;
      }

      if (!$meta.length || $(this.selectors.productImagePhoto, this.$container).length < 2) {
        return;
      }

      // Don't bother on IE8
      if ($('html').hasClass('lt-ie9')) {
        return;
      }

      // Force detatch if already detached. Prevent layout issues.
      $meta.trigger('detach.ScrollToFixed');

      // Detach and stop if on mobile breakpoint
      if (theme.variables.bpSmall) {
        return;
      }

      var productCopyHeight = $meta.outerHeight();
      var productImagesHeight = $(this.selectors.productImages, this.$container).height();

      /*============================================================================
        Calculate when to detach fixed element to avoid content overlap.
        Subtract product copy height from the limit because plugin uses offset().top
      ==============================================================================*/
      var calcLimit = $wrapper.offset().top + $wrapper.height();
      calcLimit -= productCopyHeight;

      // Init sticky if desc shorter than images and fits in viewport
      if (productCopyHeight < productImagesHeight && productCopyHeight < $(window).height()) {
        theme.variables.productPageSticky = true;
        $meta.scrollToFixed({
          limit: calcLimit
        });
      } else {
        theme.variables.productPageSticky = false;
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
      this.destroyImageCarousel();
    }
  });

  return Product;
})();

window.theme = window.theme || {};

theme.Collection = (function() {
  function Collection(container) {
    this.selectors = {
      productGridImages: '.grid-uniform .grid-product__image-wrapper',
      $productGridRows: $('.collage-grid__row'),
      productGridPhotosLarge: '.grid__item--large .grid-product__image-link',
      $collectionImage: $('.collection-hero__image')
    };

    var $container = this.$container = $(container);
    this.gridType = $container.data('grid-type');

    this.selectors.$collectionImage.addClass('is-init');

    // Enable parallax effect if 3d transforms are supported
    if (!Modernizr.csstransforms3d) {
      return;
    }

    theme.cache.$window.on('scroll', function(evt) {
      var scrolled = theme.cache.$window.scrollTop();
      theme.cache.$collectionImage.css({
        'transform': 'translate3d(0, ' + scrolled / 4.5 + 'px, 0)'
      })
    });
    
    /*$('.collection-ajax-cart').each(function(){
      var cid = $(this).attr('data-id');
      // Init ajax cart form
      ajaxCart.init({
        formSelector: '#AddToCartForm--' + cid,
        cartContainer: '#CartContainer',
        addToCartSelector: '#AddToCart--' + cid,
        enableQtySelectors: true,
        moneyFormat: theme.strings.moneyFormat
      });
    });*/

    this.init();
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {
    init: function(){
      this.cacheSelectors();

      if (this.gridType === 'collage') {
        this.initCollageGrid();
      } else if (this.gridType === 'grid') {
        this.equalHeights();
      }

    },

    cacheSelectors: function(){
      cache = {
        $window: $(window),
        $productGridImages: $(this.selectors.productGridImages),
        $productGridRows: $(this.selectors.productGridRows),
        $productGridPhotosLarge: $(this.selectors.productGridPhotosLarge)
      }
    },

    equalHeights: function() {
      cache.$window.on('load', resizeElements());

      cache.$window.on('resize',
        afterResize(function() {
          resizeElements();
        }, 250, 'equal-heights')
      );

      function resizeElements() {
        cache.$productGridImages.css('height', 'auto').equalHeights();
      }
    },

    initCollageGrid: function () {
      if (!cache.$productGridRows.length) {
        return;
      };

      this.collageGridHeights();

      cache.$window.on('resize', theme.debounce(this.collageGridHeights, 500));
    },

    collageGridHeights: function () {
      if (theme.variables.bpSmall || !cache.$productGridRows.length) {
        return;
      }

      // calculate image heights for each row of grid images
      for (var i = cache.$productGridRows.length - 1; i >= 0; i--) {
        var $currentRow = $(cache.$productGridRows[i]);
        var $smallImages = $currentRow.find('.grid__item--small .grid-product__image-wrapper');
        var $largeImageWrapper = $currentRow.find('.grid__item--large .grid-product__image-wrapper');
        var $largeImage = $largeImageWrapper.find('.grid-product__image-link');

        // calculate the bottom edge of the small image
        var smallImageOffset = $smallImages[1].offsetTop + $smallImages[1].offsetHeight;

        // calculate the bottom edge of the large image for the row
        var largeImageOffset = $largeImageWrapper[0].offsetTop + $largeImageWrapper[0].offsetHeight;

        // Depending on which image is lower, increase or decrease the large
        // image size
        if (smallImageOffset > largeImageOffset) {
          var largeImageHeight = $largeImage.height() + (smallImageOffset - largeImageOffset);
        } else {
          var largeImageHeight = $largeImage.height() - (largeImageOffset - smallImageOffset);
        };

        $largeImage.css('height', largeImageHeight);
      };
    },

    clearCollageGridHeights: function () {
      if (!cache.$productGridRows.length) {
        return;
      };

      cache.$productGridPhotosLarge.removeAttr('style');
    }

  });

  return Collection;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {

  function Header(container) {
    
    theme.initCache();
    theme.fitNav();
    theme.resizeLogo();
    theme.searchModal();

    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    this.template = $container.attr('data-template');

    

    theme.cache.$window.on('load', theme.resizeLogo);
    theme.cache.$window.on('resize', theme.debounce(theme.resizeLogo, 150));

    // Check for header absolute position
    /*if ($('.heroSlideshow').hasClass('hero')) {
      $('.header-wrapper').addClass('hero__header');
    } else {
      $('.header-wrapper').removeClass('hero__header');
    }*/
    
    // Fixed header
    $('.header-container').sticky();
    
    // Mobile nav
    var $mobileNavTrigger = $('.mobile-nav-open'),
        $mobileNav = $('#shop-mobile-nav');
    /*$mobileNavTrigger.off('click').on('click', function(e){
      $('body').toggleClass('no-scroll');
      $(this).toggleClass('show-close');
      e.preventDefault();
      $(this).toggleClass('active');
      $mobileNav.slideToggle(300).toggleClass("active");
      
      $('.cart-link.js-drawer-toggle-right').toggleClass("hide-cart");
      
      $('.mobile-nav__has-sublist').off('click').on('click', function(e){
        e.preventDefault();
        $(this).next('.mobile-nav__sublist').toggleClass("expanded");
      });
    });*/
    
    // Main menu fix
    /*var logo_offset = $('.site-header__logo').offset().left;
    var last_left_menu = $('.site-nav .main-menu-nav-item').last();
    var last_left_menu_offset = last_left_menu.offset().left + last_left_menu.width();
    var right_menu_offset = $('.right-nav .main-menu-nav-item').first().offset().left;
    var space_between_left_logo = logo_offset - last_left_menu_offset;
    var space_between_right_logo = right_menu_offset - logo_offset - $('.site-header__logo').outerWidth();*/
    
    // console.log(logo_offset);
    // console.log(last_left_menu_offset);
    // console.log(right_menu_offset);
    // console.log(space_between_left_logo);
    // console.log(space_between_right_logo);
    // console.log( $('.right-nav .main-menu-nav-item').first() );
    
    
    //$('.right-nav .main-menu-nav-item').last().css('margin-right', (space_between_right_logo - space_between_left_logo + 20)+"px");
    
    //$('.shop-mobile-nav-wrapper').css('max-height', ($(window).height() - $('.header-wrapper').height())+'px' );
  }

  return Header;

})();

window.theme = window.theme || {};

theme.FeaturedContentSection = (function() {

  function FeaturedContent() {
    theme.styleTextLinks();
  }

  return FeaturedContent;
})();



window.theme = window.theme || {};






theme.variables = {
  productPageLoad     : false,
  productPageSticky   : true,

  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  mediaQuerySmall     : 'screen and (max-width: 590px)',
  mediaQueryMediumDown: 'screen and (max-width: 768px)',
  mediaQueryMedium    : 'screen and (min-width: 591px) and (max-width: 768px)',
  mediaQueryMediumUp  : 'screen and (min-width: 591px)',
  mediaQueryLarge     : 'screen and (min-width: 769px)',
  bpSmall             : false
};

theme.initCache = function() {
  theme.cache = {
    $window                 : $(window),
    $html                   : $('html'),
    $body                   : $('body'),
    $drawerRight            : $('.drawer--right'),

    $hero                   : $('.heroSlideshow'),
    $customSelect           : $('.js-selector'),

    $collectionImage        : $('.collection-hero__image'),

    $siteNav                : $('.site-nav'),
    $cartBuggle             : $('.cart-link__bubble'),
    $logo                   : $('.site-header__logo img'),
    $toggleSearchModal      : $('.js-toggle-search-modal'),

    $productImages          : $('.product-single__photos'),
    $productImagePhoto      : $('.product-single__photo'),

    $indentedRteImages      : $('.rte--indented-images'),

    $productGridRows        : $('.collage-grid__row'),
    $productGridPhotosLarge : $('.grid__item--large .grid-product__image-link'),

    // Equal height elements
    $productGridImages      : $('.grid-uniform .grid-product__image-wrapper'),

    $returnLink             : $('.return-link')
  };
};

theme.init = function() {
  theme.initCache();
  theme.setBreakpoints();
  theme.fitNav();
  theme.cartInit();
  
  theme.returnLink();
  theme.styleTextLinks();
  theme.searchModal();

  // Functions to run on load so image sizes can be calculated
  theme.cache.$window.on('load', theme.resizeLogo);
  theme.cache.$window.on('load', theme.articleImages);

  // Functions to re-run on resize
  theme.cache.$window.on('resize', theme.debounce(theme.resizeLogo, 150));
};

theme.returnLink = function() {
  if (!document.referrer || !theme.cache.$returnLink.length || !window.history.length) {
    return;
  }

  theme.cache.$returnLink.on('click', theme.backButton);
};

theme.backButton = function() {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  }
};

theme.setBreakpoints = function() {
  if(!theme.cache.$html.hasClass('lt-ie9')) {
    enquire.register(theme.variables.mediaQuerySmall, {
      match: function() {
        if (theme.settings.gridType === 'collage') {
          theme.clearCollageGridHeights();
        }

        theme.variables.bpSmall = true;
      },
      unmatch: function() {
        theme.variables.bpSmall = false;
      }
    });
  }
};

theme.fitNav = function() {
  // Measure children of site nav on load and resize.
  // If wider than parent, switch to mobile nav.
  controlNav();
  theme.cache.$window.on('load', controlNav);
  theme.cache.$window.on('resize', theme.debounce(controlNav, 150));

  function controlNav() {
    // Subtract 20 from width to account for inline-block spacing
    var navWidth = theme.cache.$siteNav.parent().outerWidth() - 20;
    var navItemWidth = 0;
    theme.cache.$siteNav.find('> li').each(function() {
      var $el = $(this);
      if (!$el.hasClass('site-nav--compress__menu')) {
        // Round up to be safe
        navItemWidth += Math.ceil($(this).width());
      }
    });

    if (navItemWidth > navWidth) {
      theme.cache.$siteNav.addClass('site-nav--compress');
      $('.right-nav .main-menu-nav-item').hide();
    } else {
      theme.cache.$siteNav.removeClass('site-nav--compress');
      $('.right-nav .main-menu-nav-item').show();
    }

    theme.cache.$siteNav.addClass('site-nav--init');
  }
};

theme.resizeLogo = function() {
  // Using .each() as there can be a reversed logo too
  theme.cache.$logo.each(function() {
    var $el = $(this),
        logoWidthOnScreen = $el.width(),
        containerWidth = $el.closest('.grid__item').width();
    // If image exceeds container, let's make it smaller
    if (logoWidthOnScreen > containerWidth) {
      $el.css('maxWidth', containerWidth);
    }
    else {
      $el.removeAttr('style');
    }
  });
};

theme.sizeCartDrawerFooter = function() {
  // Stop if our drawer doesn't have a fixed footer
  if (!theme.cache.$drawerRight.hasClass('drawer--has-fixed-footer')) {
    return;
  }

  // Elements are reprinted regularly so selectors are not cached
  var $cartFooter = $('.ajaxcart__footer').removeAttr('style'),
      $cartInner = $('.ajaxcart__inner').removeAttr('style'),
      cartFooterHeight = $cartFooter.outerHeight();

  $cartInner.css('bottom', cartFooterHeight);
  $cartFooter.css('height', cartFooterHeight);
};



theme.searchModal = function() {
  if (!theme.cache.$toggleSearchModal.length) {
    return;
  }

  var openSearch = false;

  theme.cache.$toggleSearchModal.magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade mfp-search',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: false,
    tClose: theme.strings.zoomClose,
    alignTop: true,
    removalDelay: 200,
    callbacks: {
      open: function() {
        openSearch = true;
        var self = this;
        $('.site-nav .site-nav__item.has-mega-menu-2').removeClass('active');
        this.contentContainer.css('top', $('#sticky-wrapper').outerHeight());
        $('body').addClass('mfp-search-open');
        setTimeout(function() {
          var input = self.content.find('form > input[type="search"]');
          var empty_search_container = self.content.find('.instant-search-container:empty');
          input.focus();
          input.click();
          if (input.val().trim() && empty_search_container.length)
            input.change();
        }, ($(window).width() < 768 ? 1000 : 500));
        if (openSearch == true) {
          theme.cache.$toggleSearchModal.off('click').on('click', function(event) {
            self.close();
            event.preventDefault();
          });
        }
      },
      close: function() {
        openSearch = false;
        $('body').removeClass('mfp-search-open');
        theme.searchModal();
      }
    }
  });
}

theme.clearCollageGridHeights = function() {
  if (!theme.cache.$productGridRows.length) {
    return;
  };

  theme.cache.$productGridPhotosLarge.removeAttr('style');
};

theme.articleImages = function() {
  if (!theme.cache.$indentedRteImages.length) {
    return;
  }

  theme.cache.$indentedRteImages.find('img').each(function() {
    var $el = $(this);
    var attr = $el.attr('style');

    // Check if undefined or float: none
    if (!attr || attr == 'float: none;') {
      // Remove grid-breaking styles if image isn't wider than parent
      if ($el.width() < theme.cache.$indentedRteImages.width()) {
        $el.addClass('rte__no-indent');
      }
    }
  });
};

theme.styleTextLinks = function() {
  $('.rte').find('a:not(:has(img))').addClass('text-link');
};

theme.cartInit = function() {
  if (!theme.cookiesEnabled()) {
    theme.cache.$body.addClass('cart--no-cookies');
  }
};

theme.cookiesEnabled = function() {
  var cookieEnabled = navigator.cookieEnabled;

  if (!cookieEnabled){
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
  }
  return cookieEnabled;
}

$(document).ready(function() {
  theme.init();
  var sections = new theme.Sections();

  
  sections.register('product-template', theme.Product);
  sections.register('product-template-new', theme.Product);
  sections.register('collection-template', theme.Collection);
  sections.register('header-section', theme.HeaderSection);
  sections.register('featured-content-section', theme.FeaturedContentSection);
  
  

  //$('select.currency-picker').niceSelect2();

  var tabs = $('ul.tabs');
  tabs.each(function(index) {
    var container = $(this).parent();

    $('.single-review:eq(0)').clone().appendTo($(this).find('> li > a[data-tab="reviews"]'));
    $('.prd-review').appendTo('ul.tabs-content li[data-tab="reviews"]').removeClass('hide');

    var tabsContent = container.find('ul.tabs-content > li');
    if ($(window).width() < 768) tabsContent.removeClass('active');
    tabsContent.filter(':not(.active)').hide();
    tabsContent.each(function(index) {
      $(this).before('<a class="mobile-tab" href="javascript:void(0)"><span class="mobile-tab-text">' + container.find('.tabs li a[data-tab="' + $(this).data('tab') + '"]').html() + '</span><span class="mobile-tab-switch mobile-tab-plus"><svg width="21px" height="21px" viewBox="0 0 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="UI-KIT" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1062.000000, -6284.000000)"><g id="UI_COMPONENTS" transform="translate(206.000000, 5895.000000)" fill="#555759"><g id="$ICON-/-plus" transform="translate(850.000000, 383.000000)"><g id="2044286---add-interface-plus-u" transform="translate(6.000000, 6.000000)"><path d="M10.9195787,9.68042131 L19.6804213,9.68042131 C20.0226052,9.68042131 20.3,9.95781614 20.3,10.3 C20.3,10.6421839 20.0226052,10.9195787 19.6804213,10.9195787 L10.9195787,10.9195787 L10.9195787,19.6804213 C10.9195787,20.0226052 10.6421839,20.3 10.3,20.3 C9.95781614,20.3 9.68042131,20.0226052 9.68042131,19.6804213 L9.68042131,10.9195787 L0.919578686,10.9195787 C0.577394827,10.9195787 0.3,10.6421839 0.3,10.3 C0.3,9.95781614 0.577394827,9.68042131 0.919578686,9.68042131 L9.68042131,9.68042131 L9.68042131,0.919578686 C9.68042131,0.577394827 9.95781614,0.3 10.3,0.3 C10.6421839,0.3 10.9195787,0.577394827 10.9195787,0.919578686 L10.9195787,9.68042131 Z" id="Combined-Shape" fill-rule="nonzero"></path></g></g></g></g></svg></span><span class="mobile-tab-switch mobile-tab-minus"><svg width="21px" height="2px" viewBox="0 0 15 1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="SUNGLASS-PDP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="PDP_1480px_GLASSES_LIFESTYLE_1" transform="translate(-1313.000000, -962.000000)" fill="#7B7B7B"><g id="Group-6" transform="translate(115.000000, 946.000000)"> <g id="$ICON-/-#21-/-minus" transform="translate(1189.000000, 0.000000)"><polygon id="icon-minus" points="24 16 9 16 9 16.7142857 24 16.7142857"></polygon></g></g></g></g></svg></span></a>');
    });

    var tab = $(this).find('> li > a');
    tab.click(function(event) {
      var href = $(this).attr('href');
      if (href.charAt(0) == '#') {
        var tabContent = container.find(href);
        event.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        tabContent.show().addClass('active').siblings('li').hide().removeClass('active');
        tabContent.prev('.mobile-tab').addClass('active').siblings('.mobile-tab').removeClass('active');
      }
    });
    var mobileTab = container.find('.mobile-tab');
    mobileTab.click(function(event) {
      event.preventDefault();
      $(this).toggleClass('active');
      $(this).next('li').toggleClass('active').slideToggle();
      tab.removeClass('active');
      tab.filter('[href="#' + $(this).next('li').attr('id') + '"]').addClass('active');
    });
  });

  $('.stamped-badge').not('.title-container-secondary .stamped-badge').on('click', function() {
    if (!$('.product_tab_desc .tabs li a[data-tab="reviews"].active').length) {
      $('.product_tab_desc .tabs li a[data-tab="reviews"]').click();
      $(this).click();
    }
  });

  $('.title-container-secondary .stamped-badge').on('click', function() {
    $('.title-container-primary .stamped-badge').click();
  });
  
  
  
  // menu hover
  $('.child-site-nav__dropdown.child > li').not('.menu-banner-image').each(function(){
    $(this).off('mouseenter').on('mouseenter', function(){
      var index = $(this).index() + 1;
      console.log(index);
      $(this).siblings('.menu-banner-image').hide();
      $(this).siblings('.menu-banner-image.image-'+index).show();
      $('.child-site-nav__dropdown').removeClass('active');
      $(this).closest('.child-site-nav__dropdown').addClass('active');
    });
  });
  
  $('.site-nav--has-dropdown.child').hover(function(){
    $('.child-site-nav__dropdown').removeClass('active');
    $(this).closest('.child-site-nav__dropdown').addClass('active');
  }, function(){});
  
  if ($('.counter').length)
  {
  $('.counter').counterUp({
    delay: 10,
    time: 1000
  });
  }
  
  if( $('.my_stamped-carousel-scroll-wrapper.my-slider').length > 0 ){
//     $('.my_stamped-carousel-scroll-wrapper.my-slider').flickity({
//       pageDots: false,
//       imagesLoaded: true,
//       cellAlign: 'left',
//       dragThreshold: 10,
//       selectedAttraction: 0.2,
//       friction: 0.8,
//       wrapAround: true,
//       arrowShape: { 
//         x0: 10,
//         x1: 60, y1: 50,
//         x2: 60, y2: 45,
//         x3: 15
//       }
    //     });
    $('.my_stamped-carousel-scroll-wrapper.my-slider').slick({
      infinite: true,
      speed: (window.isChromeMobile ? 150 : 300),
      slidesToShow: 3,
      slidesToScroll: 1,
      arrow: true,
      nextArrow:'<button type="button" data-role="none" class="slick-next-custom slick-arrow" aria-label="Next" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      prevArrow:'<button type="button" data-role="none" class="slick-prev-custom slick-arrow" aria-label="Previous" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow"></path></svg></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  
  if ($(window).width() < 768) {
    $('.multicolumn-list-mobile-slider, .three-icons-items-mobile-slider').each(function() {
      $(this).slick({
        infinite: true,
        speed: (window.isChromeMobile ? 150 : 300),
        slidesToShow: 1,
        slidesToScroll: 1,
        arrow: true,
        nextArrow:'<button type="button" data-role="none" class="slick-next-custom slick-arrow" aria-label="Next" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        prevArrow:'<button type="button" data-role="none" class="slick-prev-custom slick-arrow" aria-label="Previous" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow"></path></svg></button>',
      });
    });
  }
  
  if(!theme.cache.$html.hasClass('lt-ie9')) {
    enquire.register(theme.variables.mediaQueryMediumDown, {
      match: function() {
        // Gallery bellow slider
        if ($('.gallery-slider-mobile').length > 0) {
//           $('.gallery-slider-mobile').flickity({
//             pageDots: false,
//             imagesLoaded: true,
//             dragThreshold: 10,
//             selectedAttraction: 0.2,
//             friction: 0.8,
//             cellAlign: 'left',
//             wrapAround: true
//           });
          if ($(window).width() < 768)
            $('.gallery-slider-mobile img').removeClass('fade-in');
          $('.gallery-slider-mobile').slick({
            infinite: true,
            speed: (window.isChromeMobile ? 150 : 300),
            slidesToShow: 4,
            slidesToScroll: 1,
            arrow: true,
            nextArrow: '<button type="button" data-role="none" class="slick-next-custom slick-arrow" aria-label="Next" role="button" style="display: block;" aria-disabled="false"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
            prevArrow: '<button type="button" data-role="none" class="slick-prev-custom slick-arrow slick-disabled" aria-label="Previous" role="button" aria-disabled="true" style="display: block;"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '15%'
                }
              }
            ]
          });
        }
        
        // change title
        if( $('.category-item-box').length > 0 ){
          $('.category-item-box').each(function(){
            var $title = $(this).find('.grid-product__title');
            var newTitle = $(this).find('.grid-product__title').text().replace('TruWood', 'TruWood<br/>');
            $title.html(newTitle);
          });
        }
        
        // Featured products
        /*if( $('.home-featured-products').length > 0 ){
          
          $('.home-featured-products').flickity({
            pageDots: false,
            imagesLoaded: true,
            cellAlign: 'left',
            wrapAround: true,
            dragThreshold: 10,
            selectedAttraction: 0.2,
            friction: 0.8,
            arrowShape: { 
              x0: 10,
              x1: 60, y1: 50,
              x2: 60, y2: 45,
              x3: 15
            }
          });
        }*/
        
        // Wood type
        if( $('.wood-types-wrapper').length > 0 ){
          
          // init slider
//           $('.wood-types-wrapper').flickity({
//             pageDots: false,
//             imagesLoaded: true,
//             cellAlign: 'left',
//             wrapAround: true,
//             dragThreshold: 10,
//             selectedAttraction: 0.2,
//             friction: 0.8,
//             arrowShape: { 
//               x0: 10,
//               x1: 60, y1: 50,
//               x2: 60, y2: 45,
//               x3: 15
//             }
//           });
          if ($(window).width() < 769) {

            $('.wood-types-wrapper').slick({
              infinite: false,
              speed: (window.isChromeMobile ? 150 : 300),
              slidesToShow: 6,
              slidesToScroll:6,
              arrow:true,
              nextArrow:'<button type="button" data-role="none" class="slick-next-custom slick-arrow" aria-label="Next" role="button" style="display: block;" aria-disabled="false"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
              prevArrow:'<button type="button" data-role="none" class="slick-prev-custom slick-arrow slick-disabled" aria-label="Previous" role="button" aria-disabled="true" style="display: block;"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
              responsive: [
                {
                  breakpoint: 769,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                }
              ]
            });
          }
        }
        
        // Block 4 Tree page
        if( $('.block-4-lists').length > 0 ){
          $('.block-4-lists').flickity({
            pageDots: false,
            cellAlign: 'left',
            dragThreshold: 10,
            selectedAttraction: 0.2,
            friction: 0.8,
            wrapAround: true,
            adaptiveHeight: true,
            arrowShape: { 
              x0: 10,
              x1: 60, y1: 50,
              x2: 60, y2: 45,
              x3: 15
            }
          });
        }
        
        /*
        // Related products
        if( $('.related-products .products-grid').length > 0 && $('.related-products .products-grid .product-grid-item').length > 1 ){
          $('.related-products .products-grid').flickity({
            pageDots: false,
            imagesLoaded: true,
            cellAlign: 'left',
            dragThreshold: 10,
            // selectedAttraction: 0.01,
            // friction: 0.15,
            selectedAttraction: 0.2,
            friction: 0.8,
            wrapAround: true,
            arrowShape: { 
              x0: 10,
              x1: 60, y1: 50,
              x2: 60, y2: 45,
              x3: 15
            }
          });
        }
        */
        
        // Wood products
        /*
        if( $('.wood-banner-collection').length > 0 ){
          $('.wood-banner-collection').flickity({
            pageDots: false,
            imagesLoaded: true,
            cellAlign: 'left',
            dragThreshold: 10,
            //selectedAttraction: 0.2,
            //friction: 0.8,
            wrapAround: true,
            arrowShape: { 
              x0: 10,
              x1: 60, y1: 50,
              x2: 60, y2: 45,
              x3: 15
            }
          });
        }
        */
        if ($('.wood-banner-collection').length) {
          $('.wood-banner-collection').slick({
            infinite: true,
            speed: (window.isChromeMobile ? 150 : 500),
            slidesToShow: 1,
            slidesToScroll: 1,
            arrow: false,
            responsive: [
              {
                breakpoint: 769,
                settings: {
                  arrow: true,
                  nextArrow:'<button class="flickity-prev-next-button next" type="button" aria-label="next"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
                  prevArrow:'<button class="flickity-prev-next-button previous" type="button" aria-label="previous"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow"></path></svg></button>'
                }
              }
            ]
          });
        }
        
        if( $('.carousel-item.slider-new').length > 0 ){
          /*
          $('.carousel-item.slider-new').flickity({
            pageDots: false,
            adaptiveHeight: true,
            imagesLoaded: true,
            cellAlign: 'left',
            dragThreshold: 10,
            //selectedAttraction: 0.2,
            //friction: 0.8,
            wrapAround: true,
            arrowShape: { 
              x0: 10,
              x1: 60, y1: 50,
              x2: 60, y2: 45,
              x3: 15
            }
          });
          */
          $('.carousel-item.slider-new').slick({
            infinite: true,
            speed: (window.isChromeMobile ? 150 : 400),
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            arrow: false,
            responsive: [
              {
                breakpoint: 769,
                settings: {
                  arrow: true,
                  nextArrow:'<button class="flickity-prev-next-button next" type="button" aria-label="next"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
                  prevArrow:'<button class="flickity-prev-next-button previous" type="button" aria-label="previous"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow"></path></svg></button>'
                }
              }
            ]
          });
        }
        
        if( $('body').hasClass('template-product') ) {
          $('.mobile-review-showing').off('click').on('click', function(e){
            $("html, body").animate({ scrollTop: $('.customer-reviews').offset().top - $(".site-header").height() }, 350);
            e.preventDefault();
          });
        }
        
        
      },
      unmatch: function() {
        // Gallery bellow slider
        if ($('.gallery-slider-mobile').length) {
          //$('.gallery-slider-mobile').flickity('destroy');
          $('.gallery-slider-mobile').slick('unslick');
        }
        // Featured products
        if ($('.home-featured-products').length) {
          //$('.home-featured-products').flickity('destroy');
          $('.home-featured-products').slick('unslick');
        }
        
        // Wood type
        if ($('.wood-types-wrapper').length) {
          //$('.wood-types-wrapper').flickity('destroy');
          $('.wood-types-wrapper').slick('unslick');
        }
        
        if ($('.category-item-box').length) {
          // change title
          $('.category-item-box').each(function() {
            var $title = $(this).find('.grid-product__title');
            var oldTitle = $title.attr('data-originTitle');
            $title.html(oldTitle);
          });
        }
        
        /*
        // Related products
        if( $('.related-products .products-grid').length > 0 ){
          $('.related-products .products-grid').flickity('destroy');
        }
        */

        // Block 4 Tree page
        if ($('.block-4-lists').length) {
          //$('.block-4-lists').flickity('destroy');
          $('.block-4-lists').slick('unslick');
        }
        // Wood page
        if ($('.wood-banner-collection').length) {
          //$('.wood-banner-collection').flickity('destroy');
          $('.wood-banner-collection').slick('unslick');
        }
        if ($('.carousel-item.slider-new').length) {
          //$('.carousel-item.slider-new').flickity('destroy');
          $('.carousel-item.slider-new').slick('unslick');
        }
      }
    });
  }
  
  
  
  if ($('body').hasClass('template-cart')) {
    // Setup listeners to add/subtract from the input
    $('#full-cart').on('click','.js-qty__adjust', function() {
      var $el = $(this),
          id = $el.data('id'),
          line = $el.closest('.cc-quantity').data('line'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
        // We have a valid number!
      } else {
        // Not a number. Default to 1.
        qty = 1;
      }

      // Add or subtract from the current quantity
      if ($el.hasClass('js-qty__adjust--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        //if (qty <= 1) qty = 1;
      }

      if (qty < 1) { return false; }

      // Update the input's number oncartpage qty update
      $qtySelector.val(qty);
      
      var cart_line_item = $(this).closest('.cartLineItem');
      var mattr = cart_line_item.attr('data-master');
      if (typeof mattr !== typeof undefined && mattr !== false) {
        //var opId = $(this).closest('.cartLineItem').attr('data-optionid');
        //var nli = Number(line)+1;
        var engrave_line_item = $('.customize-option[data-engrave-no="' + cart_line_item.attr('data-engrave-no') + '"]');
        var engrave_li = engrave_line_item.attr('data-line');
        var engrave_ip = parseInt(engrave_line_item.attr('data-lineqty')) + ($(this).hasClass('js-qty__adjust--plus') ? 1 : -1);
        $.ajax({
          type: 'POST',
          url: window.routes.cartChangeUrl + '.js',
          //data: { line: nli, quantity: qty },
          data: { line: engrave_li, quantity: engrave_ip },
          dataType: 'json',
          async: false,
          success: function(jqXHR, textStatus, errorThrown) {
            adjustProdMain(line, qty);
          }
        });
      }
      else {
        adjustProdMain(line, qty);
      }
      
      function adjustProdMain(line, qty) {
        $.ajax({
          type: 'POST',
          url: window.routes.cartChangeUrl + '.js',
          data: { line: line, quantity: qty },
          dataType: 'json',
          async: false,
          success: function(jqXHR, textStatus, errorThrown) {
            //location.reload();
            $.get(window.routes.cartUrl + '/?view=full-cart', function(data) {
              $('#full-cart-temp').append($('#full-cart .additional_checkout_buttons'));
              $('#full-cart').html(data);
              $('#full-cart .additional_checkout_buttons').replaceWith($('#full-cart-temp .additional_checkout_buttons'));
            });
          }
        });
      }
    });

    if ($('[name="note"]').text().trim() == '')
    {
      $(document).ready(function() {
        $('.cart__checkout, .additional-checkout-button').on('click',function() {
          var note = ''; ShopifyAPI.updateCartNote(note, function() {});
        });
      });
    }

    
    /* snippet 'extend-cart-integration.liquid' (custom) */

    if (window.Shopify.currency.active === 'USD') {
      function extendCartMain(startTime) {
        if (!(window.Extend && window.ExtendShopify)) {
          if (new Date() - startTime < 10000)
            setTimeout(function() { extendCartMain(startTime); }, 100);
          return;
        }

        var slice = Array.prototype.slice;
        var cart = {};

        function findAll(selector) {
          var items = document.querySelectorAll(selector);
          return items ? slice.call(items, 0) : [];
        }

        function hardRefresh() {
          location.href = location.hash ? location.href.substring(0, location.href.indexOf('#')) : location.href;
        }

        function initCartOffer() {
          // fail safes
          if (!cart || !slice) return;

          findAll('#extend-cart-offer').forEach(function (el) {
            var variantId = el.getAttribute('data-extend-variant');
            var quantity = el.getAttribute('data-extend-quantity');

            if (ExtendShopify.warrantyAlreadyInCart(variantId, cart.items)) { return; }

            Extend.buttons.renderSimpleOffer(el, {
              referenceId: variantId,
              onAddToCart: function (options) {
                ExtendShopify.addPlanToCart(
                  {
                    plan: options.plan,
                    product: options.product,
                    quantity: quantity,
                  },
                  function (err) {
                    // an error occurred
                    if (err) {
                      return;
                    } else {
                      hardRefresh();
                    }
                  }
                );
              }
            });
          });

          ExtendShopify.normalizeCart({ cart: cart, balance: true }, function (err, data) {
            if (data && data.updates) {
              hardRefresh();
            }
          });
        }

        $.getJSON(window.routes.cartUrl + '.js', function(data)
        {
          cart = data;
          initCartOffer();
        });
      }

      if ($('body.template-cart .cart__row').length)
        extendCartMain(new Date());
    }
    
  }
  
  // limit Widget 2.0 replies to # lines with 'read more' link
  $(document).ready(function() {
      if ($('.stamped-ratings-wrapper').length) {
        replaceTxt();
        addVerifiedBuyer();
      }
      if ($('.my_stamped-ratings-wrapper').length) {
        // replaceTxt2();
      }
  });
  
  var activeReview = 1;

  $(document).on('stamped:widget:carousel:loaded', function() {
    // if( $('body').hasClass('template-product') ) {
      replaceTxt();
      addVerifiedBuyer();
    // }
    // $(document).on('click', '.r-read-more', function() {
      
    // });
  });
  
  function addVerifiedBuyer() {
    $('.stamped-reviews-author').after('<span class="stamped-verified-label" data-verified-type="2"></span>');
  }

  // avatar initial
  function replaceTxt() {
      var text_limit = 75;
      if( $(window).width() < 768 ){
        text_limit = 50;
      }
      $('.stamped-ratings-wrapper').each(function(index) {
          var _obj = $('.stamped-reviews-message', this).find('.stamped-reviews-message-block');
          if (_obj.length) {
              var txtOriginal = $(_obj).html();
              if (txtOriginal.length > text_limit) {
                  var txtTrimmed = txtOriginal.substring(0, text_limit) // get first 75 characters
                      .split(" ") // separate characters into an array of words
                      .slice(0, -1) // remove the last full or partial word
                      .join(" ") + "..."; // combine into a single string and append "..."
                  $('.stamped-reviews-message', this).find('.stamped-reviews-message-block').html('<span class="r-readless">'+txtTrimmed+'</span>');
                  $('.stamped-reviews-message', this).find('.stamped-reviews-message-block').append('<span class="original-review" style="display:none !important;">' + txtOriginal + '</span>');
                  $('.stamped-reviews-message', this).find('.stamped-reviews-message-block').append('<a class="r-read-more">read more</span>');
              }

          }
      });
  }
  $(document).on('click', '.r-read-more', function() {
    var $block = $(this).closest('.block');
    var $ratingWrapper = $(this).closest('.stamped-ratings-wrapper');
    var $scroll = $(this).closest('.stamped-carousel-scroll');
    // remove link
    // replace text
    if( $(this).text() == "read more" ) {
      $(this).text("read less");
    } else {
      $(this).text("read more");
    }
    // var txtOriginal = $(this).closest('.stamped-reviews-message-block').find('.original-review').html();
    // $(this).closest('.stamped-reviews-message-block').html(txtOriginal);
  
    $(this).closest('.stamped-reviews-message-block').find('.original-review').toggle();
    $(this).closest('.stamped-reviews-message-block').find('.r-readless').toggle();
    
    if( $(window).width() > 768 ){
      var blockH = $ratingWrapper.outerHeight() > 210 ? $ratingWrapper.outerHeight() : 210;
      $block.height( blockH );
    } else {
      var blockH = $ratingWrapper.outerHeight() > 210 ? $ratingWrapper.outerHeight() : 210;
      $block.height( blockH + 9 );
    }
    
//     var newH = $block.outerHeight() + 30;
//     var oldH = $scroll.height();
//     if( $(window).width() < 768 ){
//       $scroll.height( newH );
//     } else {
//       if( oldH < newH && newH > 250 ) {
//         $scroll.height( newH );
//       }
//     }
    StampedCarouselFn.switchSlide(this, 0)
  });
  
  function replaceTxt2() {
      var text_limit = 75;
      if( $(window).width() < 768 ){
        text_limit = 50;
      }
      $('.my_stamped-ratings-wrapper').each(function(index) {
          var _obj = $('.my_stamped-reviews-message', this).find('.my_stamped-reviews-message-block');
          if (_obj.length) {
              var txtOriginal = $(_obj).html();
              if (txtOriginal.length > text_limit) {
                  var txtTrimmed = txtOriginal.substring(0, text_limit) // get first 75 characters
                      .split(" ") // separate characters into an array of words
                      .slice(0, -1) // remove the last full or partial word
                      .join(" ") + "..."; // combine into a single string and append "..."
                  $('.my_stamped-reviews-message', this).find('.my_stamped-reviews-message-block').html('<span class="r-readless">'+txtTrimmed+'</span>');
                  $('.my_stamped-reviews-message', this).find('.my_stamped-reviews-message-block').append('<span class="original-review" style="display:none !important;">' + txtOriginal + '</span>');
                  $('.my_stamped-reviews-message', this).find('.my_stamped-reviews-message-block').append('<a class="r-read-more-2">read more</span>');
              }

          }
      });
  }
  $(document).on('click', '.r-read-more-2', function() {
    var $block = $(this).closest('.block');
    var $ratingWrapper = $(this).closest('.my_stamped-ratings-wrapper');
    var $scroll = $(this).closest('.my_stamped-carousel-scroll');
    // remove link
    // replace text
    if( $(this).text() == "read more" ) {
      $(this).text("read less");
    } else {
      $(this).text("read more");
    }
    // var txtOriginal = $(this).closest('.my_stamped-reviews-message-block').find('.original-review').html();
    // $(this).closest('.my_stamped-reviews-message-block').html(txtOriginal);
    
    $(this).closest('.my_stamped-reviews-message-block').find('.original-review').toggle();
    $(this).closest('.my_stamped-reviews-message-block').find('.r-readless').toggle();
    
    // if( $(window).width() > 768 ){
    //   var blockH = $ratingWrapper.outerHeight() > 210 ? $ratingWrapper.outerHeight() : 210;
    //   $block.height( blockH );
    // } else {
    //   var blockH = $ratingWrapper.outerHeight() > 210 ? $ratingWrapper.outerHeight() : 210;
    //   $block.height( blockH + 9 );
    // }
    
//     var newH = $block.outerHeight() + 30;
//     var oldH = $scroll.height();
//     if( $(window).width() < 768 ){
//       $scroll.height( newH );
//     } else {
//       if( oldH < newH && newH > 250 ) {
//         $scroll.height( newH );
//       }
//     }
    // my_StampedCarouselFn.switchSlide(this, 0)
    $('.my_stamped-carousel-scroll-wrapper.my-slider').flickity('resize');
  });
  
  $(document).on('stamped:widget:full-page:loaded', function() {
    if( $('.stamped-reviews-wrapper').length ){
      $('.stamped-reviews-wrapper').each(function(){
        if( $(this).attr('data-loaded') != 'loaded' ){
          var colTitle = $(this).closest('.stamped-reviews-widget-wrapper').attr('data-title');
          $(this).find('.stamped-ratings-wrapper').each(function(){
            var reviewDate = $(this).find('.stamped-reviews-date').detach();
            var reviewAuthor = $(this).find('.stamped-reviews-author').text();
            var reviewTitle = $(this).find('.stamped-review-title').text();
            
            $(this).find('.stamped-reviews-author').remove();
            var reviewVerified = '<span class="stamped-verified-label" style="float: right;" data-verified-type="2"></span>';
            var reviewNewElm1 = '<div class="stamped-reviews-aut-date">';
                reviewNewElm1 += '<div class="stamped-reviews-author">by '+reviewAuthor + '</div>' + '<div class="stamped-reviews-rating">' +reviewDate.html() + '</div>';
                reviewNewElm1 += '</div>';

            $(this).find('.stamped-reviews-rating').after(reviewNewElm1);
            
            $(this).append( reviewVerified );
            
            var productName = $(this).find('.stamped-review-product').text();
            $(this).find('.stamped-review-product').text( colTitle + " / " +  productName);
            
            var a = '<div class="stamped-reviews-rating-title">';
              a += '<div class="stamped-reviews-rating">'+$(this).find('.stamped-reviews-rating').html()+'</div>';
              a += '<div class="stamped-review-title">'+reviewTitle+'</div>';
            a += '</div>'
            
            $(this).prepend(a);
            
            $(this).children('.stamped-reviews-rating').remove();
            
          });
          $(this).attr('data-loaded', 'loaded');
        }
      });
    }
  });
  
  //$('select.new-select').niceSelect2();
  
  
  if( /reviews/.test($('body').attr('id')) ) {
    $('.review-collection-item').click(function(e){
      
      $('.page-reviews .nice-select .current').attr('data-value','FILTER BY RATING');
      $('.page-reviews .nice-select .current').data('value','FILTER BY RATING');
      $('.page-reviews .nice-select .current').text('FILTER BY RATING');
      

      $('.review-collection-item').removeClass('active');
      $(this).addClass('active');
      
      $('.rvp-c-title').text( $(this).attr('data-title') );
      $('.rvp-c-href').attr('href', '/collections/'+$(this).attr('data-handle') );
      
      var colHandle = $(this).attr('data-handle');
      $('.review-listing-wrapper').hide();
      $('.review-listing-'+colHandle).first().show();
      
      $('html, body').animate({
        scrollTop: $('.review-listing-'+colHandle).first().offset().top - 260
      }, 350);
      
      e.preventDefault();
    });
    
    $(document).on('stamped:widget:full-page:loaded', function() {
      $('.stamped-pagination-page a, .stamped-pagination-next a, .stamped-pagination-prev a').on('click', function(e){
          $('html, body').animate({
          scrollTop: $('.collection-review-filter').offset().top - 100
        }, 350);
        e.preventDefault();
      });
    });
  }
  
  
  
});



/**
 * Plugin to handle product
 */

(function ($) {

  'use strict';

  var pluginName = 'product',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   * @param {Object} options
   */
  function Plugin(element, options) {
    this.element = $(element);
    this.options = options;

    this._init();

    var self = this;

    $(document).on('shopify:section:load', function(event) {
      self.element = $('#product-' + self.options['product']['id']);
      self._init();
    });
  }

  Plugin.prototype._init = function() {
    this.element.find('span.money').each(function() {
      jQuery(this).attr('data-currency-usd', jQuery(this).html());
    });
    var $window = $(window);
    var product = this.options['product'];
    this.settings = {
      productPageLoad: false,
      preloadImage: false,
      enableHistoryState: true,
      namespace: '.productSection'
    };
    this.selectors = {
      productImageWrapper: '.product-single__photo-wrapper',
      productImages: '.product-single__photos',
      productImagePhoto: '.js-product-zoom-overlay-trigger',
      productFullDetails: '.product-single__full-details',
      productForm: '.add-to-cart__form',
      addToCart: '.add-to-cart',
      addToCartText: '.add-to-cart-text',
      productPrice: '.product-price',
      mainSlider: '.js-product-zoom-slider',
      navSlider: '.js-product-zoom-nav-slider',
      SKU: '.variant-sku',
      priceA11y: '#PriceA11y',
      comparePrice: '.product-compare-price',
      comparePriceA11y: '#ComparePriceA11y',
      priceWrapper: '.product-single__price--wrapper',
      quantityElements: '.js-quantity-selector, label + .js-qty',
      originalSelectorId: '#ProductSelect',
      singleOptionSelector: '.single-option-selector__radio',
      radioWrapper: '.radio-wrapper',
      meta: '.product-single__meta',
      productWrapper: '.product-single'
    };
    var sectionId = this.element.attr('data-section-id');

    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.zoomType = this.element.data('image-zoom-type');
    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + this.options['product']['id']).innerHTML);

    
    this.initBreakpoints();
    this.stringOverrides();
    this.initProductVariant();
    this.initStickyProductMeta();
    this.initSlider();

    if (this.zoomType && typeof window.orientation === 'undefined') {
      this.productImageZoom();
    }
    
    
//     setTimeout(function() {
//       $('select.currency-picker').first().change();
//     }, 2500);
    $('body').trigger('quickview.afterLoad');

    $window
      .on('load' + namespace, theme.initStickyProductMeta)
      .on('resize' + namespace, theme.debounce(this.initStickyProductMeta, 150).bind(this));
  };

  Plugin.prototype.initProductVariant = function() {
    var options = {
      $container: this.element,
      enableHistoryState: this.element.data('enable-history-state') || false,
      singleOptionSelector: this.selectors.singleOptionSelector,
      originalSelectorId: this.selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.variants = new slate.Variants(options);
    this.element.on('variantChange' + namespace, this.productPage.bind(this));
    this.element.on('variantImageChange' + namespace, this.showVariantImage.bind(this));
  },
    
  Plugin.prototype.initSlider = function(){
      this.element.find(this.selectors.mainSlider).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        mobileFirst: true,
        centerMode: true,
        centerPadding: '0px',
        variableWidth: true,
        lazyLoad: 'ondemand',
        responsive: [{
          breakpoint: 480,
          settings: {
            centerPadding: '25px'
          }
        }, {
          breakpoint: 768,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            dots: false,
            draggable: false,
            swipe: false,
            variableWidth: false
          }
        }, {
          breakpoint: 1199,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            dots: false,
            draggable: false,
            swipe: false,
            variableWidth: false
          }
        }]
      });

      var self = this;

      this.element.find(this.selectors.navSlider).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        swipe: false,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        asNavFor: '.js-product-zoom-slider'
      });
  },
    
  Plugin.prototype.initBreakpoints = function() {
    var self = this;
    var $container = self.element;
    self.zoomType = $container.data('image-zoom-type');

    if (!$('html').hasClass('lt-ie9')) {
      enquire.register(theme.variables.mediaQuerySmall, {
        match: function() {
          self.createImageCarousel();
          if (self.zoomType) {
            if (self.element.find(self.selectors.productImagePhoto).length) {
              // remove event handlers for product zoom on mobile
              self.element.find(self.selectors.productImagePhoto).off();
            }
          }
        },
        unmatch: function() {
          self.destroyImageCarousel();
          if (self.zoomType && typeof window.orientation === 'undefined') {
            // reinit product zoom
            self.productImageZoom();
          }
        }
      });
    }
  },
  
  Plugin.prototype.stringOverrides = function() {
    // Override defaults in theme.strings with potential
    // template overrides

    theme.productStrings = theme.productStrings || {};
    $.extend(theme.strings, theme.productStrings);
  },

  Plugin.prototype.resizeElements = function() {
    this.element.find(this.selectors.productGridImages, this.element).imagesLoaded(function() {
      this.element.find(this.selectors.productGridImages, this.element).css('height', 'auto').equalHeights();
    });
  },

  Plugin.prototype.showVariantImage = function(evt) {
    var variant = evt.variant;
    var $newImage = $('.product-single__photo[data-image-id="' + variant.featured_image.id + '"]');
    var imageIndex;

    if (theme.variables.bpSmall) {
      // Switch carousel slide, unless it's the first photo on load
      imageIndex = $newImage.closest('.slick-slide').attr('index');
      // Navigate to slide unless it's the first photo on load

      // If there is no index, slider is not initalized.
      if (_.isUndefined(imageIndex)) {
        return;
      }

      if (imageIndex !== 0 || theme.variables.productPageLoad) {
        this.element.find(this.selectors.productImages, this.element).slickGoTo(imageIndex);
      }
    } else {
      if (this.element.data('scroll-to-image')) {
        imageIndex = $newImage.closest('.slick-slide').index();
        // Scroll to/reorder image unless it's the first photo on load
        if (imageIndex !== 0 || theme.variables.productPageLoad) {
          if (theme.variables.productPageSticky) {
            // Scroll to variant image
            $('html, body').animate({
              scrollTop: $newImage.offset().top
            }, 250);
          } else {
            // Move selected variant image to top, preventing scrolling
            var currentScroll = $(document).scrollTop();
            $newImage.parent().prependTo(this.element.find(this.selectors.productImages, this.element));
            $(document).scrollTop(currentScroll);
          }
        }
      }
    }

    if (!theme.variables.productPageLoad) {
      theme.variables.productPageLoad = true;
    }
  },

  Plugin.prototype.productImageZoom = function() {
    if (!this.element.find(this.selectors.productImagePhoto, this.element).length || theme.variables.bpSmall) {
      return;
    }

//     this.element.find(this.selectors.productImagePhoto, this.element).magnificPopup({
//       type: 'image',
//       mainClass: 'mfp-fade',
//       closeOnBgClick: true,
//       closeBtnInside: false,
//       closeOnContentClick: true,
//       tClose: theme.strings.zoomClose,
//       removalDelay: 500,
//       gallery: {
//         enabled: true,
//         navigateByImgClick: false,
//         arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
//         tPrev: theme.strings.zoomPrev,
//         tNext: theme.strings.zoomNext
//       }
//     });
    this.element.find('.image-zoom')
    .wrap('<span style="display:inline-block"></span>')
    .css('display', 'block')
    .parent()
    .zoom({
      on:'click',
      url: $(this).find('img').attr('data-zoom'),
      onZoomIn: function(){
        $(this).closest('.product-zoom-slider-slide').addClass('zoomIn');
        $(this).siblings('.image-zoom').addClass('zoomIn');
      },
      onZoomOut: function(){
        $(this).closest('.product-zoom-slider-slide').removeClass('zoomIn');
        $(this).siblings('.image-zoom').removeClass('zoomIn');
      }
    });
  },

  Plugin.prototype.createImageCarousel = function() {
    if (!this.element.find(this.selectors.productImages, this.element).length || this.element.find(this.selectors.productImagePhoto, this.element).length < 2) {
      return;
    }

    this.element.find(this.selectors.productImages, this.element).slick({
      arrows: false,
      dots: true,
      adaptiveHeight: true
    });
  },

  Plugin.prototype.destroyImageCarousel = function() {
    if (!this.element.find(this.selectors.productImages, this.element).length) {
      return;
    }

    this.element.find(this.selectors.productImages, this.element).unslick();
  },

  Plugin.prototype.productPage = function(evt) {
    var moneyFormat = theme.strings.moneyFormat;
    var variant = evt.variant;
    var translations = theme.strings;

    if (variant) {
      // Select a valid variant if available
      if (variant.available) {
        // Available, enable the submit button, change text, show quantity elements
        this.element.find(this.selectors.addToCart, this.element).removeClass('disabled').prop('disabled', false);
        this.element.find(this.selectors.addToCartText, this.element).html(translations.addToCart);
        this.element.find(this.selectors.quantityElements, this.element).show();

        if (!$('body').hasClass('template-product')) {
          var $newImage = this.element.find(this.selectors.productImageWrapper + '[data-image-id="' + variant.featured_image.id + '"]', this.element);
          var $otherImages = this.element.find(this.selectors.productImageWrapper + ':not([data-image-id="' + variant.featured_image.id + '"])', this.element);

          $newImage.removeClass('hide');
          $otherImages.addClass('hide');
        }

        // Update the full details link
        var $link = this.element.find(this.selectors.productFullDetails, this.element);
        if ($link.length) {
          $link.attr('href', this.updateUrlParameter($link.attr('href'), 'variant', variant.id));
        }
      } else {
        // Sold out, disable the submit button, change text, hide quantity elements
        this.element.find(this.selectors.addToCart, this.element).addClass('disabled').prop('disabled', true);
        this.element.find(this.selectors.addToCartText, this.element).html(translations.soldOut);
        this.element.find(this.selectors.quantityElements, this.element).hide();
      }

      this.element.find(this.selectors.productPrice, this.element).html(theme.Currency.formatMoney(variant.price, moneyFormat)).show();

      // Also update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        this.element.find(this.selectors.comparePrice, this.element).html(theme.Currency.formatMoney(variant.compare_at_price, moneyFormat));
        this.element.find(this.selectors.priceWrapper, this.element).show();
        this.element.find(this.selectors.productPrice, this.element).addClass('on-sale');
        this.element.find(this.selectors.comparePriceA11y, this.element).attr('aria-hidden', 'false');
        this.element.find(this.selectors.priceA11y, this.element).attr('aria-hidden', 'false');
      } else {
        this.element.find(this.selectors.priceWrapper, this.element).hide();
        this.element.find(this.selectors.productPrice, this.element).removeClass('on-sale');
        this.element.find(this.selectors.comparePriceA11y, this.element).attr('aria-hidden', 'true');
      }

      // Also Show SKU
      this.element.find(this.selectors.SKU).html(variant.sku);

    } else {
      // The variant doesn't exist, disable submit button.
      // This may be an error or notice that a specific variant is not available.
      // To only show available variants, implement linked product options:
      //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
      this.element.find(this.selectors.addToCart, this.element).addClass('disabled').prop('disabled', true);
      this.element.find(this.selectors.addToCartText, this.element).html(translations.unavailable);
      this.element.find(this.selectors.quantityElements, this.element).hide();
    }
  },

  Plugin.prototype.updateUrlParameter = function(url, key, value) {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = url.indexOf('?') === -1 ? '?' : '&';

    if (url.match(re)) {
      return url.replace(re, '$1' + key + '=' + value + '$2');
    } else {
      return url + separator + key + '=' + value;
    }
  },

  Plugin.prototype.initStickyProductMeta = function() {
    var $meta = this.element.find(this.selectors.meta, this.element);
    var $wrapper = this.element.find(this.selectors.productWrapper, this.element);

    if ($meta.find('#shopify-product-reviews').length) {
      theme.variables.productPageSticky = false;
      return;
    }

    if (!$meta.length || this.element.find(this.selectors.productImagePhoto, this.element).length < 2) {
      return;
    }

    // Don't bother on IE8
    if ($('html').hasClass('lt-ie9')) {
      return;
    }

    // Force detatch if already detached. Prevent layout issues.
    $meta.trigger('detach.ScrollToFixed');

    // Detach and stop if on mobile breakpoint
    if (theme.variables.bpSmall) {
      return;
    }

    var productCopyHeight = $meta.outerHeight();
    var productImagesHeight = this.element.find(this.selectors.productImages, this.element).height();

    /*============================================================================
      Calculate when to detach fixed element to avoid content overlap.
      Subtract product copy height from the limit because plugin uses offset().top
    ==============================================================================*/
    var calcLimit = $wrapper.offset().top + $wrapper.height();
    calcLimit -= productCopyHeight;

    // Init sticky if desc shorter than images and fits in viewport
    if (productCopyHeight < productImagesHeight && productCopyHeight < $(window).height()) {
      theme.variables.productPageSticky = true;
      $meta.scrollToFixed({
        limit: calcLimit
      });
    } else {
      theme.variables.productPageSticky = false;
    }
  },

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));



function refreshCartDrawer()
{
  var bh = $('.cartButtonOuter').outerHeight() + $('.drawerHader').outerHeight() + ($('.cart-goal-bar[data-type="free-shipping"]').length ? $('.cart-goal-bar[data-type="free-shipping"]').outerHeight() : 0);
  //var vh = ($(window).width() < 1300 ?  window.innerHeight - $('#sticky-wrapper').outerHeight() : window.innerHeight);
  var vh = window.innerHeight;
  var newh = vh - bh;
  $('.cartDrawerModal').removeClass('nofix');
  $('.quick-items').removeAttr('style');
  var qih = $('.quick-items').height();
  if (newh > 137) { // 137 is one line-item height in cart 
    if (qih > newh) {
      $('.quick-items').css('max-height', newh + 'px').css('overflow-x', 'hidden').css('overflow-y', 'scroll').css('-webkit-overflow-scrolling', 'touch');
    }
  }
  else {
    $('.cartDrawerModal').addClass('nofix');
  }

  
}

$(document).ready(function()
{
  if ($('.owl_caro_desc').length)
  {
    /*
    function adjustSlides()
    {
      var width = 0;
      var height = 0;
      $('.owl_caro_desc .slick-slide li img').each(function()
      {
        var slideWidth = $(this).width();
        var slideHeight = $(this).height();
        width = (slideWidth > width ? slideWidth : width);
        height = (slideHeight > height ? slideHeight : height);
      });
      if (width > 1 && height > 1)
        $('.owl_caro_desc .slick-slide .pro_desc_video').css({'width': width, 'height': height}).find('img').css({'width': width, 'height': height});
      else
        setTimeout(function() { adjustSlides(); }, 100);
    }

    $('.owl_caro_desc').on('init reInit setPosition', function()
    {
      adjustSlides();
    });
    */

    var oldSlide = null;

    $('.owl_caro_desc').on('beforeChange', function(event, slick, currentSlide, nextSlide)
    {
      oldSlide = currentSlide;
    });

    $('.owl_caro_desc').on('afterChange', function(event, slick, currentSlide)
    {
      if (currentSlide != oldSlide)
      {
        $(this).find('.custom-full-video .pro_desc_video a:not(:visible)').each(function()
        {
          $(this).show().closest('.pro_desc_video').removeClass('active');
          //$(this).siblings('iframe').attr('src', '');
          var iframe = $(this).siblings('iframe');
          var iframeParent = iframe.parent();
          iframe.remove().attr('src', '');
          iframeParent.append(iframe);
        });
      }
    });

    //$('.owl-lazy').addClass('lazyload');

    $('.owl_caro_desc').slick({
      centerMode: true,
      infinite: true,
      centerPadding: '8%',
      slidesToShow: 4,
      slidesToScroll: 4,
      arrow: true,
      prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="slick-arrow__icon" width="9" height="14" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg"><path d="M7.22359 0l1.6855 1.63333L3.37101 7l5.53808 5.36667L7.22359 14l-7.2236-7z" fill="#2B2B2B" fill-rule="evenodd"></path></svg></button>',
      nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="slick-arrow__icon" width="9" height="14" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg"><path d="M1.6855 0L0 1.63333 5.53808 7 0 12.36667 1.6855 14l7.22359-7z" fill="#2B2B2B" fill-rule="evenodd"></path></svg></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 590,
          settings: {
            centerPadding: '0',
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }
});



$(document).ready(function(){
  
  function closePopup() {
    $('.popupBox').removeClass('fadeInUp');
    $('.popupBox').addClass('fadeOutUp');
    $('.popupOverlay').fadeOut('slow');
    $('.cls_popup').remove();
    $('body').removeClass('popupOpned');
  }
  function openPopup(a) {
    $('.popupBox').addClass('fadeInUp');
    $('.popupBox').removeClass('fadeOutUp');
    $('.popupOverlay.'+a).fadeIn('slow');
    $('body').addClass('popupOpned');
    $('.popupBox').append('<a class="cls_popup icon icon-x" ></a>');
  }

  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }   
  }
  $('body').on('click','.cls_popup, .closeEngrave',function(e) {
    e.preventDefault();
    setTimeout(function() {
      closePopup();
    }, 0);
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
    }
  });
  
  function demoEngrave(text, wraper) {
    var demo = $(wraper+' .demoVisiblePart');
    demo.html(text.replace(/(?:\r\n|\r|\n)/g, '<br />'));
    //var ih = demo.innerHeight();
    //var sh = demo[0].scrollHeight;
    var ih = Math.round(demo.innerHeight());
    var sh = Math.round(demo.prop('scrollHeight'));
    if(sh > ih) {
      $(wraper+' .demoHTMLContainer').css('color','#c64235');
      $(wraper+' .engErrorMsg').show();
      $(wraper+' .engraveDemoHTML').addClass('errorInInput');
    } else {
      $(wraper+' .demoHTMLContainer').css('color','#080808');
      $(wraper+' .engraveDemoHTML').removeClass('errorInInput');
      $(wraper+' .engErrorMsg').hide();
    }
    var font = $(wraper+' .engFontStyle').val();
    if(font=='script') {
      $(wraper+' .demoVisiblePart').addClass('scriptFont');
    } else {
      $(wraper+' .demoVisiblePart').removeClass('scriptFont');
    }
  }
  function demoFont(font, wraper) {
    
        console.log($(wraper+' .engInputTextBox').val());

    if(font=='script') {
      $(wraper+' .demoVisiblePart').addClass('scriptFont');
    } else {
      $(wraper+' .demoVisiblePart').removeClass('scriptFont');
    }
    demoEngrave($(wraper+' .engInputTextBox').val(), wraper);
  }
  $('.engInputTextBox').on('keyup blur', function() {
    $(this).val($(this).val().replace(/\p{Other_Symbol}|\p{Extended_Pictographic}/gu, '')).change();
    demoEngrave($(this).val(), $(this).attr('data-parent'));
  });
  $('.engFontStyle').on('change',function() {
    demoFont($(this).val(), $(this).attr('data-parent'));
  });
  
  $('body').on('click','.editEngrave', function(e){
    e.preventDefault();
    var vid = $(this).attr('data-id');
    var pt = $(this).attr('data-pt');
    var font = $(this).attr('data-font');
    var text = $(this).attr('data-text');
    var oid = $(this).attr('data-oid');
    var qty = $(this).attr('data-qty');
    var lne = $(this).attr('data-line');
    var caseSixe = Number($(this).attr('data-size'));
    var proSize = Number(caseSixe - 3);
    var textAvailSize = (caseSixe - 3)/2;
    var mmtopx = 3.779528;
    $('.currentProductVId').val(vid);
    $('.currentProductOId').val(oid);
    $('.currentProductQty').val(qty);
    $('.currentProductLne').val(lne);
    $('.editEngraveWrap .demoHTMLContainer').height(mmtopx*proSize).width(mmtopx*proSize);
    
    var abnew = mmtopx*proSize/2;
    var abnew = abnew*1.4142;
    
    $('.editEngraveWrap .demoVisiblePart').height(abnew).width(abnew).css('margin-top',(mmtopx*textAvailSize/4)+mmtopx);
    $('.editEngraveWrap .engInputTextBox').val(text);
    $('.editEngraveWrap .engFontStyle').val(font).trigger('change');
    $('.editEngraveWrap .demoVisiblePart').html(text);
    if(font=='script') {
      $('.editEngraveWrap .demoVisiblePart').addClass('scriptFont');
    }
    $('.editEngraveBox h3').text(pt);
    openPopup('editEngraveBox');
  });
  
  $('.triggerUpdateProduct').on('click', function(e) {
    e.preventDefault();
    var btn = $(this);
    
    var opWrap = $(this).closest('.engraveInput');
    var engvTxt = opWrap.find('.engInputTextBox').val().trim();
    var engvFont = opWrap.find('.engFontStyle').val();
    var engvOid = opWrap.find('.currentProductOId').val();
    
    opWrap.find('.engErr').remove();
    if (engvTxt == '') {
      opWrap.append('<p class="engErr">Please write any text.</p>');
    } else {
      if (opWrap.closest('.editEngraveWrap').find('.engraveDemoHTML').hasClass('errorInInput')) {
        opWrap.append('<p class="engErr">It appears that the message you wish to have engraved on the back of the watch will not fit. Please modify your message to ensure that the text fits within the available space.</p>');
      } else {
        btn.attr('disabled', 'disabled').text('Updating');

        $.getJSON(window.routes.cartUrl + '.js', function(data)
        {
          var properties_engraving = {'Engraving': 'Yes', 'Engrave Font': engvFont, 'Engrave Text': engvTxt};
          var properties_old = data.items[Number($('.currentProductLne').val())-1].properties;
          var properties_new = {...properties_old, ...properties_engraving};

          $.ajax({
            type: 'POST',
            url: window.routes.cartChangeUrl + '.js',
            data: {line: Number($('.currentProductLne').val()), quantity: Number($('.currentProductQty').val()), properties: properties_new},
            dataType: 'json',
            async: false,
            error: function(jqXHR, textStatus, errorThrown) {
              var response = $.parseJSON(jqXHR.responseText);
              //alert(response.description);
            },
            success: function() {
              opWrap.append('<p class="engSucc">Engraving updated...</p>');
              setTimeout(function() {
                closePopup();
                $('.engSucc').remove();
                addToCartSuccess();
                btn.removeAttr('disabled').text('Update');
              }, 1000);
            }
          });
        });

        /*
        $.ajax({
          type: 'POST',
          url: window.routes.cartChangeUrl + '.js',
          data: { line: Number($('.currentProductLne').val()), quantity: Number($('.currentProductQty').val()), properties: {"Engraving":"Yes","Engrave Font": engvFont,"Engrave Text": engvTxt} },
          dataType: 'json',
          async: false,
          error: function(jqXHR, textStatus, errorThrown){
            var response = $.parseJSON(jqXHR.responseText);
            //alert(response.description);
          },
          success: function(){
            opWrap.append('<p class="engSucc">Engraving updated...</p>');
            setTimeout(function(){
              closePopup();
              $('.engSucc').remove();
              addToCartSuccess();
              btn.removeAttr('disabled').text('Update');
            },1000);
          }
        });
        */
      }
    }
  });

  $('body').on('click', '.removeEngrave', function(e) {
    e.preventDefault();
    $(this).attr('disabled', 'disabled');
    var oid = $(this).attr('data-oid');
    var qty = Number($(this).attr('data-qty'));
    var lne = Number($(this).attr('data-line'));
    //var engrave_lne = lne + 1;
    var engrave_lne = $('.customize-option[data-engrave-no="' + $(this).closest('.cartLineItem').attr('data-engrave-no') + '"]').attr('data-line');

    $.getJSON(window.routes.cartUrl + '.js', function(data)
    {
      var properties_new = data.items[lne-1].properties;
      $.each(['Engraving', 'Engrave No.', 'Engrave Font', 'Engrave Text'], function(index, value) { delete properties_new[value]; });
      if ($.isEmptyObject(properties_new)) { properties_new = {null: null}; }

      $.ajax({
        type: 'POST',
        url: window.routes.cartChangeUrl + '.js',
        data: {line: lne, quantity: qty, properties: properties_new},
        dataType: 'json',
        async: false,
        error: function(jqXHR, textStatus, errorThrown) {
          var response = $.parseJSON(jqXHR.responseText);
          //alert(response.description);
        },
        success: function() {
          $.ajax({
            type: 'POST',
            url: window.routes.cartChangeUrl + '.js',
            data: {line: engrave_lne, quantity: 0},
            dataType: 'json',
            async: false,
            error: function(jqXHR, textStatus, errorThrown) {
              var response = $.parseJSON(jqXHR.responseText);
              //alert(response.description);
            },
            success: function() {
              addToCartSuccess();
            }
          });
        }
      });
    });

    /*
    $.ajax({
      type: 'POST',
      url: window.routes.cartChangeUrl + '.js',
      data: { line: lne, quantity: qty, properties: { null: null} },
      dataType: 'json',
      async: false,
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        //alert(response.description);
      },
      success: function(){
        $.ajax({
          type: 'POST',
          url: window.routes.cartChangeUrl + '.js',
          data: { line: rmProd, quantity: 0 },
          dataType: 'json',
          async: false,
          error: function(jqXHR, textStatus, errorThrown){
            var response = $.parseJSON(jqXHR.responseText);
            //alert(response.description);
          },
          success: function(){
            addToCartSuccess();
          }
        });
      }
    });
    */
  });
  
  if ($('body.template-product').length && $('.stickyAddtoCart').length) {
    var adb = $('[id^="AddToCart--"][id$="product-template"], [id^="AddToCart--"][id$="product-template-new"], .form-btn-grp .addtocart').offset().top + 70;
    function adjustStickyAddtoCart() {
      var hh = $('#shopify-section-header').outerHeight();
      var scroll = $(window).scrollTop();
      var width = $(window).width();
      $('.stickyAddtoCart').css('top', hh + 'px');
      if (scroll >= adb || width < 768) {
        $('.stickyAddtoCart').slideDown();
        if (width < 768) {
          //$('.shopify-currency').addClass('shopify-currency-move-up');
          //$('#gorgias-web-messenger-container').addClass('gorgias-move-up');
          //$('#chatra.chatra--side-bottom').addClass('chatra-move-up');
          $('#dummy-chat-button-iframe, #ShopifyChat').addClass('shopify-chat-move-up');
        }
        else {
          //$('.shopify-currency').removeClass('shopify-currency-move-up');
          //$('#gorgias-web-messenger-container').removeClass('gorgias-move-up');
          //$('#chatra.chatra--side-bottom').removeClass('chatra-move-up');
          $('#dummy-chat-button-iframe, #ShopifyChat').removeClass('shopify-chat-move-up');
        }
      } else {
        $('.stickyAddtoCart').slideUp();
        //$('.shopify-currency').removeClass('shopify-currency-move-up');
        //$('#gorgias-web-messenger-container').removeClass('gorgias-move-up');
        //$('#chatra.chatra--side-bottom').removeClass('chatra-move-up');
        $('#dummy-chat-button-iframe, #ShopifyChat').removeClass('shopify-chat-move-up');
      }
    }
    var startTime = new Date();
    //$('body').on('DOMNodeInserted', function() {
      //if ($('#chatra.chatra--side-bottom').length || new Date() - startTime > 10000) {
        //adjustStickyAddtoCart();
        //$(this).off('DOMNodeInserted');
      //}
    //});
    $('body').on('DOMNodeInserted', function() {
      if ($('#dummy-chat-button-iframe, #ShopifyChat').length || new Date() - startTime > 10000) {
        $(this).off('DOMNodeInserted');
        if ($('#dummy-chat-button-iframe, #ShopifyChat').length) {
          adjustStickyAddtoCart();
          if (!$('#ShopifyChat').length) {
            $('body').on('DOMNodeInserted', function() {
              if ($('#ShopifyChat').length) {
                adjustStickyAddtoCart();
                $(this).off('DOMNodeInserted');
              }
            });
          }
        }
      }
    });
    $(window).on('load resize scroll', function() {
      adjustStickyAddtoCart();
    });
  }
  
  function updateItem(li,ip,we,callback) {
    //const start = new Date();
    $.ajax({
      type: 'POST',
      url: window.routes.cartChangeUrl + '.js',
      data: { line: li, quantity: ip },
      dataType: 'json',
      async: false,
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        //alert(response.description);
        $('#crt').removeClass('loading');
      }
    }).done(function( data ) {
      if (callback) {
        //const end = (Date.now() - start) / 1000;
        //console.log('updateItem() callback()...: ' + end + ' seconds');
        callback();
      }
      else if (we==0) {
        //const end = (Date.now() - start) / 1000;
        //console.log('updateItem() addToCartSuccess()...: ' + end + ' seconds');
        addToCartSuccess();
      }
    });
  }
  
  function cartNumber(callback) {
    
    //const start1 = new Date();
    
    $.getJSON(window.routes.cartUrl + '.js', function(c){
      
      //const end1 = (Date.now() - start1) / 1000;
      //console.log('cartNumber() GET /cart.js: ' + end1 + ' seconds');
      
      //const start2 = new Date();
      
      var x = 0;
      $.each(c.items, function(i,v){
        if(v.product_type != 'Customize option') {
          x = x + v.quantity;
        }
      });
      $('.cartCount').text(x);
      if(!c.item_count) {
        $('.cartCount').addClass('hidden-count');
      } else {
        $('.cartCount').removeClass('hidden-count');
      }
      if(c.item_count == 1 && c.items[0].variant_id == 4102296272937) {
        updateItem(1,0,we=0);
      }
      if(c.item_count == 1 && c.items[0].variant_id == 8207428354146) {
        updateItem(1,0,we=0);
      }
      if (callback) { callback(); }
      
      //const end2 = (Date.now() - start2) / 1000;
      //console.log('cartNumber() GET /cart.js end: ' + end2 + ' seconds');
    });
  }
  
  //cartNumber();
  
  $(window).on('load', function()
  {
    setTimeout(function() {
      cartNumber();
    }, 500);
  });
  
  //refreshCartDrawer();
  //$('.cartDrawer').css('height', window.innerHeight + 'px');
  
  //$(window).resize(function() {
    //setTimeout(function() {
      //refreshCartDrawer();
      //$('.cartDrawer').css('height', window.innerHeight + 'px');
    //}, 50);
  //});
  
  $(window).on('load resize', function()
  {
    setTimeout(function() {
      refreshCartDrawer();
      //if ($(window).width() < 1300) {
        //$('.cartDrawerModal').css({
          //'top': $('#sticky-wrapper').outerHeight() + 'px',
          //'height': window.innerHeight - $('#sticky-wrapper').outerHeight() + 'px'
        //});
      //}
      //else {
        $('.cartDrawerModal').css({'top': '', 'height': window.innerHeight + 'px'});
      //}
    }, 500);
  });
  
  function addToCartSuccess(ca, btn) {
    var cc = $('body').attr('data-cc');
    
    //const start1 = new Date();
    
    $.get( window.routes.cartUrl + "?view=mini", function( data ) {
      
      //const end1 = (Date.now() - start1) / 1000;
      //console.log('addToCartSuccess() GET /cart?view=mini: ' + end1 + ' seconds');
      
      //const start2 = new Date();
      
      if ($('#crt .quick-items .draweAddOns').length)
        $('#crt-drawers').html('').append($('#crt .quick-items .draweAddOns'));

      $('#crt').html(data);

      $('#crt .quick-items .draweAddOns-placeholder').each(function()
      {
        $('#crt-drawers .draweAddOns[data-drawer-type="' + $(this).data('drawer-type') + '"]').insertBefore($(this));
        $(this).remove();
      });
      
      //const end2 = (Date.now() - start2) / 1000;
      //console.log('addToCartSuccess() $(\'#crt\').html(data): ' + end2 + ' seconds');
      
      cartHoverModel();
      
      //const start3 = new Date();
      
      if (btn && btn.data('discount')) {
        if ($('#crt form input[name="discount"]').length) {
          $('#crt form input[name="discount"]').val(btn.data('discount'));
        }
        else if ($('#crt form input[type="submit"]').length) {
          $('#crt form input[type="submit"]').before('<input type="hidden" name="discount" value="' + btn.data('discount') + '">');
        }
      }
      
      if ($('.sgcol_loop').length) {
        if ($('.sgcol_loop').hasClass('slick-initialized')) {
          $('.sgcol_loop').slick('refresh');
        } else {
          $('.sgcol_loop').slick();
        }
      }
      if ($('.brcol_loop').length) {
        if ($('.brcol_loop').hasClass('slick-initialized')) {
          $('.brcol_loop').slick('refresh');
        } else {
          $('.brcol_loop').slick();
        }
      }
      
//       if(Currency) {
//         Currency.convertAll(shopCurrency, $('.currency-picker').val()); 
//       }
      if (ca && ca==1) {
        $('body').addClass('cartOpen');
        $('html').addClass('cartOpenHtml');
        //$('.fullPage').addClass('witcart');

        $('.cart-link-open-icon').addClass('invisible');
        $('.cart-link-close-icon').removeClass('invisible');
        $('.cartDrawer').addClass('active');
      }

      var callback = function () {
        refreshCartDrawer();
        $('#crt').removeClass('loading');
      }
      
      //const end3 = (Date.now() - start3) / 1000;
      //console.log('addToCartSuccess() cartHoverModel() -> cartNumber(): ' + end3 + ' seconds');
          
      cartNumber(callback);
      //setTimeout(function() {
        //refreshCartDrawer();
        //$('#crt').removeClass('loading');
      //}, 1000);
    });
    
  }

  

  $('.triggerMainProduct').on('click', function(e) {
    e.preventDefault();
    var btn = $(this);
    btn.attr('disabled', 'disabled');
    var opWrap = $(this).closest('.engraveInput');
    var engvTxt = opWrap.find('.engInputTextBox').val().trim();
    opWrap.find('.engErr').remove();
    if(engvTxt == '' ) {
      opWrap.append('<p class="engErr">Please write any text.</p>');
    } else {
      if(opWrap.closest('.productSingle,.new-prdt').find('.engraveDemoHTML').hasClass('errorInInput')) {
        opWrap.append('<p class="engErr">It appears that the message you wish to have engraved on the back of the watch will not fit. Please modify your message to ensure that the text fits within the available space.</p>');
      } else {
        $('.isEngraving').val('Yes').removeAttr('disabled');
        opWrap.closest('.productSingle,.new-prdt').find('.add-to-cart').trigger('click');
      }
    }
    btn.removeAttr('disabled');
  });
  
  $('body').on('click', '.add-to-cart, .buy-now, .pre-order, .triggerMainPro', function(e) {
    e.preventDefault();

    if ($(this).hasClass('sold-out')) { return false; }

    if (/\-clone$/.test($(this).attr('id'))) {
      var _btn = $('#' + $(this).attr('id').replace(/\-clone$/, ''));
      if (_btn.length) { _btn.click(); }
      return false;
    }
    
    var cc = $('body').attr('data-cc');
    var btn = $(this);
    var form = $(this).closest('form');
    var buy_now = ($(this).hasClass('buy-now') ? true : false);
    var pre_order = ($(this).hasClass('pre-order') ? true : false);
    var preorder_line_item_name = (pre_order ? $(this).data('preorder-line-item-name') : '');
    var preorder_line_item_value = (pre_order ? $(this).data('preorder-line-item-value') : '');
    var wood_gift_box_option = (form.find('.wood-gift-box-option-input:checked').length ? true : false);
    var watch_tool_kit_option = (form.find('.watch-tool-kit-option-input:checked').length ? true : false);
    var discount = ($(this).data('discount') ? $(this).data('discount') : null);
    btn.attr('disabled', 'disabled');
    form.find('.error').remove();
    
    $('.engErr').remove();
    var addEngvBlank = false;
    var isEngv = false;
    if (form.find('.isEngraving').val() == 'Yes') {
      isEngv = true;
      var engvProId = form.find('.engvProId').val();
      var engvFont = form.closest('.productSingle, .new-prdt').find('.engFontStyle').val();
      var engvTxt = form.closest('.productSingle, .new-prdt').find('.engInputTextBox').val().trim();
      var mainPTitle = form.closest('.productSingle, .new-prdt').find('.product-single__title').text();     
      if (engvTxt == '' ) {
        form.append('<p class="engErr">You have enable Engrave this product and Engrave input is empty! please write any text.</p>');
        addEngvBlank = true;
      } 
      if (form.closest('.productSingle, .new-prdt').find('.engraveDemoHTML').hasClass('errorInInput')) {
        form.append('<p class="engErr">It appears that the message you wish to have engraved on the back of the watch will not fit. Please modify your message to ensure that the text fits within the available space.</p>');
        addEngvBlank = true;
      }
    }
    if (addEngvBlank) {
      btn.removeAttr('disabled');
      return false;
    }
    
    var random_number = new Date().getTime();
    random_number = random_number.toString();

    function mainProdAdd(withEngv) {
      if (form.find('.addonItem.active').length ) {
        form.find('.addonItem.active').each(function() {
          var item = $(this);
          var addid = item.find('.addonitemid').val();
          $.ajax({
            type: 'POST',
            url: window.routes.cartAddUrl + '.js',
            data: {id: addid},
            dataType: 'json',
            async: false,
            error: function(jqXHR, textStatus, errorThrown) {
              var response = $.parseJSON(jqXHR.responseText);
              item.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
            },
            success: function(item) {
              /*
              pintrk('track', 'AddToCart', {
                value: item.price/100,
                order_quantity: item.quantity,
                currency: cc
              });
              */
            }
          });
        });
      }

      var pdata = form.serialize();
      var properties = {};
      if (withEngv) {
        properties['Engrave Font'] = engvFont;
        properties['Engrave Text'] = engvTxt;
        properties['Engrave No.'] = random_number;
      }
      if (wood_gift_box_option) {
        properties['Wood Gift Box Upgrade'] = 'Yes';
      }
      if (pre_order) {
        properties[preorder_line_item_name] = preorder_line_item_value;
      }
      if (!$.isEmptyObject(properties)) { pdata = pdata + '&' + $.param({"properties": properties}); }
      $.ajax({
        type: 'POST',
        url: window.routes.cartAddUrl + '.js',
        data: pdata,
        dataType: 'json',
        async: false,
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
          btn.removeAttr('disabled');
        },
        success: function(item){
          /*
          pintrk('track', 'AddToCart', {
            value: item.price/100,
            order_quantity: item.quantity,
            currency: cc
          });
          */
        }
      }).done(function( data ) {
        if (!buy_now)
          addToCartSuccess(ca=1, btn);
        else
          window.location = '/checkout' + (discount ? '?discount=' + discount : '');
        //btn.val('Add to cart');
        btn.removeAttr('disabled');
        $('.isEngraving').val('').attr('disabled','disabled');
      });
    }

    function engvProdAdd() {
      $.ajax({
        url: window.routes.cartAddUrl + '.js',
        type: 'POST',
        dataType: 'json',
        data: {id: engvProId, quantity: 1, properties: {'Engrave for watch': mainPTitle, 'Engrave No.': random_number}},
        async: false,
        success: function(item) {
          mainProdAdd(withEngv = true);
          /*
          pintrk('track', 'AddToCart', {
            value: item.price/100,
            order_quantity: item.quantity,
            currency: cc
          });
          */
        }
      });
    }

    function watchToolKitAdd() {
      $.ajax({
        type: 'POST',
        url: window.routes.cartAddUrl + '.js',
        data: {id: form.find('.watch-tool-kit-option').data('id')},
        dataType: 'json',
        async: false,
        error: function(jqXHR, textStatus, errorThrown) {
          var response = $.parseJSON(jqXHR.responseText);
          form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        },
        success: function(item) {
          if (isEngv) {
            engvProdAdd();
          } else {
            mainProdAdd(withEngv = false);
          }
          /*
          pintrk('track', 'AddToCart', {
            value: item.price/100,
            order_quantity: item.quantity,
            currency: cc
          });
          */
        }
      });
    }

    if (watch_tool_kit_option) {
      watchToolKitAdd();
    }
    else if (isEngv) {
      engvProdAdd();
    } else {
      mainProdAdd(withEngv = false); 
    }
  });
  
/*start bundle*/
  function custom_bundle(form){
    var isEngv = false;
    console.log('sdjfhsfgsagyf'+jQuery(form).find('.isEngraving').val());
    if(jQuery(form).find('.isEngraving').val()=='Yes') {
      isEngv = true;
      var engvProId = $(form).find('.engvProId').val();
      var engvTxt = form.find('.engInputTextBox').val();
      var engvFont = form.find('.engFontStyle').val();
      var engvOid = form.find('.currentProductOId').val();
      var rendom_number = new Date().getTime();
      var mainPTitle = $(form).closest('.category-item-box').find('.grid-product__title').text();   
      rendom_number = rendom_number.toString();
    }

    var pdata = form.serialize();
    if(isEngv==true) {
      pdata = pdata+'&'+$.param({properties: { "Engrave Font": engvFont, "Engrave Text": engvTxt, "Engrave No.": rendom_number  }});
      jQuery.ajax({
        url: window.routes.cartAddUrl + '.js',
        type: 'POST',
        dataType: 'json',
        data: { id: engvProId, quantity: 1, properties: { 'Engrave for watch': mainPTitle, "Engrave No.": rendom_number }},
        async: false,
        success: function(item) {
        }
      });
    }else{
      pdata = pdata;
    }
    $.ajax({
      type: 'POST',
      url: window.routes.cartAddUrl + '.js',
      data: pdata,
      dataType: 'json',
      async: false,
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
      },
      success: function(item){

      }
    }).done(function( data ) {

    });
  }
  $('.custom_add').click(function(){
    if($('#section-4 .engInputTextBox').val() == ''){
      $('#section-3 .isEngraving').val('').attr('disabled');
    }else{
      $('#section-3 .isEngraving').val('Yes').removeAttr('disabled');
    }
    $('.custom_add').text('Adding....');
     setTimeout(function(){
       $('.show_add .add-to-cart').each(function(){
         var form = $(this).closest('form');
         custom_bundle(form);
       });
       addToCartSuccess();
       $('.custom_add').text('Added!').attr('disabled','disabled');
       $('.isEngraving').val('').attr('disabled','disabled');
       $('.cart-link').trigger('click');
     },200);



  });
  $('.feel_addtocart').click(function(){
    var self = $(this);
    if($('#section-4 .engInputTextBox').val() == ''){
      $(this).closest('.tab').find('.error').html('<p class="error_view">Write the text you wish to have engraved on the back of this timepiece.</p>');
      $('#section-7 .customactive .isEngraving').val('').attr('disabled');
    }
      $('.error').html(' ');
     if($('#section-4 .engInputTextBox').val() == ''){
      $('#section-7 .customactive .isEngraving').val('').attr('disabled');
     }else{
      $('#section-7 .customactive .isEngraving').val('Yes').removeAttr('disabled');
     }
      self.text('Adding....');
      setTimeout(function(){
        $('.last_section .customactive form .add-to-cart').each(function(i){
          var form = $(this).closest('form');
          custom_bundle(form);
        });
        addToCartSuccess();
        self.text('Added!').attr('disabled','disabled');
        $('.isEngraving').val('').attr('disabled','disabled');
        $('.cart-link').trigger('click');
        $('.overlay').trigger('click');
      },200);

  });
/*endbundle*/
  $('#crt').on('click', 'a.remove_item', function(e) {
    $('#crt').addClass('loading');
    e.preventDefault();
    var cart_line_item = $(this).closest('.cartLineItem');
    var li = $(this).attr('data-line');
    
    
    
    var mattr = cart_line_item.attr('data-master');
    //var withEng = false;
    if (typeof mattr !== typeof undefined && mattr !== false) {
      //var opId = $(this).closest('.cartLineItem').attr('data-optionid');
      //var nli = $('.customize-option[data-optionid="'+opId+'"] .quantity').attr('data-line');
      //var nli = Number(li)+1;
      var engrave_line_item = $('.customize-option[data-engrave-no="' + cart_line_item.attr('data-engrave-no') + '"]');
      var engrave_li = engrave_line_item.attr('data-line');
      var engrave_ip = parseInt(engrave_line_item.attr('data-lineqty')) - parseInt(cart_line_item.attr('data-lineqty'));
      var callback = function() {
        updateItem(li,ip=0,we=0);
      }
      //updateItem(nli,ip=0,we=1,callback);
      updateItem(engrave_li,engrave_ip,we=1,callback);
      //var withEng = true;
    }
    else {
      updateItem(li,ip=0,we=0);
    }
    //var sto = 1;
    //if(withEng) {
      //sto = 1000;
    //}
    //setTimeout(function(){
      //updateItem(li,ip=0,we=0);
    //},sto);
  });
  
  $('#full-cart').on('click', '.removeItemCart', function(e) {
    e.preventDefault();
    var cart_line_item = $(this).closest('.cartLineItem');
    var cart_li = cart_line_item.attr('data-line');
    if ($(this).filter('[data-main="yes"]').length) {
      var engrave_line_item = $('.customize-option[data-engrave-no="' + cart_line_item.attr('data-engrave-no') + '"]');
      var engrave_li = engrave_line_item.attr('data-line');
      var engrave_ip = parseInt(engrave_line_item.attr('data-lineqty')) - parseInt(cart_line_item.attr('data-lineqty'));
      //cart_line_item.next('.cartLineItem').find('.cart__product-qty').val(0);
      //engrave_line_item.find('.cart__product-qty').val(engrave_ip);
      //cart_line_item.find('.cart__product-qty').val(0);
      //$(this).closest('form').prepend('<button type="submit" name="update" class="updateCartBtn" style="display:none;" >Update</button>');
      //$('.updateCartBtn').trigger('click');
      $.ajax({
        type: 'POST',
        url: window.routes.cartChangeUrl + '.js',
        data: { line: engrave_li, quantity: engrave_ip },
        dataType: 'json',
        async: false,
        success: function(jqXHR, textStatus, errorThrown) {
          removeProdMain(cart_li);
        }
      });
    }
    else {
      removeProdMain(cart_li);
    }
    
    function removeProdMain(line) {
      $.ajax({
        type: 'POST',
        url: window.routes.cartChangeUrl + '.js',
        data: { line: line, quantity: 0 },
        dataType: 'json',
        async: false,
        success: function(jqXHR, textStatus, errorThrown) {
          //location.reload();
          $.getJSON(window.routes.cartUrl + '.js', function(data) {
            if (!data.item_count) { location.reload(); return; }
            $.get(window.routes.cartUrl + '/?view=full-cart', function(data) {
              $('#full-cart-temp').append($('#full-cart .additional_checkout_buttons'));
              $('#full-cart').html(data);
              $('#full-cart .additional_checkout_buttons').replaceWith($('#full-cart-temp .additional_checkout_buttons'));
            });
          });
        }
      });
    }
  });
  
  $('body').on('click', '.quick-cart-details .adjust', function() {
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    $('#crt').addClass('loading');
    input.val(ip);
    var cart_line_item = $(this).closest('.cartLineItem');
    var li = parseInt(input.attr('data-line'));
    
    
    
    var mattr = cart_line_item.attr('data-master');
    if (typeof mattr !== typeof undefined && mattr !== false) {
      //var nli = Number(li)+1;
      //updateItem(nli,ip,we=1);
      var engrave_line_item = $('.customize-option[data-engrave-no="' + cart_line_item.attr('data-engrave-no') + '"]');
      var engrave_li = engrave_line_item.attr('data-line');
      var engrave_ip = parseInt(engrave_line_item.attr('data-lineqty')) + ($(this).hasClass('plus') ? 1 : -1);
      var callback = function() {
        updateItem(li,ip,we=0);
      }
      updateItem(engrave_li,engrave_ip,we=1,callback);
    }
    else {
      updateItem(li,ip,we=0);
    }
  });

  $('.item-quantityg').keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  });

  $('#crt').on('change', '.watch-tool-kit-option-input', function() {
    if (this.checked) {
      var watch_tool_kit_option = $(this).closest('.watch-tool-kit-option');
      var id = watch_tool_kit_option.data('id');

      $.getJSON(window.routes.cartUrl + '.js', function(data)
      {
        $.ajax({
          type: 'POST',
          url: window.routes.cartAddUrl + '.js',
          data: {id: id},
          dataType: 'json',
          async: false,
          error: function(jqXHR, textStatus, errorThrown) {
            var response = $.parseJSON(jqXHR.responseText);
            watch_tool_kit_option.after('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
          },
          success: function(item) {
            $.get(window.routes.cartUrl + '?view=mini', function(data) {
              if ($('#crt .quick-items .draweAddOns').length)
                $('#crt-drawers').html('').append($('#crt .quick-items .draweAddOns'));
              $('#crt').html(data);
              $('#crt .quick-items .draweAddOns-placeholder').each(function()
              {
                $('#crt-drawers .draweAddOns[data-drawer-type="' + $(this).data('drawer-type') + '"]').insertBefore($(this));
                $(this).remove();
              });
              cartHoverModel();
              if ($('.sgcol_loop').length) {
                if ($('.sgcol_loop').hasClass('slick-initialized')) {
                  $('.sgcol_loop').slick('refresh');
                } else {
                  $('.sgcol_loop').slick();
                }
              }
              if ($('.brcol_loop').length) {
                if ($('.brcol_loop').hasClass('slick-initialized')) {
                  $('.brcol_loop').slick('refresh');
                } else {
                  $('.brcol_loop').slick();
                }
              }
              refreshCartDrawer();
            });
            /*
            pintrk('track', 'AddToCart', {
              value: item.price/100,
              order_quantity: item.quantity,
              currency: $('body').attr('data-cc')
            });
            */
          }
        });
      });

      /*
      var watch_tool_kit_option = $(this).closest('.watch-tool-kit-option');
      var id = watch_tool_kit_option.data('id');
      $.ajax({
        type: 'POST',
        url: window.routes.cartAddUrl + '.js',
        data: {id: id},
        dataType: 'json',
        async: false,
        error: function(jqXHR, textStatus, errorThrown) {
          var response = $.parseJSON(jqXHR.responseText);
          watch_tool_kit_option.after('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        },
        success: function(item) {
          $.get(window.routes.cartUrl + '?view=mini', function(data) {
            if ($('#crt .quick-items .draweAddOns').length)
              $('#crt-drawers').html('').append($('#crt .quick-items .draweAddOns'));
            $('#crt').html(data);
            $('#crt .quick-items .draweAddOns-placeholder').each(function()
            {
              $('#crt-drawers .draweAddOns[data-drawer-type="' + $(this).data('drawer-type') + '"]').insertBefore($(this));
              $(this).remove();
            });
            cartHoverModel();
            if ($('.sgcol_loop').length) {
              if ($('.sgcol_loop').hasClass('slick-initialized')) {
                $('.sgcol_loop').slick('refresh');
              } else {
                $('.sgcol_loop').slick();
              }
            }
            if ($('.brcol_loop').length) {
              if ($('.brcol_loop').hasClass('slick-initialized')) {
                $('.brcol_loop').slick('refresh');
              } else {
                $('.brcol_loop').slick();
              }
            }
            refreshCartDrawer();
          });
          pintrk('track', 'AddToCart', {
            value: item.price/100,
            order_quantity: item.quantity,
            currency: $('body').attr('data-cc')
          });
        }
      });
      */
    }
  });

  
  
  function toggleCartDrawer() {
    //setTimeout(function() {
      //$('body').addClass('cartOpen');
      //$('html').addClass('cartOpenHtml');
      //$('.fullPage').addClass('witcart');
      //$('body').removeClass('menuOpen');
      //$('.fullPage').removeClass('witmenu');

      if ($('.cartDrawer:not(.active)').length)
      {
        $('body').addClass('cartOpen');
        $('html').addClass('cartOpenHtml');
        $('.cartDrawer').addClass('active');

        $('.cart-link-open-icon').addClass('invisible');
        $('.cart-link-close-icon').removeClass('invisible');

        /*
        if ($(window).width() < 1300) {
          $('.cartDrawerModal').css({
            'top': $('#sticky-wrapper').outerHeight() + 'px',
            'height': window.innerHeight - $('#sticky-wrapper').outerHeight() + 'px'
          });
        }
        else {
          $('.cartDrawerModal').css({'top': '', 'height': window.innerHeight + 'px'});
        }
        */

        
        $('#crt img[loading="lazy"]').attr('loading', 'eager');

        if ($('.sgcol_loop').length) {
          if ($('.sgcol_loop').hasClass('slick-initialized')) {
            $('.sgcol_loop').slick('refresh');
          }
          else {
            $('.sgcol_loop').slick();
          }
        }
        if ($('.brcol_loop').length) {
          if ($('.brcol_loop').hasClass('slick-initialized')) {
            $('.brcol_loop').slick('refresh');
          }
          else {
            $('.brcol_loop').slick();
          }
        }

        refreshCartDrawer();
      }
      else
      {
        $('body').removeClass('cartOpen');
        $('html').removeClass('cartOpenHtml');
        //$('.cartDrawer').addClass('transitioning');
        $('.cartDrawer').removeClass('active');

        $('.cart-link-open-icon').removeClass('invisible');
        $('.cart-link-close-icon').addClass('invisible');
      }
    //}, 50);
  }

  /*
  $('body').on('click','.fullPage.witcart, .closecart', function(e){
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witcart');
    $('body').removeClass('cartOpen');
    $('html').removeClass('cartOpenHtml');
  });
  */

  $('.js-drawer-toggle-right').on('click',function(event) {
    event.preventDefault();
    toggleCartDrawer();
  });
  
  $('.closecart').on('click',function(event) {
    toggleCartDrawer();
  });

  $(document).on('click', function(event) {
    if ($('.cartDrawer.active').length && !$(event.target).closest('.js-drawer-toggle-right').length && !$(event.target).closest('.cartDrawer.active .cartDrawerModal').length && !$(event.target).closest('.editEngraveBox').length) {
      toggleCartDrawer();
    }
  });

  /*
  $('.cartDrawer .cartDrawerModal').on('transitionstart', function() {
    $(this).closest('.cartDrawer').addClass('transitioning');
  });

  $('.cartDrawer .cartDrawerModal').on('transitionend', function() {
    $(this).closest('.cartDrawer').removeClass('transitioning');
  });
  */
  
  $('.anouncment_ccode.wihtout_refrence').on('click',function(){
    $('.copied').remove();
    var copyText = document.getElementById("aancode");
    copyText.select();
    document.execCommand("copy");
    $(this).find('.ccode').text('COPIED');
    /*$('body').append('<p class="copied">Copied to clipboard</p>');
    setTimeout(function(){
      $('.copied').fadeOut();
    },1000);*/
  });
  
  $('.anouncment_ccode.email_refrence').on('click',function(){
    $('.copied').remove();
    var copyText = document.getElementById("aancode2");
    copyText.select();
    document.execCommand("copy");
    $(this).find('.ccode').text('COPIED');
  });
  
  function offerBar() {
    if ($.cookie('closeOfferBar') == null || typeof $.cookie('closeOfferBar') === 'undefined') {
      $('.offerBar').slideDown();
    }
    
    $('.ofClose').on('click', function() {
      $('.offerBar').slideUp();
      $.cookie('closeOfferBar', 'yes', { expires: 7, path: '/' });
    });
  }
  
  //if ($(window).width() > 767) {
    $(window).on('mousedown.offerBar mousemove.offerBar touchstart.offerBar keydown.offerBar scroll.offerBar', function() {
      $(this).off('.offerBar');
      offerBar();
    });
  //} else {
    //offerBar();
  //}
  
  if($(window).width() < 769) {
    $('.removeSmall').remove();
  } else {
    $('.removeLarge').remove();
  }

  if($('.addOnProducts').length) { // also added on quickshop line ~3711
    $('.addonItem').on('click', function(){
      $(this).toggleClass('active');
      $(this).find('.addonAdded').toggle();
      $(this).find('.addonPrice').toggle();
    });
    $('.addOnProducts').slick({
      infinite: false,
      speed: (window.isChromeMobile ? 150 : 300),
      slidesToShow: 3,
      slidesToScroll: 1
    });
  }

  
  //$(window).on('pageshow', function(event) {
  setTimeout(function() {
  if($(window).width() < 591) {
    $('.product-grid-item').each(function(i,v){
      
      var s = $(this).index()+1;
      
      if(s % 2 == 0) {
        if($(this).find('.grid-product__title').height() > $(this).prev().find('.grid-product__title').height()) {
          $(this).prev().find('.grid-product__title').css('min-height',$(this).find('.grid-product__title').height()+'px');
        } else {
          $(this).find('.grid-product__title').css('min-height',$(this).prev().find('.grid-product__title').height()+'px')
        }
        
        if($(this).find('.grid-product__image-link').height() > $(this).prev().find('.grid-product__image-link').height()) {
          $(this).prev().find('.grid-product__image-link').css('min-height',$(this).find('.grid-product__image-link').height()+'px');
        } else {
          $(this).find('.grid-product__image-link').css('min-height',$(this).prev().find('.grid-product__image-link').height()+'px');
        }
        
      }
    });
  }
  }, 500);
  //});
  
  
  $('.feel_addtocart').click(function(i){
  });
  $("body").on('click', ".popup-opener", function(e){
    e.preventDefault();
    var $parents = $(this).attr('data-popup-id');
    var $customPop = $(this).attr('data-overlay');
    $("div[data-popup='" + $parents + "']").addClass("active");
    $("body").addClass("open_model");
    if($customPop !== "false"){$('.overlay').addClass("active");}
    $("div[data-popup='" + $parents + "']").siblings(".cs-popup").removeClass("active");
  });
  $("body").on('click', ".close-btn", function(e){
    e.preventDefault();
    var $parents = $('.active').attr('data-popup');
    $(this).closest(".cs-popup").removeClass("active");
    $('.overlay').removeClass("active");
    $("body").removeClass("open_model");
  });
  $("body").on('click', ".overlay", function(e){
    e.preventDefault();
    var $parents = $('.active').attr('data-popup');
    $('.cs-popup').removeClass('active');
    $('.overlay').removeClass("active");
    $("body").removeClass("open_model");
     $('#section-4').hide().removeClass('active_custom');
  });
  $("body").on('click', "#no_thanks", function(e){
    //e.preventDefault();
    $('[id^="AddToCart--"][id$="product-template-new"]').trigger('click');
    var $parents = $('.active').attr('data-popup');
    $('.cs-popup').removeClass('active');
    $('.overlay').removeClass("active");
    $("body").removeClass("open_model");
    return false;
  });
  $("body").on('click', "#great_idea", function(e){
    e.preventDefault();
    var $parents = $('.active').attr('data-popup');
    $('.cs-popup').removeClass('active');
    $('.overlay').removeClass("active");
    $("body").removeClass("open_model");
    $('button.engrv-btn').trigger('click');
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      $(".cs-popup").removeClass("active");
      $('.overlay').removeClass("active");
      $("body").removeClass("open_model");
    }
  });
//   $('#variantTitle').text($('#variantTitle').attr('data-text'));
});
  if ($(window).width() < 768) {
    $('.site-footer.mobile .footer-widget-title').click(function(){
      $('ul.panel').removeClass('active');
        var acco=$(this).attr('rel');
        $('ul#'+acco).addClass('active');
        $('ul.panel.active').slideToggle();
      });
  }




function adjust_title_font_size(title_element, max_lines)
{
  title_element.attr('style', '');
  while (title_element.height() > parseInt(title_element.css('line-height')) * max_lines)
  {
    var title_font_size = parseInt(title_element.css('font-size')) - 1;
    title_element.attr('style', 'font-size: ' + title_font_size + 'px !important;');
  }
}

function adjust_price_font_size(price_element, compare_price_element, compare_price_size_ratio)
{
  price_element.attr('style', '');
  compare_price_element.attr('style', '');
  while (price_element.height() > parseInt(price_element.css('line-height')) || compare_price_element.height() > parseInt(compare_price_element.css('line-height')))
  {
    var price_font_size = parseInt(price_element.css('font-size')) - 1;
    var compare_price_font_size = price_font_size * compare_price_size_ratio;
    price_element.attr('style', 'font-size: ' + price_font_size + 'px !important;');
    compare_price_element.attr('style', 'font-size: ' + compare_price_font_size + 'px !important;');
  }
}

if ($('.home-featured-products, .related-products .products-grid').length)
{
  function featuredProductsSelectors()
  {
    $('.home-featured-products, .related-products .products-grid').find
    ('.product-grid-item .product-select.available.multiple-variants').each(function()
    {
      new Shopify.OptionSelectors($(this).attr('id'), { product: $(this).data('json'), onVariantSelected: selectCallback, enableHistoryState: false });
    });
  }

  function featuredProductsModel(do_refresh)
  {
    do_refresh = (typeof do_refresh !== 'undefined' ? do_refresh : false);
    if (!do_refresh && $('.home-featured-products, .related-products .products-grid').length)
    {
      $('.home-featured-products, .related-products .products-grid').addClass('visible');

      featuredProductsSliders();
    }
    else if ($('body.template-index .home-featured-products').length)
    {
      var section_containers = $('.home-featured-products').closest('.shopify-section');
      var section_containers_length = section_containers.length;
      var section_containers_count = 0;
      var section_containers_loaded = false;
      section_containers.each(function()
      {
        var section_container = $(this);
        var section_id = section_container.attr('id').replace(/^shopify\-section\-/, '');
        $.get('/?section_id=' + section_id, function(data) {
          section_container.html(data);
          section_container.find('.home-featured-products').addClass('visible');
          section_containers_count++;
          if (section_containers_count >= section_containers_length && !section_containers_loaded)
          {
            section_containers_loaded = true;
            featuredProductsSelectors();
            featuredProductsSliders();
            setImagesLoaded(section_containers.find('img[loading="lazy"]'));
          }
        });
      });
    }
    else if ($('body.template-page').find('.landing-template, .gift-guide, .earth-day').find('.home-featured-products').length)
    {
      var section_container = $('.landing-template, .gift-guide, .earth-day').closest('.shopify-section');
      var section_id = section_container.attr('id').replace(/^shopify\-section\-/, '');

      $.get(window.location.pathname + '?section_id=' + section_id, function(data) {
        $('.collection-feature').each(function(index)
        {
          $(this).html($(data).find('.collection-feature').eq(index).html());
          if ($(this).hasClass('woodTypeProduct'))
            $(this).find('.home-featured-products').addClass('visible');
        });
        featuredProductsSelectors();
        featuredProductsSliders();
        setImagesLoaded($('.collection-feature img[loading="lazy"]'));
      });
    }
    else if ($('body.template-product .section-related-products, body.template-page .gift-card-page').find('.related-products .products-grid').length)
    {
      var section_container = $('.section-related-products, .gift-card-page').closest('.shopify-section');
      var section_id = section_container.attr('id').replace(/^shopify\-section\-/, '');

      $.get(window.location.pathname + '?section_id=' + section_id, function(data) {
        $('.related-products').each(function(index)
        {
          $(this).html($(data).find('.related-products').eq(index).html());
          $(this).find('.products-grid').addClass('visible');
        });
        featuredProductsSelectors();
        featuredProductsSliders();
        setImagesLoaded($('.related-products img[loading="lazy"]'));
      });
    }
  }

  function featuredProductsSliders()
  {
    if (!$('.home-featured-products, .related-products .products-grid').length) { return; }

    $('.home-featured-products, .related-products .products-grid').each(function()
    {
      $(this).on('init reInit', function(event, slick, currentSlide)
      {
        var container = $(this);
        setTimeout(function()
        {
          container.find('.swatch:not(.slick-initialized):not([id$="-clone"])').each(function()
          {
            var is_color = ($(this).hasClass('swatch_color') ? true : false);
            var swatch_elements = $(this).find('.swatch-element');
            if ((is_color && swatch_elements.length > 4) || (!is_color && swatch_elements.length > 2))
            {
              var swatch_source_id = '#' + $(this).attr('id');
              var swatch_clone_id = swatch_source_id + '-clone';
              var swatch_clone = $(swatch_clone_id);
              $(this).on('init reInit', function(event, slick, currentSlide)
              {
                $('#' + $(this).find(':radio:checked').attr('id').replace(/\-clone$/, '')).change();
              });
              $(this).slick({
                infinite: true,
                speed: (window.isChromeMobile ? 150 : 300),
                slidesToShow: (is_color ? 4 : 2),
                slidesToScroll: 1,
                arrow: true,
                nextArrow:'<button type="button" data-role="none" class="slick-next-custom slick-arrow" aria-label="Next" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
                prevArrow:'<button type="button" data-role="none" class="slick-prev-custom slick-arrow" aria-label="Previous" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow"></path></svg></button>',
                asNavFor: swatch_clone_id
              });
              if (swatch_clone.length)
              {
                swatch_clone.slick({
                  infinite: true,
                  speed: (window.isChromeMobile ? 150 : 300),
                  slidesToShow: (is_color ? 4 : 2),
                  slidesToScroll: 1,
                  arrow: true,
                  nextArrow:'<button type="button" data-role="none" class="slick-next-custom slick-arrow" aria-label="Next" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
                  prevArrow:'<button type="button" data-role="none" class="slick-prev-custom slick-arrow" aria-label="Previous" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z" class="arrow"></path></svg></button>',
                  asNavFor: swatch_source_id
                });
              }
            }
          });
        }, 0);
      });
    });

    if ($('.home-featured-products').length)
    {
      $('.home-featured-products').each(function()
      {
        var container = $(this);
        container.find('.product--image:eq(0)').on('load', function()
        {
          if (container.find('> .slick-list > .slick-track > .slick-active').length > 1)
            container.find('> .slick-arrow').css('top', Math.ceil($(this).height() / 2) + 'px');
          else
            container.find('> .slick-arrow').css('top', '');
        });
      });

      $(window).on('resize', function()
      {
        $('.home-featured-products').each(function()
        {
          if ($(this).find('> .slick-list > .slick-track > .slick-active').length > 1)
            $(this).find('> .slick-arrow').css('top', Math.ceil($(this).find('.product--image:eq(0)').height() / 2) + 'px');
          else
            $(this).find('> .slick-arrow').css('top', '');
        });
      });

      if ($('.featured-products-section .home-featured-products').length)
      {
        $('.featured-products-section .home-featured-products').each(function()
        {
          $(this).slick({
            infinite: true,
            speed: (window.isChromeMobile ? 150 : 300),
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });
        });
      }

      /* section 'page-new-landing-template(2|10|13|25|-collections|...)', 'page-(mens|womens|...)-gift-guide-template' js, page-earth-day-template' js */

      if ($('body.template-page').find('.landing-template, .gift-guide, .earth-day').find('.home-featured-products').length)
      {
        if ($('.collection-feature:not(.woodTypeProduct) .home-featured-products').length)
        {
          $('.collection-feature:not(.woodTypeProduct) .home-featured-products').each(function()
          {
            $(this).on('init reInit', function(event, slick, currentSlide)
            {
              $(this).addClass('visible');
            });

            var slideCount = $(this).find('.product-grid-item').length;
            $(this).slick({
              infinite: true,
              speed: (window.isChromeMobile ? 150 : 300),
              slidesToShow: 4,
              slidesToScroll: 1,
              centerMode: (slideCount > 4 ? true : false),
              centerPadding: (slideCount > 4 ? '10%' : ''),
              responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: (slideCount > 3 ? true : false),
                    centerPadding: (slideCount > 3 ? '12.5%' : '')
                  }
                },
                {
                  breakpoint: 769,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: (slideCount > 1 ? true : false),
                    centerPadding: (slideCount > 1 ? ($(this).hasClass('watch') || $(this).hasClass('watchbands') ? '25%' : '22%') : '')
                  }
                }
              ]
            });
          });
        }

        if ($('.collection-feature.woodTypeProduct .home-featured-products').length)
        {
          $('.collection-feature.woodTypeProduct .home-featured-products').each(function()
          {
            $(this).slick({
              infinite: true,
              speed: (window.isChromeMobile ? 150 : 300),
              slidesToShow: 4,
              slidesToScroll: 4,
              responsive: [
                {
                  breakpoint: 769,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
            });
          });
        }
      }
    }

    if ($('.related-products .products-grid').length)
    {
      if ($('body.template-product .section-related-products .related-products .products-grid').length)
      {
        $('.section-related-products .related-products .products-grid').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
      else if ($('body.template-page .gift-card-page .related-products .products-grid').length)
      {
        $('.gift-card-page .related-products .products-grid').slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }
  }
}

$(document).ready(function()
{
  $('.AnnouncementBars').slick({
    infinite: true,
    autoplay: true,
    speed: (window.isChromeMobile ? 150 : 500),
    autoplaySpeed: 4000,
    arrows: true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.06 73.11"><title>arrow</title><polyline points="4.5 4.5 36.56 36.56 4.5 68.61" style="fill:none;stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px"/></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.06 73.11"><title>arrow</title><polyline points="4.5 4.5 36.56 36.56 4.5 68.61" style="fill:none;stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px"/></svg></button>'
  });

  if ($('.AnnouncementBars .popup-message').length)
  {
    $('.AnnouncementBars .AnnouncementBar.has-popup .popup-link').on('click', function()
    {
      var AnnouncementBars = $(this).closest('.AnnouncementBars');
      var AnnouncementBar = $(this).closest('.AnnouncementBar');
      if (!$('.AnnouncementBars .popup-message.active').length)
      {
        if (!AnnouncementBars.hasClass('sliding') && AnnouncementBar.hasClass('slick-active'))
        {
          AnnouncementBars.addClass('show-popup');
          AnnouncementBar.find('.popup-message').addClass('active');
        }
      }
      else
      {
        AnnouncementBar.find('.popup-message').removeClass('active');
      }
    });

    $(document).on('click', function(event)
    {
      if ($('.AnnouncementBars .popup-message.active').length && !$(event.target).closest('.AnnouncementBars .AnnouncementBar.has-popup .popup-link').length) {
        $('.AnnouncementBars .popup-message').removeClass('active');
      }
    });

    $('.AnnouncementBars').on('mousedown touchstart', function(event)
    {
      if ($('.AnnouncementBars .popup-message.active').length && !$(event.target).closest('.AnnouncementBars .AnnouncementBar.has-popup .popup-link').length) {
        $('.AnnouncementBars .popup-message').removeClass('active');
      }
    });

    $('.AnnouncementBars').on('beforeChange', function()
    {
      $(this).addClass('sliding');
      $(this).find('.popup-message').removeClass('active');
    });

    $('.AnnouncementBars').on('afterChange', function()
    {
      $(this).removeClass('sliding');
    });

    $('.AnnouncementBars .AnnouncementBar.has-popup .popup-message').on('transitionend', function()
    {
      if (!$(this).hasClass('active')) { $(this).closest('.AnnouncementBars').removeClass('show-popup'); }
    });
  }

  function getInstantSearchResults()
  {
    var input = $('#SearchModal input[type="search"]');
    var query = input.val().trim();
    input.focus();
    if (query)
    {
      $.get(window.routes.predictiveSearchUrl + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=' + (window.location.pathname != window.routes.searchUrl ? 'instant-search' : 'instant-search-page'), function(html) {
        $('.instant-search-container').html(html);
        setImagesLoaded($('.instant-search-container img[loading="lazy"]'));
        setInstantSearchContainer();
      });
    }
    else
    {
      $('.instant-search-container').html('');
      setInstantSearchContainer();
    }
  }

  function setInstantSearchContainer()
  {
    //$('body:not(.template-search) .instant-search-container').css('max-height', ($(window).width() < 768 ? 'calc(100vh - ' + ($('#sticky-wrapper').outerHeight() + $('#SearchModal form').outerHeight()) + 'px)' : ''));
    $('body:not(.template-search) .instant-search-container').css('max-height', window.innerHeight - ($('#sticky-wrapper').outerHeight() + $('#SearchModal form').outerHeight()));
  }

  if ($('body.template-search').length)
  {
    getInstantSearchResults();
  }

  if ($('body:not(.template-search) .instant-search-container').length)
  {
    $(window).on('resize', function()
    {
      setInstantSearchContainer();
    });
  }

  $('body:not(.template-search) .site-nav__link.search').on('click', function(event)
  {
    event.preventDefault();
    if ($('body').hasClass('mfp-search-open')) { $('.js-toggle-search-modal').click(); return; }
    $('body').remove('.search-input-temp');
    $('body').prepend('<input type="text" class="search-input-temp">');
    $('.search-input-temp').css('top', $('#sticky-wrapper').outerHeight());
    $('.search-input-temp').focus();
    $('.search-input-temp').one('blur', function() { $(this).remove(); });
    $('.js-toggle-search-modal').click();
  });

  $('body.template-search .site-nav__link.search').on('click', function(event)
  {
    event.preventDefault();
    $('#SearchModal input[type="search"]').focus();
  });

  $('#SearchModal input[type="search"]').on('input change', function()
  {
    getInstantSearchResults();
  });

  $('#SearchModal').on('click', '.instant-search-terms-item a', function()
  {
    $('#SearchModal input[type="search"]').val($(this).find('.instant-search-terms-item-text').text()).change();
  });

  $(document).on('click', function(event) {
    if ($('#SearchModal:not(.mfp-hide)').length &&
       !$(event.target).closest('#SearchModal:not(.mfp-hide)').length &&
       !$(event.target).closest('.site-nav__link.search').length &&
       !$(event.target).closest('.js-toggle-search-modal').length &&
       !$(event.target).closest('.search-input-temp').length) {
      $('#SearchModal').magnificPopup('close');
    }
  });

  

  if ($('.custom-full-video').length)
  {
    function customVideoLoad()
    {
      $('.custom-full-video .pro_desc_video video').each(function()
      {
        var source = $(this).find('source');
        var src_old = source.attr('src');
        var src_new = ($(window).width() < 769 ? source.data('src-mobile') : source.data('src-desktop'));
        if (src_old != src_new)
        {
          source.attr('src', src_new);
          var video = $(this)[0];
          if ($(this).hasClass('autoplay'))
            video.load();
          else
            $(this).siblings('a').show().closest('.pro_desc_video').removeClass('active');
        }
      });
    }

    customVideoLoad();

    $(window).on('resize', customVideoLoad);

    $('.custom-full-video .pro_desc_video a').on('click', function()
    {
      $(this).hide().closest('.pro_desc_video').addClass('active');
      if ($(this).closest('.slick-slider').length)
      {
        //var iframe = $(this).siblings('iframe');
        //iframe.attr('src', iframe.data('src'));
        var iframe = $(this).siblings('iframe');
        var iframeParent = iframe.parent();
        iframe.remove().attr('src', iframe.data('src'));
        iframeParent.append(iframe);
      }
      else
      {
        var video = $(this).siblings('video')[0];
        video.load();
        video.play();
      }
    });

    $('.custom-full-video .pro_desc_video video').on('loadedmetadata', function()
    {
      var container = $(this).closest('.custom-full-video');
      var thumbnail_styles = container.find('style.thumbnail-styles');
      var video_styles = container.find('style.video-styles');
      if ($(window).width() < 769 && !video_styles.length)
      {
        var video = $(this)[0];
        var padding = (video.videoHeight / video.videoWidth) * 100 + '%';
        var styles = '<style class="video-styles">@media screen and (max-width: 768px) { #' + container.attr('id') + '.custom-full-video .pro_desc_video.active:before { padding-top: ' + padding + '; } }</style>';
        if (thumbnail_styles.length)
          thumbnail_styles.after(styles);
        else
          container.prepend(styles);
      }
    });

    $('.custom-full-video .pro_desc_video video').on('click', function()
    {
      var video = $(this)[0];
      if ($(this).hasClass('autoplay'))
      {
        $(this).removeClass('autoplay');
        video.autoplay = false;
        video.loop = false;
        video.muted = false;
        video.currentTime = 0;
      }
      else if (video.paused)
      {
        video.play();
      }
      else
      {
        video.pause();
      }
    });

    $('.custom-full-video .pro_desc_video video').on('ended', function()
    {
      if (!$(this).hasClass('autoplay'))
      {
        $(this).siblings('a').show().closest('.pro_desc_video').removeClass('active');
        var video = $(this)[0];
        video.currentTime = 0;
        video.load();
      }
    });
  }

  if ($('body.template-list-collections').length)
  {
    var isMobile = (typeof window.orientation !== 'undefined' ? true : false);

    var initCollectionsCollage = function(collections)
    {
      collections.finalTilesGallery({
        margin: isMobile ? 10 : 25,
        gridSize: 20,
        minTileWidth: isMobile ? 180 : Math.min(window.innerWidth - 25, 350),
        imageSizeFactor: [
          [2000, .5],
          [1024, .45],
          [480, .4]
        ]
      });
    };

    initCollectionsCollage($('.template-list-collections .collection-grid'));

    $(document).on('shopify:section:load', function(event)
    {
      var collections = $(event.target).find('.template-list-collections .collection-grid');

      if (collections.length) { initCollectionsCollage(collections); }
    });
  }

  else if ($('body.template-product').length)
  {
    adjust_title_font_size($('.product-details .product-single__title'), ($('.product-details .product-single__title').text().split(' ').length > 1 ? 2 : 1));
    adjust_price_font_size($('.product-details .product-price .money'), $('.product-details .product-compare-price .money'), 0.75);
    $('.product-details .product-single__title, .product-details .product-prices').addClass('visible');

    $(window).on('resize', function()
    {
      adjust_title_font_size($('.product-details .product-single__title'), ($('.product-details .product-single__title').text().split(' ').length > 1 ? 2 : 1));
      adjust_price_font_size($('.product-details .product-price .money'), $('.product-details .product-compare-price .money'), 0.75);
    });

    $('.product-details .product-prices').on('DOMNodeInserted', function()
    {
      $(this).after($(this).find('.sezzle-shopify-info-button'));
    });

    if (window.location.search.includes('show_reviews=true'))
    {
      $(window).on('load', function()
      {
       $('.product-details .title-container-primary .single-review .stamped-badge').click();
      });
    }
  }

  else if ($('body[class*="template-customers-"]').length)
  {
    if ($('body.template-customers-login').length)
    {
      $('.forgot-password').on('click', function()
      {
        $('#CustomerLoginForm').hide();
        $('#RecoverPasswordForm').show();
      });

      $('.back-to-login').on('click', function()
      {
        $('#CustomerLoginForm').show();
        $('#RecoverPasswordForm').hide();
      });
    }
    else
    {
      $('.account-header-menu-dropdown-link').on('click', function()
      {
        $(this).siblings('.account-header-menu-dropdown').toggleClass('active');
      });

      $(document).on('click', function(event)
      {
        if ($('.account-header-menu-dropdown.active').length && !$(event.target).closest('.account-header-menu-dropdown-link').length && !$(event.target).closest('.account-header-menu-dropdown.active').length)
          $('.account-header-menu-dropdown.active').removeClass('active');
      });

      $('.account-header-mobile-toggle').on('click', function()
      {
        $(this).toggleClass('active');
        $('.account-header-mobile-nav').toggleClass('active');
      });

      if ($('body.template-customers-account').length)
      {
        $('.account-orders-list tbody tr').on('click', function(event)
        {
          window.location = $(this).find('.account-order-info-number a').attr('href');
        });

        $('.account-order-info-status-text, .account-orders-list-item-status-text').each( function()
        {
          var item = $(this);
          $.get(item.data('url'), function(data) {
            var text = $(data).find('.os-step__title:eq(0)').text();
            if (/confirmed/i.test(text))
                item.text('Confirmed');
            else if (/on\s+its\s+way/i.test(text))
                item.css('color', 'blue').text('On its way');
            else if (/out\s+for\s+delivery/i.test(text))
                item.css('color', 'blue').text('Out for delivery');
            else if (/delivered|complete/i.test(text))
                item.css('color', 'green').text('Delivered');
            else if (/attempt/i.test(text))
                item.css('color', 'red').text('Attempted delivery');
            else if (/canceled/i.test(text))
                item.css('color', 'red').text('Canceled');
            else
                item.css('color', 'red').text('Unknown');
          });
        });
      }
      else if ($('body.template-customers-order').length)
      {
        $('.account-order-summary-button').on('click', function()
        {
          var item_text = $('.account-order-summary-button-header-text');
          if (/show/i.test(item_text.text()))
            item_text.text('Hide order summary');
          else
            item_text.text('Show order summary');

          $(this).toggleClass('active');
          $('.account-order-summary-section').slideToggle();
        });

        var item = $('.account-order-status');
        var item_title = item.find('.account-order-status-title');
        var item_text = item.find('.account-order-status-text');
        var item_tracking_info = item.find('.account-order-status-tracking-info');
        $.get(item.data('url'), function(data) {
          var title = $(data).find('.os-step__title:eq(0)').text();
          if (/confirmed/i.test(title))
              item_title.text('Confirmed');
          else if (/on\s+its\s+way/i.test(title))
              item_title.text('On its way');
          else if (/out\s+for\s+delivery/i.test(title))
              item_title.text('Out for delivery');
          else if (/delivered|complete/i.test(title))
              item_title.text('Delivered');
          else if (/attempt/i.test(title))
              item_title.text('Attempted delivery');
          else if (/canceled/i.test(title))
              item_title.text('Canceled');
          else
              item_title.text('Unknown order status');
          item_text.text(title);

          if (item_tracking_info.length) {
            var tracking_info = $(data).find('.tracking-info:eq(0)');
            if (tracking_info.length) { item_tracking_info.html(tracking_info.html()); }
          }
        });
      }
      else if ($('body.template-customers-addresses').length)
      {
        new Shopify.CountryProvinceSelector('address_country_new', 'address_province_new', {
          hideElement: $('#address_province_new').closest('.account-addresses-modal-form-field').attr('id')}
        );

        $('.account-addresses-modal[data-type="edit"]').each(function() {
          var id = $(this).data('id');
          new Shopify.CountryProvinceSelector('address_country_' + id, 'address_province_' + id, {
            hideElement: $('#address_province_' + id).closest('.account-addresses-modal-form-field').attr('id')}
          );
        });

        $('.account-addresses-profile-block-btn, .account-addresses-profile-block-field-btn').on('click', function() {
          openModal($(this).data('id'));
        });

        $('.account-addresses-modal button[data-type="delete"]').on('click', function() {
          var id = $(this).data('id');
          setTimeout(function() { $('.account-addresses-delete-form[data-id="' + id + '"]').submit(); }, 0);
        });

        $('.account-addresses-modal-close-btn, .account-addresses-modal button[data-type="cancel"]').on('click', function() {
          closeModal();
        });

        $(document).on('click', function(event) {
          if ($('.account-addresses-modal.active').length && !$(event.target).closest('.account-addresses-modal.active .account-addresses-modal-main').length)
            closeModal();
        });

        function openModal(id) {
          setTimeout(function() { $('.account-addresses-modal[data-id="' + id + '"]').show().addClass('active'); }, 0);
        }

        function closeModal() {
          var modal = $('.account-addresses-modal.active');
          modal.removeClass('active');
          setTimeout(function() { modal.hide(); }, 300);
        }
      }
    }
  }

  else if ($('body.template-page .page-reviews').length)
  {
    $('.page-reviews #stamped-reviews-widget[data-widget-type="full-page"]').each(function()
    {
      $(this).one('DOMNodeInserted', function()
      {
        var _this = $(this);
        setTimeout(function()
        {
          _this.find('.stamped-reviews-wrapper .stamped-ratings-wrapper').each(function()
          {
            $(this).attr('data-href', $(this).find('.stamped-reviews-image a').attr('href'));
          });

          _this.find('.stamped-reviews-message').on('click', function(event)
          {
            event.stopPropagation();
            _this.find('.read-more').click();
          });

          _this.find('.stamped-ratings-wrapper').on('click', function()
          {
            window.location = $(this).data('href');
          });
        }, 0);
      });
    });

    $('.fs-timeline-detail').on('DOMNodeInserted', function()
    {
      var product_handle = $('.fs-timeline-detail a.fs-shop-link.fs-link-list').data('original-url').replace(/^(.*\/)(.*)$/, '$2');
      var fs_product_price = $(this).find('.fs-product-price');

      $.get('/products/' + product_handle + '?view=customData', function(data) {
        fs_product_price.html(JSON.parse(data).price);
      });
    });
  }

  else if ($('body').attr('id') == 'contact')
  {
    setTimeout(function()
    {
      if (window.location.search.includes('contact_posted=true') && window.location.hash.includes('#contact_form_'))
      {
        var container = $(window.location.hash).closest('.contact-form-container');
        $('.contact-links-item[data-contact-link-name="' + container.data('contact-link-name') + '"]').click();
        $('.contact-form-container').not(container).find('.form-success').remove();
      }
    }, 0);

    $('.contact-links-item').on('click', function()
    {
      if (!$(this).hasClass('active'))
      {
        $('.contact-links-item').not($(this)).removeClass('active');
        $(this).addClass('active');
        var container = $('.contact-form-container[data-contact-link-name="' + $(this).data('contact-link-name') + '"]');
        $('.contact-form-container').not(container).hide();
        container.fadeIn(500);
        $('html, body').animate({ scrollTop: container.offset().top - $('#sticky-wrapper').outerHeight() }, 400);
      }
      else
      {
        $('.contact-links-item').removeClass('active');
        $('.contact-form-container').hide();
      }
    });

    $('.contact-form-container').each(function(index)
    {
      switch($(this).data('contact-link-name'))
      {
        case 'order status':
          $(this).find('.contact-form input[name="contact[order number]"]').on('input change', function()
          {
            var title = $(this).closest('.contact-form').find('[name="contact[title]"]');
            var input_val = $(this).val().trim();
            $(this).val(input_val);
            title.val(title.attr('placeholder').replace('[ORDER_NUMBER]', input_val));
          });

          $(this).find('.contact-form button[type="submit"]').on('click', function()
          {
            var title = $(this).closest('.contact-form').find('[name="contact[title]"]');
            var order_number = $(this).closest('.contact-form').find('[name="contact[order number]"]');
            title.val(title.attr('placeholder').replace('[ORDER_NUMBER]', order_number.val()));
          });
          break;
        case 'warranty claim':
          $(this).find('.contact-form input[name="contact[order number]"]').on('input change', function()
          {
            var title = $(this).closest('.contact-form').find('[name="contact[title]"]');
            var input_val = $(this).val().trim();
            $(this).val(input_val);
            title.val(title.attr('placeholder').replace('[ORDER_NUMBER]', input_val));
          });

          $(this).find('.contact-form button[type="submit"]').on('click', function(event)
          {
            var form = $(this).closest('.contact-form');
            if (!form.find('input[type="file"]').val()) { return; }

            event.preventDefault();

            var email = form.find('[name="contact[email]"]');
            var title = form.find('[name="contact[title]"]');
            var order_number = form.find('[name="contact[order number]"]');
            title.val(title.attr('placeholder').replace('[ORDER_NUMBER]', order_number.val()));

            var file = form.find('input[type="file"]')[0].files[0];
            var filename = order_number.val().trim() + ' - ' + email.val().trim() + ' - ' + new Date().getTime() + file.name.replace(/^([^.]+)|(\.[^.]+)$/, '$2');
            var access_token = 'sl.B-9Ntv2hBjLIiH2mCfDhlLVVzQCsmnEsH8ZMEMsS3wWt489ebO8ncluhUcFIJVae8UCt88x_jcx4KM9GwaFDEJ01r71O4aYqZxXNTlNHox43aaw0WYAFWnHbPpO4XzbI7tumbegz_tWZlm0';

            $.ajax({
              type: 'POST',
              url: 'https://content.dropboxapi.com/2/files/upload',
              data: file,
              processData: false,
              contentType: 'application/octet-stream',
              headers: {
                'Authorization': 'Bearer ' + access_token,
                'Dropbox-API-Arg': JSON.stringify({
                  path: '/' + filename,
                  mode: 'add',
                  autorename: true,
                  mute: false
                })
              },
              beforeSend: function() {
                form.find('button[type="submit"]').prop('disabled', true);
              },
              success: function(data) {
                $.ajax({
                  type: 'POST',
                  url: 'https://api.dropboxapi.com/2/sharing/create_shared_link_with_settings',
                  data: JSON.stringify({
                    path: '/' + filename
                  }),
                  contentType: 'application/json',
                  headers: {
                    'Authorization': 'Bearer ' + access_token
                  },
                  success: function(data) {
                    form.find('[name="contact[file]"]').val(data.url);
                    form.submit();
                  },
                  error: function(data) {
                    form.find('button[type="submit"]').prop('disabled', false);
                    alert('There was an error uploading the file.');
                  }
                });
              },
              error: function(data) {
                form.find('button[type="submit"]').prop('disabled', false);
                alert('There was an error uploading the file.');
              }
            });
          });

          $(this).find('.contact-form input[type="file"]').on('change', function()
          {
            if ($(this).val() && $(this)[0].files[0].size > 25600000)
            {
              //$(this).val('');
              $(this)[0].files = new DataTransfer().files;
              alert('File exceeds maximum size of 25 MB.');
            }
          });
          break;
        case 'returns and exchanges':
          $(this).find('.contact-form input[name="contact[order number]"]').on('input change', function()
          {
            var title = $(this).closest('.contact-form').find('[name="contact[title]"]');
            var type = $(this).closest('.contact-form').find('[name="contact[type]"]');
            var input_val = $(this).val().trim();
            $(this).val(input_val);
            title.val(title.attr('placeholder').replace('[ORDER_NUMBER]', input_val).replace('[TYPE]', type.find('option:selected').text()));
          });

          $(this).find('.contact-form button[type="submit"]').on('click', function()
          {
            var title = $(this).closest('.contact-form').find('[name="contact[title]"]');
            var order_number = $(this).closest('.contact-form').find('[name="contact[order number]"]');
            var type = $(this).closest('.contact-form').find('[name="contact[type]"]');
            title.val(title.attr('placeholder').replace('[ORDER_NUMBER]', order_number.val()).replace('[TYPE]', type.find('option:selected').text()));
          });
          
          $(this).find('.contact-form select[name="contact[type]"]').on('change', function()
          {
            $(this).attr('data-selected', $(this).val());

            var title = $(this).closest('.contact-form').find('[name="contact[title]"]');
            var order_number = $(this).closest('.contact-form').find('[name="contact[order number]"]');
            title.val(title.attr('placeholder').replace('[ORDER_NUMBER]', order_number.val()).replace('[TYPE]', $(this).find('option:selected').text()));
            
            var reason = $(this).closest('.contact-form').find('[name="contact[reason]"]');
            if ($(this).val() == 'return')
              reason.prop('required', true);
            else
              reason.prop('required', false);
          });
          break;
        case 'general inquiries':
          ;
          break;
        default:
          ;
      }
    });
  }

  else if ($('body').attr('id') == 'gift-card')
  {
    getExcelData();

    

    $('.balance-check-form').on('submit', function(event)
    {
      event.preventDefault();

      var emailRegExp = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.([a-zA-Z]){2,4})$/;
      if (!emailRegExp.test($('.gift-card-page input[name="email"]').val()))
      {
        alert('Please enter a valid email.');
        return false;
      }

      var foundMatch = false;
      var codeInput = $('.gift-card-page input[name="code"]').val().toUpperCase().trim();

      for (var i = window.worksheet1.length - 1; i >= 0; i--)
      {
        var obj = window.worksheet1[i];

        if (codeInput == obj['CODE'])
        {
          /*
          var currency_code = $('.shopify-currency select[name="currency"]').val();
          var currency_convert_url = 'https://free.currconv.com/api/v7/convert?q=USD_' + currency_code + '&compact=ultra&apiKey=a6a413f9c2a0e7c4c946';

          $.ajax({
            url: currency_convert_url,
            type: 'GET',
            dataType: 'json',
            success: function(data) {
              onDiscountCodeFound(obj['CODE'], obj['VALUE'], Shopify.formatMoney(obj['VALUE'] * data['USD_' + currency_code].toFixed(2) * 100, $('body').data('money')).replace(/([\.|,]00)(\s+|[a-zA-Z]+)/, '$2').replace(/[\.|,]00$/, ''));
            },
            error: function(data) {
              onDiscountCodeFound(obj['CODE'], obj['VALUE']);
            }
          });
          */

          $.ajax({
            url: '/products/50-gift-card?view=customData',
            type: 'GET',
            success: function(data) {
              onDiscountCodeFound(obj['CODE'], obj['VALUE'], JSON.parse(data)['price']);
            },
            error: function(data) {
              onDiscountCodeFound(obj['CODE'], obj['VALUE']);
            }
          });

          foundMatch = true;
          return false;
        }
      }

      if (!foundMatch)
      {
        $('.gift-card-page .balance-block').show().children().hide();
        $('.gift-card-page .balance-error-message').fadeIn(500);
      }

      return false;
    });

    function getExcelData()
    {
      var oReq;
      if (window.XMLHttpRequest) oReq = new XMLHttpRequest();
      else if (window.ActiveXObject) oReq = new ActiveXObject('MSXML2.XMLHTTP.3.0');
      else throw 'XHR unavailable for your browser';

      oReq.open('GET', window.excelFileUrl, true);

      if (typeof Uint8Array !== 'undefined')
      {
        oReq.responseType = 'arraybuffer';
        oReq.onload = function()
        {
          var arraybuffer = oReq.response;
          var data = new Uint8Array(arraybuffer);
          var arr = new Array();
          for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
          var wb = XLSX.read(arr.join(''), {type:'binary'});

          processJSON(excelToJSON(wb));
        };
      }
      else
      {
        oReq.setRequestHeader('Accept-Charset', 'x-user-defined');
        oReq.onreadystatechange = function()
        {
          if (oReq.readyState == 4 && oReq.status == 200)
          {
            var ff = convertResponseBodyToText(oReq.responseBody);
            var wb = XLSX.read(ff, {type:'binary'});

            processJSON(excelToJSON(wb));
          }
        };
      }
  
      oReq.send();
    }

    function excelToJSON(workbook)
    {
      var result = {};
      workbook.SheetNames.forEach(function(sheetName)
      {
        var roa = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
        if (roa.length > 0) { result[sheetName] = roa; }
      });

      return JSON.stringify(result, 2, 2);
    }

    function processJSON(workbook)
    {
      workbook = workbook.replace(/"([^"]+)":/g, function($0, $1) { return ('"' + $1.toUpperCase().trim() + '":'); } );
      workbook = JSON.parse(workbook);

      for (var key in workbook)
      {
        window.worksheet1 = workbook[key];
        if (typeof(window.worksheet1) !== 'function') { break; }
      }

      for (var i = window.worksheet1.length - 1; i >= 0; i--)
      {
        var obj = window.worksheet1[i];

        for (var j = window.searchFields.length - 1; j >= 0; j--)
        {
          if (!obj[window.searchFields[j]]) { obj[window.searchFields[j]] = ''; }
        }

        for (var key in obj)
        {
          key = key.trim();
          obj[key] = obj[key].trim();
        }

        for (var key in obj)
        {
          var foundMatch = false;
          for (var k = window.searchFields.length - 1; k >= 0; k--)
          {
            if (key === window.searchFields[k])
            {
              foundMatch = true;
              break;
            }
          }
          if (foundMatch)
          {
            if (!/\S/.test(obj[key])) { obj[key] = ''; }
          }
          else
          {
            delete obj[key];
          }
        }
      }
    }

    function onDiscountCodeFound(code, value, currency)
    {
      var newValue = (typeof currency !== 'undefined' ? currency : '$' + value);
      var heading = $('.gift-card-page .balance-heading').html().replace('$[value]', '<span class="money">' + newValue + '</span>');
      var subheading = $('.gift-card-page .balance-subheading').html().replace('$[value]', '<span class="money">' + newValue + '</span>');

      $('form[action="' + window.routes.cartAddUrl + '"] button[type=submit]').attr('data-discount', code);

      window._learnq.push(['identify', {
        '$email' : $('.gift-card-page .balance-check-form input[name="email"]').val(),
        'checkedgiftcard' : true
      }]);

      $('.gift-card-page .balance-block').show().children().hide();
      $('.gift-card-page .balance-heading').html(heading);
      $('.gift-card-page .balance-subheading').html(subheading);

      $('.gift-card-page .balance-block > .related-products').each(function()
      {
        $(this).show();
        $(this).find('.products-grid').slick('setPosition');
        $(this).find('.products-grid .swatch.slick-initialized').slick('setPosition');
        $(this).hide();
      });

      $('html, body').animate({scrollTop: 0}, 0, 'swing', function()
      {
        $('.gift-card-page .balance-info, .gift-card-page .balance-check-form').fadeOut(500, function()
        {
          $('.gift-card-page .balance-heading, .gift-card-page .balance-subheading').fadeIn(500, function()
          {
            $('.gift-card-page .related-products').fadeIn(500);
          });
        });
      });

      $('.currency-selector select').on('change', function()
      {
        $.ajax({
          url: '/products/50-gift-card?view=customData',
          type: 'GET',
          success: function(data) {
            $('.gift-card-page .balance-heading .money').html(JSON.parse(data)['price']);
          }
        });
      });
    }
  }

  

  setTimeout(function() {
    $('.nice-select.currency-box').on('click.nice_select', function()
    {
      var _this = $(this);
      setTimeout(function() {
        adjustCurrencyBox(_this);
      }, 100);
    });

    $(window).on('load resize scroll', function()
    {
      setTimeout(function() {
        adjustCurrencyBox($('.nice-select.currency-box'));
      }, 100);
    });

    function adjustCurrencyBox(items)
    {
      items.each(function()
      {
        $(this).find('ul.list').css('max-height', '');
        if ($(this).hasClass('open'))
          $(this).find('ul.list').css('max-height', $(this).find('ul.list')[0].getBoundingClientRect().bottom);
      });
    }
  }, 500);
});